!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.Survicate = t() : e.Survicate = t();
}(globalThis, () => (() => {
  var e,
    t,
    r = {
      8054: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(2733));
        t.default = class {
          static init({
            cookies: e
          }) {
            e && e.forEach(({
              cookie_name: e,
              cookie_random: t
            }) => {
              const r = Math.floor(Math.random() * parseInt(t, 10) + 1);
              i.default.set(e, `${r}`);
            });
          }
        };
      },
      974: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(6890);
        t.default = new class {
          constructor() {
            this.isEnabled = !1;
          }
          init() {
            this.isEnabled = !0;
          }
          pushEvent(e, t) {
            if (window.FS && this.isEnabled && e === s.FullStoryEvents.SurveyPointAnswered) {
              const e = t;
              window.FS.event(s.FullStoryEvents.SurveyPointAnswered, {
                answer_str: e.textResponse,
                question_str: e.question,
                survey_name_str: e.surveyName
              }), window.FS.setUserVars({
                survey_id: t.survey.id,
                survicate_response_uuid_str: t.response_uuid,
                survicate_visitor_uuid_str: t.visitor_uuid
              });
            }
          }
        }();
      },
      1778: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(9902),
          n = s(r(328));
        class o {
          constructor() {
            this.trackerRegex = /.*/, this.isEnabled = !1, this.settings = {};
          }
          init(e) {
            this.isEnabled = e.enabled, this.settings = e;
            let t = /.*/;
            e.tracker && (e.regex ? t = (0, n.default)(e.tracker_regex) || /.*/ : e.tracker_names && (t = new RegExp(`^(${e.tracker_names.map(e => e.name).join("|")})$`))), this.trackerRegex = t;
          }
          static getGA4MatchingDataStreams(e) {
            return "object" == typeof window.google_tag_manager && "/.*/" !== e.toString() && this.areAnyGA4Trackers(e) ? Object.keys(window.google_tag_manager).filter(t => e.test(t)) : null;
          }
          static areAnyGA4Trackers(e) {
            var t;
            return !!(null === (t = e.source.match(/G-\w+/g)) || void 0 === t ? void 0 : t.length);
          }
          static areOnlyGA4Trackers(e) {
            const t = /^G-\w+$/,
              r = e.source,
              s = r.match(/\bG-\w+\b/g);
            return s ? s.every(e => t.test(e)) : t.test(r);
          }
          static getGaMatchingTrackers(e) {
            const t = window.ga.getAll().map(e => e.get("name"));
            return this.areOnlyGA4Trackers(e) ? t : t.filter(t => e.test(t));
          }
          static getCategoryName(e) {
            return `Survicate - ${e}`;
          }
          static getActionName(e, t) {
            let r;
            switch (e) {
              case i.IntegrationEventTypes.SurveyClosed:
                r = "Closed survey";
                break;
              case i.IntegrationEventTypes.SurveyMaximized:
                r = "Maximized survey";
                break;
              case i.IntegrationEventTypes.SurveyMinimized:
                r = "Minimized survey";
                break;
              case i.IntegrationEventTypes.SurveyPointAnswered:
                r = `Question answered - ${t}`;
                break;
              case i.IntegrationEventTypes.SurveyPointSeen:
                r = `Question seen - ${t}`;
                break;
              case i.IntegrationEventTypes.SurveySeen:
                r = "Seen survey";
            }
            return r;
          }
          static handleEvent(e) {
            const {
                trackerNameRegex: t,
                eventType: r,
                pointContent: s,
                surveyName: i,
                pointResponses: n,
                interaction: a
              } = e,
              u = this.getActionName(r, s);
            if (!u) return;
            const l = this.getCategoryName(i),
              c = n,
              d = {},
              v = {};
            d.event_category = l, d.non_interaction = !a, c && (d.event_label = c);
            const p = o.getGA4MatchingDataStreams(t);
            (null == p ? void 0 : p.length) && (d.send_to = p), window.google_tag_manager && Object.keys(window.google_tag_manager).some(e => e.startsWith("GTM-")) && "function" != typeof window.gtag && window.dataLayer && (window.gtag = function () {
              window.dataLayer.push(arguments);
            }), "function" == typeof window.gtag && window.gtag("event", u, d), "function" == typeof window.ga && (v.hitType = "event", v.eventCategory = l, v.eventAction = u, v.nonInteraction = !a, c && (v.eventLabel = c), window.ga(() => {
              o.getGaMatchingTrackers(t).forEach(e => {
                window.ga(`${e}.send`, v);
              });
            }));
          }
          pushEvent(e, t, r) {
            if (this.isEnabled && r && r.google_analytics && r.google_analytics.on_response) {
              let s;
              s = r.google_analytics.anonymize && "anonymizedTextResponse" in t ? t.anonymizedTextResponse : t.textResponse;
              let n = !0;
              e !== i.IntegrationEventTypes.SurveyPointSeen && e !== i.IntegrationEventTypes.SurveySeen || (n = !1), o.handleEvent({
                eventType: e,
                interaction: n,
                pointContent: t.question,
                pointResponses: s,
                surveyName: t.surveyName,
                trackerNameRegex: this.trackerRegex
              });
            }
          }
        }
        t.default = new o();
      },
      328: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => {
          const t = /^\/(.*)\/(.*)$/;
          if (!e) return null;
          let r = e;
          t.test(r) || (r = `/${r}/`);
          const s = t.exec(r),
            i = s ? s[1] : "",
            n = s ? s[2] : void 0;
          try {
            r = new RegExp(i, n);
          } catch (e) {
            return null;
          }
          return r;
        };
      },
      1394: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(9902),
          n = r(8656),
          o = s(r(974)),
          a = s(r(1778)),
          u = s(r(6042)),
          l = s(r(5898)),
          c = s(r(468)),
          d = [{
            classInstance: u.default,
            name: n.IntegrationNames.Segment
          }, {
            classInstance: a.default,
            name: n.IntegrationNames.GoogleAnalytics
          }, {
            classInstance: c.default,
            name: n.IntegrationNames.Woopra
          }, {
            classInstance: o.default,
            name: n.IntegrationNames.Fullstory
          }, {
            classInstance: l.default,
            name: n.IntegrationNames.Smartlook
          }];
        t.default = class {
          static pushEvent(e, t, r) {
            d.forEach(({
              name: s,
              classInstance: o
            }) => {
              const a = s === n.IntegrationNames.GoogleAnalytics ? e : i.EventNamesMap[s][e];
              o.pushEvent(a, t, r);
            });
          }
        };
      },
      6042: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SegmentEvents = void 0;
        const s = r(1263);
        var i;
        !function (e) {
          e.SurveySeen = "survicate_survey_shown", e.SurveyPointAnswered = "survicate_survey_answered";
        }(i || (t.SegmentEvents = i = {}));
        class n {
          constructor() {
            this.isEnabledPerWorkspace = !1;
          }
          init() {
            this.isEnabledPerWorkspace = !0;
          }
          pushEvent(e, t) {
            if (window.analytics && this.isEnabledPerWorkspace) {
              if (e === i.SurveyPointAnswered) {
                if ("contactForm" in t) return void n.identify(t.contactForm);
                n.trackAnswered(t);
              }
              e === i.SurveySeen && n.trackSurveySeen(t.surveyName);
            }
          }
          static identify(e) {
            window.analytics.identify(e);
          }
          static trackAnswered(e) {
            e.pointType !== s.SurveyPointType.question ? window.analytics.track(i.SurveyPointAnswered, {
              survey: e.surveyName,
              question: e.question,
              answer: e.textResponse,
              type: e.pointType,
              user_tag: e.user_tag
            }) : window.analytics.track(i.SurveyPointAnswered, {
              survey: e.surveyName,
              question: e.question,
              answer: e.textResponse,
              type: e.pointType,
              answer_type: e.answer_type
            });
          }
          static trackSurveySeen(e) {
            window.analytics.track(i.SurveySeen, {
              survey: e
            });
          }
        }
        t.default = new n();
      },
      5898: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SmartlookEvents = void 0, function (e) {
          e.SurveyPointAnswered = "survicate.questionAnswered";
        }(r || (t.SmartlookEvents = r = {}));
        t.default = new class {
          constructor() {
            this.isEnabled = !1;
          }
          init() {
            this.isEnabled = !0;
          }
          pushEvent(e, t) {
            if (window.smartlook && this.isEnabled && e === r.SurveyPointAnswered) {
              const e = t;
              if ("function" != typeof window.smartlook) return;
              window.smartlook("track", r.SurveyPointAnswered, {
                answer: e.textResponse,
                question: e.question,
                response_uuid: t.response_uuid,
                "survey.id": t.survey.id,
                "survey.name": e.surveyName
              });
            }
          }
        }();
      },
      468: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.WoopraEvents = void 0;
        const s = r(1263);
        var i;
        !function (e) {
          e.SurveySeen = "survicate survey shown", e.SurveyPointAnswered = "survicate survey answered";
        }(i || (t.WoopraEvents = i = {}));
        class n {
          constructor() {
            this.isEnabledPerWorkspace = !1;
          }
          init() {
            this.isEnabledPerWorkspace = !0;
          }
          pushEvent(e, t) {
            if (window.woopra && this.isEnabledPerWorkspace) {
              if (e === i.SurveyPointAnswered) {
                if ("contactForm" in t) return void n.identify(t.contactForm);
                n.trackAnswered(t);
              }
              e === i.SurveySeen && n.trackSurveySeen(t.surveyName);
            }
          }
          static identify(e) {
            window.woopra.identify(e).push();
          }
          static trackAnswered(e) {
            e.pointType !== s.SurveyPointType.question ? window.woopra.track(i.SurveyPointAnswered, {
              answer: e.textResponse,
              question: e.question,
              survey: e.surveyName,
              type: e.pointType,
              user_tag: e.user_tag
            }) : window.woopra.track(i.SurveyPointAnswered, {
              answer: e.textResponse,
              answer_type: e.answer_type,
              question: e.question,
              survey: e.surveyName,
              type: e.pointType
            });
          }
          static trackSurveySeen(e) {
            window.woopra.track(i.SurveySeen, {
              survey: e
            });
          }
        }
        t.default = new n();
      },
      1960: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getAPIToAnsweredIntegrations = void 0;
        const s = r(3124);
        t.getAPIToAnsweredIntegrations = ({
          fullstory: e,
          sessionCam: t,
          smartlook: r
        }) => {
          const i = {};
          let n = !1;
          if (e) {
            const e = window.FS && "function" == typeof window.FS.getCurrentSessionURL && window.FS.getCurrentSessionURL(!0) || void 0;
            e && (i[s.AnsweredIntegration.fullstory] = e, n = !0);
          }
          if (t) {
            const e = window.sessionCamRecorder && "function" == typeof window.sessionCamRecorder.sessionId && window.sessionCamRecorder.sessionId() || void 0;
            e && (i[s.AnsweredIntegration.sessionCam] = e, n = !0);
          }
          if (r) {
            const e = null === (o = window.smartlook) || void 0 === o ? void 0 : o.playUrl;
            e && (i[s.AnsweredIntegration.smartlook] = e, n = !0);
          }
          var o;
          return n ? i : null;
        };
      },
      6528: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.setIdentitiesFromURL = t.isIdentityProvider = void 0;
        const i = r(3694),
          n = r(3306),
          o = s(r(2240));
        t.isIdentityProvider = e => i.IdentityProvidersArray.includes(e);
        t.setIdentitiesFromURL = (e, r, s) => {
          const a = e[n.ReservedParams.p];
          if (!a || !(0, t.isIdentityProvider)(a)) return;
          const u = (e => {
            const t = {};
            return Object.keys(e).filter(t => {
              const r = !(t in n.ReservedParams) || t === n.ReservedParams.uid,
                s = !e[t].match(/{{.*}}/);
              return r && s;
            }).forEach(r => {
              t[r] = e[r];
            }), t;
          })(e);
          Object.keys(u).forEach(e => {
            if (e === n.ReservedParams.uid && a === i.Providers.Intercom) return void s.action(o.default)({
              identityProvider: i.Providers.Intercom,
              key: "user_id",
              value: u[e]
            }, s);
            if (e === i.USER_ID_TRAIT || e === n.ReservedParams.uid) return void s.action(o.default)({
              identityProvider: i.Providers.Api,
              key: "id",
              value: u[e]
            }, s);
            const t = (r.find(e => e.provider === a) || {
              whitelist: []
            }).whitelist || [];
            (i.PROVIDERS_TRAITS_WHITELIST[a] || []).concat(t).includes(e) && s.action(o.default)({
              identityProvider: a,
              key: e,
              value: u[e]
            }, s);
          });
        };
      },
      5033: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.setIdentityFromCookie = void 0;
        const i = s(r(2733)),
          n = r(8656),
          o = s(r(2240)),
          a = {
            [n.IntegrationNames.Hubspot]: "hubspotutk",
            [n.IntegrationNames.Marketo]: "_mkto_trk"
          },
          u = {
            [n.IntegrationNames.Pardot]: /^visitor_id[0-9]+$/g
          },
          l = {
            [n.IntegrationNames.Hubspot]: "cookie",
            [n.IntegrationNames.Marketo]: "cookie",
            [n.IntegrationNames.Pardot]: "visitor_id"
          };
        t.setIdentityFromCookie = (e, t) => {
          e !== n.IntegrationNames.Pardot ? ((e, t) => {
            const r = i.default.get(a[e]);
            r && t.action(o.default)({
              identityProvider: e,
              key: l[e],
              value: r
            }, t);
          })(e, t) : ((e, t) => {
            Object.keys(i.default.get()).forEach(r => {
              u[e].test(r) && t.action(o.default)({
                identityProvider: e,
                key: l[e],
                value: i.default.get(r)
              }, t);
            });
          })(e, t);
        };
      },
      2158: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getAttributesFromURL = void 0;
        const s = r(3306);
        t.getAttributesFromURL = e => {
          const t = {};
          return Object.keys(e).forEach(r => {
            Object.values(s.ReservedParams).includes(r) || (t[r] = e[r]);
          }), t;
        };
      },
      4395: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(9636);
        t.default = ({
          storageService: e,
          isKioskMode: t
        }, r, i) => {
          i.setState({
            visitor: r
          }), t || null == e || e.put({
            key: s.StorageTableKeys.visitor,
            table: s.StorageTables.all
          }, r);
        };
      },
      5032: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.setIdentitiesFromWindow = void 0;
        const i = r(3694),
          n = r(8656),
          o = s(r(2240));
        t.setIdentitiesFromWindow = (e, t) => {
          var r, s, a, u, l;
          const c = (null === (r = window.amplitude) || void 0 === r ? void 0 : r.getInstance) && (null === (a = null === (s = window.amplitude) || void 0 === s ? void 0 : s.getInstance().options) || void 0 === a ? void 0 : a.userId),
            d = (null === (u = window.mixpanel) || void 0 === u ? void 0 : u.get_distinct_id) && (null === (l = window.mixpanel) || void 0 === l ? void 0 : l.get_distinct_id()),
            v = e.map(({
              provider: e,
              enabled: t
            }) => {
              if (e && t) return e;
            });
          v.includes(n.IntegrationNames.Amplitude) && c && t.action(o.default)({
            identityProvider: i.Providers.Amplitude,
            key: "user_id",
            value: c
          }, t), v.includes(n.IntegrationNames.Mixpanel) && d && t.action(o.default)({
            identityProvider: i.Providers.Mixpanel,
            key: "distinct_id",
            value: d
          }, t);
        };
      },
      2240: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(4395));
        t.default = (e, {
          identityProvider: t,
          key: r,
          value: s
        }, n) => {
          const o = Object.assign({}, e.visitor),
            a = Object.assign({}, o.identities);
          a[t] = Object.assign(Object.assign({}, a[t]), {
            [r]: s
          }), o.identities = a, n.action(i.default)(o, n);
        };
      },
      8621: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.setIdentitiesFromSVA = void 0;
        const i = r(3694),
          n = s(r(2240)),
          o = r(6528);
        t.setIdentitiesFromSVA = (e, t = {}, r = {}, s) => {
          Object.keys(t).forEach(r => {
            if (!(0, o.isIdentityProvider)(r)) return;
            const a = t[r];
            Object.keys(a).forEach(t => {
              const o = (e.find(e => e.provider === r) || {
                whitelist: []
              }).whitelist || [];
              (i.PROVIDERS_TRAITS_WHITELIST[r] || []).concat(o).includes(t) && s.action(n.default)({
                identityProvider: r,
                key: t,
                value: a[t]
              }, s);
            });
          }), r[i.USER_ID_TRAIT] && s.action(n.default)({
            identityProvider: i.Providers.Api,
            key: "id",
            value: r[i.USER_ID_TRAIT]
          }, s);
        };
      },
      7885: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(8656),
          n = s(r(8054)),
          o = s(r(974)),
          a = s(r(1778)),
          u = s(r(6042)),
          l = s(r(5898)),
          c = s(r(468)),
          d = r(1960),
          v = r(5033),
          p = r(5032),
          _ = r(8621),
          f = r(6528);
        t.default = class {
          constructor() {
            this.integrations = [];
          }
          init(e = [], t, r) {
            this.integrations = e;
            const s = window._sva && window._sva.integrations || {},
              d = window._sva && window._sva.traits || {};
            (0, f.setIdentitiesFromURL)(t, this.integrations, r), (0, _.setIdentitiesFromSVA)(this.integrations, s, d, r), (0, p.setIdentitiesFromWindow)(this.integrations, r), this.integrations.forEach(e => {
              if (e.enabled) switch (e.provider) {
                case i.IntegrationNames.Marketo:
                case i.IntegrationNames.Hubspot:
                case i.IntegrationNames.Pardot:
                  setTimeout(() => {
                    (0, v.setIdentityFromCookie)(e.provider, r);
                  }, 5e3);
                  break;
                case i.IntegrationNames.GoogleAnalytics:
                  a.default.init(e);
                  break;
                case i.IntegrationNames.Fullstory:
                  o.default.init();
                  break;
                case i.IntegrationNames.Segment:
                  u.default.init();
                  break;
                case i.IntegrationNames.Woopra:
                  c.default.init();
                  break;
                case i.IntegrationNames.ABTesting:
                  n.default.init(e);
                  break;
                case i.IntegrationNames.Smartlook:
                  l.default.init();
              }
            });
          }
          getAPIToAnsweredJsonIntegrations() {
            const e = this.integrations.find(e => e.provider === i.IntegrationNames.Fullstory),
              t = this.integrations.find(e => e.provider === i.IntegrationNames.SessionCam),
              r = this.integrations.find(e => e.provider === i.IntegrationNames.Smartlook);
            return (0, d.getAPIToAnsweredIntegrations)({
              fullstory: !(!e || !e.enabled),
              sessionCam: !(!t || !t.enabled),
              smartlook: !(!r || !r.enabled)
            });
          }
        };
      },
      3124: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.AnsweredIntegration = void 0, function (e) {
          e.fullstory = "fullstory_url", e.sessionCam = "sessioncam_id", e.smartlook = "smartlook_url";
        }(r || (t.AnsweredIntegration = r = {}));
      },
      3694: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.USER_ID_TRAIT = t.PROVIDERS_TRAITS_WHITELIST = t.IdentityProvidersArray = t.Providers = void 0;
        const s = r(8656);
        var i;
        !function (e) {
          e.Intercom = "intercom", e.Api = "api", e.Salesforce = "salesforce", e.CustomerIO = "customerio", e.Vero = "vero", e.Boomtrain = "boomtrain", e.Amplitude = "amplitude", e.Mixpanel = "mixpanel";
        }(i || (t.Providers = i = {})), t.IdentityProvidersArray = [i.Intercom, i.Api, i.Salesforce, i.CustomerIO, i.Vero, i.Boomtrain, s.IntegrationNames.Marketo, s.IntegrationNames.Hubspot, s.IntegrationNames.Pardot, s.IntegrationNames.Zendesk], t.PROVIDERS_TRAITS_WHITELIST = {
          api: ["id"],
          intercom: ["user_id"],
          marketo: ["lead_id"],
          pardot: ["prospect_id"],
          salesforce: ["contact_id", "lead_id", "account_id", "case_id", "case_number", "event_id", "opportunity_id", "contract_id", "event_name", "event_location"],
          zendesk: ["t_id"]
        }, t.USER_ID_TRAIT = "user_id";
      },
      6890: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.FullStoryEvents = void 0, function (e) {
          e.SurveyPointAnswered = "Survicate question answered";
        }(r || (t.FullStoryEvents = r = {}));
      },
      9902: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.EventNamesMap = t.IntegrationEventTypes = void 0;
        const s = r(6890),
          i = r(8656),
          n = r(1798),
          o = r(1158),
          a = r(8880);
        var u;
        !function (e) {
          e.SurveyMinimized = "SurveyMinimized", e.SurveyClosed = "SurveyClosed", e.SurveyMaximized = "SurveyMaximized", e.SurveySeen = "SurveySeen", e.SurveyPointAnswered = "SurveyPointAnswered", e.SurveyPointSeen = "SurveyPointSeen";
        }(u || (t.IntegrationEventTypes = u = {})), t.EventNamesMap = {
          [i.IntegrationNames.Woopra]: {
            [u.SurveySeen]: a.WoopraEvents.SurveySeen,
            [u.SurveyPointAnswered]: a.WoopraEvents.SurveyPointAnswered
          },
          [i.IntegrationNames.Segment]: {
            [u.SurveySeen]: n.SegmentEvents.SurveySeen,
            [u.SurveyPointAnswered]: n.SegmentEvents.SurveyPointAnswered
          },
          [i.IntegrationNames.Fullstory]: {
            [u.SurveyPointAnswered]: s.FullStoryEvents.SurveyPointAnswered
          },
          [i.IntegrationNames.Smartlook]: {
            [u.SurveyPointAnswered]: o.SmartlookEvents.SurveyPointAnswered
          }
        };
      },
      8656: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.IntegrationNames = void 0, function (e) {
          e.Marketo = "marketo", e.Hubspot = "hubspot", e.Pardot = "pardot", e.GoogleAnalytics = "google_analytics", e.Segment = "segment", e.Woopra = "woopra", e.SessionCam = "sessioncam", e.Fullstory = "fullstory", e.ABTesting = "ab_testing", e.Optimizely = "optimizely", e.Intercom = "intercom20", e.Zendesk = "zendesk", e.Mixpanel = "mixpanel", e.Amplitude = "amplitude", e.Smartlook = "smartlook";
        }(r || (t.IntegrationNames = r = {}));
      },
      1798: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SegmentEvents = void 0, function (e) {
          e.SurveySeen = "survicate_survey_shown", e.SurveyPointAnswered = "survicate_survey_answered";
        }(r || (t.SegmentEvents = r = {}));
      },
      1158: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SmartlookEvents = void 0, function (e) {
          e.SurveyPointAnswered = "survicate.questionAnswered";
        }(r || (t.SmartlookEvents = r = {}));
      },
      8880: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.WoopraEvents = void 0, function (e) {
          e.SurveySeen = "survicate survey shown", e.SurveyPointAnswered = "survicate survey answered";
        }(r || (t.WoopraEvents = r = {}));
      },
      9636: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.StorageTableKeys = t.StorageTables = void 0, function (e) {
          e.requests = "requests", e.status = "status", e.all = "all";
        }(r || (t.StorageTables = r = {})), function (e) {
          e.visitor = "visitor", e.requestHandler = "requestHandler";
        }(s || (t.StorageTableKeys = s = {}));
      },
      1263: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyPointType = void 0, function (e) {
          e.question = "SurveyQuestion", e.nps = "SurveyNps", e.form = "SurveyForm", e.cta = "SurveyCta";
        }(r || (t.SurveyPointType = r = {}));
      },
      3306: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ReservedParams = void 0, function (e) {
          e.aid = "aid", e.multiple_responses = "multiple_responses", e.sid = "sid", e.uid = "uid", e.p = "p", e.autofocus = "autofocus";
        }(r || (t.ReservedParams = r = {}));
      },
      6880: function (e) {
        e.exports = function (e) {
          var t = {};
          function r(s) {
            if (t[s]) return t[s].exports;
            var i = t[s] = {
              i: s,
              l: !1,
              exports: {}
            };
            return e[s].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
          }
          return r.m = e, r.c = t, r.d = function (e, t, s) {
            r.o(e, t) || Object.defineProperty(e, t, {
              enumerable: !0,
              get: s
            });
          }, r.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
              value: "Module"
            }), Object.defineProperty(e, "__esModule", {
              value: !0
            });
          }, r.t = function (e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var s = Object.create(null);
            if (r.r(s), Object.defineProperty(s, "default", {
              enumerable: !0,
              value: e
            }), 2 & t && "string" != typeof e) for (var i in e) r.d(s, i, function (t) {
              return e[t];
            }.bind(null, i));
            return s;
          }, r.n = function (e) {
            var t = e && e.__esModule ? function () {
              return e.default;
            } : function () {
              return e;
            };
            return r.d(t, "a", t), t;
          }, r.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }, r.p = "", r(r.s = 90);
        }({
          17: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.default = void 0;
            var s = r(18),
              i = function () {
                function e() {}
                return e.getFirstMatch = function (e, t) {
                  var r = t.match(e);
                  return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function (e, t) {
                  var r = t.match(e);
                  return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function (e, t, r) {
                  if (e.test(t)) return r;
                }, e.getWindowsVersionName = function (e) {
                  switch (e) {
                    case "NT":
                      return "NT";
                    case "XP":
                    case "NT 5.1":
                      return "XP";
                    case "NT 5.0":
                      return "2000";
                    case "NT 5.2":
                      return "2003";
                    case "NT 6.0":
                      return "Vista";
                    case "NT 6.1":
                      return "7";
                    case "NT 6.2":
                      return "8";
                    case "NT 6.3":
                      return "8.1";
                    case "NT 10.0":
                      return "10";
                    default:
                      return;
                  }
                }, e.getMacOSVersionName = function (e) {
                  var t = e.split(".").splice(0, 2).map(function (e) {
                    return parseInt(e, 10) || 0;
                  });
                  if (t.push(0), 10 === t[0]) switch (t[1]) {
                    case 5:
                      return "Leopard";
                    case 6:
                      return "Snow Leopard";
                    case 7:
                      return "Lion";
                    case 8:
                      return "Mountain Lion";
                    case 9:
                      return "Mavericks";
                    case 10:
                      return "Yosemite";
                    case 11:
                      return "El Capitan";
                    case 12:
                      return "Sierra";
                    case 13:
                      return "High Sierra";
                    case 14:
                      return "Mojave";
                    case 15:
                      return "Catalina";
                    default:
                      return;
                  }
                }, e.getAndroidVersionName = function (e) {
                  var t = e.split(".").splice(0, 2).map(function (e) {
                    return parseInt(e, 10) || 0;
                  });
                  if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function (e) {
                  return e.split(".").length;
                }, e.compareVersions = function (t, r, s) {
                  void 0 === s && (s = !1);
                  var i = e.getVersionPrecision(t),
                    n = e.getVersionPrecision(r),
                    o = Math.max(i, n),
                    a = 0,
                    u = e.map([t, r], function (t) {
                      var r = o - e.getVersionPrecision(t),
                        s = t + new Array(r + 1).join(".0");
                      return e.map(s.split("."), function (e) {
                        return new Array(20 - e.length).join("0") + e;
                      }).reverse();
                    });
                  for (s && (a = o - Math.min(i, n)), o -= 1; o >= a;) {
                    if (u[0][o] > u[1][o]) return 1;
                    if (u[0][o] === u[1][o]) {
                      if (o === a) return 0;
                      o -= 1;
                    } else if (u[0][o] < u[1][o]) return -1;
                  }
                }, e.map = function (e, t) {
                  var r,
                    s = [];
                  if (Array.prototype.map) return Array.prototype.map.call(e, t);
                  for (r = 0; r < e.length; r += 1) s.push(t(e[r]));
                  return s;
                }, e.find = function (e, t) {
                  var r, s;
                  if (Array.prototype.find) return Array.prototype.find.call(e, t);
                  for (r = 0, s = e.length; r < s; r += 1) {
                    var i = e[r];
                    if (t(i, r)) return i;
                  }
                }, e.assign = function (e) {
                  for (var t, r, s = e, i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), o = 1; o < i; o++) n[o - 1] = arguments[o];
                  if (Object.assign) return Object.assign.apply(Object, [e].concat(n));
                  var a = function () {
                    var e = n[t];
                    "object" == typeof e && null !== e && Object.keys(e).forEach(function (t) {
                      s[t] = e[t];
                    });
                  };
                  for (t = 0, r = n.length; t < r; t += 1) a();
                  return e;
                }, e.getBrowserAlias = function (e) {
                  return s.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function (e) {
                  return s.BROWSER_MAP[e] || "";
                }, e;
              }();
            t.default = i, e.exports = t.default;
          },
          18: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
              "Amazon Silk": "amazon_silk",
              "Android Browser": "android",
              Bada: "bada",
              BlackBerry: "blackberry",
              Chrome: "chrome",
              Chromium: "chromium",
              Electron: "electron",
              Epiphany: "epiphany",
              Firefox: "firefox",
              Focus: "focus",
              Generic: "generic",
              "Google Search": "google_search",
              Googlebot: "googlebot",
              "Internet Explorer": "ie",
              "K-Meleon": "k_meleon",
              Maxthon: "maxthon",
              "Microsoft Edge": "edge",
              "MZ Browser": "mz",
              "NAVER Whale Browser": "naver",
              Opera: "opera",
              "Opera Coast": "opera_coast",
              PhantomJS: "phantomjs",
              Puffin: "puffin",
              QupZilla: "qupzilla",
              QQ: "qq",
              QQLite: "qqlite",
              Safari: "safari",
              Sailfish: "sailfish",
              "Samsung Internet for Android": "samsung_internet",
              SeaMonkey: "seamonkey",
              Sleipnir: "sleipnir",
              Swing: "swing",
              Tizen: "tizen",
              "UC Browser": "uc",
              Vivaldi: "vivaldi",
              "WebOS Browser": "webos",
              WeChat: "wechat",
              "Yandex Browser": "yandex",
              Roku: "roku"
            }, t.BROWSER_MAP = {
              amazon_silk: "Amazon Silk",
              android: "Android Browser",
              bada: "Bada",
              blackberry: "BlackBerry",
              chrome: "Chrome",
              chromium: "Chromium",
              electron: "Electron",
              epiphany: "Epiphany",
              firefox: "Firefox",
              focus: "Focus",
              generic: "Generic",
              googlebot: "Googlebot",
              google_search: "Google Search",
              ie: "Internet Explorer",
              k_meleon: "K-Meleon",
              maxthon: "Maxthon",
              edge: "Microsoft Edge",
              mz: "MZ Browser",
              naver: "NAVER Whale Browser",
              opera: "Opera",
              opera_coast: "Opera Coast",
              phantomjs: "PhantomJS",
              puffin: "Puffin",
              qupzilla: "QupZilla",
              qq: "QQ Browser",
              qqlite: "QQ Browser Lite",
              safari: "Safari",
              sailfish: "Sailfish",
              samsung_internet: "Samsung Internet for Android",
              seamonkey: "SeaMonkey",
              sleipnir: "Sleipnir",
              swing: "Swing",
              tizen: "Tizen",
              uc: "UC Browser",
              vivaldi: "Vivaldi",
              webos: "WebOS Browser",
              wechat: "WeChat",
              yandex: "Yandex Browser"
            }, t.PLATFORMS_MAP = {
              tablet: "tablet",
              mobile: "mobile",
              desktop: "desktop",
              tv: "tv"
            }, t.OS_MAP = {
              WindowsPhone: "Windows Phone",
              Windows: "Windows",
              MacOS: "macOS",
              iOS: "iOS",
              Android: "Android",
              WebOS: "WebOS",
              BlackBerry: "BlackBerry",
              Bada: "Bada",
              Tizen: "Tizen",
              Linux: "Linux",
              ChromeOS: "Chrome OS",
              PlayStation4: "PlayStation 4",
              Roku: "Roku"
            }, t.ENGINE_MAP = {
              EdgeHTML: "EdgeHTML",
              Blink: "Blink",
              Trident: "Trident",
              Presto: "Presto",
              Gecko: "Gecko",
              WebKit: "WebKit"
            };
          },
          90: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.default = void 0;
            var s,
              i = (s = r(91)) && s.__esModule ? s : {
                default: s
              },
              n = r(18);
            function o(e, t) {
              for (var r = 0; r < t.length; r++) {
                var s = t[r];
                s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
              }
            }
            var a = function () {
              function e() {}
              var t, r, s;
              return e.getParser = function (e, t) {
                if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                return new i.default(e, t);
              }, e.parse = function (e) {
                return new i.default(e).getResult();
              }, t = e, s = [{
                key: "BROWSER_MAP",
                get: function () {
                  return n.BROWSER_MAP;
                }
              }, {
                key: "ENGINE_MAP",
                get: function () {
                  return n.ENGINE_MAP;
                }
              }, {
                key: "OS_MAP",
                get: function () {
                  return n.OS_MAP;
                }
              }, {
                key: "PLATFORMS_MAP",
                get: function () {
                  return n.PLATFORMS_MAP;
                }
              }], (r = null) && o(t.prototype, r), s && o(t, s), e;
            }();
            t.default = a, e.exports = t.default;
          },
          91: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.default = void 0;
            var s = u(r(92)),
              i = u(r(93)),
              n = u(r(94)),
              o = u(r(95)),
              a = u(r(17));
            function u(e) {
              return e && e.__esModule ? e : {
                default: e
              };
            }
            var l = function () {
              function e(e, t) {
                if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
              }
              var t = e.prototype;
              return t.getUA = function () {
                return this._ua;
              }, t.test = function (e) {
                return e.test(this._ua);
              }, t.parseBrowser = function () {
                var e = this;
                this.parsedResult.browser = {};
                var t = a.default.find(s.default, function (t) {
                  if ("function" == typeof t.test) return t.test(e);
                  if (t.test instanceof Array) return t.test.some(function (t) {
                    return e.test(t);
                  });
                  throw new Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
              }, t.getBrowser = function () {
                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
              }, t.getBrowserName = function (e) {
                return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
              }, t.getBrowserVersion = function () {
                return this.getBrowser().version;
              }, t.getOS = function () {
                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
              }, t.parseOS = function () {
                var e = this;
                this.parsedResult.os = {};
                var t = a.default.find(i.default, function (t) {
                  if ("function" == typeof t.test) return t.test(e);
                  if (t.test instanceof Array) return t.test.some(function (t) {
                    return e.test(t);
                  });
                  throw new Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
              }, t.getOSName = function (e) {
                var t = this.getOS().name;
                return e ? String(t).toLowerCase() || "" : t || "";
              }, t.getOSVersion = function () {
                return this.getOS().version;
              }, t.getPlatform = function () {
                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
              }, t.getPlatformType = function (e) {
                void 0 === e && (e = !1);
                var t = this.getPlatform().type;
                return e ? String(t).toLowerCase() || "" : t || "";
              }, t.parsePlatform = function () {
                var e = this;
                this.parsedResult.platform = {};
                var t = a.default.find(n.default, function (t) {
                  if ("function" == typeof t.test) return t.test(e);
                  if (t.test instanceof Array) return t.test.some(function (t) {
                    return e.test(t);
                  });
                  throw new Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
              }, t.getEngine = function () {
                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
              }, t.getEngineName = function (e) {
                return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
              }, t.parseEngine = function () {
                var e = this;
                this.parsedResult.engine = {};
                var t = a.default.find(o.default, function (t) {
                  if ("function" == typeof t.test) return t.test(e);
                  if (t.test instanceof Array) return t.test.some(function (t) {
                    return e.test(t);
                  });
                  throw new Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
              }, t.parse = function () {
                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
              }, t.getResult = function () {
                return a.default.assign({}, this.parsedResult);
              }, t.satisfies = function (e) {
                var t = this,
                  r = {},
                  s = 0,
                  i = {},
                  n = 0;
                if (Object.keys(e).forEach(function (t) {
                  var o = e[t];
                  "string" == typeof o ? (i[t] = o, n += 1) : "object" == typeof o && (r[t] = o, s += 1);
                }), s > 0) {
                  var o = Object.keys(r),
                    u = a.default.find(o, function (e) {
                      return t.isOS(e);
                    });
                  if (u) {
                    var l = this.satisfies(r[u]);
                    if (void 0 !== l) return l;
                  }
                  var c = a.default.find(o, function (e) {
                    return t.isPlatform(e);
                  });
                  if (c) {
                    var d = this.satisfies(r[c]);
                    if (void 0 !== d) return d;
                  }
                }
                if (n > 0) {
                  var v = Object.keys(i),
                    p = a.default.find(v, function (e) {
                      return t.isBrowser(e, !0);
                    });
                  if (void 0 !== p) return this.compareVersion(i[p]);
                }
              }, t.isBrowser = function (e, t) {
                void 0 === t && (t = !1);
                var r = this.getBrowserName().toLowerCase(),
                  s = e.toLowerCase(),
                  i = a.default.getBrowserTypeByAlias(s);
                return t && i && (s = i.toLowerCase()), s === r;
              }, t.compareVersion = function (e) {
                var t = [0],
                  r = e,
                  s = !1,
                  i = this.getBrowserVersion();
                if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (s = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (s = !0, r = e.substr(1)), t.indexOf(a.default.compareVersions(i, r, s)) > -1;
              }, t.isOS = function (e) {
                return this.getOSName(!0) === String(e).toLowerCase();
              }, t.isPlatform = function (e) {
                return this.getPlatformType(!0) === String(e).toLowerCase();
              }, t.isEngine = function (e) {
                return this.getEngineName(!0) === String(e).toLowerCase();
              }, t.is = function (e, t) {
                return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
              }, t.some = function (e) {
                var t = this;
                return void 0 === e && (e = []), e.some(function (e) {
                  return t.is(e);
                });
              }, e;
            }();
            t.default = l, e.exports = t.default;
          },
          92: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.default = void 0;
            var s,
              i = (s = r(17)) && s.__esModule ? s : {
                default: s
              },
              n = /version\/(\d+(\.?_?\d+)+)/i,
              o = [{
                test: [/googlebot/i],
                describe: function (e) {
                  var t = {
                      name: "Googlebot"
                    },
                    r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/opera/i],
                describe: function (e) {
                  var t = {
                      name: "Opera"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/opr\/|opios/i],
                describe: function (e) {
                  var t = {
                      name: "Opera"
                    },
                    r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/SamsungBrowser/i],
                describe: function (e) {
                  var t = {
                      name: "Samsung Internet for Android"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/Whale/i],
                describe: function (e) {
                  var t = {
                      name: "NAVER Whale Browser"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/MZBrowser/i],
                describe: function (e) {
                  var t = {
                      name: "MZ Browser"
                    },
                    r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/focus/i],
                describe: function (e) {
                  var t = {
                      name: "Focus"
                    },
                    r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/swing/i],
                describe: function (e) {
                  var t = {
                      name: "Swing"
                    },
                    r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/coast/i],
                describe: function (e) {
                  var t = {
                      name: "Opera Coast"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/opt\/\d+(?:.?_?\d+)+/i],
                describe: function (e) {
                  var t = {
                      name: "Opera Touch"
                    },
                    r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/yabrowser/i],
                describe: function (e) {
                  var t = {
                      name: "Yandex Browser"
                    },
                    r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/ucbrowser/i],
                describe: function (e) {
                  var t = {
                      name: "UC Browser"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/Maxthon|mxios/i],
                describe: function (e) {
                  var t = {
                      name: "Maxthon"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/epiphany/i],
                describe: function (e) {
                  var t = {
                      name: "Epiphany"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/puffin/i],
                describe: function (e) {
                  var t = {
                      name: "Puffin"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/sleipnir/i],
                describe: function (e) {
                  var t = {
                      name: "Sleipnir"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/k-meleon/i],
                describe: function (e) {
                  var t = {
                      name: "K-Meleon"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/micromessenger/i],
                describe: function (e) {
                  var t = {
                      name: "WeChat"
                    },
                    r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/qqbrowser/i],
                describe: function (e) {
                  var t = {
                      name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                    },
                    r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/msie|trident/i],
                describe: function (e) {
                  var t = {
                      name: "Internet Explorer"
                    },
                    r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/\sedg\//i],
                describe: function (e) {
                  var t = {
                      name: "Microsoft Edge"
                    },
                    r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/edg([ea]|ios)/i],
                describe: function (e) {
                  var t = {
                      name: "Microsoft Edge"
                    },
                    r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/vivaldi/i],
                describe: function (e) {
                  var t = {
                      name: "Vivaldi"
                    },
                    r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/seamonkey/i],
                describe: function (e) {
                  var t = {
                      name: "SeaMonkey"
                    },
                    r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/sailfish/i],
                describe: function (e) {
                  var t = {
                      name: "Sailfish"
                    },
                    r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/silk/i],
                describe: function (e) {
                  var t = {
                      name: "Amazon Silk"
                    },
                    r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/phantom/i],
                describe: function (e) {
                  var t = {
                      name: "PhantomJS"
                    },
                    r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/slimerjs/i],
                describe: function (e) {
                  var t = {
                      name: "SlimerJS"
                    },
                    r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
                describe: function (e) {
                  var t = {
                      name: "BlackBerry"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/(web|hpw)[o0]s/i],
                describe: function (e) {
                  var t = {
                      name: "WebOS Browser"
                    },
                    r = i.default.getFirstMatch(n, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/bada/i],
                describe: function (e) {
                  var t = {
                      name: "Bada"
                    },
                    r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/tizen/i],
                describe: function (e) {
                  var t = {
                      name: "Tizen"
                    },
                    r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/qupzilla/i],
                describe: function (e) {
                  var t = {
                      name: "QupZilla"
                    },
                    r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/firefox|iceweasel|fxios/i],
                describe: function (e) {
                  var t = {
                      name: "Firefox"
                    },
                    r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/electron/i],
                describe: function (e) {
                  var t = {
                      name: "Electron"
                    },
                    r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/MiuiBrowser/i],
                describe: function (e) {
                  var t = {
                      name: "Miui"
                    },
                    r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/chromium/i],
                describe: function (e) {
                  var t = {
                      name: "Chromium"
                    },
                    r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/chrome|crios|crmo/i],
                describe: function (e) {
                  var t = {
                      name: "Chrome"
                    },
                    r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/GSA/i],
                describe: function (e) {
                  var t = {
                      name: "Google Search"
                    },
                    r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: function (e) {
                  var t = !e.test(/like android/i),
                    r = e.test(/android/i);
                  return t && r;
                },
                describe: function (e) {
                  var t = {
                      name: "Android Browser"
                    },
                    r = i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/playstation 4/i],
                describe: function (e) {
                  var t = {
                      name: "PlayStation 4"
                    },
                    r = i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/safari|applewebkit/i],
                describe: function (e) {
                  var t = {
                      name: "Safari"
                    },
                    r = i.default.getFirstMatch(n, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/.*/i],
                describe: function (e) {
                  var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                  return {
                    name: i.default.getFirstMatch(t, e),
                    version: i.default.getSecondMatch(t, e)
                  };
                }
              }];
            t.default = o, e.exports = t.default;
          },
          93: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.default = void 0;
            var s,
              i = (s = r(17)) && s.__esModule ? s : {
                default: s
              },
              n = r(18),
              o = [{
                test: [/Roku\/DVP/],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                  return {
                    name: n.OS_MAP.Roku,
                    version: t
                  };
                }
              }, {
                test: [/windows phone/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                  return {
                    name: n.OS_MAP.WindowsPhone,
                    version: t
                  };
                }
              }, {
                test: [/windows /i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e),
                    r = i.default.getWindowsVersionName(t);
                  return {
                    name: n.OS_MAP.Windows,
                    version: t,
                    versionName: r
                  };
                }
              }, {
                test: [/Macintosh(.*?) FxiOS(.*?)\//],
                describe: function (e) {
                  var t = {
                      name: n.OS_MAP.iOS
                    },
                    r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/macintosh/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."),
                    r = i.default.getMacOSVersionName(t),
                    s = {
                      name: n.OS_MAP.MacOS,
                      version: t
                    };
                  return r && (s.versionName = r), s;
                }
              }, {
                test: [/(ipod|iphone|ipad)/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                  return {
                    name: n.OS_MAP.iOS,
                    version: t
                  };
                }
              }, {
                test: function (e) {
                  var t = !e.test(/like android/i),
                    r = e.test(/android/i);
                  return t && r;
                },
                describe: function (e) {
                  var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e),
                    r = i.default.getAndroidVersionName(t),
                    s = {
                      name: n.OS_MAP.Android,
                      version: t
                    };
                  return r && (s.versionName = r), s;
                }
              }, {
                test: [/(web|hpw)[o0]s/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e),
                    r = {
                      name: n.OS_MAP.WebOS
                    };
                  return t && t.length && (r.version = t), r;
                }
              }, {
                test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                  return {
                    name: n.OS_MAP.BlackBerry,
                    version: t
                  };
                }
              }, {
                test: [/bada/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                  return {
                    name: n.OS_MAP.Bada,
                    version: t
                  };
                }
              }, {
                test: [/tizen/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                  return {
                    name: n.OS_MAP.Tizen,
                    version: t
                  };
                }
              }, {
                test: [/linux/i],
                describe: function () {
                  return {
                    name: n.OS_MAP.Linux
                  };
                }
              }, {
                test: [/CrOS/],
                describe: function () {
                  return {
                    name: n.OS_MAP.ChromeOS
                  };
                }
              }, {
                test: [/PlayStation 4/],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                  return {
                    name: n.OS_MAP.PlayStation4,
                    version: t
                  };
                }
              }];
            t.default = o, e.exports = t.default;
          },
          94: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.default = void 0;
            var s,
              i = (s = r(17)) && s.__esModule ? s : {
                default: s
              },
              n = r(18),
              o = [{
                test: [/googlebot/i],
                describe: function () {
                  return {
                    type: "bot",
                    vendor: "Google"
                  };
                }
              }, {
                test: [/huawei/i],
                describe: function (e) {
                  var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova",
                    r = {
                      type: n.PLATFORMS_MAP.mobile,
                      vendor: "Huawei"
                    };
                  return t && (r.model = t), r;
                }
              }, {
                test: [/nexus\s*(?:7|8|9|10).*/i],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tablet,
                    vendor: "Nexus"
                  };
                }
              }, {
                test: [/ipad/i],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tablet,
                    vendor: "Apple",
                    model: "iPad"
                  };
                }
              }, {
                test: [/Macintosh(.*?) FxiOS(.*?)\//],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tablet,
                    vendor: "Apple",
                    model: "iPad"
                  };
                }
              }, {
                test: [/kftt build/i],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tablet,
                    vendor: "Amazon",
                    model: "Kindle Fire HD 7"
                  };
                }
              }, {
                test: [/silk/i],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tablet,
                    vendor: "Amazon"
                  };
                }
              }, {
                test: [/tablet(?! pc)/i],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tablet
                  };
                }
              }, {
                test: function (e) {
                  var t = e.test(/ipod|iphone/i),
                    r = e.test(/like (ipod|iphone)/i);
                  return t && !r;
                },
                describe: function (e) {
                  var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                  return {
                    type: n.PLATFORMS_MAP.mobile,
                    vendor: "Apple",
                    model: t
                  };
                }
              }, {
                test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.mobile,
                    vendor: "Nexus"
                  };
                }
              }, {
                test: [/[^-]mobi/i],
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.mobile
                  };
                }
              }, {
                test: function (e) {
                  return "blackberry" === e.getBrowserName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.mobile,
                    vendor: "BlackBerry"
                  };
                }
              }, {
                test: function (e) {
                  return "bada" === e.getBrowserName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.mobile
                  };
                }
              }, {
                test: function (e) {
                  return "windows phone" === e.getBrowserName();
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.mobile,
                    vendor: "Microsoft"
                  };
                }
              }, {
                test: function (e) {
                  var t = Number(String(e.getOSVersion()).split(".")[0]);
                  return "android" === e.getOSName(!0) && t >= 3;
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tablet
                  };
                }
              }, {
                test: function (e) {
                  return "android" === e.getOSName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.mobile
                  };
                }
              }, {
                test: function (e) {
                  return "macos" === e.getOSName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.desktop,
                    vendor: "Apple"
                  };
                }
              }, {
                test: function (e) {
                  return "windows" === e.getOSName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.desktop
                  };
                }
              }, {
                test: function (e) {
                  return "linux" === e.getOSName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.desktop
                  };
                }
              }, {
                test: function (e) {
                  return "playstation 4" === e.getOSName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tv
                  };
                }
              }, {
                test: function (e) {
                  return "roku" === e.getOSName(!0);
                },
                describe: function () {
                  return {
                    type: n.PLATFORMS_MAP.tv
                  };
                }
              }];
            t.default = o, e.exports = t.default;
          },
          95: function (e, t, r) {
            "use strict";

            t.__esModule = !0, t.default = void 0;
            var s,
              i = (s = r(17)) && s.__esModule ? s : {
                default: s
              },
              n = r(18),
              o = [{
                test: function (e) {
                  return "microsoft edge" === e.getBrowserName(!0);
                },
                describe: function (e) {
                  if (/\sedg\//i.test(e)) return {
                    name: n.ENGINE_MAP.Blink
                  };
                  var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                  return {
                    name: n.ENGINE_MAP.EdgeHTML,
                    version: t
                  };
                }
              }, {
                test: [/trident/i],
                describe: function (e) {
                  var t = {
                      name: n.ENGINE_MAP.Trident
                    },
                    r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: function (e) {
                  return e.test(/presto/i);
                },
                describe: function (e) {
                  var t = {
                      name: n.ENGINE_MAP.Presto
                    },
                    r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: function (e) {
                  var t = e.test(/gecko/i),
                    r = e.test(/like gecko/i);
                  return t && !r;
                },
                describe: function (e) {
                  var t = {
                      name: n.ENGINE_MAP.Gecko
                    },
                    r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }, {
                test: [/(apple)?webkit\/537\.36/i],
                describe: function () {
                  return {
                    name: n.ENGINE_MAP.Blink
                  };
                }
              }, {
                test: [/(apple)?webkit/i],
                describe: function (e) {
                  var t = {
                      name: n.ENGINE_MAP.WebKit
                    },
                    r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                  return r && (t.version = r), t;
                }
              }];
            t.default = o, e.exports = t.default;
          }
        });
      },
      3469: (e, t, r) => {
        "use strict";

        r.d(t, {
          A: () => a
        });
        var s = r(1601),
          i = r.n(s),
          n = r(6314),
          o = r.n(n)()(i());
        o.push([e.id, '#survicate-box{/*! normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css */}@keyframes shrink-bounce{0%{transform:scale(1)}33%{transform:scale(0.5)}100%{transform:scale(1)}}#survicate-box h1,#survicate-box h2,#survicate-box h3,#survicate-box h4{color:#29292a;font-weight:400;margin:0 0 16px;padding:0}#survicate-box h1,#survicate-box .h1{font-size:24px}#survicate-box h2,#survicate-box .h2{font-size:18px}#survicate-box h3,#survicate-box .h3{font-size:16px}#survicate-box h4,#survicate-box .h4{font-size:14px}#survicate-box .g-row{display:flex;flex-direction:row;box-sizing:border-box;margin-right:-16px;margin-left:-16px;flex-wrap:wrap}#survicate-box div[class*=g-col]{box-sizing:border-box;padding-right:16px;padding-left:16px}#survicate-box .g-col{flex-grow:1;flex-basis:0}#survicate-box .g-col-4{max-width:33.3333333333%;flex-basis:33.3333333333%}#survicate-box html{line-height:1.15;-webkit-text-size-adjust:100%}#survicate-box body{margin:0}#survicate-box h1{font-size:2em;margin:.67em 0}#survicate-box hr{box-sizing:content-box;height:0;overflow:visible}#survicate-box pre{font-family:monospace,monospace;font-size:1em}#survicate-box a{background-color:rgba(0,0,0,0)}#survicate-box abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}#survicate-box b,#survicate-box strong{font-weight:bolder}#survicate-box code,#survicate-box kbd,#survicate-box samp{font-family:monospace,monospace;font-size:1em}#survicate-box small{font-size:80%}#survicate-box sub,#survicate-box sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}#survicate-box sub{bottom:-0.25em}#survicate-box sup{top:-0.5em}#survicate-box img{border-style:none}#survicate-box button,#survicate-box input,#survicate-box optgroup,#survicate-box select,#survicate-box textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}#survicate-box button,#survicate-box input{overflow:visible}#survicate-box button,#survicate-box select{text-transform:none}#survicate-box button,#survicate-box [type=button],#survicate-box [type=reset],#survicate-box [type=submit]{-webkit-appearance:button}#survicate-box button::-moz-focus-inner,#survicate-box [type=button]::-moz-focus-inner,#survicate-box [type=reset]::-moz-focus-inner,#survicate-box [type=submit]::-moz-focus-inner{border-style:none;padding:0}#survicate-box button:-moz-focusring,#survicate-box [type=button]:-moz-focusring,#survicate-box [type=reset]:-moz-focusring,#survicate-box [type=submit]:-moz-focusring{outline:1px dotted ButtonText}#survicate-box fieldset{padding:.35em .75em .625em}#survicate-box legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}#survicate-box progress{vertical-align:baseline}#survicate-box textarea{overflow:auto}#survicate-box [type=checkbox],#survicate-box [type=radio]{box-sizing:border-box;padding:0}#survicate-box [type=number]::-webkit-inner-spin-button,#survicate-box [type=number]::-webkit-outer-spin-button{height:auto}#survicate-box [type=search]{-webkit-appearance:textfield;outline-offset:-2px}#survicate-box [type=search]::-webkit-search-decoration{-webkit-appearance:none}#survicate-box ::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}#survicate-box details{display:block}#survicate-box summary{display:list-item}#survicate-box template{display:none}#survicate-box [hidden]{display:none}#survicate-box .sv__answer-hint{font-size:12px;line-height:20px;margin-bottom:8px}#survicate-box .sv__answer-hint+.sv__choice-button-wrapper{margin-top:8px}#survicate-box .sv__multiple-choice .sv__answer-hint,#survicate-box .sv__single-choice .sv__answer-hint{font-size:14px}#survicate-box .sv__multiple-choice .sv__answer-hint--small,#survicate-box .sv__single-choice .sv__answer-hint--small{font-size:12px;margin-bottom:0}#survicate-box .sv__footer{display:inline-block;font-size:11px;padding-bottom:0;padding-left:5px;padding-right:5px;padding-top:0}#survicate-box .sv__footer__wrapper{display:flex}#survicate-box .sv__labels{display:flex;justify-content:space-between;margin-bottom:20px;margin-left:0;margin-right:0;margin-top:20px}#survicate-box .sv__labels .sv__label{font-size:12px}#survicate-box .sv__labels .sv__label--left{margin-right:5px}#survicate-box .sv__labels .sv__label--right{margin-left:5px}#survicate-box .sv__progress-bar{height:4px;left:0;position:absolute;top:0;width:100%}#survicate-box .sv__progress-bar>div{height:100%}#survicate-box .sv__position{margin:0 10px 0 20px}#survicate-box .sv__opened-in-new-tab{align-items:center;display:flex;flex-direction:column;height:100vh;justify-content:center;text-align:center}:host #survicate-box .sv__opened-in-new-tab{height:100%}#survicate-box .sv__opened-in-new-tab p{font-size:21px}#survicate-box .sv__branded-footer,#survicate-box .sv__branded-footer__content{align-items:center;display:flex}#survicate-box .sv__branded-footer{justify-content:center}#survicate-box .sv__branded-footer::before{border-top:1px solid #c2cbcb;content:"";left:24px;position:absolute;transform:translateY(-39px);width:calc(100% - 48px)}#survicate-box .sv__branded-footer__content{transform:translateX(16px)}#survicate-box .sv__branded-footer__content .sv__branded-footer__text{color:#7f8c8d;font-size:12px}#survicate-box .sv__branded-footer__content .sv__survicate-wordmark{height:10px}#survicate-box .sv__survey-status-view--with-branding .sv__branded-footer{background-color:#fff;bottom:0;height:72px;overflow:hidden;position:fixed;width:100%;z-index:1}:host #survicate-box .sv__survey-status-view--with-branding .sv__branded-footer{bottom:calc(var(--root-element-bottom, 0px) + 0px)}#survicate-box .sv__survey-status-view--with-branding .sv__branded-footer .sv__survicate-wordmark{transform:translateX(-8px)}#survicate-box .sv__survey-status-view--with-branding .sv__branded-footer .sv__arrow-forward{height:12px;transform:translate(-24px, 1px)}#survicate-box .sv__micro-theme.sv__survey--button_link .sv__branded-footer::before{border-top-style:hidden}#survicate-box .sv__micro-theme.sv__position-mobile .sv__footer__wrapper.sv__branded-footer--with-border{border-bottom-left-radius:unset;border-bottom-right-radius:unset}#survicate-box .sv__micro-theme .sv__footer__wrapper.sv__branded-footer--with-border{background-color:#fff;border-bottom-left-radius:10px;border-bottom-right-radius:10px;padding-bottom:24px;padding-left:0;padding-right:0;padding-top:23px;transform:translateY(16px);width:100%}#survicate-box .sv__micro-theme .sv__footer__wrapper .sv__branded-footer{padding-bottom:8px;padding-top:8px;position:unset}#survicate-box .sv__micro-theme .sv__footer__wrapper .sv__branded-footer .sv__survicate-wordmark{transform:translate(-8px, 0px)}#survicate-box .sv__micro-theme .sv__footer__wrapper .sv__branded-footer .sv__arrow-forward{height:14px;transform:translate(-24px, 1px)}#survicate-box .sv__choice-button{overflow-wrap:break-word}#survicate-box .sv__rtl-lang .sv__choice-button-wrapper .sv__choice-button{text-align:right}#survicate-box .sv__date{border-color:rgba(0,0,0,0);border-radius:6px;border-style:solid;border-width:2px;display:block;justify-content:flex-start}#survicate-box .sv__date__input{background-color:rgba(0,0,0,0);border:none;font-weight:400}#survicate-box .sv__date__input:focus{border-color:rgba(0,0,0,0) !important}#survicate-box .sv__date.sv__invalid{background-color:#ffedea;border-style:solid;border-width:2px}#survicate-box .sv__date.sv__invalid.focused{border-color:#e33a22 !important}#survicate-box .sv__date.sv__invalid .sv__date__input{background-color:rgba(0,0,0,0)}#survicate-box .sv__dropdown__wrapper{margin-bottom:0px;margin-left:auto;margin-right:auto;margin-top:25px;position:relative}#survicate-box .sv__dropdown__wrapper .sv__select-buttons .sv__select-icon{align-items:center;display:flex;height:44px;justify-content:center;right:0px;top:2px;width:46px}#survicate-box .sv__dropdown__wrapper .sv__select-buttons .sv__select-icon.sv__select__clear-input{right:0;top:0}#survicate-box .sv__dropdown__wrapper .sv__select input{cursor:text}#survicate-box .sv__dropdown__wrapper .sv__select input:focus{padding:14px}#survicate-box .sv__dropdown__wrapper .sv__select input,#survicate-box .sv__dropdown__wrapper .sv__select input:focus{padding-right:48px;text-overflow:ellipsis}#survicate-box .sv__dropdown__wrapper .sv__select .sv__caret svg{transform:scale(1.5)}#survicate-box .sv__dropdown__wrapper .sv__select--open .sv__caret svg{transform:scale(1.5) rotate(180deg) translateY(2px)}#survicate-box .sv__dropdown__wrapper .sv__select .sv__select-list{margin-top:8px}#survicate-box .sv__dropdown__wrapper .sv__validation{top:11px}@media(max-width: 1181px){#survicate-box .sv-box-child .sv__dropdown__wrapper .sv__validation{top:-26px}}#survicate-box .sv__nps .sv__buttons{display:flex;justify-content:space-between}#survicate-box .sv__nps--vertical{margin:auto;width:100%}#survicate-box .sv__rating{text-align:center}#survicate-box .sv__rating__wrapper{flex-direction:column;margin-bottom:0;margin-left:auto;margin-right:auto;margin-top:0}#survicate-box .sv__rating__wrapper .sv__buttons{flex-direction:row}#survicate-box .sv__rating__wrapper .sv__buttons .sv__button{background:none;margin-bottom:0;margin-top:0;padding:0}#survicate-box .sv__rating__wrapper .sv__buttons .sv__button:first-child{margin-left:0}#survicate-box .sv__rating__wrapper .sv__buttons .sv__button:last-child{margin-right:0}#survicate-box .sv__rating__wrapper .sv__buttons .sv__button--selected{border:none}#survicate-box .sv__rating__number{font-weight:400}#survicate-box .sv__smiley-scale{margin:auto;text-align:center}#survicate-box .sv__smiley-scale .sv__selected{transform:scale(1.2)}#survicate-box .sv__smiley-scale.sv__three-smileys{text-align:center}#survicate-box .sv__smiley-scale.sv__three-smileys .sv__smiley-scale__buttons .sv__smiley-scale__button:first-child{margin-right:22px}#survicate-box .sv__smiley-scale.sv__three-smileys .sv__smiley-scale__buttons .sv__smiley-scale__button:last-child{margin-left:22px}#survicate-box .sv__smiley-scale__wrapper{display:inline-flex;flex-direction:column;margin-bottom:0;margin-left:auto;margin-right:auto;margin-top:0}#survicate-box .sv__smiley-scale__buttons{display:flex;justify-content:center}#survicate-box .sv__smiley-scale__button{background:none;border-radius:50%;height:59px;margin-bottom:0;margin-left:20px;margin-right:20px;margin-top:0;padding:0;transition:transform 200ms ease-out;width:59px}#survicate-box .sv__smiley-scale__button:first-child{margin-left:0}#survicate-box .sv__smiley-scale__button:last-child{margin-right:0}#survicate-box .sv__smiley-scale__button:hover{transform:scale(1.1)}#survicate-box .sv__smiley-scale__icon-container{background-repeat:no-repeat;background-size:contain;display:block;height:100%;position:relative;width:100%}#survicate-box .sv__smiley-scale .sv__very-sad{background-image:url("https://surveys-static.survicate.com/images/emojiAngry.png")}#survicate-box .sv__smiley-scale .sv__sad{background-image:url("https://surveys-static.survicate.com/images/emojiSad.png")}#survicate-box .sv__smiley-scale .sv__neutral{background-image:url("https://surveys-static.survicate.com/images/emojiNeutral.png")}#survicate-box .sv__smiley-scale .sv__happy{background-image:url("https://surveys-static.survicate.com/images/emojiSmile.png")}#survicate-box .sv__smiley-scale .sv__very-happy{background-image:url("https://surveys-static.survicate.com/images/emojiHeartEyes.png")}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-animation-wrapper{box-sizing:border-box}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown{height:unset;justify-content:space-between;margin-bottom:8px;min-height:64px;padding:16px}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown .sv__matrix-answer{overflow:hidden;width:inherit}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown .sv__matrix-answer .sv__answer-text,#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown .sv__matrix-answer .sv__matrix-answer--selected{overflow:inherit;text-overflow:ellipsis;white-space:normal;width:95%}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown .sv__matrix-answer--selected{font-size:12px}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown .sv__caret{align-items:center;display:flex;height:24px;justify-content:center;width:24px}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown .sv__caret svg{height:12px;transform:rotate(180deg);width:20px}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown--closed.sv__choice-button{height:64px}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown--closed.sv__choice-button svg{transform:initial}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown--closed.sv__choice-button .sv__matrix-answer .sv__answer-text,#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown--closed.sv__choice-button .sv__matrix-answer--selected{white-space:nowrap}#survicate-box .sv__matrix-row{border-color:rgba(0,0,0,0);border-radius:6px;border-style:solid;border-width:2px;display:flex;gap:5px;margin-bottom:12px;min-height:50px;padding:11px 0}#survicate-box .sv__matrix-row.sv__selected .sv__matrix-cell div{font-weight:600}#survicate-box .sv__matrix-row:first-child{background-color:rgba(0,0,0,0)}#survicate-box .sv__matrix-row:not(:first-child) .sv__matrix-cell:not(:first-child){cursor:pointer}#survicate-box .sv__matrix-cell{align-items:center;color:#7f8c8d;display:flex;flex-basis:50px;flex-grow:1;font-size:14px;font-weight:400;justify-content:center;text-align:center}#survicate-box .sv__matrix-cell:first-child{flex-basis:30%;justify-content:flex-start;padding:0 20px;text-align:left;word-break:break-word}#survicate-box .sv__matrix-cell .sv__checkbox{margin:0}#survicate-box .sv__matrix-cell .sv__checkbox.sv__circle{background-clip:content-box;border-style:solid;border-width:2px;padding:4px}#survicate-box .sv__ie .sv__matrix-cell{height:40px}#survicate-box .sv__matrix-widget .sv__matrix-dropdown__wrapper .sv__matrix-dropdown{display:flex}#survicate-box .sv-box-child.sv-mobile{font-size:16px}@media only screen and (max-width: 767px),only screen and (max-device-width: 812px)and (-webkit-min-device-pixel-ratio: 3)and (orientation: landscape){#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop){font-size:16px}}@media only screen and (min-width: 813px),only screen and (min-width: 768px)and (-webkit-max-device-pixel-ratio: 2){#survicate-box .sv-box-child:not(.sv-mobile) .sv__matrix-widget{max-width:256px}}#survicate-box .sv-box-child.sv-tablet .sv__matrix-widget,#survicate-box .sv-box-child.sv-desktop .sv__matrix-widget{max-width:256px}#survicate-box .sv__buttons{display:flex;justify-content:center}#survicate-box .sv__buttons .sv__button{border-radius:6px}#survicate-box .sv__buttons--vertical.sv__buttons{display:flex;flex-direction:column-reverse;width:100%}#survicate-box .sv__buttons--vertical.sv__buttons .sv__button{overflow-wrap:break-word;border:none;font-weight:400;height:48px;margin-bottom:8px;margin-left:0;margin-right:0;margin-top:0;width:100%}#survicate-box .sv__buttons--vertical.sv__buttons .sv__button--selected,#survicate-box .sv__buttons--vertical.sv__buttons .sv__button:active{border-style:solid;border-width:2px;font-weight:600}#survicate-box .sv__buttons--vertical.sv__buttons .sv__button--selected svg,#survicate-box .sv__buttons--vertical.sv__buttons .sv__button:active svg{margin-bottom:0}#survicate-box .sv__buttons__answer{overflow-x:auto;overflow-wrap:break-word}#survicate-box .sv__checkbox{cursor:pointer;display:inline-block;height:20px;margin-right:10px;position:relative;width:20px}#survicate-box .sv__checkbox.sv__circle{border-radius:50%}#survicate-box .sv__checkbox.sv__circle .sv__tick{border-radius:100%;display:none;height:5px;left:6px;top:4px;width:5px}#survicate-box .sv__checkbox.sv__square{border-radius:4px;border-style:solid;border-width:2px;margin-top:1px;transition:background-color .3s cubic-bezier(0.4, 0, 0.23, 1)}#survicate-box .sv__checkbox.sv__square:after{border-radius:100%;content:"";height:36px;left:-10px;position:absolute;top:-10px;width:36px}#survicate-box .sv__checkbox.sv__square svg{border-radius:3px;height:100%;position:absolute;transform:scale(1.2);width:100%}#survicate-box .sv__checkbox .sv__tick{display:none;display:block;position:absolute}#survicate-box .sv__checkbox.sv__circle .sv__tick{background-color:#fff;display:none;height:8px;top:6px;width:8px}#survicate-box .sv__rtl-lang .sv__checkbox{margin-left:10px;margin-right:0}#survicate-box .sv__hide-input{height:0;opacity:0;pointer-events:none;position:absolute;width:0}#survicate-box .sv__outline .sv__checkbox.sv__checkbox--focused{box-shadow:0 0 0 8px rgba(26,109,85,.2);outline:2px solid #6f27f6}#survicate-box .sv__mobile-datepicker{background-color:#fff;border-radius:10px;box-shadow:0 0 20px rgba(0,0,0,.15);display:flex;height:240px;justify-content:center;margin-bottom:32px;margin-left:32px;margin-right:32px;margin-top:20px;overflow:hidden;padding:20px;position:relative;text-transform:capitalize;width:calc(100% - 64px)}#survicate-box .sv__mobile-datepicker--selected{border-bottom-color:#dee2e2;border-bottom-style:solid;border-bottom-width:1px;border-top-color:#dee2e2;border-top-style:solid;border-top-width:1px;position:absolute;top:50%;transform:translate(0, -50%);width:calc(100% - 40px)}#survicate-box .sv__mobile-datepicker .sv__roller{text-align:center;width:100px}#survicate-box .sv__mobile-datepicker .sv__roller__option{font-size:16px;line-height:40px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}#survicate-box .sv__mobile-datepicker .sv__roller__wrapper{overflow:hidden;position:relative}#survicate-box .sv__mobile-datepicker .sv__roller__wrapper::before,#survicate-box .sv__mobile-datepicker .sv__roller__wrapper::after{background-repeat:no-repeat;bottom:0;content:"";cursor:grab;display:block;height:100%;position:absolute;top:0;width:100%;z-index:1}#survicate-box .sv__mobile-datepicker .sv__roller__wrapper::before{background:linear-gradient(180deg, rgba(255, 255, 255, 0.2), #ffffff);background-position:right 0 top 120px;background-repeat:no-repeat}#survicate-box .sv__mobile-datepicker .sv__roller__wrapper::after{background:linear-gradient(180deg, #ffffff, rgba(255, 255, 255, 0.2));background-position:right 0 bottom 120px;background-repeat:no-repeat}#survicate-box .sv__select{border-radius:6px;position:relative;width:100%;z-index:1}#survicate-box .sv__select-icon{position:absolute;right:16px;top:10px}#survicate-box .sv__select input{border-radius:6px;cursor:pointer;font-size:16px;font-weight:400;padding:16px;width:100%}#survicate-box .sv__select--open{border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:6px;border-top-right-radius:6px;z-index:100}#survicate-box .sv__select .sv__clear-input-icon{background:none;font-weight:600}#survicate-box .sv__select .sv__caret{background:none;border:none;cursor:pointer}#survicate-box .sv__select .sv__select-list{border-bottom-left-radius:6px;border-bottom-right-radius:6px;border-top-left-radius:0;border-top-right-radius:0;list-style:none;margin:0;max-height:200px;overflow:auto;padding:0;position:absolute;width:100%;z-index:100}#survicate-box .sv__select .sv__select-list .sv__select-button{border:none;border-radius:0;font-size:inherit;font-weight:400;height:auto;overflow-wrap:break-word;padding-bottom:10px;padding-left:16px;padding-right:16px;padding-top:10px;text-align:left;transition:none;width:100%}#survicate-box .sv__select.sv-invalid{border:none}#survicate-box .sv__select.sv-invalid input,#survicate-box .sv__select.sv-invalid input:focus{background-color:#ffedea;border:2px;border-color:#e33a22;border-style:solid;color:initial;padding:14px}#survicate-box .sv__select.sv-invalid+.sv__submit-button__wrapper{visibility:visible}#survicate-box .sv__outline .sv__select-list .sv__select-button.sv__select-button--focused{outline:2px solid #6f27f6;outline-offset:-4px}#survicate-box .sv__rtl-lang .sv__dropdown__wrapper .sv__select-list .sv__select-button{text-align:right}#survicate-box .sv__rtl-lang .sv__dropdown__wrapper .sv__select-icon{left:16px;right:unset}#survicate-box .sv__rtl-lang .sv__dropdown__wrapper .sv__select-icon.sv__select__clear-input{left:0}#survicate-box .sv__rtl-lang .sv__dropdown__wrapper .sv__select .sv__input{padding-right:16px}#survicate-box .sv__validation{align-items:center;background-color:#e33a22;border-radius:4px;display:flex;left:100%;padding-bottom:5px;padding-left:6px;padding-right:6px;padding-top:5px;position:absolute;top:36px;white-space:nowrap;width:max-content}#survicate-box .sv__validation__message{color:#fff;font-size:12px;margin-left:3px}#survicate-box .sv__validation::after{border-bottom-width:4px;border-color:rgba(0,0,0,0) #e33a22 rgba(0,0,0,0) rgba(0,0,0,0);border-left-width:0;border-right-width:8px;border-style:solid;border-top-width:4px;content:" ";height:0;left:-8px;position:absolute;top:9px;width:0}#survicate-box .sv__survey .sv__invalid input{background-color:#ffedea;color:#e33a22}#survicate-box .sv__survey .sv__invalid input:focus{border-color:#e33a22;border-width:2px}@media(max-width: 1181px){#survicate-box .sv-box-child .sv__validation{left:auto;right:0;top:1px}#survicate-box .sv-box-child .sv__validation::after{border-bottom-width:0;border-color:#e33a22 rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0);border-left-width:4px;border-right-width:4px;border-top-width:8px;bottom:-8px;left:auto;right:10px;top:auto}}:host #survicate-box .sv-mobile .sv__validation{left:auto;right:0;top:1px}:host #survicate-box .sv-mobile .sv__validation::after{border-bottom-width:0;border-color:#e33a22 rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0);border-left-width:4px;border-right-width:4px;border-top-width:8px;bottom:-8px;left:auto;right:10px;top:auto}#survicate-box .sv__point .sv__point-description a,#survicate-box .sv__point .sv__point-description b,#survicate-box .sv__point .sv__point-description i,#survicate-box .sv__point .sv__point-description strong,#survicate-box .sv__point .sv__point-description small,#survicate-box .sv__point .sv__point-question a,#survicate-box .sv__point .sv__point-question b,#survicate-box .sv__point .sv__point-question i,#survicate-box .sv__point .sv__point-question strong,#survicate-box .sv__point .sv__point-question small,#survicate-box .sv__point .sv__point-wrapper a,#survicate-box .sv__point .sv__point-wrapper b,#survicate-box .sv__point .sv__point-wrapper i,#survicate-box .sv__point .sv__point-wrapper strong,#survicate-box .sv__point .sv__point-wrapper small{color:inherit}#survicate-box .sv__point .sv__point-description a.sv__social-button,#survicate-box .sv__point .sv__point-description b.sv__social-button,#survicate-box .sv__point .sv__point-description i.sv__social-button,#survicate-box .sv__point .sv__point-description strong.sv__social-button,#survicate-box .sv__point .sv__point-description small.sv__social-button,#survicate-box .sv__point .sv__point-question a.sv__social-button,#survicate-box .sv__point .sv__point-question b.sv__social-button,#survicate-box .sv__point .sv__point-question i.sv__social-button,#survicate-box .sv__point .sv__point-question strong.sv__social-button,#survicate-box .sv__point .sv__point-question small.sv__social-button,#survicate-box .sv__point .sv__point-wrapper a.sv__social-button,#survicate-box .sv__point .sv__point-wrapper b.sv__social-button,#survicate-box .sv__point .sv__point-wrapper i.sv__social-button,#survicate-box .sv__point .sv__point-wrapper strong.sv__social-button,#survicate-box .sv__point .sv__point-wrapper small.sv__social-button{color:#fff}#survicate-box .sv__point .sv__point-description b,#survicate-box .sv__point .sv__point-description strong,#survicate-box .sv__point .sv__point-question b,#survicate-box .sv__point .sv__point-question strong,#survicate-box .sv__point .sv__point-wrapper b,#survicate-box .sv__point .sv__point-wrapper strong{font-weight:600}#survicate-box .sv__point .sv__point-description small,#survicate-box .sv__point .sv__point-question small,#survicate-box .sv__point .sv__point-wrapper small{font-size:12px}#survicate-box .sv__point .sv__point-description small a,#survicate-box .sv__point .sv__point-description small b,#survicate-box .sv__point .sv__point-description small i,#survicate-box .sv__point .sv__point-description small strong,#survicate-box .sv__point .sv__point-question small a,#survicate-box .sv__point .sv__point-question small b,#survicate-box .sv__point .sv__point-question small i,#survicate-box .sv__point .sv__point-question small strong,#survicate-box .sv__point .sv__point-wrapper small a,#survicate-box .sv__point .sv__point-wrapper small b,#survicate-box .sv__point .sv__point-wrapper small i,#survicate-box .sv__point .sv__point-wrapper small strong{font-size:inherit}#survicate-box *{box-sizing:border-box;font-family:"Open sans",sans-serif;font-size:14px;font-weight:400;line-height:normal;outline:none}#survicate-box .sv__outline *:focus{outline:2px solid #6f27f6}#survicate-box button{border:none;cursor:pointer;display:inline-block;margin:0;padding:3px}#survicate-box p{margin:0}#survicate-box a{text-decoration:none}#survicate-box .sr-only{border:0;clip:rect(0, 0, 0, 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}#survicate-box .sv-invalid.sv-invalid.sv-invalid{border:1px solid #c00}#survicate-box .sv__overlay{height:100vh;left:0;position:fixed;top:0;width:100vw;z-index:999995}:host #survicate-box .sv__overlay{height:100%;position:absolute;width:100%}#survicate-box .sv__overlay--dark{background-color:#000;opacity:.35}#survicate-box .sv__overlay--light{background-color:#fff;opacity:.5}@keyframes slide-out{0%{transform:translateX(0)}100%{transform:translateX(-100%)}}@keyframes slide-in{0%{transform:translateX(100%)}100%{transform:translateX(0)}}@keyframes slide-down{0%{transform:translateY(0)}100%{transform:translateY(100%)}}#survicate-box .sv__survey.sv__micro-theme{border-radius:10px;box-shadow:0 0 10px 5px rgba(41,41,42,.07);display:flex;flex-direction:column;max-height:664px;max-width:304px;min-width:304px;padding-bottom:16px;padding-left:0;padding-right:0;padding-top:0;position:fixed;width:unset;z-index:2147483646}#survicate-box .sv__survey.sv__micro-theme.sv__rtl-lang{direction:rtl}#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey{border-radius:10px;margin-left:0px;margin-right:0px;margin-top:0px;top:50%;transform:translateY(-50%);z-index:2147483645}#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-center-right{right:24px}#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-center-right.sv__position-mobile.sv__feedback-survey--mobile.sv__feedback-survey--minimized,#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-center-right.sv__feedback-survey--minimized{border-radius:0 0 10px 10px;margin-right:0;right:0;transform:translateY(50%) rotateY(0deg) rotate(90deg);transform-origin:right top}#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-center-left{left:24px}#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-center-left.sv__position-mobile.sv__feedback-survey--mobile.sv__feedback-survey--minimized,#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-center-left.sv__feedback-survey--minimized{border-radius:0 0 10px 10px;left:0;margin-left:0;transform:translateY(-50%) rotate(270deg) translateX(-50%);transform-origin:left top}#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-mobile.sv__feedback-survey--mobile:not(.sv__feedback-survey--minimized){bottom:unset;margin-left:24px;margin-right:24px;max-width:unset;min-width:unset;width:calc(100% - 48px)}#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-mobile.sv__feedback-survey--mobile:not(.sv__feedback-survey--minimized).sv__position-center-left,#survicate-box .sv__survey.sv__micro-theme.sv__feedback-survey.sv__position-mobile.sv__feedback-survey--mobile:not(.sv__feedback-survey--minimized).sv__position-center-right{left:unset;right:unset}:host #survicate-box .sv__survey.sv__micro-theme{position:absolute}#survicate-box .sv__survey.sv__micro-theme.sv__position-top-right,#survicate-box .sv__survey.sv__micro-theme.sv__position-top-left{top:0}#survicate-box .sv__survey.sv__micro-theme.sv__position-left,#survicate-box .sv__survey.sv__micro-theme.sv__position-right{bottom:0}#survicate-box .sv__survey.sv__micro-theme.sv__position-right,#survicate-box .sv__survey.sv__micro-theme.sv__position-top-right{right:30px}#survicate-box .sv__survey.sv__micro-theme.sv__position-left,#survicate-box .sv__survey.sv__micro-theme.sv__position-top-left{left:30px}#survicate-box .sv__survey.sv__micro-theme.sv__position-center{bottom:50%;max-width:608px;right:50%;transform:translate(50%, 50%)}#survicate-box .sv__survey.sv__micro-theme.sv__position-fullscreen{height:100vh;justify-content:space-between}:host #survicate-box .sv__survey.sv__micro-theme.sv__position-fullscreen{height:100%}#survicate-box .sv__survey.sv__micro-theme:not(.sv__position-center){margin-bottom:24px;margin-left:-6px;margin-right:-6px;margin-top:24px}#survicate-box .sv__survey.sv__micro-theme.sv__minimized{align-items:center;cursor:pointer;display:inline-flex;flex-direction:row;justify-content:space-between;min-height:39px;overflow-wrap:break-word;padding:16px 24px}#survicate-box .sv__survey.sv__micro-theme.sv__minimized.sv__position-center{bottom:50%;right:50%;transform:translate(50%);width:auto}#survicate-box .sv__survey.sv__micro-theme.sv__minimized .sv__minimized-symbol{align-items:center;border-radius:6px;display:flex;height:40px;justify-content:center;margin-left:12px;width:40px}#survicate-box .sv__survey.sv__micro-theme.sv__minimized .sv__minimized-symbol:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #6f27f6;outline:none}#survicate-box .sv__survey.sv__micro-theme.sv__minimized .sv__minimized__text{width:75%}#survicate-box .sv__survey.sv__micro-theme.sv__survey--nps,#survicate-box .sv__survey.sv__micro-theme.sv__survey--numerical_scale,#survicate-box .sv__survey.sv__micro-theme.sv__survey--rating{max-width:520px}#survicate-box .sv__survey.sv__micro-theme.sv__survey--matrix{max-width:unset;min-width:unset}#survicate-box .sv__survey.sv__micro-theme.sv__survey--matrix .sv__matrix-wrapper{max-width:608px;min-width:336px}#survicate-box .sv__survey.sv__micro-theme.sv__survey--finished{width:304px}#survicate-box .sv__survey.sv__micro-theme.sv__survey--finished.sv__survey--branded{background-color:#fff !important;color:#000 !important}#survicate-box .sv__survey.sv__micro-theme.sv__survey--slide-out{animation-duration:.3s;animation-name:slide-out}#survicate-box .sv__survey.sv__micro-theme.sv__survey--slide-in{animation-duration:.3s;animation-name:slide-in}#survicate-box .sv__survey.sv__micro-theme.sv__survey--slide-down{animation-duration:.3s;animation-name:slide-down}#survicate-box .sv__micro-theme.sv__survey.sv__mobile-survey.sv__position-fullscreen .sv__point{margin:auto 0}#survicate-box .sv__micro-theme .sv__point{max-height:none;overflow-y:auto;padding:0}#survicate-box .sv__micro-theme .sv__point::-webkit-scrollbar{background-color:rgba(0,0,0,0);width:4px}#survicate-box .sv__micro-theme .sv__point::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5);border-radius:4px}#survicate-box .sv__micro-theme .sv__point-wrapper{box-sizing:content-box;overflow:hidden;padding-bottom:0;padding-left:24px;padding-right:24px}#survicate-box .sv__micro-theme .sv__point-wrapper .sv__scroll-container{margin-right:-18px;padding-right:14px}#survicate-box .sv__micro-theme .sv__point .sv__point-text{margin:0;margin-bottom:8px;overflow-wrap:break-word;text-align:left}#survicate-box .sv__micro-theme .sv__point .sv__point-text.sv__point-description{font-size:12px;line-height:19px;margin-bottom:4px;margin-left:0;margin-right:0;margin-top:4px}#survicate-box .sv__micro-theme .sv__point .sv__point-text.sv__point-question{font-size:14px;font-weight:600;line-height:22px;margin-bottom:16px}#survicate-box .sv__micro-theme .sv__point .sv__point-text.sv__point-description a,#survicate-box .sv__micro-theme .sv__point .sv__point-text.sv__point-question a{font-size:inherit;font-weight:inherit;text-decoration:underline}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__point .sv__point-wrapper .sv__point-text{margin-right:4px;text-align:right}#survicate-box .sv__micro-theme .sv__contact-form{display:flex;flex-direction:column}#survicate-box .sv__micro-theme .sv__contact-form-field{border-radius:6px;margin-bottom:8px;margin-top:0;position:relative;width:100%}#survicate-box .sv__micro-theme .sv__contact-form-field:last-child{margin-bottom:16px}#survicate-box .sv__micro-theme .sv__contact-form-field.sv__invalid input{background-color:#ffedea !important;border-color:#c00 !important;color:#e33a22 !important}#survicate-box .sv__micro-theme .sv__contact-form-field .sv__input{border-color:rgba(0,0,0,0);border-radius:4px;border-style:solid;border-width:2px;box-sizing:border-box;height:40px;outline-offset:3px;padding-bottom:0;padding-left:16px;padding-right:16px;padding-top:0;transition:none;width:100%}#survicate-box .sv__micro-theme .sv__contact-form-field .sv__input:focus{border-style:solid;border-width:2px}#survicate-box .sv__micro-theme .sv__contact-form-field-label{display:block;font-size:14px;font-weight:600;margin-bottom:8px;opacity:1;overflow-wrap:break-word;position:static;transition:opacity .5s}#survicate-box .sv__micro-theme .sv__contact-form-security,#survicate-box .sv__micro-theme .sv__contact-form-confirmation{align-items:center;display:flex;margin-top:16px;min-height:40px;padding:8px 16px}#survicate-box .sv__micro-theme .sv__contact-form-security .sv__checkbox,#survicate-box .sv__micro-theme .sv__contact-form-confirmation .sv__checkbox{margin-right:16px}#survicate-box .sv__micro-theme .sv__contact-form-security .sv__checkbox.sv__square.sv-invalid.sv-nested-bg-bw,#survicate-box .sv__micro-theme .sv__contact-form-confirmation .sv__checkbox.sv__square.sv-invalid.sv-nested-bg-bw{border-style:solid;border-width:2px}#survicate-box .sv__micro-theme .sv__contact-form-security .sv__lock-icon,#survicate-box .sv__micro-theme .sv__contact-form-confirmation .sv__lock-icon{margin-right:8px;padding-left:2px}#survicate-box .sv__micro-theme .sv__contact-form-security .sv__lock-icon svg,#survicate-box .sv__micro-theme .sv__contact-form-confirmation .sv__lock-icon svg{height:20px;margin-right:8px}#survicate-box .sv__micro-theme .sv__contact-form-security .sv__validation,#survicate-box .sv__micro-theme .sv__contact-form-confirmation .sv__validation{bottom:unset;top:-27px}#survicate-box .sv__micro-theme .sv__contact-form-confirmation *{flex:none}#survicate-box .sv__micro-theme .sv__contact-form-confirmation>div:last-child{cursor:pointer;flex-shrink:1}#survicate-box .sv__micro-theme .sv__contact-form-security{font-size:12px}#survicate-box .sv__micro-theme .sv__contact-form-agreement-label{overflow-wrap:break-word;overflow-x:auto}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__contact-form .sv__contact-form-security .sv__lock-icon{margin-left:8px;margin-right:0;padding-left:0;padding-right:2px}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__contact-form .sv__contact-form-security .sv__lock-icon svg{margin-left:8px;margin-right:0}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__contact-form .sv__contact-form-confirmation .sv__checkbox{margin-right:0}#survicate-box .sv__micro-theme .sv__choice-button{align-items:center;border-color:rgba(0,0,0,0);border-radius:6px;border-style:solid;border-width:2px;cursor:pointer;display:flex;font-weight:400;margin:5px 0;margin-bottom:0;margin-top:0;min-height:40px;padding:10px;text-align:left;transition:background-color 300ms;width:100%}#survicate-box .sv__micro-theme .sv__choice-button-wrapper{margin-bottom:8px}#survicate-box .sv__micro-theme .sv__choice-button-wrapper:last-child{margin-bottom:16px}#survicate-box .sv__micro-theme .sv__choice-button-question{align-items:center;display:flex;overflow-x:initial;width:100%}#survicate-box .sv__micro-theme .sv__choice-button-question .sv-bg-bv{width:auto}#survicate-box .sv__micro-theme .sv__choice-button-question .sv-col-fa{overflow-x:inherit;width:100%}#survicate-box .sv__micro-theme .sv__choice-button>div:last-child{width:auto}#survicate-box .sv__micro-theme .sv__choice-button.sv__choice-button--selected--expanded{align-items:baseline}#survicate-box .sv__micro-theme .sv__choice-button.sv__choice-button--selected--expanded>div:last-child{width:100%}#survicate-box .sv__micro-theme .sv__choice-button.sv__choice-button--selected .sv-col-fa{font-weight:600}#survicate-box .sv__micro-theme .sv__choice-button:active .sv__circle{background-color:rgba(0,0,0,0);border-style:solid;border-width:2px}#survicate-box .sv__micro-theme .sv__choice-button--selected--expanded{flex-direction:column}#survicate-box .sv__micro-theme .sv__choice-button:active .sv__circle,#survicate-box .sv__micro-theme .sv__choice-button--selected .sv__circle{background-clip:content-box;padding:2px}#survicate-box .sv__micro-theme .sv__choice-button .sv__textarea-wrapper{margin-top:16px}#survicate-box .sv__micro-theme .sv__choice-button .sv__textarea-wrapper .sv__answer-hint{font-size:12px}#survicate-box .sv__micro-theme .sv__choice-button .sv__textarea-wrapper .sv__textarea{border-color:rgba(0,0,0,0);border-radius:4px;border-style:solid;border-width:2px;margin-top:0;max-height:72px;min-height:64px;padding:8px;resize:none;width:100%}#survicate-box .sv__micro-theme .sv__choice-button .sv__textarea-wrapper .sv__textarea:active{border-width:2px}#survicate-box .sv__micro-theme .sv__choice-button .sv__checkbox{flex:1 0 auto}#survicate-box .sv__micro-theme .sv__choice-button .sv__circle{padding:3px;top:0}#survicate-box .sv__micro-theme .sv__choice-button .sv__answer-text{overflow-wrap:anywhere;word-break:break-word}#survicate-box .sv__micro-theme.sv__mobile-survey .sv__circle:hover,#survicate-box .sv__micro-theme.sv__mobile-survey .sv__circle:hover::after,#survicate-box .sv__micro-theme.sv__mobile-survey .sv__square:hover,#survicate-box .sv__micro-theme.sv__mobile-survey .sv__square:hover::after{box-shadow:none !important}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__choice-button-wrapper .sv__choice-button{text-align:right}#survicate-box .sv__micro-theme .sv__customer-satisfaction .sv__buttons--vertical{margin-bottom:0}#survicate-box .sv__micro-theme .sv__date{box-sizing:border-box;display:block;height:40px;margin-bottom:16px;margin-top:0;padding:10px;padding-bottom:8px;padding-left:8px;padding-top:8px;text-align:left}#survicate-box .sv__micro-theme .sv__date__input,#survicate-box .sv__micro-theme .sv__date__separator{display:inline-block}#survicate-box .sv__micro-theme .sv__date__input{background:none;padding:0;text-align:center;width:30%}#survicate-box .sv__micro-theme .sv__date__separator{padding:0}#survicate-box .sv__micro-theme .sv__date__wrapper .sv__mobile-datepicker{box-shadow:none;font-size:14px;margin:0 auto;padding:0;width:100%;width:max-content}#survicate-box .sv__micro-theme .sv__date__wrapper .sv__mobile-datepicker--selected{border:none;border-radius:6px;transform:translateY(-60%);width:100%}#survicate-box .sv__micro-theme .sv__date__wrapper .sv__mobile-datepicker .sv__roller__wrapper{display:flex}#survicate-box .sv__micro-theme .sv__date__wrapper .sv__mobile-datepicker .sv__roller__wrapper::before,#survicate-box .sv__micro-theme .sv__date__wrapper .sv__mobile-datepicker .sv__roller__wrapper::after{background:inherit}#survicate-box .sv__micro-theme .sv__date__wrapper .sv__mobile-datepicker .sv__roller__option{font-size:14px}#survicate-box .sv__micro-theme .sv__date.sv__invalid,#survicate-box .sv__micro-theme .sv__date.sv__invalid.sv--background-answer-opacity-10{background-color:#ffedea !important;position:relative}#survicate-box .sv__micro-theme .sv__date.sv__invalid .sv__date__separator,#survicate-box .sv__micro-theme .sv__date.sv__invalid .sv__date__input,#survicate-box .sv__micro-theme .sv__date.sv__invalid .sv__date__input::placeholder,#survicate-box .sv__micro-theme .sv__date.sv__invalid.sv--background-answer-opacity-10 .sv__date__separator,#survicate-box .sv__micro-theme .sv__date.sv__invalid.sv--background-answer-opacity-10 .sv__date__input,#survicate-box .sv__micro-theme .sv__date.sv__invalid.sv--background-answer-opacity-10 .sv__date__input::placeholder{color:#e33a22 !important}#survicate-box .sv__micro-theme .sv__date.sv__invalid.focused,#survicate-box .sv__micro-theme .sv__date.sv__invalid.sv--background-answer-opacity-10.focused{border-color:#e33a22 !important}#survicate-box .sv__micro-theme .sv__date .sv__validation{bottom:38px;display:flex;padding:5px 6px;right:0}#survicate-box .sv__micro-theme .sv__point-texts--empty+.sv__date{margin-top:26px}#survicate-box .sv__micro-theme.sv__outline .sv--background-answer-opacity-10.sv__date.focused{border-color:#6f27f6 !important}#survicate-box .sv__micro-theme.sv__outline .sv--background-answer-opacity-10.sv__date.focused .sv__date__input{outline:none}#survicate-box .sv__micro-theme .sv__dropdown_list-survey-point{overflow-y:visible !important}#survicate-box .sv__micro-theme .sv__dropdown_list-survey-point .sv__point-wrapper{overflow:visible}#survicate-box .sv__micro-theme .sv__dropdown__wrapper{margin-left:0;margin-right:0;margin-top:0}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv-invalid.sv__select .sv__clear-input-icon svg g g{fill:#000}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv-invalid.sv__select.sv-invalid .sv__input{background-color:#ffedea !important;color:#e33a22 !important}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv-invalid.sv__select.sv-invalid .sv__input:focus{border-color:#e33a22 !important}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv-invalid.sv__select.sv-invalid svg g g polygon{fill:#e33a22 !important}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv__select-list{margin-top:0}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv__select-icon{top:4px}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv__select-icon.sv__caret{border:0}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv__select .sv__clear-input-icon{right:0;top:0}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv__select input{border-color:rgba(0,0,0,0);border-style:solid;border-width:2px;font-size:14px;height:50px;padding:16px}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv__select .sv__validation{bottom:50px;top:auto}#survicate-box .sv__micro-theme .sv__dropdown__wrapper .sv__submit-button__wrapper{bottom:initial}#survicate-box .sv__micro-theme .sv__outline .sv__select-list .sv__select-button.sv__select-button--focused{outline:2px solid #6f27f6;outline-offset:-4px}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__dropdown__wrapper .sv__select .sv__caret{left:20px;right:unset}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__dropdown__wrapper .sv__select .sv__clear-input-icon{left:0;right:unset}#survicate-box .sv__micro-theme .sv__numerical-scale--mobile .sv__numerical-scale__wrapper{display:flex;flex-direction:column}#survicate-box .sv__micro-theme .sv__numerical-scale--mobile .sv__numerical-scale__buttons{flex-direction:column-reverse}#survicate-box .sv__micro-theme .sv__numerical-scale--mobile .sv__numerical-scale__button{margin-bottom:10px;margin-left:0;margin-right:0;margin-top:0;width:100%}#survicate-box .sv__micro-theme .sv__numerical-scale .sv__point-text{min-width:100%;width:min-content}#survicate-box .sv__micro-theme .sv__numerical-scale__wrapper{display:flex;flex-direction:column}#survicate-box .sv__micro-theme .sv__numerical-scale__wrapper .sv__buttons{display:flex;justify-content:center;margin-left:0;margin-right:0;width:100%}#survicate-box .sv__micro-theme .sv__numerical-scale__wrapper .sv__buttons .sv__button{align-items:center;border-radius:6px;cursor:pointer;display:flex;justify-content:center;padding:initial;text-align:center}#survicate-box .sv__micro-theme .sv__numerical-scale__wrapper .sv__buttons .sv__button:first-child{margin-left:0}#survicate-box .sv__micro-theme .sv__numerical-scale__wrapper .sv__buttons .sv__button:last-child{margin-right:0}#survicate-box .sv__micro-theme .sv__rating .sv__point-text{min-width:100%;width:min-content}#survicate-box .sv__micro-theme .sv__rating-survey-point .sv__point-wrapper--with-personalization .sv__micro-top-bar__row,#survicate-box .sv__micro-theme .sv__rating__micro-top-bar.sv__micro-top-bar--with-personalization .sv__micro-top-bar__row{min-width:100%;width:min-content}#survicate-box .sv__micro-theme .sv__rating__number{font-weight:400}#survicate-box .sv__micro-theme .sv__rating .sv__buttons{justify-content:center;margin-bottom:16px}#survicate-box .sv__micro-theme .sv__rating .sv__buttons .sv__button{align-items:center;display:flex;flex-direction:column;height:unset;justify-content:center;min-height:unset;min-width:unset}#survicate-box .sv__micro-theme .sv__rating .sv__buttons .sv__button:hover{background-color:rgba(0,0,0,0)}#survicate-box .sv__micro-theme .sv__rating .sv__buttons .sv__button--selected,#survicate-box .sv__micro-theme .sv__rating .sv__buttons .sv__button:active{border-width:0}#survicate-box .sv__micro-theme .sv__rating .sv__buttons .sv__button svg{height:32px;margin-bottom:8px;width:32px}#survicate-box .sv__micro-theme .sv__rating .sv__buttons--vertical.sv__buttons{flex-direction:column-reverse}#survicate-box .sv__micro-theme .sv__rating .sv__buttons--vertical.sv__buttons .sv__button{flex-direction:row;height:40px;margin-bottom:8px;margin-left:0;margin-right:0;margin-top:0}#survicate-box .sv__micro-theme .sv__rating .sv__buttons--vertical.sv__buttons .sv__button:active{border-width:2px}#survicate-box .sv__micro-theme .sv__rating .sv__buttons--vertical.sv__buttons .sv__button svg{height:20px;margin-bottom:0;width:20px}#survicate-box .sv__micro-theme.sv__outline .sv__rating .sv__rating__buttons .sv__button:focus,#survicate-box .sv__micro-theme.sv__outline .sv__rating .sv__rating__buttons .sv__button--selected{outline:none}#survicate-box .sv__micro-theme.sv__outline .sv__rating .sv__rating__buttons .sv__button:focus svg path,#survicate-box .sv__micro-theme.sv__outline .sv__rating .sv__rating__buttons .sv__button--selected svg path{box-shadow:0 0 0 2px #fff,0 0 0 4px #6f27f6;fill:#6f27f6 !important}#survicate-box .sv__micro-theme .sv__smiley_scale-survey-point .sv__smiley-scale__buttons{display:flex;justify-content:space-between;margin-bottom:32px;padding-left:3px;padding-right:3px}#survicate-box .sv__micro-theme .sv__smiley_scale-survey-point .sv__smiley-scale__wrapper{width:100%}#survicate-box .sv__micro-theme .sv__smiley_scale-survey-point .sv__smiley-scale__button{margin:0}#survicate-box .sv__micro-theme .sv__smiley_scale-survey-point .sv__smiley-scale__icon-container,#survicate-box .sv__micro-theme .sv__smiley_scale-survey-point .sv__smiley-scale__button{height:38px;min-height:38px;min-width:38px;width:38px}#survicate-box .sv__micro-theme .sv__smiley_scale-survey-point .sv__smiley-scale.sv__three-smileys .sv__smiley-scale__buttons{justify-content:center}#survicate-box .sv__micro-theme .sv__smiley_scale .sv__point-texts .sv__point-question{margin-bottom:32px}#survicate-box .sv__micro-theme.sv__mobile-survey .sv__smiley-scale__button:hover{transform:none}#survicate-box .sv__micro-theme .sv__point-texts--empty+.sv__smiley-scale__buttons{margin-top:16px}#survicate-box .sv__micro-theme.sv__outline .sv__smiley-scale__button:focus{box-shadow:0 0 0 2px #fff,0 0 0 4px #6f27f6;outline:none;transform:scale(1.2)}#survicate-box .sv__micro-theme .sv-box-child.sv-mobile .sv__smiley-scale__icon-container,#survicate-box .sv__micro-theme .sv-box-child.sv-mobile .sv__smiley-scale__button{height:48px;width:48px}@media only screen and (max-width: 767px),only screen and (max-device-width: 812px)and (-webkit-min-device-pixel-ratio: 3)and (orientation: landscape){#survicate-box .sv__micro-theme .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__smiley-scale__icon-container,#survicate-box .sv__micro-theme .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__smiley-scale__button{height:48px;width:48px}}#survicate-box .sv__micro-theme .sv__text-question .sv__textarea{border-color:rgba(0,0,0,0);border-radius:6px;border-style:solid;border-width:2px;font-size:14px;margin-bottom:16px;max-height:200px;min-height:80px;padding:8px;resize:none;width:100%}#survicate-box .sv__micro-theme .sv__text-question .sv__textarea:focus{border:solid 2px}#survicate-box .sv__micro-theme .sv__matrix-row{gap:8px}#survicate-box .sv__micro-theme .sv__social-button{border-radius:4px;color:#fff;display:block;font-weight:600;margin-bottom:10px;padding:10px;position:relative;text-align:center;transition:background-color 300ms}#survicate-box .sv__micro-theme .sv__social-button.sv__fb{background-color:#3579ea;border-bottom:1px solid #11192b}#survicate-box .sv__micro-theme .sv__social-button.sv__fb:hover{background-color:#165ed6}#survicate-box .sv__micro-theme .sv__social-button.sv__twitter{background-color:#4aa1ec;border-bottom:1px solid #0f5f9b}#survicate-box .sv__micro-theme .sv__social-button.sv__twitter:hover{background-color:#1c89e7}#survicate-box .sv__micro-theme .sv__social-button.sv__twitter svg{left:17px;top:12px}#survicate-box .sv__micro-theme .sv__social-button.sv__linkedin{background-color:#2a66bc;border-bottom:1px solid #0f5f9b}#survicate-box .sv__micro-theme .sv__social-button.sv__linkedin:hover{background-color:#4480d5}#survicate-box .sv__micro-theme .sv__social-button.sv__linkedin svg{left:17px}#survicate-box .sv__micro-theme .sv__social-button svg{fill:#fff;left:20px;position:absolute}#survicate-box .sv__micro-theme .sv__nps--horizontal .sv__buttons{display:flex;flex-wrap:wrap;gap:8px;justify-content:center}#survicate-box .sv__micro-theme .sv__nps .sv__button{border-radius:4px;min-height:40px;min-width:39px;padding:initial;text-align:center}#survicate-box .sv__micro-theme .sv__footer{justify-content:center}#survicate-box .sv__micro-theme .sv__footer__wrapper{align-items:center;display:flex;justify-content:center;margin-top:0}#survicate-box .sv__micro-theme .sv__footer__button{align-items:center;display:flex;padding:8px}#survicate-box .sv__micro-theme .sv__footer__button svg{height:10px;margin-top:-2px;width:68px}#survicate-box .sv__micro-theme .sv__footer__small-text{font-size:12px;margin-right:4px}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__footer__wrapper{direction:ltr}#survicate-box .sv__micro-theme.sv__outline .sv__footer__wrapper .sv__footer .sv__footer__button:focus{outline:none}#survicate-box .sv__micro-theme.sv__outline .sv__footer__wrapper .sv__footer .sv__footer__button:focus .sv__footer__small-text{color:#6f27f6 !important}#survicate-box .sv__micro-theme.sv__outline .sv__footer__wrapper .sv__footer .sv__footer__button:focus svg path{fill:#6f27f6 !important}#survicate-box .sv__micro-theme .sv__micro-top-bar{margin-left:24px;margin-right:24px;margin-top:24px}#survicate-box .sv__micro-theme .sv__micro-top-bar--with-personalization.sv__micro-top-bar--with-logo .sv__micro-top-bar__row{align-items:center}#survicate-box .sv__micro-theme .sv__micro-top-bar--with-personalization .sv__micro-top-bar__row{align-items:flex-start}#survicate-box .sv__micro-theme .sv__micro-top-bar__personalization{align-items:center;display:flex;margin-top:12px}#survicate-box .sv__micro-theme .sv__micro-top-bar__row{align-items:center;display:flex;justify-content:space-between;position:relative;top:-10px}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__micro-top-bar__logo{margin-right:8px;max-height:24px;max-width:60%}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__micro-top-bar__avatar{border-radius:100%;border-style:none;height:24px;max-width:unset;object-fit:cover;object-position:center;width:24px}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__micro-top-bar__short-text{line-height:1.3;margin-right:8px;word-break:break-word}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons{color:#b3b3b3;display:flex;justify-content:flex-end}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv-col-small-button-bw{background:none;border:none;color:inherit;display:inline-block;font-family:"Open sans",sans-serif;font-weight:600;padding:6px;transition:color 300ms}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv-col-small-button-bw:focus{border-radius:10px}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv__btn-close,#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv__btn-minimize{height:40px;padding:0;width:40px}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv__btn-close{margin-right:-12px}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv__btn-minimize svg rect:first-child{fill:rgba(0,0,0,0)}#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv__btn-minimize:hover svg g,#survicate-box .sv__micro-theme .sv__micro-top-bar__row .sv__bar-buttons .sv__btn-minimize:active svg g{opacity:1}#survicate-box .sv__micro-theme .sv__micro-top-bar--flat{align-items:flex-end;display:flex;flex-direction:row-reverse}#survicate-box .sv__micro-theme .sv__micro-top-bar--flat .sv__micro-top-bar__row{flex-direction:row-reverse;justify-content:space-between}#survicate-box .sv__micro-theme .sv__micro-top-bar--flat .sv__progress-bar__wrapper{width:100%}#survicate-box .sv__micro-theme .sv__micro-top-bar--flat .sv__progress-bar__wrapper .sv__progress-bar{top:2px}#survicate-box .sv__micro-theme .sv__micro-top-bar--flat .sv__bar-buttons{margin-left:16px;margin-right:unset}#survicate-box .sv__micro-theme .sv__micro-top-bar .sv__bar-buttons svg{height:40px;width:40px}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__micro-top-bar .sv__bar-buttons{margin-left:unset;margin-right:16px}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__micro-top-bar .sv__bar-buttons .sv__btn-close{margin-left:-12px;margin-right:unset}#survicate-box .sv__micro-theme.sv__mobile-survey .sv__btn-close:hover svg g g{fill:inherit !important}#survicate-box .sv__micro-theme.sv__survey--finished .sv__micro-top-bar--branded{margin-bottom:24px}#survicate-box .sv__micro-theme.sv__survey--finished .sv__micro-top-bar--branded .sv__micro-top-bar__row{flex-direction:row;justify-content:space-between;width:100%}#survicate-box .sv__micro-theme.sv__survey--finished .sv__micro-top-bar--branded .sv__micro-top-bar__row .sv__survicate__logo{max-width:106px}#survicate-box .sv__micro-theme .sv__progress-bar{border-radius:4px;height:4px;position:relative;top:0}#survicate-box .sv__micro-theme .sv__progress-bar>div{border-radius:4px}#survicate-box .sv__micro-theme .sv__progress-bar__wrapper{height:28px}@media only screen and (min-width: 813px),only screen and (min-width: 768px)and (-webkit-max-device-pixel-ratio: 2){#survicate-box .sv__micro-theme .sv-box-child:not(.sv-mobile) .sv__position-top-right .sv__progress-bar,#survicate-box .sv__micro-theme .sv-box-child:not(.sv-mobile) .sv__position-top-left .sv__progress-bar{border-radius:0}#survicate-box .sv__micro-theme .sv-box-child:not(.sv-mobile) .sv__position-top-right .sv__progress-bar>div,#survicate-box .sv__micro-theme .sv-box-child:not(.sv-mobile) .sv__position-top-left .sv__progress-bar>div{border-radius:0}}#survicate-box .sv__micro-theme .sv-box-child.sv-tablet .sv__position-top-right .sv__progress-bar,#survicate-box .sv__micro-theme .sv-box-child.sv-tablet .sv__position-top-left .sv__progress-bar,#survicate-box .sv__micro-theme .sv-box-child.sv-desktop .sv__position-top-right .sv__progress-bar,#survicate-box .sv__micro-theme .sv-box-child.sv-desktop .sv__position-top-left .sv__progress-bar{border-radius:0}#survicate-box .sv__micro-theme .sv-box-child.sv-tablet .sv__position-top-right .sv__progress-bar>div,#survicate-box .sv__micro-theme .sv-box-child.sv-tablet .sv__position-top-left .sv__progress-bar>div,#survicate-box .sv__micro-theme .sv-box-child.sv-desktop .sv__position-top-right .sv__progress-bar>div,#survicate-box .sv__micro-theme .sv-box-child.sv-desktop .sv__position-top-left .sv__progress-bar>div{border-radius:0}#survicate-box .sv__micro-theme.sv__survey--branded .sv__finish-view{overflow-x:hidden;overflow-y:auto}#survicate-box .sv__micro-theme .sv__finish-view,#survicate-box .sv__micro-theme .sv__branded-finish-view--content{display:flex;flex-direction:column}#survicate-box .sv__micro-theme .sv__finish-view{margin-left:24px;margin-right:24px}#survicate-box .sv__micro-theme .sv__finish-view .sv__branded-finish-view--content{margin-right:-18px;overflow-y:auto;padding-right:14px}#survicate-box .sv__micro-theme .sv__finish-view .sv__branded-finish-view--content::-webkit-scrollbar{background-color:rgba(0,0,0,0);width:4px}#survicate-box .sv__micro-theme .sv__finish-view .sv__branded-finish-view--content::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.15) !important;border-radius:4px}#survicate-box .sv__micro-theme .sv__finish-view .sv__introduction{margin-bottom:24px}#survicate-box .sv__micro-theme .sv__finish-view .sv__paragraph__item,#survicate-box .sv__micro-theme .sv__finish-view .sv__thank-you-message{font-weight:600}#survicate-box .sv__micro-theme .sv__finish-view .sv__thank-you-message{align-items:flex-end;display:flex;margin-bottom:8px}#survicate-box .sv__micro-theme .sv__finish-view .sv__paragraph__container{margin-bottom:32px}#survicate-box .sv__micro-theme .sv__finish-view .sv__paragraph__item{margin-bottom:16px}#survicate-box .sv__micro-theme .sv__finish-view .sv__finish-logo{margin-bottom:48px;margin-left:auto;margin-right:auto;width:168px}#survicate-box .sv__micro-theme .sv__finish-view .sv__simple-link-button__wrapper{border-top:1px solid #c2cbcb;padding-bottom:8px;padding-top:24px}#survicate-box .sv__micro-theme .sv__finish-view .sv__simple-link-button__wrapper .sv__simple-link-button{align-items:center;background-color:#6f27f6;border-radius:6px;color:#fff;display:flex;font-size:16px;font-weight:600;height:56px;justify-content:center;width:100%}#survicate-box .sv__micro-theme .sv__finish-view .sv__simple-link-button__wrapper .sv__simple-link-button:hover{background-color:#390993}@media(max-width: 1181px){#survicate-box .sv__micro-theme .sv-box-child .sv__finish-view{width:300px}}#survicate-box .sv__micro-theme .sv__buttons{margin-bottom:16px}#survicate-box .sv__micro-theme .sv__buttons--vertical.sv__buttons .sv__button{align-items:center;display:flex;height:auto;justify-content:center;min-height:40px;padding:8px;width:100%}#survicate-box .sv__micro-theme .sv__buttons--vertical.sv__buttons .sv__button svg{margin-bottom:0;margin-right:10px;width:20px}#survicate-box .sv__micro-theme .sv__buttons .sv__button{font-size:14px;height:40px;margin-right:4px;width:40px}#survicate-box .sv__micro-theme .sv__buttons .sv__button:last-child{margin-right:0}#survicate-box .sv__micro-theme .sv__buttons .sv__button--selected,#survicate-box .sv__micro-theme .sv__buttons .sv__button:active{border-color:unset;border-style:solid;border-width:2px}#survicate-box .sv__micro-theme .sv__social-button{border-radius:6px}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__buttons .sv__button:last-child{margin-right:4px}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__buttons .sv__button:first-child{margin-right:0}#survicate-box .sv__micro-theme .sv__checkbox{background:rgba(0,0,0,0);height:20px;width:20px}#survicate-box .sv__micro-theme .sv__checkbox.sv__square{border-radius:4px}#survicate-box .sv__micro-theme .sv__checkbox.sv__square svg{border-radius:0;transform:scale(1.2)}#survicate-box .sv__micro-theme .sv__checkbox.sv__square::after{height:20px;left:-2px;top:-2px;width:20px}#survicate-box .sv__micro-theme .sv__circle{border-style:solid;border-width:2px;top:2px}#survicate-box .sv__micro-theme .sv__circle:active{background-clip:content-box;padding:2px}#survicate-box .sv__micro-theme .sv__labels{margin-bottom:8px;margin-left:0;margin-right:0;margin-top:0;overflow-wrap:break-word}#survicate-box .sv__micro-theme .sv__labels .sv__label{font-size:12px;line-height:18px}#survicate-box .sv__micro-theme .sv__labels .sv__label--right{margin-left:4px}#survicate-box .sv__micro-theme .sv__labels .sv__label--left{margin-right:4px}#survicate-box .sv__micro-theme .sv__select{margin-bottom:16px;position:relative}#survicate-box .sv__micro-theme .sv__select-icon{top:16px}#survicate-box .sv__micro-theme .sv__select-list{border-radius:6px !important;border-style:solid;border-width:1px;bottom:calc(100% + 10px);box-shadow:0 0 10px 5px rgba(41,41,42,.07)}#survicate-box .sv__micro-theme .sv__select-list::-webkit-scrollbar{background-color:rgba(0,0,0,0);width:4px}#survicate-box .sv__micro-theme .sv__select-list::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5);border-radius:4px}#survicate-box .sv__micro-theme .sv__select .sv__input{width:100%}#survicate-box .sv__micro-theme .sv__select .sv__input .sv__caret{background:none}#survicate-box .sv__micro-theme .sv__select .sv__input,#survicate-box .sv__micro-theme .sv__select .sv__select-list .sv__select-button{min-height:40px}#survicate-box .sv__micro-theme.sv__position-mobile .sv__dropdown__wrapper .sv__select-list{bottom:calc(100% + 10px);top:unset}#survicate-box .sv__micro-theme.sv__position-top-right .sv__dropdown__wrapper .sv__select-list,#survicate-box .sv__micro-theme.sv__position-top-left .sv__dropdown__wrapper .sv__select-list,#survicate-box .sv__micro-theme.sv__position-center .sv__dropdown__wrapper .sv__select-list{bottom:initial}#survicate-box .sv__micro-theme .sv__submit-button__wrapper{border-top-style:solid;border-top-width:1px;bottom:0;margin-left:24px;margin-top:0;padding-bottom:8px;padding-left:0;padding-right:0;padding-top:23px;width:calc(100% - 48px)}#survicate-box .sv__micro-theme .sv__submit-button__wrapper .sv__submit-button{align-items:center;border-bottom-width:0;border-radius:4px;border-style:none none solid none;display:flex;font-weight:600;height:auto;justify-content:center;margin:auto;min-height:40px;outline-offset:3px;overflow-wrap:break-word;width:100%}#survicate-box .sv__micro-theme .sv__submit-button__wrapper .sv__submit-button:disabled{cursor:not-allowed;opacity:.5}#survicate-box .sv__micro-theme .sv__submit-button__wrapper .sv__submit-button:disabled:hover{opacity:.5}#survicate-box .sv__micro-theme .sv__submit-button__wrapper .sv__submit-button:hover{opacity:.8;text-decoration:none}#survicate-box .sv__micro-theme.sv__rtl-lang .sv__submit-button__wrapper{margin-left:0;margin-right:24px}#survicate-box .sv__micro-theme.sv__mobile-survey .sv__submit-button:hover{opacity:unset}#survicate-box .sv__micro-theme .sv__validation{bottom:40px;left:auto;right:0;top:auto}#survicate-box .sv__micro-theme .sv__validation::after{border-color:#e33a22 rgba(0,0,0,0) rgba(0,0,0,0) rgba(0,0,0,0);border-width:8px 4px 0 4px;bottom:-8px;left:auto;right:10px;top:auto}#survicate-box .sv__micro-theme .sv-invalid.sv-invalid.sv-invalid{border:none}#survicate-box .sv__micro-theme.sv__feedback-survey.sv__feedback-survey--minimized{cursor:pointer;display:flex;justify-content:center;max-height:80px;max-width:304px;min-width:112px;padding-bottom:0;transform:translateY(-50%) rotate(270deg);transform-origin:left center}#survicate-box .sv__micro-theme.sv__feedback-survey.sv__feedback-survey--minimized .sv__feedback-survey__text{font-size:14px;font-weight:600;margin-left:unset;margin-right:unset;padding-bottom:8px;padding-left:24px;padding-right:24px;padding-top:8px;word-break:break-word}#survicate-box .sv__micro-theme.sv__position-center-right.sv__feedback-survey.sv__feedback-survey--minimized .sv__feedback-survey__text{transform:rotate(180deg)}#survicate-box .sv-desktop .sv__survey.sv__micro-theme .sv__mobile-datepicker{width:100%}#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey){border-radius:4px;left:20px;margin:20px auto;right:20px;transform:none;width:calc(100% - 40px)}#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__position-top-right,#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__position-top-left{top:0}#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__position-left,#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__position-right{bottom:0}#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__position-center{transform:translateY(50%)}#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__minimized{left:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;right:0;width:100%}#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__minimized.sv__position-center{right:0;transform:none;width:100%}#survicate-box .sv-box-child.sv-mobile .sv__survey:not(.sv__feedback-survey).sv__minimized .sv__minimized-symbol{background-color:rgba(0,0,0,0);bottom:10px;position:absolute;right:15px}@media only screen and (max-width: 568px){#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey){border-radius:4px;left:20px;margin:20px auto;right:20px;transform:none;width:calc(100% - 40px)}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__position-top-right,#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__position-top-left{top:0}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__position-left,#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__position-right{bottom:0}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__position-center{transform:translateY(50%)}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__minimized{left:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;right:0;width:100%}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__minimized.sv__position-center{right:0;transform:none;width:100%}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey:not(.sv__feedback-survey).sv__minimized .sv__minimized-symbol{background-color:rgba(0,0,0,0);bottom:10px;position:absolute;right:15px}}@media only screen and (max-width: 1181px)and (orientation: portrait){#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey){border-radius:10px 10px 0 0;bottom:0;display:flex;flex-direction:column;left:initial;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;max-height:90vh;max-width:100%;min-width:100%;right:initial;top:unset;transform:unset;width:100%}:host #survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey){max-height:90%}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__position-fullscreen{max-height:unset}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) input,#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) textarea{font-size:16px}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point{overflow-y:auto}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__scroll-container{transition:max-height .3s ease-in-out}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper{max-width:unset}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__point-description{font-size:14px;line-height:22px}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__point-question{font-size:16px;line-height:24px}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__choice-button{min-height:48px}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__minimized{align-items:center;flex-direction:row;height:104px}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__minimized .sv__minimized-symbol{bottom:unset;position:relative;right:unset}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__micro-top-bar{max-width:none}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey .sv__answer-picker{height:280px;overflow:hidden;position:relative}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey .sv__answer-picker--selected{position:absolute;top:25%;width:100%}#survicate-box .sv-box-child:not(.sv-desktop) .sv__survey .sv__answer-picker .sv__roller{align-items:center;display:flex;flex-direction:column}}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey){border-radius:10px 10px 0 0;bottom:0;display:flex;flex-direction:column;left:initial;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;max-height:90vh;max-width:100%;min-width:100%;right:initial;top:unset;transform:unset;width:100%}:host #survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey){max-height:90%}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__position-fullscreen{max-height:unset}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) input,#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) textarea{font-size:16px}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point{overflow-y:auto}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__scroll-container{transition:max-height .3s ease-in-out}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper{max-width:unset}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__point-description{font-size:14px;line-height:22px}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__point-question{font-size:16px;line-height:24px}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__choice-button{min-height:48px}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__minimized{align-items:center;flex-direction:row;height:104px}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__minimized .sv__minimized-symbol{bottom:unset;position:relative;right:unset}#survicate-box .sv-box-child.sv-mobile .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__micro-top-bar{max-width:none}#survicate-box .sv-box-child.sv-mobile .sv__survey .sv__answer-picker{height:280px;overflow:hidden;position:relative}#survicate-box .sv-box-child.sv-mobile .sv__survey .sv__answer-picker--selected{position:absolute;top:25%;width:100%}#survicate-box .sv-box-child.sv-mobile .sv__survey .sv__answer-picker .sv__roller{align-items:center;display:flex;flex-direction:column}@media only screen and (max-width: 568px){#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey){border-radius:10px 10px 0 0;bottom:0;display:flex;flex-direction:column;left:initial;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;max-height:90vh;max-width:100%;min-width:100%;right:initial;top:unset;transform:unset;width:100%}:host #survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey){max-height:90%}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__position-fullscreen{max-height:unset}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) input,#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) textarea{font-size:16px}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point{overflow-y:auto}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__scroll-container{transition:max-height .3s ease-in-out}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper{max-width:unset}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__point-description{font-size:14px;line-height:22px}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__point-question{font-size:16px;line-height:24px}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__point .sv__point-wrapper .sv__choice-button{min-height:48px}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__minimized{align-items:center;flex-direction:row;height:104px}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey).sv__minimized .sv__minimized-symbol{bottom:unset;position:relative;right:unset}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey.sv__micro-theme:not(.sv__feedback-survey) .sv__micro-top-bar{max-width:none}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey .sv__answer-picker{height:280px;overflow:hidden;position:relative}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey .sv__answer-picker--selected{position:absolute;top:25%;width:100%}#survicate-box .sv-box-child:not(.sv-tablet):not(.sv-desktop) .sv__survey .sv__answer-picker .sv__roller{align-items:center;display:flex;flex-direction:column}}#survicate-box .sv__survey-bottom-placeholder{height:12px}#survicate-box .survicate_plus-button_OvC0J{bottom:10px;position:absolute;right:15px}#survicate-box .sv__survey.sv-tablet.sv__micro-theme{min-height:285px}#survicate-box .sv__survey.sv-tablet.sv__micro-theme .sv__micro-top-bar{max-width:none}#survicate-box input::-webkit-input-placeholder{line-height:normal !important}', ""]);
        const a = o;
      },
      6314: e => {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var r = "",
                s = void 0 !== t[5];
              return t[4] && (r += "@supports (".concat(t[4], ") {")), t[2] && (r += "@media ".concat(t[2], " {")), s && (r += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), r += e(t), s && (r += "}"), t[2] && (r += "}"), t[4] && (r += "}"), r;
            }).join("");
          }, t.i = function (e, r, s, i, n) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var o = {};
            if (s) for (var a = 0; a < this.length; a++) {
              var u = this[a][0];
              null != u && (o[u] = !0);
            }
            for (var l = 0; l < e.length; l++) {
              var c = [].concat(e[l]);
              s && o[c[0]] || (void 0 !== n && (void 0 === c[5] || (c[1] = "@layer".concat(c[5].length > 0 ? " ".concat(c[5]) : "", " {").concat(c[1], "}")), c[5] = n), r && (c[2] ? (c[1] = "@media ".concat(c[2], " {").concat(c[1], "}"), c[2] = r) : c[2] = r), i && (c[4] ? (c[1] = "@supports (".concat(c[4], ") {").concat(c[1], "}"), c[4] = i) : c[4] = "".concat(i)), t.push(c));
            }
          }, t;
        };
      },
      1601: e => {
        "use strict";

        e.exports = function (e) {
          return e[1];
        };
      },
      4744: e => {
        "use strict";

        var t = function (e) {
          return function (e) {
            return !!e && "object" == typeof e;
          }(e) && !function (e) {
            var t = Object.prototype.toString.call(e);
            return "[object RegExp]" === t || "[object Date]" === t || function (e) {
              return e.$$typeof === r;
            }(e);
          }(e);
        };
        var r = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;
        function s(e, t) {
          return !1 !== t.clone && t.isMergeableObject(e) ? u((r = e, Array.isArray(r) ? [] : {}), e, t) : e;
          var r;
        }
        function i(e, t, r) {
          return e.concat(t).map(function (e) {
            return s(e, r);
          });
        }
        function n(e) {
          return Object.keys(e).concat(function (e) {
            return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function (t) {
              return Object.propertyIsEnumerable.call(e, t);
            }) : [];
          }(e));
        }
        function o(e, t) {
          try {
            return t in e;
          } catch (e) {
            return !1;
          }
        }
        function a(e, t, r) {
          var i = {};
          return r.isMergeableObject(e) && n(e).forEach(function (t) {
            i[t] = s(e[t], r);
          }), n(t).forEach(function (n) {
            (function (e, t) {
              return o(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
            })(e, n) || (o(e, n) && r.isMergeableObject(t[n]) ? i[n] = function (e, t) {
              if (!t.customMerge) return u;
              var r = t.customMerge(e);
              return "function" == typeof r ? r : u;
            }(n, r)(e[n], t[n], r) : i[n] = s(t[n], r));
          }), i;
        }
        function u(e, r, n) {
          (n = n || {}).arrayMerge = n.arrayMerge || i, n.isMergeableObject = n.isMergeableObject || t, n.cloneUnlessOtherwiseSpecified = s;
          var o = Array.isArray(r);
          return o === Array.isArray(e) ? o ? n.arrayMerge(e, r, n) : a(e, r, n) : s(r, n);
        }
        u.all = function (e, t) {
          if (!Array.isArray(e)) throw new Error("first argument should be an array");
          return e.reduce(function (e, r) {
            return u(e, r, t);
          }, {});
        };
        var l = u;
        e.exports = l;
      },
      4460: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.attributeNames = t.elementNames = void 0, t.elementNames = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function (e) {
          return [e.toLowerCase(), e];
        })), t.attributeNames = new Map(["definitionURL", "attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function (e) {
          return [e.toLowerCase(), e];
        }));
      },
      3806: function (e, t, r) {
        "use strict";

        var s = this && this.__assign || function () {
            return s = Object.assign || function (e) {
              for (var t, r = 1, s = arguments.length; r < s; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
              return e;
            }, s.apply(this, arguments);
          },
          i = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          n = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          o = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && i(t, e, r);
            return n(t, e), t;
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.render = void 0;
        var a = o(r(5413)),
          u = r(2730),
          l = r(4460),
          c = new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
        function d(e) {
          return e.replace(/"/g, "&quot;");
        }
        var v = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
        function p(e, t) {
          void 0 === t && (t = {});
          for (var r = ("length" in e) ? e : [e], s = "", i = 0; i < r.length; i++) s += _(r[i], t);
          return s;
        }
        function _(e, t) {
          switch (e.type) {
            case a.Root:
              return p(e.children, t);
            case a.Doctype:
            case a.Directive:
              return "<".concat(e.data, ">");
            case a.Comment:
              return function (e) {
                return "\x3c!--".concat(e.data, "--\x3e");
              }(e);
            case a.CDATA:
              return function (e) {
                return "<![CDATA[".concat(e.children[0].data, "]]>");
              }(e);
            case a.Script:
            case a.Style:
            case a.Tag:
              return function (e, t) {
                var r;
                "foreign" === t.xmlMode && (e.name = null !== (r = l.elementNames.get(e.name)) && void 0 !== r ? r : e.name, e.parent && f.has(e.parent.name) && (t = s(s({}, t), {
                  xmlMode: !1
                })));
                !t.xmlMode && h.has(e.name) && (t = s(s({}, t), {
                  xmlMode: "foreign"
                }));
                var i = "<".concat(e.name),
                  n = function (e, t) {
                    var r;
                    if (e) {
                      var s = !1 === (null !== (r = t.encodeEntities) && void 0 !== r ? r : t.decodeEntities) ? d : t.xmlMode || "utf8" !== t.encodeEntities ? u.encodeXML : u.escapeAttribute;
                      return Object.keys(e).map(function (r) {
                        var i,
                          n,
                          o = null !== (i = e[r]) && void 0 !== i ? i : "";
                        return "foreign" === t.xmlMode && (r = null !== (n = l.attributeNames.get(r)) && void 0 !== n ? n : r), t.emptyAttrs || t.xmlMode || "" !== o ? "".concat(r, '="').concat(s(o), '"') : r;
                      }).join(" ");
                    }
                  }(e.attribs, t);
                n && (i += " ".concat(n));
                0 === e.children.length && (t.xmlMode ? !1 !== t.selfClosingTags : t.selfClosingTags && v.has(e.name)) ? (t.xmlMode || (i += " "), i += "/>") : (i += ">", e.children.length > 0 && (i += p(e.children, t)), !t.xmlMode && v.has(e.name) || (i += "</".concat(e.name, ">")));
                return i;
              }(e, t);
            case a.Text:
              return function (e, t) {
                var r,
                  s = e.data || "";
                !1 === (null !== (r = t.encodeEntities) && void 0 !== r ? r : t.decodeEntities) || !t.xmlMode && e.parent && c.has(e.parent.name) || (s = t.xmlMode || "utf8" !== t.encodeEntities ? (0, u.encodeXML)(s) : (0, u.escapeText)(s));
                return s;
              }(e, t);
          }
        }
        t.render = p, t.default = p;
        var f = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]),
          h = new Set(["svg", "math"]);
      },
      5413: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0, function (e) {
          e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
        }(r = t.ElementType || (t.ElementType = {})), t.isTag = function (e) {
          return e.type === r.Tag || e.type === r.Script || e.type === r.Style;
        }, t.Root = r.Root, t.Text = r.Text, t.Directive = r.Directive, t.Comment = r.Comment, t.Script = r.Script, t.Style = r.Style, t.Tag = r.Tag, t.CDATA = r.CDATA, t.Doctype = r.Doctype;
      },
      1141: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__exportStar || function (e, t) {
            for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || s(t, e, r);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DomHandler = void 0;
        var n = r(5413),
          o = r(6957);
        i(r(6957), t);
        var a = {
            withStartIndices: !1,
            withEndIndices: !1,
            xmlMode: !1
          },
          u = function () {
            function e(e, t, r) {
              this.dom = [], this.root = new o.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, "function" == typeof t && (r = t, t = a), "object" == typeof e && (t = e, e = void 0), this.callback = null != e ? e : null, this.options = null != t ? t : a, this.elementCB = null != r ? r : null;
            }
            return e.prototype.onparserinit = function (e) {
              this.parser = e;
            }, e.prototype.onreset = function () {
              this.dom = [], this.root = new o.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
            }, e.prototype.onend = function () {
              this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
            }, e.prototype.onerror = function (e) {
              this.handleCallback(e);
            }, e.prototype.onclosetag = function () {
              this.lastNode = null;
              var e = this.tagStack.pop();
              this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
            }, e.prototype.onopentag = function (e, t) {
              var r = this.options.xmlMode ? n.ElementType.Tag : void 0,
                s = new o.Element(e, t, void 0, r);
              this.addNode(s), this.tagStack.push(s);
            }, e.prototype.ontext = function (e) {
              var t = this.lastNode;
              if (t && t.type === n.ElementType.Text) t.data += e, this.options.withEndIndices && (t.endIndex = this.parser.endIndex);else {
                var r = new o.Text(e);
                this.addNode(r), this.lastNode = r;
              }
            }, e.prototype.oncomment = function (e) {
              if (this.lastNode && this.lastNode.type === n.ElementType.Comment) this.lastNode.data += e;else {
                var t = new o.Comment(e);
                this.addNode(t), this.lastNode = t;
              }
            }, e.prototype.oncommentend = function () {
              this.lastNode = null;
            }, e.prototype.oncdatastart = function () {
              var e = new o.Text(""),
                t = new o.CDATA([e]);
              this.addNode(t), e.parent = t, this.lastNode = e;
            }, e.prototype.oncdataend = function () {
              this.lastNode = null;
            }, e.prototype.onprocessinginstruction = function (e, t) {
              var r = new o.ProcessingInstruction(e, t);
              this.addNode(r);
            }, e.prototype.handleCallback = function (e) {
              if ("function" == typeof this.callback) this.callback(e, this.dom);else if (e) throw e;
            }, e.prototype.addNode = function (e) {
              var t = this.tagStack[this.tagStack.length - 1],
                r = t.children[t.children.length - 1];
              this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), t.children.push(e), r && (e.prev = r, r.next = e), e.parent = t, this.lastNode = null;
            }, e;
          }();
        t.DomHandler = u, t.default = u;
      },
      6957: function (e, t, r) {
        "use strict";

        var s,
          i = this && this.__extends || (s = function (e, t) {
            return s = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
            }, s(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function r() {
              this.constructor = e;
            }
            s(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
          }),
          n = this && this.__assign || function () {
            return n = Object.assign || function (e) {
              for (var t, r = 1, s = arguments.length; r < s; r++) for (var i in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
              return e;
            }, n.apply(this, arguments);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.cloneNode = t.hasChildren = t.isDocument = t.isDirective = t.isComment = t.isText = t.isCDATA = t.isTag = t.Element = t.Document = t.CDATA = t.NodeWithChildren = t.ProcessingInstruction = t.Comment = t.Text = t.DataNode = t.Node = void 0;
        var o = r(5413),
          a = function () {
            function e() {
              this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
            }
            return Object.defineProperty(e.prototype, "parentNode", {
              get: function () {
                return this.parent;
              },
              set: function (e) {
                this.parent = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "previousSibling", {
              get: function () {
                return this.prev;
              },
              set: function (e) {
                this.prev = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "nextSibling", {
              get: function () {
                return this.next;
              },
              set: function (e) {
                this.next = e;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.cloneNode = function (e) {
              return void 0 === e && (e = !1), x(this, e);
            }, e;
          }();
        t.Node = a;
        var u = function (e) {
          function t(t) {
            var r = e.call(this) || this;
            return r.data = t, r;
          }
          return i(t, e), Object.defineProperty(t.prototype, "nodeValue", {
            get: function () {
              return this.data;
            },
            set: function (e) {
              this.data = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(a);
        t.DataNode = u;
        var l = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = o.ElementType.Text, t;
          }
          return i(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 3;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(u);
        t.Text = l;
        var c = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = o.ElementType.Comment, t;
          }
          return i(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 8;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(u);
        t.Comment = c;
        var d = function (e) {
          function t(t, r) {
            var s = e.call(this, r) || this;
            return s.name = t, s.type = o.ElementType.Directive, s;
          }
          return i(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(u);
        t.ProcessingInstruction = d;
        var v = function (e) {
          function t(t) {
            var r = e.call(this) || this;
            return r.children = t, r;
          }
          return i(t, e), Object.defineProperty(t.prototype, "firstChild", {
            get: function () {
              var e;
              return null !== (e = this.children[0]) && void 0 !== e ? e : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "lastChild", {
            get: function () {
              return this.children.length > 0 ? this.children[this.children.length - 1] : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "childNodes", {
            get: function () {
              return this.children;
            },
            set: function (e) {
              this.children = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(a);
        t.NodeWithChildren = v;
        var p = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = o.ElementType.CDATA, t;
          }
          return i(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 4;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(v);
        t.CDATA = p;
        var _ = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = o.ElementType.Root, t;
          }
          return i(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 9;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(v);
        t.Document = _;
        var f = function (e) {
          function t(t, r, s, i) {
            void 0 === s && (s = []), void 0 === i && (i = "script" === t ? o.ElementType.Script : "style" === t ? o.ElementType.Style : o.ElementType.Tag);
            var n = e.call(this, s) || this;
            return n.name = t, n.attribs = r, n.type = i, n;
          }
          return i(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "tagName", {
            get: function () {
              return this.name;
            },
            set: function (e) {
              this.name = e;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "attributes", {
            get: function () {
              var e = this;
              return Object.keys(this.attribs).map(function (t) {
                var r, s;
                return {
                  name: t,
                  value: e.attribs[t],
                  namespace: null === (r = e["x-attribsNamespace"]) || void 0 === r ? void 0 : r[t],
                  prefix: null === (s = e["x-attribsPrefix"]) || void 0 === s ? void 0 : s[t]
                };
              });
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(v);
        function h(e) {
          return (0, o.isTag)(e);
        }
        function m(e) {
          return e.type === o.ElementType.CDATA;
        }
        function g(e) {
          return e.type === o.ElementType.Text;
        }
        function b(e) {
          return e.type === o.ElementType.Comment;
        }
        function y(e) {
          return e.type === o.ElementType.Directive;
        }
        function w(e) {
          return e.type === o.ElementType.Root;
        }
        function x(e, t) {
          var r;
          if (void 0 === t && (t = !1), g(e)) r = new l(e.data);else if (b(e)) r = new c(e.data);else if (h(e)) {
            var s = t ? S(e.children) : [],
              i = new f(e.name, n({}, e.attribs), s);
            s.forEach(function (e) {
              return e.parent = i;
            }), null != e.namespace && (i.namespace = e.namespace), e["x-attribsNamespace"] && (i["x-attribsNamespace"] = n({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (i["x-attribsPrefix"] = n({}, e["x-attribsPrefix"])), r = i;
          } else if (m(e)) {
            s = t ? S(e.children) : [];
            var o = new p(s);
            s.forEach(function (e) {
              return e.parent = o;
            }), r = o;
          } else if (w(e)) {
            s = t ? S(e.children) : [];
            var a = new _(s);
            s.forEach(function (e) {
              return e.parent = a;
            }), e["x-mode"] && (a["x-mode"] = e["x-mode"]), r = a;
          } else {
            if (!y(e)) throw new Error("Not implemented yet: ".concat(e.type));
            var u = new d(e.name, e.data);
            null != e["x-name"] && (u["x-name"] = e["x-name"], u["x-publicId"] = e["x-publicId"], u["x-systemId"] = e["x-systemId"]), r = u;
          }
          return r.startIndex = e.startIndex, r.endIndex = e.endIndex, null != e.sourceCodeLocation && (r.sourceCodeLocation = e.sourceCodeLocation), r;
        }
        function S(e) {
          for (var t = e.map(function (e) {
              return x(e, !0);
            }), r = 1; r < t.length; r++) t[r].prev = t[r - 1], t[r - 1].next = t[r];
          return t;
        }
        t.Element = f, t.isTag = h, t.isCDATA = m, t.isText = g, t.isComment = b, t.isDirective = y, t.isDocument = w, t.hasChildren = function (e) {
          return Object.prototype.hasOwnProperty.call(e, "children");
        }, t.cloneNode = x;
      },
      4437: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFeed = void 0;
        var s = r(6037),
          i = r(3209);
        t.getFeed = function (e) {
          var t = u(d, e);
          return t ? "feed" === t.name ? function (e) {
            var t,
              r = e.children,
              s = {
                type: "atom",
                items: (0, i.getElementsByTagName)("entry", r).map(function (e) {
                  var t,
                    r = e.children,
                    s = {
                      media: a(r)
                    };
                  c(s, "id", "id", r), c(s, "title", "title", r);
                  var i = null === (t = u("link", r)) || void 0 === t ? void 0 : t.attribs.href;
                  i && (s.link = i);
                  var n = l("summary", r) || l("content", r);
                  n && (s.description = n);
                  var o = l("updated", r);
                  return o && (s.pubDate = new Date(o)), s;
                })
              };
            c(s, "id", "id", r), c(s, "title", "title", r);
            var n = null === (t = u("link", r)) || void 0 === t ? void 0 : t.attribs.href;
            n && (s.link = n);
            c(s, "description", "subtitle", r);
            var o = l("updated", r);
            o && (s.updated = new Date(o));
            return c(s, "author", "email", r, !0), s;
          }(t) : function (e) {
            var t,
              r,
              s = null !== (r = null === (t = u("channel", e.children)) || void 0 === t ? void 0 : t.children) && void 0 !== r ? r : [],
              n = {
                type: e.name.substr(0, 3),
                id: "",
                items: (0, i.getElementsByTagName)("item", e.children).map(function (e) {
                  var t = e.children,
                    r = {
                      media: a(t)
                    };
                  c(r, "id", "guid", t), c(r, "title", "title", t), c(r, "link", "link", t), c(r, "description", "description", t);
                  var s = l("pubDate", t) || l("dc:date", t);
                  return s && (r.pubDate = new Date(s)), r;
                })
              };
            c(n, "title", "title", s), c(n, "link", "link", s), c(n, "description", "description", s);
            var o = l("lastBuildDate", s);
            o && (n.updated = new Date(o));
            return c(n, "author", "managingEditor", s, !0), n;
          }(t) : null;
        };
        var n = ["url", "type", "lang"],
          o = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
        function a(e) {
          return (0, i.getElementsByTagName)("media:content", e).map(function (e) {
            for (var t = e.attribs, r = {
                medium: t.medium,
                isDefault: !!t.isDefault
              }, s = 0, i = n; s < i.length; s++) {
              t[l = i[s]] && (r[l] = t[l]);
            }
            for (var a = 0, u = o; a < u.length; a++) {
              var l;
              t[l = u[a]] && (r[l] = parseInt(t[l], 10));
            }
            return t.expression && (r.expression = t.expression), r;
          });
        }
        function u(e, t) {
          return (0, i.getElementsByTagName)(e, t, !0, 1)[0];
        }
        function l(e, t, r) {
          return void 0 === r && (r = !1), (0, s.textContent)((0, i.getElementsByTagName)(e, t, r, 1)).trim();
        }
        function c(e, t, r, s, i) {
          void 0 === i && (i = !1);
          var n = l(r, s, i);
          n && (e[t] = n);
        }
        function d(e) {
          return "rss" === e || "feed" === e || "rdf:RDF" === e;
        }
      },
      5397: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.uniqueSort = t.compareDocumentPosition = t.DocumentPosition = t.removeSubsets = void 0;
        var s,
          i = r(1141);
        function n(e, t) {
          var r = [],
            n = [];
          if (e === t) return 0;
          for (var o = (0, i.hasChildren)(e) ? e : e.parent; o;) r.unshift(o), o = o.parent;
          for (o = (0, i.hasChildren)(t) ? t : t.parent; o;) n.unshift(o), o = o.parent;
          for (var a = Math.min(r.length, n.length), u = 0; u < a && r[u] === n[u];) u++;
          if (0 === u) return s.DISCONNECTED;
          var l = r[u - 1],
            c = l.children,
            d = r[u],
            v = n[u];
          return c.indexOf(d) > c.indexOf(v) ? l === t ? s.FOLLOWING | s.CONTAINED_BY : s.FOLLOWING : l === e ? s.PRECEDING | s.CONTAINS : s.PRECEDING;
        }
        t.removeSubsets = function (e) {
          for (var t = e.length; --t >= 0;) {
            var r = e[t];
            if (t > 0 && e.lastIndexOf(r, t - 1) >= 0) e.splice(t, 1);else for (var s = r.parent; s; s = s.parent) if (e.includes(s)) {
              e.splice(t, 1);
              break;
            }
          }
          return e;
        }, function (e) {
          e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
        }(s = t.DocumentPosition || (t.DocumentPosition = {})), t.compareDocumentPosition = n, t.uniqueSort = function (e) {
          return (e = e.filter(function (e, t, r) {
            return !r.includes(e, t + 1);
          })).sort(function (e, t) {
            var r = n(e, t);
            return r & s.PRECEDING ? -1 : r & s.FOLLOWING ? 1 : 0;
          }), e;
        };
      },
      8888: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__exportStar || function (e, t) {
            for (var r in e) "default" === r || Object.prototype.hasOwnProperty.call(t, r) || s(t, e, r);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.hasChildren = t.isDocument = t.isComment = t.isText = t.isCDATA = t.isTag = void 0, i(r(6037), t), i(r(8938), t), i(r(3403), t), i(r(718), t), i(r(3209), t), i(r(5397), t), i(r(4437), t);
        var n = r(1141);
        Object.defineProperty(t, "isTag", {
          enumerable: !0,
          get: function () {
            return n.isTag;
          }
        }), Object.defineProperty(t, "isCDATA", {
          enumerable: !0,
          get: function () {
            return n.isCDATA;
          }
        }), Object.defineProperty(t, "isText", {
          enumerable: !0,
          get: function () {
            return n.isText;
          }
        }), Object.defineProperty(t, "isComment", {
          enumerable: !0,
          get: function () {
            return n.isComment;
          }
        }), Object.defineProperty(t, "isDocument", {
          enumerable: !0,
          get: function () {
            return n.isDocument;
          }
        }), Object.defineProperty(t, "hasChildren", {
          enumerable: !0,
          get: function () {
            return n.hasChildren;
          }
        });
      },
      3209: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getElementsByTagType = t.getElementsByTagName = t.getElementById = t.getElements = t.testElement = void 0;
        var s = r(1141),
          i = r(718),
          n = {
            tag_name: function (e) {
              return "function" == typeof e ? function (t) {
                return (0, s.isTag)(t) && e(t.name);
              } : "*" === e ? s.isTag : function (t) {
                return (0, s.isTag)(t) && t.name === e;
              };
            },
            tag_type: function (e) {
              return "function" == typeof e ? function (t) {
                return e(t.type);
              } : function (t) {
                return t.type === e;
              };
            },
            tag_contains: function (e) {
              return "function" == typeof e ? function (t) {
                return (0, s.isText)(t) && e(t.data);
              } : function (t) {
                return (0, s.isText)(t) && t.data === e;
              };
            }
          };
        function o(e, t) {
          return "function" == typeof t ? function (r) {
            return (0, s.isTag)(r) && t(r.attribs[e]);
          } : function (r) {
            return (0, s.isTag)(r) && r.attribs[e] === t;
          };
        }
        function a(e, t) {
          return function (r) {
            return e(r) || t(r);
          };
        }
        function u(e) {
          var t = Object.keys(e).map(function (t) {
            var r = e[t];
            return Object.prototype.hasOwnProperty.call(n, t) ? n[t](r) : o(t, r);
          });
          return 0 === t.length ? null : t.reduce(a);
        }
        t.testElement = function (e, t) {
          var r = u(e);
          return !r || r(t);
        }, t.getElements = function (e, t, r, s) {
          void 0 === s && (s = 1 / 0);
          var n = u(e);
          return n ? (0, i.filter)(n, t, r, s) : [];
        }, t.getElementById = function (e, t, r) {
          return void 0 === r && (r = !0), Array.isArray(t) || (t = [t]), (0, i.findOne)(o("id", e), t, r);
        }, t.getElementsByTagName = function (e, t, r, s) {
          return void 0 === r && (r = !0), void 0 === s && (s = 1 / 0), (0, i.filter)(n.tag_name(e), t, r, s);
        }, t.getElementsByTagType = function (e, t, r, s) {
          return void 0 === r && (r = !0), void 0 === s && (s = 1 / 0), (0, i.filter)(n.tag_type(e), t, r, s);
        };
      },
      3403: (e, t) => {
        "use strict";

        function r(e) {
          if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
            var t = e.parent.children,
              r = t.lastIndexOf(e);
            r >= 0 && t.splice(r, 1);
          }
          e.next = null, e.prev = null, e.parent = null;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prepend = t.prependChild = t.append = t.appendChild = t.replaceElement = t.removeElement = void 0, t.removeElement = r, t.replaceElement = function (e, t) {
          var r = t.prev = e.prev;
          r && (r.next = t);
          var s = t.next = e.next;
          s && (s.prev = t);
          var i = t.parent = e.parent;
          if (i) {
            var n = i.children;
            n[n.lastIndexOf(e)] = t, e.parent = null;
          }
        }, t.appendChild = function (e, t) {
          if (r(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
            var s = e.children[e.children.length - 2];
            s.next = t, t.prev = s;
          } else t.prev = null;
        }, t.append = function (e, t) {
          r(t);
          var s = e.parent,
            i = e.next;
          if (t.next = i, t.prev = e, e.next = t, t.parent = s, i) {
            if (i.prev = t, s) {
              var n = s.children;
              n.splice(n.lastIndexOf(i), 0, t);
            }
          } else s && s.children.push(t);
        }, t.prependChild = function (e, t) {
          if (r(t), t.parent = e, t.prev = null, 1 !== e.children.unshift(t)) {
            var s = e.children[1];
            s.prev = t, t.next = s;
          } else t.next = null;
        }, t.prepend = function (e, t) {
          r(t);
          var s = e.parent;
          if (s) {
            var i = s.children;
            i.splice(i.indexOf(e), 0, t);
          }
          e.prev && (e.prev.next = t), t.parent = s, t.prev = e.prev, t.next = e, e.prev = t;
        };
      },
      718: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.findAll = t.existsOne = t.findOne = t.findOneChild = t.find = t.filter = void 0;
        var s = r(1141);
        function i(e, t, r, i) {
          for (var n = [], o = [t], a = [0];;) if (a[0] >= o[0].length) {
            if (1 === a.length) return n;
            o.shift(), a.shift();
          } else {
            var u = o[0][a[0]++];
            if (e(u) && (n.push(u), --i <= 0)) return n;
            r && (0, s.hasChildren)(u) && u.children.length > 0 && (a.unshift(0), o.unshift(u.children));
          }
        }
        t.filter = function (e, t, r, s) {
          return void 0 === r && (r = !0), void 0 === s && (s = 1 / 0), i(e, Array.isArray(t) ? t : [t], r, s);
        }, t.find = i, t.findOneChild = function (e, t) {
          return t.find(e);
        }, t.findOne = function e(t, r, i) {
          void 0 === i && (i = !0);
          for (var n = null, o = 0; o < r.length && !n; o++) {
            var a = r[o];
            (0, s.isTag)(a) && (t(a) ? n = a : i && a.children.length > 0 && (n = e(t, a.children, !0)));
          }
          return n;
        }, t.existsOne = function e(t, r) {
          return r.some(function (r) {
            return (0, s.isTag)(r) && (t(r) || e(t, r.children));
          });
        }, t.findAll = function (e, t) {
          for (var r = [], i = [t], n = [0];;) if (n[0] >= i[0].length) {
            if (1 === i.length) return r;
            i.shift(), n.shift();
          } else {
            var o = i[0][n[0]++];
            (0, s.isTag)(o) && (e(o) && r.push(o), o.children.length > 0 && (n.unshift(0), i.unshift(o.children)));
          }
        };
      },
      6037: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.innerText = t.textContent = t.getText = t.getInnerHTML = t.getOuterHTML = void 0;
        var i = r(1141),
          n = s(r(3806)),
          o = r(5413);
        function a(e, t) {
          return (0, n.default)(e, t);
        }
        t.getOuterHTML = a, t.getInnerHTML = function (e, t) {
          return (0, i.hasChildren)(e) ? e.children.map(function (e) {
            return a(e, t);
          }).join("") : "";
        }, t.getText = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, i.isTag)(t) ? "br" === t.name ? "\n" : e(t.children) : (0, i.isCDATA)(t) ? e(t.children) : (0, i.isText)(t) ? t.data : "";
        }, t.textContent = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, i.hasChildren)(t) && !(0, i.isComment)(t) ? e(t.children) : (0, i.isText)(t) ? t.data : "";
        }, t.innerText = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, i.hasChildren)(t) && (t.type === o.ElementType.Tag || (0, i.isCDATA)(t)) ? e(t.children) : (0, i.isText)(t) ? t.data : "";
        };
      },
      8938: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prevElementSibling = t.nextElementSibling = t.getName = t.hasAttrib = t.getAttributeValue = t.getSiblings = t.getParent = t.getChildren = void 0;
        var s = r(1141);
        function i(e) {
          return (0, s.hasChildren)(e) ? e.children : [];
        }
        function n(e) {
          return e.parent || null;
        }
        t.getChildren = i, t.getParent = n, t.getSiblings = function (e) {
          var t = n(e);
          if (null != t) return i(t);
          for (var r = [e], s = e.prev, o = e.next; null != s;) r.unshift(s), s = s.prev;
          for (; null != o;) r.push(o), o = o.next;
          return r;
        }, t.getAttributeValue = function (e, t) {
          var r;
          return null === (r = e.attribs) || void 0 === r ? void 0 : r[t];
        }, t.hasAttrib = function (e, t) {
          return null != e.attribs && Object.prototype.hasOwnProperty.call(e.attribs, t) && null != e.attribs[t];
        }, t.getName = function (e) {
          return e.name;
        }, t.nextElementSibling = function (e) {
          for (var t = e.next; null !== t && !(0, s.isTag)(t);) t = t.next;
          return t;
        }, t.prevElementSibling = function (e) {
          for (var t = e.prev; null !== t && !(0, s.isTag)(t);) t = t.prev;
          return t;
        };
      },
      9878: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          n = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && s(t, e, r);
            return i(t, e), t;
          },
          o = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeXML = t.decodeHTMLStrict = t.decodeHTMLAttribute = t.decodeHTML = t.determineBranch = t.EntityDecoder = t.DecodingMode = t.BinTrieFlags = t.fromCodePoint = t.replaceCodePoint = t.decodeCodePoint = t.xmlDecodeTree = t.htmlDecodeTree = void 0;
        var a = o(r(3603));
        t.htmlDecodeTree = a.default;
        var u = o(r(2517));
        t.xmlDecodeTree = u.default;
        var l = n(r(5096));
        t.decodeCodePoint = l.default;
        var c,
          d = r(5096);
        Object.defineProperty(t, "replaceCodePoint", {
          enumerable: !0,
          get: function () {
            return d.replaceCodePoint;
          }
        }), Object.defineProperty(t, "fromCodePoint", {
          enumerable: !0,
          get: function () {
            return d.fromCodePoint;
          }
        }), function (e) {
          e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
        }(c || (c = {}));
        var v, p, _;
        function f(e) {
          return e >= c.ZERO && e <= c.NINE;
        }
        function h(e) {
          return e === c.EQUALS || function (e) {
            return e >= c.UPPER_A && e <= c.UPPER_Z || e >= c.LOWER_A && e <= c.LOWER_Z || f(e);
          }(e);
        }
        !function (e) {
          e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
        }(v = t.BinTrieFlags || (t.BinTrieFlags = {})), function (e) {
          e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
        }(p || (p = {})), function (e) {
          e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
        }(_ = t.DecodingMode || (t.DecodingMode = {}));
        var m = function () {
          function e(e, t, r) {
            this.decodeTree = e, this.emitCodePoint = t, this.errors = r, this.state = p.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = _.Strict;
          }
          return e.prototype.startEntity = function (e) {
            this.decodeMode = e, this.state = p.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
          }, e.prototype.write = function (e, t) {
            switch (this.state) {
              case p.EntityStart:
                return e.charCodeAt(t) === c.NUM ? (this.state = p.NumericStart, this.consumed += 1, this.stateNumericStart(e, t + 1)) : (this.state = p.NamedEntity, this.stateNamedEntity(e, t));
              case p.NumericStart:
                return this.stateNumericStart(e, t);
              case p.NumericDecimal:
                return this.stateNumericDecimal(e, t);
              case p.NumericHex:
                return this.stateNumericHex(e, t);
              case p.NamedEntity:
                return this.stateNamedEntity(e, t);
            }
          }, e.prototype.stateNumericStart = function (e, t) {
            return t >= e.length ? -1 : (32 | e.charCodeAt(t)) === c.LOWER_X ? (this.state = p.NumericHex, this.consumed += 1, this.stateNumericHex(e, t + 1)) : (this.state = p.NumericDecimal, this.stateNumericDecimal(e, t));
          }, e.prototype.addToNumericResult = function (e, t, r, s) {
            if (t !== r) {
              var i = r - t;
              this.result = this.result * Math.pow(s, i) + parseInt(e.substr(t, i), s), this.consumed += i;
            }
          }, e.prototype.stateNumericHex = function (e, t) {
            for (var r, s = t; t < e.length;) {
              var i = e.charCodeAt(t);
              if (!(f(i) || (r = i, r >= c.UPPER_A && r <= c.UPPER_F || r >= c.LOWER_A && r <= c.LOWER_F))) return this.addToNumericResult(e, s, t, 16), this.emitNumericEntity(i, 3);
              t += 1;
            }
            return this.addToNumericResult(e, s, t, 16), -1;
          }, e.prototype.stateNumericDecimal = function (e, t) {
            for (var r = t; t < e.length;) {
              var s = e.charCodeAt(t);
              if (!f(s)) return this.addToNumericResult(e, r, t, 10), this.emitNumericEntity(s, 2);
              t += 1;
            }
            return this.addToNumericResult(e, r, t, 10), -1;
          }, e.prototype.emitNumericEntity = function (e, t) {
            var r;
            if (this.consumed <= t) return null === (r = this.errors) || void 0 === r || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            if (e === c.SEMI) this.consumed += 1;else if (this.decodeMode === _.Strict) return 0;
            return this.emitCodePoint((0, l.replaceCodePoint)(this.result), this.consumed), this.errors && (e !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
          }, e.prototype.stateNamedEntity = function (e, t) {
            for (var r = this.decodeTree, s = r[this.treeIndex], i = (s & v.VALUE_LENGTH) >> 14; t < e.length; t++, this.excess++) {
              var n = e.charCodeAt(t);
              if (this.treeIndex = b(r, s, this.treeIndex + Math.max(1, i), n), this.treeIndex < 0) return 0 === this.result || this.decodeMode === _.Attribute && (0 === i || h(n)) ? 0 : this.emitNotTerminatedNamedEntity();
              if (0 !== (i = ((s = r[this.treeIndex]) & v.VALUE_LENGTH) >> 14)) {
                if (n === c.SEMI) return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
                this.decodeMode !== _.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
              }
            }
            return -1;
          }, e.prototype.emitNotTerminatedNamedEntity = function () {
            var e,
              t = this.result,
              r = (this.decodeTree[t] & v.VALUE_LENGTH) >> 14;
            return this.emitNamedEntityData(t, r, this.consumed), null === (e = this.errors) || void 0 === e || e.missingSemicolonAfterCharacterReference(), this.consumed;
          }, e.prototype.emitNamedEntityData = function (e, t, r) {
            var s = this.decodeTree;
            return this.emitCodePoint(1 === t ? s[e] & ~v.VALUE_LENGTH : s[e + 1], r), 3 === t && this.emitCodePoint(s[e + 2], r), r;
          }, e.prototype.end = function () {
            var e;
            switch (this.state) {
              case p.NamedEntity:
                return 0 === this.result || this.decodeMode === _.Attribute && this.result !== this.treeIndex ? 0 : this.emitNotTerminatedNamedEntity();
              case p.NumericDecimal:
                return this.emitNumericEntity(0, 2);
              case p.NumericHex:
                return this.emitNumericEntity(0, 3);
              case p.NumericStart:
                return null === (e = this.errors) || void 0 === e || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
              case p.EntityStart:
                return 0;
            }
          }, e;
        }();
        function g(e) {
          var t = "",
            r = new m(e, function (e) {
              return t += (0, l.fromCodePoint)(e);
            });
          return function (e, s) {
            for (var i = 0, n = 0; (n = e.indexOf("&", n)) >= 0;) {
              t += e.slice(i, n), r.startEntity(s);
              var o = r.write(e, n + 1);
              if (o < 0) {
                i = n + r.end();
                break;
              }
              i = n + o, n = 0 === o ? i + 1 : i;
            }
            var a = t + e.slice(i);
            return t = "", a;
          };
        }
        function b(e, t, r, s) {
          var i = (t & v.BRANCH_LENGTH) >> 7,
            n = t & v.JUMP_TABLE;
          if (0 === i) return 0 !== n && s === n ? r : -1;
          if (n) {
            var o = s - n;
            return o < 0 || o >= i ? -1 : e[r + o] - 1;
          }
          for (var a = r, u = a + i - 1; a <= u;) {
            var l = a + u >>> 1,
              c = e[l];
            if (c < s) a = l + 1;else {
              if (!(c > s)) return e[l + i];
              u = l - 1;
            }
          }
          return -1;
        }
        t.EntityDecoder = m, t.determineBranch = b;
        var y = g(a.default),
          w = g(u.default);
        t.decodeHTML = function (e, t) {
          return void 0 === t && (t = _.Legacy), y(e, t);
        }, t.decodeHTMLAttribute = function (e) {
          return y(e, _.Attribute);
        }, t.decodeHTMLStrict = function (e) {
          return y(e, _.Strict);
        }, t.decodeXML = function (e) {
          return w(e, _.Strict);
        };
      },
      5096: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.replaceCodePoint = t.fromCodePoint = void 0;
        var s = new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
        function i(e) {
          var t;
          return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : null !== (t = s.get(e)) && void 0 !== t ? t : e;
        }
        t.fromCodePoint = null !== (r = String.fromCodePoint) && void 0 !== r ? r : function (e) {
          var t = "";
          return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += String.fromCharCode(e);
        }, t.replaceCodePoint = i, t.default = function (e) {
          return (0, t.fromCodePoint)(i(e));
        };
      },
      1818: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.encodeNonAsciiHTML = t.encodeHTML = void 0;
        var i = s(r(5504)),
          n = r(5987),
          o = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
        function a(e, t) {
          for (var r, s = "", o = 0; null !== (r = e.exec(t));) {
            var a = r.index;
            s += t.substring(o, a);
            var u = t.charCodeAt(a),
              l = i.default.get(u);
            if ("object" == typeof l) {
              if (a + 1 < t.length) {
                var c = t.charCodeAt(a + 1),
                  d = "number" == typeof l.n ? l.n === c ? l.o : void 0 : l.n.get(c);
                if (void 0 !== d) {
                  s += d, o = e.lastIndex += 1;
                  continue;
                }
              }
              l = l.v;
            }
            if (void 0 !== l) s += l, o = a + 1;else {
              var v = (0, n.getCodePoint)(t, a);
              s += "&#x".concat(v.toString(16), ";"), o = e.lastIndex += Number(v !== u);
            }
          }
          return s + t.substr(o);
        }
        t.encodeHTML = function (e) {
          return a(o, e);
        }, t.encodeNonAsciiHTML = function (e) {
          return a(n.xmlReplacer, e);
        };
      },
      5987: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.getCodePoint = t.xmlReplacer = void 0, t.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
        var r = new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]);
        function s(e) {
          for (var s, i = "", n = 0; null !== (s = t.xmlReplacer.exec(e));) {
            var o = s.index,
              a = e.charCodeAt(o),
              u = r.get(a);
            void 0 !== u ? (i += e.substring(n, o) + u, n = o + 1) : (i += "".concat(e.substring(n, o), "&#x").concat((0, t.getCodePoint)(e, o).toString(16), ";"), n = t.xmlReplacer.lastIndex += Number(55296 == (64512 & a)));
          }
          return i + e.substr(n);
        }
        function i(e, t) {
          return function (r) {
            for (var s, i = 0, n = ""; s = e.exec(r);) i !== s.index && (n += r.substring(i, s.index)), n += t.get(s[0].charCodeAt(0)), i = s.index + 1;
            return n + r.substring(i);
          };
        }
        t.getCodePoint = null != String.prototype.codePointAt ? function (e, t) {
          return e.codePointAt(t);
        } : function (e, t) {
          return 55296 == (64512 & e.charCodeAt(t)) ? 1024 * (e.charCodeAt(t) - 55296) + e.charCodeAt(t + 1) - 56320 + 65536 : e.charCodeAt(t);
        }, t.encodeXML = s, t.escape = s, t.escapeUTF8 = i(/[&<>'"]/g, r), t.escapeAttribute = i(/["&\u00A0]/g, new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]])), t.escapeText = i(/[&<>\u00A0]/g, new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
      },
      3603: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Uint16Array('ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function (e) {
          return e.charCodeAt(0);
        }));
      },
      2517: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Uint16Array("Ȁaglq\tɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function (e) {
          return e.charCodeAt(0);
        }));
      },
      5504: (e, t) => {
        "use strict";

        function r(e) {
          for (var t = 1; t < e.length; t++) e[t][0] += e[t - 1][0] + 1;
          return e;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Map(r([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, {
          v: "&lt;",
          n: 8402,
          o: "&nvlt;"
        }], [0, {
          v: "&equals;",
          n: 8421,
          o: "&bne;"
        }], [0, {
          v: "&gt;",
          n: 8402,
          o: "&nvgt;"
        }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, {
          n: 106,
          o: "&fjlig;"
        }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, {
          v: "&MediumSpace;",
          n: 8202,
          o: "&ThickSpace;"
        }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, {
          v: "&rarrw;",
          n: 824,
          o: "&nrarrw;"
        }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, {
          v: "&part;",
          n: 824,
          o: "&npart;"
        }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, {
          v: "&ang;",
          n: 8402,
          o: "&nang;"
        }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, {
          v: "&cap;",
          n: 65024,
          o: "&caps;"
        }], [0, {
          v: "&cup;",
          n: 65024,
          o: "&cups;"
        }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, {
          v: "&sim;",
          n: 8402,
          o: "&nvsim;"
        }], [0, {
          v: "&backsim;",
          n: 817,
          o: "&race;"
        }], [0, {
          v: "&ac;",
          n: 819,
          o: "&acE;"
        }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, {
          v: "&eqsim;",
          n: 824,
          o: "&nesim;"
        }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, {
          v: "&apid;",
          n: 824,
          o: "&napid;"
        }], [0, "&backcong;"], [0, {
          v: "&asympeq;",
          n: 8402,
          o: "&nvap;"
        }], [0, {
          v: "&bump;",
          n: 824,
          o: "&nbump;"
        }], [0, {
          v: "&bumpe;",
          n: 824,
          o: "&nbumpe;"
        }], [0, {
          v: "&doteq;",
          n: 824,
          o: "&nedot;"
        }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, {
          v: "&Congruent;",
          n: 8421,
          o: "&bnequiv;"
        }], [0, "&nequiv;"], [1, {
          v: "&le;",
          n: 8402,
          o: "&nvle;"
        }], [0, {
          v: "&ge;",
          n: 8402,
          o: "&nvge;"
        }], [0, {
          v: "&lE;",
          n: 824,
          o: "&nlE;"
        }], [0, {
          v: "&gE;",
          n: 824,
          o: "&ngE;"
        }], [0, {
          v: "&lnE;",
          n: 65024,
          o: "&lvertneqq;"
        }], [0, {
          v: "&gnE;",
          n: 65024,
          o: "&gvertneqq;"
        }], [0, {
          v: "&ll;",
          n: new Map(r([[824, "&nLtv;"], [7577, "&nLt;"]]))
        }], [0, {
          v: "&gg;",
          n: new Map(r([[824, "&nGtv;"], [7577, "&nGt;"]]))
        }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, {
          v: "&scsim;",
          n: 824,
          o: "&NotSucceedsTilde;"
        }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, {
          v: "&sub;",
          n: 8402,
          o: "&NotSubset;"
        }], [0, {
          v: "&sup;",
          n: 8402,
          o: "&NotSuperset;"
        }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, {
          v: "&subne;",
          n: 65024,
          o: "&varsubsetneq;"
        }], [0, {
          v: "&supne;",
          n: 65024,
          o: "&varsupsetneq;"
        }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, {
          v: "&sqsub;",
          n: 824,
          o: "&NotSquareSubset;"
        }], [0, {
          v: "&sqsup;",
          n: 824,
          o: "&NotSquareSuperset;"
        }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, {
          v: "&sqcap;",
          n: 65024,
          o: "&sqcaps;"
        }], [0, {
          v: "&sqcup;",
          n: 65024,
          o: "&sqcups;"
        }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, {
          v: "&LeftTriangleEqual;",
          n: 8402,
          o: "&nvltrie;"
        }], [0, {
          v: "&RightTriangleEqual;",
          n: 8402,
          o: "&nvrtrie;"
        }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, {
          v: "&Ll;",
          n: 824,
          o: "&nLl;"
        }], [0, {
          v: "&Gg;",
          n: 824,
          o: "&nGg;"
        }], [0, {
          v: "&leg;",
          n: 65024,
          o: "&lesg;"
        }], [0, {
          v: "&gel;",
          n: 65024,
          o: "&gesl;"
        }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, {
          v: "&isindot;",
          n: 824,
          o: "&notindot;"
        }], [0, "&notinvc;"], [0, "&notinvb;"], [1, {
          v: "&isinE;",
          n: 824,
          o: "&notinE;"
        }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, {
          v: "&rarrc;",
          n: 824,
          o: "&nrarrc;"
        }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, {
          v: "&LeftTriangleBar;",
          n: 824,
          o: "&NotLeftTriangleBar;"
        }], [0, {
          v: "&RightTriangleBar;",
          n: 824,
          o: "&NotRightTriangleBar;"
        }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, {
          v: "&congdot;",
          n: 824,
          o: "&ncongdot;"
        }], [0, "&easter;"], [0, "&apacir;"], [0, {
          v: "&apE;",
          n: 824,
          o: "&napE;"
        }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, {
          v: "&leqslant;",
          n: 824,
          o: "&nleqslant;"
        }], [0, {
          v: "&geqslant;",
          n: 824,
          o: "&ngeqslant;"
        }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, {
          v: "&LessLess;",
          n: 824,
          o: "&NotNestedLessLess;"
        }], [0, {
          v: "&GreaterGreater;",
          n: 824,
          o: "&NotNestedGreaterGreater;"
        }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, {
          v: "&smte;",
          n: 65024,
          o: "&smtes;"
        }], [0, {
          v: "&late;",
          n: 65024,
          o: "&lates;"
        }], [0, "&bumpE;"], [0, {
          v: "&PrecedesEqual;",
          n: 824,
          o: "&NotPrecedesEqual;"
        }], [0, {
          v: "&sce;",
          n: 824,
          o: "&NotSucceedsEqual;"
        }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, {
          v: "&subE;",
          n: 824,
          o: "&nsubE;"
        }], [0, {
          v: "&supE;",
          n: 824,
          o: "&nsupE;"
        }], [0, "&subsim;"], [0, "&supsim;"], [2, {
          v: "&subnE;",
          n: 65024,
          o: "&varsubsetneqq;"
        }], [0, {
          v: "&supnE;",
          n: 65024,
          o: "&varsupsetneqq;"
        }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, {
          v: "&parsl;",
          n: 8421,
          o: "&nparsl;"
        }], [44343, {
          n: new Map(r([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]]))
        }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
      },
      2730: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLAttribute = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.DecodingMode = t.EntityDecoder = t.encodeHTML5 = t.encodeHTML4 = t.encodeNonAsciiHTML = t.encodeHTML = t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.encode = t.decodeStrict = t.decode = t.EncodingMode = t.EntityLevel = void 0;
        var s,
          i,
          n = r(9878),
          o = r(1818),
          a = r(5987);
        function u(e, t) {
          if (void 0 === t && (t = s.XML), ("number" == typeof t ? t : t.level) === s.HTML) {
            var r = "object" == typeof t ? t.mode : void 0;
            return (0, n.decodeHTML)(e, r);
          }
          return (0, n.decodeXML)(e);
        }
        !function (e) {
          e[e.XML = 0] = "XML", e[e.HTML = 1] = "HTML";
        }(s = t.EntityLevel || (t.EntityLevel = {})), function (e) {
          e[e.UTF8 = 0] = "UTF8", e[e.ASCII = 1] = "ASCII", e[e.Extensive = 2] = "Extensive", e[e.Attribute = 3] = "Attribute", e[e.Text = 4] = "Text";
        }(i = t.EncodingMode || (t.EncodingMode = {})), t.decode = u, t.decodeStrict = function (e, t) {
          var r;
          void 0 === t && (t = s.XML);
          var i = "number" == typeof t ? {
            level: t
          } : t;
          return null !== (r = i.mode) && void 0 !== r || (i.mode = n.DecodingMode.Strict), u(e, i);
        }, t.encode = function (e, t) {
          void 0 === t && (t = s.XML);
          var r = "number" == typeof t ? {
            level: t
          } : t;
          return r.mode === i.UTF8 ? (0, a.escapeUTF8)(e) : r.mode === i.Attribute ? (0, a.escapeAttribute)(e) : r.mode === i.Text ? (0, a.escapeText)(e) : r.level === s.HTML ? r.mode === i.ASCII ? (0, o.encodeNonAsciiHTML)(e) : (0, o.encodeHTML)(e) : (0, a.encodeXML)(e);
        };
        var l = r(5987);
        Object.defineProperty(t, "encodeXML", {
          enumerable: !0,
          get: function () {
            return l.encodeXML;
          }
        }), Object.defineProperty(t, "escape", {
          enumerable: !0,
          get: function () {
            return l.escape;
          }
        }), Object.defineProperty(t, "escapeUTF8", {
          enumerable: !0,
          get: function () {
            return l.escapeUTF8;
          }
        }), Object.defineProperty(t, "escapeAttribute", {
          enumerable: !0,
          get: function () {
            return l.escapeAttribute;
          }
        }), Object.defineProperty(t, "escapeText", {
          enumerable: !0,
          get: function () {
            return l.escapeText;
          }
        });
        var c = r(1818);
        Object.defineProperty(t, "encodeHTML", {
          enumerable: !0,
          get: function () {
            return c.encodeHTML;
          }
        }), Object.defineProperty(t, "encodeNonAsciiHTML", {
          enumerable: !0,
          get: function () {
            return c.encodeNonAsciiHTML;
          }
        }), Object.defineProperty(t, "encodeHTML4", {
          enumerable: !0,
          get: function () {
            return c.encodeHTML;
          }
        }), Object.defineProperty(t, "encodeHTML5", {
          enumerable: !0,
          get: function () {
            return c.encodeHTML;
          }
        });
        var d = r(9878);
        Object.defineProperty(t, "EntityDecoder", {
          enumerable: !0,
          get: function () {
            return d.EntityDecoder;
          }
        }), Object.defineProperty(t, "DecodingMode", {
          enumerable: !0,
          get: function () {
            return d.DecodingMode;
          }
        }), Object.defineProperty(t, "decodeXML", {
          enumerable: !0,
          get: function () {
            return d.decodeXML;
          }
        }), Object.defineProperty(t, "decodeHTML", {
          enumerable: !0,
          get: function () {
            return d.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTMLStrict", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeHTMLAttribute", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLAttribute;
          }
        }), Object.defineProperty(t, "decodeHTML4", {
          enumerable: !0,
          get: function () {
            return d.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTML5", {
          enumerable: !0,
          get: function () {
            return d.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTML4Strict", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeHTML5Strict", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeXMLStrict", {
          enumerable: !0,
          get: function () {
            return d.decodeXML;
          }
        });
      },
      2834: e => {
        "use strict";

        e.exports = e => {
          if ("string" != typeof e) throw new TypeError("Expected a string");
          return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
        };
      },
      1724: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          n = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && s(t, e, r);
            return i(t, e), t;
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Parser = void 0;
        var o = n(r(7918)),
          a = r(9878),
          u = new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]),
          l = new Set(["p"]),
          c = new Set(["thead", "tbody"]),
          d = new Set(["dd", "dt"]),
          v = new Set(["rt", "rp"]),
          p = new Map([["tr", new Set(["tr", "th", "td"])], ["th", new Set(["th"])], ["td", new Set(["thead", "th", "td"])], ["body", new Set(["head", "link", "script"])], ["li", new Set(["li"])], ["p", l], ["h1", l], ["h2", l], ["h3", l], ["h4", l], ["h5", l], ["h6", l], ["select", u], ["input", u], ["output", u], ["button", u], ["datalist", u], ["textarea", u], ["option", new Set(["option"])], ["optgroup", new Set(["optgroup", "option"])], ["dd", d], ["dt", d], ["address", l], ["article", l], ["aside", l], ["blockquote", l], ["details", l], ["div", l], ["dl", l], ["fieldset", l], ["figcaption", l], ["figure", l], ["footer", l], ["form", l], ["header", l], ["hr", l], ["main", l], ["nav", l], ["ol", l], ["pre", l], ["section", l], ["table", l], ["ul", l], ["rt", v], ["rp", v], ["tbody", c], ["tfoot", c]]),
          _ = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]),
          f = new Set(["math", "svg"]),
          h = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]),
          m = /\s|\//,
          g = function () {
            function e(e, t) {
              var r, s, i, n, a;
              void 0 === t && (t = {}), this.options = t, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.buffers = [], this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1, this.cbs = null != e ? e : {}, this.lowerCaseTagNames = null !== (r = t.lowerCaseTags) && void 0 !== r ? r : !t.xmlMode, this.lowerCaseAttributeNames = null !== (s = t.lowerCaseAttributeNames) && void 0 !== s ? s : !t.xmlMode, this.tokenizer = new (null !== (i = t.Tokenizer) && void 0 !== i ? i : o.default)(this.options, this), null === (a = (n = this.cbs).onparserinit) || void 0 === a || a.call(n, this);
            }
            return e.prototype.ontext = function (e, t) {
              var r,
                s,
                i = this.getSlice(e, t);
              this.endIndex = t - 1, null === (s = (r = this.cbs).ontext) || void 0 === s || s.call(r, i), this.startIndex = t;
            }, e.prototype.ontextentity = function (e) {
              var t,
                r,
                s = this.tokenizer.getSectionStart();
              this.endIndex = s - 1, null === (r = (t = this.cbs).ontext) || void 0 === r || r.call(t, (0, a.fromCodePoint)(e)), this.startIndex = s;
            }, e.prototype.isVoidElement = function (e) {
              return !this.options.xmlMode && _.has(e);
            }, e.prototype.onopentagname = function (e, t) {
              this.endIndex = t;
              var r = this.getSlice(e, t);
              this.lowerCaseTagNames && (r = r.toLowerCase()), this.emitOpenTag(r);
            }, e.prototype.emitOpenTag = function (e) {
              var t, r, s, i;
              this.openTagStart = this.startIndex, this.tagname = e;
              var n = !this.options.xmlMode && p.get(e);
              if (n) for (; this.stack.length > 0 && n.has(this.stack[this.stack.length - 1]);) {
                var o = this.stack.pop();
                null === (r = (t = this.cbs).onclosetag) || void 0 === r || r.call(t, o, !0);
              }
              this.isVoidElement(e) || (this.stack.push(e), f.has(e) ? this.foreignContext.push(!0) : h.has(e) && this.foreignContext.push(!1)), null === (i = (s = this.cbs).onopentagname) || void 0 === i || i.call(s, e), this.cbs.onopentag && (this.attribs = {});
            }, e.prototype.endOpenTag = function (e) {
              var t, r;
              this.startIndex = this.openTagStart, this.attribs && (null === (r = (t = this.cbs).onopentag) || void 0 === r || r.call(t, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
            }, e.prototype.onopentagend = function (e) {
              this.endIndex = e, this.endOpenTag(!1), this.startIndex = e + 1;
            }, e.prototype.onclosetag = function (e, t) {
              var r, s, i, n, o, a;
              this.endIndex = t;
              var u = this.getSlice(e, t);
              if (this.lowerCaseTagNames && (u = u.toLowerCase()), (f.has(u) || h.has(u)) && this.foreignContext.pop(), this.isVoidElement(u)) this.options.xmlMode || "br" !== u || (null === (s = (r = this.cbs).onopentagname) || void 0 === s || s.call(r, "br"), null === (n = (i = this.cbs).onopentag) || void 0 === n || n.call(i, "br", {}, !0), null === (a = (o = this.cbs).onclosetag) || void 0 === a || a.call(o, "br", !1));else {
                var l = this.stack.lastIndexOf(u);
                if (-1 !== l) {
                  if (this.cbs.onclosetag) for (var c = this.stack.length - l; c--;) this.cbs.onclosetag(this.stack.pop(), 0 !== c);else this.stack.length = l;
                } else this.options.xmlMode || "p" !== u || (this.emitOpenTag("p"), this.closeCurrentTag(!0));
              }
              this.startIndex = t + 1;
            }, e.prototype.onselfclosingtag = function (e) {
              this.endIndex = e, this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = e + 1) : this.onopentagend(e);
            }, e.prototype.closeCurrentTag = function (e) {
              var t,
                r,
                s = this.tagname;
              this.endOpenTag(e), this.stack[this.stack.length - 1] === s && (null === (r = (t = this.cbs).onclosetag) || void 0 === r || r.call(t, s, !e), this.stack.pop());
            }, e.prototype.onattribname = function (e, t) {
              this.startIndex = e;
              var r = this.getSlice(e, t);
              this.attribname = this.lowerCaseAttributeNames ? r.toLowerCase() : r;
            }, e.prototype.onattribdata = function (e, t) {
              this.attribvalue += this.getSlice(e, t);
            }, e.prototype.onattribentity = function (e) {
              this.attribvalue += (0, a.fromCodePoint)(e);
            }, e.prototype.onattribend = function (e, t) {
              var r, s;
              this.endIndex = t, null === (s = (r = this.cbs).onattribute) || void 0 === s || s.call(r, this.attribname, this.attribvalue, e === o.QuoteType.Double ? '"' : e === o.QuoteType.Single ? "'" : e === o.QuoteType.NoValue ? void 0 : null), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribvalue = "";
            }, e.prototype.getInstructionName = function (e) {
              var t = e.search(m),
                r = t < 0 ? e : e.substr(0, t);
              return this.lowerCaseTagNames && (r = r.toLowerCase()), r;
            }, e.prototype.ondeclaration = function (e, t) {
              this.endIndex = t;
              var r = this.getSlice(e, t);
              if (this.cbs.onprocessinginstruction) {
                var s = this.getInstructionName(r);
                this.cbs.onprocessinginstruction("!".concat(s), "!".concat(r));
              }
              this.startIndex = t + 1;
            }, e.prototype.onprocessinginstruction = function (e, t) {
              this.endIndex = t;
              var r = this.getSlice(e, t);
              if (this.cbs.onprocessinginstruction) {
                var s = this.getInstructionName(r);
                this.cbs.onprocessinginstruction("?".concat(s), "?".concat(r));
              }
              this.startIndex = t + 1;
            }, e.prototype.oncomment = function (e, t, r) {
              var s, i, n, o;
              this.endIndex = t, null === (i = (s = this.cbs).oncomment) || void 0 === i || i.call(s, this.getSlice(e, t - r)), null === (o = (n = this.cbs).oncommentend) || void 0 === o || o.call(n), this.startIndex = t + 1;
            }, e.prototype.oncdata = function (e, t, r) {
              var s, i, n, o, a, u, l, c, d, v;
              this.endIndex = t;
              var p = this.getSlice(e, t - r);
              this.options.xmlMode || this.options.recognizeCDATA ? (null === (i = (s = this.cbs).oncdatastart) || void 0 === i || i.call(s), null === (o = (n = this.cbs).ontext) || void 0 === o || o.call(n, p), null === (u = (a = this.cbs).oncdataend) || void 0 === u || u.call(a)) : (null === (c = (l = this.cbs).oncomment) || void 0 === c || c.call(l, "[CDATA[".concat(p, "]]")), null === (v = (d = this.cbs).oncommentend) || void 0 === v || v.call(d)), this.startIndex = t + 1;
            }, e.prototype.onend = function () {
              var e, t;
              if (this.cbs.onclosetag) {
                this.endIndex = this.startIndex;
                for (var r = this.stack.length; r > 0; this.cbs.onclosetag(this.stack[--r], !0));
              }
              null === (t = (e = this.cbs).onend) || void 0 === t || t.call(e);
            }, e.prototype.reset = function () {
              var e, t, r, s;
              null === (t = (e = this.cbs).onreset) || void 0 === t || t.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack.length = 0, this.startIndex = 0, this.endIndex = 0, null === (s = (r = this.cbs).onparserinit) || void 0 === s || s.call(r, this), this.buffers.length = 0, this.bufferOffset = 0, this.writeIndex = 0, this.ended = !1;
            }, e.prototype.parseComplete = function (e) {
              this.reset(), this.end(e);
            }, e.prototype.getSlice = function (e, t) {
              for (; e - this.bufferOffset >= this.buffers[0].length;) this.shiftBuffer();
              for (var r = this.buffers[0].slice(e - this.bufferOffset, t - this.bufferOffset); t - this.bufferOffset > this.buffers[0].length;) this.shiftBuffer(), r += this.buffers[0].slice(0, t - this.bufferOffset);
              return r;
            }, e.prototype.shiftBuffer = function () {
              this.bufferOffset += this.buffers[0].length, this.writeIndex--, this.buffers.shift();
            }, e.prototype.write = function (e) {
              var t, r;
              this.ended ? null === (r = (t = this.cbs).onerror) || void 0 === r || r.call(t, new Error(".write() after done!")) : (this.buffers.push(e), this.tokenizer.running && (this.tokenizer.write(e), this.writeIndex++));
            }, e.prototype.end = function (e) {
              var t, r;
              this.ended ? null === (r = (t = this.cbs).onerror) || void 0 === r || r.call(t, new Error(".end() after done!")) : (e && this.write(e), this.ended = !0, this.tokenizer.end());
            }, e.prototype.pause = function () {
              this.tokenizer.pause();
            }, e.prototype.resume = function () {
              for (this.tokenizer.resume(); this.tokenizer.running && this.writeIndex < this.buffers.length;) this.tokenizer.write(this.buffers[this.writeIndex++]);
              this.ended && this.tokenizer.end();
            }, e.prototype.parseChunk = function (e) {
              this.write(e);
            }, e.prototype.done = function (e) {
              this.end(e);
            }, e;
          }();
        t.Parser = g;
      },
      7918: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.QuoteType = void 0;
        var s,
          i,
          n,
          o = r(9878);
        function a(e) {
          return e === s.Space || e === s.NewLine || e === s.Tab || e === s.FormFeed || e === s.CarriageReturn;
        }
        function u(e) {
          return e === s.Slash || e === s.Gt || a(e);
        }
        function l(e) {
          return e >= s.Zero && e <= s.Nine;
        }
        !function (e) {
          e[e.Tab = 9] = "Tab", e[e.NewLine = 10] = "NewLine", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationMark = 33] = "ExclamationMark", e[e.Number = 35] = "Number", e[e.Amp = 38] = "Amp", e[e.SingleQuote = 39] = "SingleQuote", e[e.DoubleQuote = 34] = "DoubleQuote", e[e.Dash = 45] = "Dash", e[e.Slash = 47] = "Slash", e[e.Zero = 48] = "Zero", e[e.Nine = 57] = "Nine", e[e.Semi = 59] = "Semi", e[e.Lt = 60] = "Lt", e[e.Eq = 61] = "Eq", e[e.Gt = 62] = "Gt", e[e.Questionmark = 63] = "Questionmark", e[e.UpperA = 65] = "UpperA", e[e.LowerA = 97] = "LowerA", e[e.UpperF = 70] = "UpperF", e[e.LowerF = 102] = "LowerF", e[e.UpperZ = 90] = "UpperZ", e[e.LowerZ = 122] = "LowerZ", e[e.LowerX = 120] = "LowerX", e[e.OpeningSquareBracket = 91] = "OpeningSquareBracket";
        }(s || (s = {})), function (e) {
          e[e.Text = 1] = "Text", e[e.BeforeTagName = 2] = "BeforeTagName", e[e.InTagName = 3] = "InTagName", e[e.InSelfClosingTag = 4] = "InSelfClosingTag", e[e.BeforeClosingTagName = 5] = "BeforeClosingTagName", e[e.InClosingTagName = 6] = "InClosingTagName", e[e.AfterClosingTagName = 7] = "AfterClosingTagName", e[e.BeforeAttributeName = 8] = "BeforeAttributeName", e[e.InAttributeName = 9] = "InAttributeName", e[e.AfterAttributeName = 10] = "AfterAttributeName", e[e.BeforeAttributeValue = 11] = "BeforeAttributeValue", e[e.InAttributeValueDq = 12] = "InAttributeValueDq", e[e.InAttributeValueSq = 13] = "InAttributeValueSq", e[e.InAttributeValueNq = 14] = "InAttributeValueNq", e[e.BeforeDeclaration = 15] = "BeforeDeclaration", e[e.InDeclaration = 16] = "InDeclaration", e[e.InProcessingInstruction = 17] = "InProcessingInstruction", e[e.BeforeComment = 18] = "BeforeComment", e[e.CDATASequence = 19] = "CDATASequence", e[e.InSpecialComment = 20] = "InSpecialComment", e[e.InCommentLike = 21] = "InCommentLike", e[e.BeforeSpecialS = 22] = "BeforeSpecialS", e[e.SpecialStartSequence = 23] = "SpecialStartSequence", e[e.InSpecialTag = 24] = "InSpecialTag", e[e.BeforeEntity = 25] = "BeforeEntity", e[e.BeforeNumericEntity = 26] = "BeforeNumericEntity", e[e.InNamedEntity = 27] = "InNamedEntity", e[e.InNumericEntity = 28] = "InNumericEntity", e[e.InHexEntity = 29] = "InHexEntity";
        }(i || (i = {})), function (e) {
          e[e.NoValue = 0] = "NoValue", e[e.Unquoted = 1] = "Unquoted", e[e.Single = 2] = "Single", e[e.Double = 3] = "Double";
        }(n = t.QuoteType || (t.QuoteType = {}));
        var c = {
            Cdata: new Uint8Array([67, 68, 65, 84, 65, 91]),
            CdataEnd: new Uint8Array([93, 93, 62]),
            CommentEnd: new Uint8Array([45, 45, 62]),
            ScriptEnd: new Uint8Array([60, 47, 115, 99, 114, 105, 112, 116]),
            StyleEnd: new Uint8Array([60, 47, 115, 116, 121, 108, 101]),
            TitleEnd: new Uint8Array([60, 47, 116, 105, 116, 108, 101])
          },
          d = function () {
            function e(e, t) {
              var r = e.xmlMode,
                s = void 0 !== r && r,
                n = e.decodeEntities,
                a = void 0 === n || n;
              this.cbs = t, this.state = i.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = i.Text, this.isSpecial = !1, this.running = !0, this.offset = 0, this.currentSequence = void 0, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.entityResult = 0, this.entityExcess = 0, this.xmlMode = s, this.decodeEntities = a, this.entityTrie = s ? o.xmlDecodeTree : o.htmlDecodeTree;
            }
            return e.prototype.reset = function () {
              this.state = i.Text, this.buffer = "", this.sectionStart = 0, this.index = 0, this.baseState = i.Text, this.currentSequence = void 0, this.running = !0, this.offset = 0;
            }, e.prototype.write = function (e) {
              this.offset += this.buffer.length, this.buffer = e, this.parse();
            }, e.prototype.end = function () {
              this.running && this.finish();
            }, e.prototype.pause = function () {
              this.running = !1;
            }, e.prototype.resume = function () {
              this.running = !0, this.index < this.buffer.length + this.offset && this.parse();
            }, e.prototype.getIndex = function () {
              return this.index;
            }, e.prototype.getSectionStart = function () {
              return this.sectionStart;
            }, e.prototype.stateText = function (e) {
              e === s.Lt || !this.decodeEntities && this.fastForwardTo(s.Lt) ? (this.index > this.sectionStart && this.cbs.ontext(this.sectionStart, this.index), this.state = i.BeforeTagName, this.sectionStart = this.index) : this.decodeEntities && e === s.Amp && (this.state = i.BeforeEntity);
            }, e.prototype.stateSpecialStartSequence = function (e) {
              var t = this.sequenceIndex === this.currentSequence.length;
              if (t ? u(e) : (32 | e) === this.currentSequence[this.sequenceIndex]) {
                if (!t) return void this.sequenceIndex++;
              } else this.isSpecial = !1;
              this.sequenceIndex = 0, this.state = i.InTagName, this.stateInTagName(e);
            }, e.prototype.stateInSpecialTag = function (e) {
              if (this.sequenceIndex === this.currentSequence.length) {
                if (e === s.Gt || a(e)) {
                  var t = this.index - this.currentSequence.length;
                  if (this.sectionStart < t) {
                    var r = this.index;
                    this.index = t, this.cbs.ontext(this.sectionStart, t), this.index = r;
                  }
                  return this.isSpecial = !1, this.sectionStart = t + 2, void this.stateInClosingTagName(e);
                }
                this.sequenceIndex = 0;
              }
              (32 | e) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : 0 === this.sequenceIndex ? this.currentSequence === c.TitleEnd ? this.decodeEntities && e === s.Amp && (this.state = i.BeforeEntity) : this.fastForwardTo(s.Lt) && (this.sequenceIndex = 1) : this.sequenceIndex = Number(e === s.Lt);
            }, e.prototype.stateCDATASequence = function (e) {
              e === c.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === c.Cdata.length && (this.state = i.InCommentLike, this.currentSequence = c.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this.index + 1) : (this.sequenceIndex = 0, this.state = i.InDeclaration, this.stateInDeclaration(e));
            }, e.prototype.fastForwardTo = function (e) {
              for (; ++this.index < this.buffer.length + this.offset;) if (this.buffer.charCodeAt(this.index - this.offset) === e) return !0;
              return this.index = this.buffer.length + this.offset - 1, !1;
            }, e.prototype.stateInCommentLike = function (e) {
              e === this.currentSequence[this.sequenceIndex] ? ++this.sequenceIndex === this.currentSequence.length && (this.currentSequence === c.CdataEnd ? this.cbs.oncdata(this.sectionStart, this.index, 2) : this.cbs.oncomment(this.sectionStart, this.index, 2), this.sequenceIndex = 0, this.sectionStart = this.index + 1, this.state = i.Text) : 0 === this.sequenceIndex ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : e !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
            }, e.prototype.isTagStartChar = function (e) {
              return this.xmlMode ? !u(e) : function (e) {
                return e >= s.LowerA && e <= s.LowerZ || e >= s.UpperA && e <= s.UpperZ;
              }(e);
            }, e.prototype.startSpecial = function (e, t) {
              this.isSpecial = !0, this.currentSequence = e, this.sequenceIndex = t, this.state = i.SpecialStartSequence;
            }, e.prototype.stateBeforeTagName = function (e) {
              if (e === s.ExclamationMark) this.state = i.BeforeDeclaration, this.sectionStart = this.index + 1;else if (e === s.Questionmark) this.state = i.InProcessingInstruction, this.sectionStart = this.index + 1;else if (this.isTagStartChar(e)) {
                var t = 32 | e;
                this.sectionStart = this.index, this.xmlMode || t !== c.TitleEnd[2] ? this.state = this.xmlMode || t !== c.ScriptEnd[2] ? i.InTagName : i.BeforeSpecialS : this.startSpecial(c.TitleEnd, 3);
              } else e === s.Slash ? this.state = i.BeforeClosingTagName : (this.state = i.Text, this.stateText(e));
            }, e.prototype.stateInTagName = function (e) {
              u(e) && (this.cbs.onopentagname(this.sectionStart, this.index), this.sectionStart = -1, this.state = i.BeforeAttributeName, this.stateBeforeAttributeName(e));
            }, e.prototype.stateBeforeClosingTagName = function (e) {
              a(e) || (e === s.Gt ? this.state = i.Text : (this.state = this.isTagStartChar(e) ? i.InClosingTagName : i.InSpecialComment, this.sectionStart = this.index));
            }, e.prototype.stateInClosingTagName = function (e) {
              (e === s.Gt || a(e)) && (this.cbs.onclosetag(this.sectionStart, this.index), this.sectionStart = -1, this.state = i.AfterClosingTagName, this.stateAfterClosingTagName(e));
            }, e.prototype.stateAfterClosingTagName = function (e) {
              (e === s.Gt || this.fastForwardTo(s.Gt)) && (this.state = i.Text, this.baseState = i.Text, this.sectionStart = this.index + 1);
            }, e.prototype.stateBeforeAttributeName = function (e) {
              e === s.Gt ? (this.cbs.onopentagend(this.index), this.isSpecial ? (this.state = i.InSpecialTag, this.sequenceIndex = 0) : this.state = i.Text, this.baseState = this.state, this.sectionStart = this.index + 1) : e === s.Slash ? this.state = i.InSelfClosingTag : a(e) || (this.state = i.InAttributeName, this.sectionStart = this.index);
            }, e.prototype.stateInSelfClosingTag = function (e) {
              e === s.Gt ? (this.cbs.onselfclosingtag(this.index), this.state = i.Text, this.baseState = i.Text, this.sectionStart = this.index + 1, this.isSpecial = !1) : a(e) || (this.state = i.BeforeAttributeName, this.stateBeforeAttributeName(e));
            }, e.prototype.stateInAttributeName = function (e) {
              (e === s.Eq || u(e)) && (this.cbs.onattribname(this.sectionStart, this.index), this.sectionStart = -1, this.state = i.AfterAttributeName, this.stateAfterAttributeName(e));
            }, e.prototype.stateAfterAttributeName = function (e) {
              e === s.Eq ? this.state = i.BeforeAttributeValue : e === s.Slash || e === s.Gt ? (this.cbs.onattribend(n.NoValue, this.index), this.state = i.BeforeAttributeName, this.stateBeforeAttributeName(e)) : a(e) || (this.cbs.onattribend(n.NoValue, this.index), this.state = i.InAttributeName, this.sectionStart = this.index);
            }, e.prototype.stateBeforeAttributeValue = function (e) {
              e === s.DoubleQuote ? (this.state = i.InAttributeValueDq, this.sectionStart = this.index + 1) : e === s.SingleQuote ? (this.state = i.InAttributeValueSq, this.sectionStart = this.index + 1) : a(e) || (this.sectionStart = this.index, this.state = i.InAttributeValueNq, this.stateInAttributeValueNoQuotes(e));
            }, e.prototype.handleInAttributeValue = function (e, t) {
              e === t || !this.decodeEntities && this.fastForwardTo(t) ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(t === s.DoubleQuote ? n.Double : n.Single, this.index), this.state = i.BeforeAttributeName) : this.decodeEntities && e === s.Amp && (this.baseState = this.state, this.state = i.BeforeEntity);
            }, e.prototype.stateInAttributeValueDoubleQuotes = function (e) {
              this.handleInAttributeValue(e, s.DoubleQuote);
            }, e.prototype.stateInAttributeValueSingleQuotes = function (e) {
              this.handleInAttributeValue(e, s.SingleQuote);
            }, e.prototype.stateInAttributeValueNoQuotes = function (e) {
              a(e) || e === s.Gt ? (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = -1, this.cbs.onattribend(n.Unquoted, this.index), this.state = i.BeforeAttributeName, this.stateBeforeAttributeName(e)) : this.decodeEntities && e === s.Amp && (this.baseState = this.state, this.state = i.BeforeEntity);
            }, e.prototype.stateBeforeDeclaration = function (e) {
              e === s.OpeningSquareBracket ? (this.state = i.CDATASequence, this.sequenceIndex = 0) : this.state = e === s.Dash ? i.BeforeComment : i.InDeclaration;
            }, e.prototype.stateInDeclaration = function (e) {
              (e === s.Gt || this.fastForwardTo(s.Gt)) && (this.cbs.ondeclaration(this.sectionStart, this.index), this.state = i.Text, this.sectionStart = this.index + 1);
            }, e.prototype.stateInProcessingInstruction = function (e) {
              (e === s.Gt || this.fastForwardTo(s.Gt)) && (this.cbs.onprocessinginstruction(this.sectionStart, this.index), this.state = i.Text, this.sectionStart = this.index + 1);
            }, e.prototype.stateBeforeComment = function (e) {
              e === s.Dash ? (this.state = i.InCommentLike, this.currentSequence = c.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this.index + 1) : this.state = i.InDeclaration;
            }, e.prototype.stateInSpecialComment = function (e) {
              (e === s.Gt || this.fastForwardTo(s.Gt)) && (this.cbs.oncomment(this.sectionStart, this.index, 0), this.state = i.Text, this.sectionStart = this.index + 1);
            }, e.prototype.stateBeforeSpecialS = function (e) {
              var t = 32 | e;
              t === c.ScriptEnd[3] ? this.startSpecial(c.ScriptEnd, 4) : t === c.StyleEnd[3] ? this.startSpecial(c.StyleEnd, 4) : (this.state = i.InTagName, this.stateInTagName(e));
            }, e.prototype.stateBeforeEntity = function (e) {
              this.entityExcess = 1, this.entityResult = 0, e === s.Number ? this.state = i.BeforeNumericEntity : e === s.Amp || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.state = i.InNamedEntity, this.stateInNamedEntity(e));
            }, e.prototype.stateInNamedEntity = function (e) {
              if (this.entityExcess += 1, this.trieIndex = (0, o.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, e), this.trieIndex < 0) return this.emitNamedEntity(), void this.index--;
              this.trieCurrent = this.entityTrie[this.trieIndex];
              var t = this.trieCurrent & o.BinTrieFlags.VALUE_LENGTH;
              if (t) {
                var r = (t >> 14) - 1;
                if (this.allowLegacyEntity() || e === s.Semi) {
                  var i = this.index - this.entityExcess + 1;
                  i > this.sectionStart && this.emitPartial(this.sectionStart, i), this.entityResult = this.trieIndex, this.trieIndex += r, this.entityExcess = 0, this.sectionStart = this.index + 1, 0 === r && this.emitNamedEntity();
                } else this.trieIndex += r;
              }
            }, e.prototype.emitNamedEntity = function () {
              if (this.state = this.baseState, 0 !== this.entityResult) switch ((this.entityTrie[this.entityResult] & o.BinTrieFlags.VALUE_LENGTH) >> 14) {
                case 1:
                  this.emitCodePoint(this.entityTrie[this.entityResult] & ~o.BinTrieFlags.VALUE_LENGTH);
                  break;
                case 2:
                  this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                  break;
                case 3:
                  this.emitCodePoint(this.entityTrie[this.entityResult + 1]), this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
              }
            }, e.prototype.stateBeforeNumericEntity = function (e) {
              (32 | e) === s.LowerX ? (this.entityExcess++, this.state = i.InHexEntity) : (this.state = i.InNumericEntity, this.stateInNumericEntity(e));
            }, e.prototype.emitNumericEntity = function (e) {
              var t = this.index - this.entityExcess - 1;
              t + 2 + Number(this.state === i.InHexEntity) !== this.index && (t > this.sectionStart && this.emitPartial(this.sectionStart, t), this.sectionStart = this.index + Number(e), this.emitCodePoint((0, o.replaceCodePoint)(this.entityResult))), this.state = this.baseState;
            }, e.prototype.stateInNumericEntity = function (e) {
              e === s.Semi ? this.emitNumericEntity(!0) : l(e) ? (this.entityResult = 10 * this.entityResult + (e - s.Zero), this.entityExcess++) : (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--);
            }, e.prototype.stateInHexEntity = function (e) {
              e === s.Semi ? this.emitNumericEntity(!0) : l(e) ? (this.entityResult = 16 * this.entityResult + (e - s.Zero), this.entityExcess++) : !function (e) {
                return e >= s.UpperA && e <= s.UpperF || e >= s.LowerA && e <= s.LowerF;
              }(e) ? (this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state = this.baseState, this.index--) : (this.entityResult = 16 * this.entityResult + ((32 | e) - s.LowerA + 10), this.entityExcess++);
            }, e.prototype.allowLegacyEntity = function () {
              return !this.xmlMode && (this.baseState === i.Text || this.baseState === i.InSpecialTag);
            }, e.prototype.cleanup = function () {
              this.running && this.sectionStart !== this.index && (this.state === i.Text || this.state === i.InSpecialTag && 0 === this.sequenceIndex ? (this.cbs.ontext(this.sectionStart, this.index), this.sectionStart = this.index) : this.state !== i.InAttributeValueDq && this.state !== i.InAttributeValueSq && this.state !== i.InAttributeValueNq || (this.cbs.onattribdata(this.sectionStart, this.index), this.sectionStart = this.index));
            }, e.prototype.shouldContinue = function () {
              return this.index < this.buffer.length + this.offset && this.running;
            }, e.prototype.parse = function () {
              for (; this.shouldContinue();) {
                var e = this.buffer.charCodeAt(this.index - this.offset);
                switch (this.state) {
                  case i.Text:
                    this.stateText(e);
                    break;
                  case i.SpecialStartSequence:
                    this.stateSpecialStartSequence(e);
                    break;
                  case i.InSpecialTag:
                    this.stateInSpecialTag(e);
                    break;
                  case i.CDATASequence:
                    this.stateCDATASequence(e);
                    break;
                  case i.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(e);
                    break;
                  case i.InAttributeName:
                    this.stateInAttributeName(e);
                    break;
                  case i.InCommentLike:
                    this.stateInCommentLike(e);
                    break;
                  case i.InSpecialComment:
                    this.stateInSpecialComment(e);
                    break;
                  case i.BeforeAttributeName:
                    this.stateBeforeAttributeName(e);
                    break;
                  case i.InTagName:
                    this.stateInTagName(e);
                    break;
                  case i.InClosingTagName:
                    this.stateInClosingTagName(e);
                    break;
                  case i.BeforeTagName:
                    this.stateBeforeTagName(e);
                    break;
                  case i.AfterAttributeName:
                    this.stateAfterAttributeName(e);
                    break;
                  case i.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(e);
                    break;
                  case i.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(e);
                    break;
                  case i.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(e);
                    break;
                  case i.AfterClosingTagName:
                    this.stateAfterClosingTagName(e);
                    break;
                  case i.BeforeSpecialS:
                    this.stateBeforeSpecialS(e);
                    break;
                  case i.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(e);
                    break;
                  case i.InSelfClosingTag:
                    this.stateInSelfClosingTag(e);
                    break;
                  case i.InDeclaration:
                    this.stateInDeclaration(e);
                    break;
                  case i.BeforeDeclaration:
                    this.stateBeforeDeclaration(e);
                    break;
                  case i.BeforeComment:
                    this.stateBeforeComment(e);
                    break;
                  case i.InProcessingInstruction:
                    this.stateInProcessingInstruction(e);
                    break;
                  case i.InNamedEntity:
                    this.stateInNamedEntity(e);
                    break;
                  case i.BeforeEntity:
                    this.stateBeforeEntity(e);
                    break;
                  case i.InHexEntity:
                    this.stateInHexEntity(e);
                    break;
                  case i.InNumericEntity:
                    this.stateInNumericEntity(e);
                    break;
                  default:
                    this.stateBeforeNumericEntity(e);
                }
                this.index++;
              }
              this.cleanup();
            }, e.prototype.finish = function () {
              this.state === i.InNamedEntity && this.emitNamedEntity(), this.sectionStart < this.index && this.handleTrailingData(), this.cbs.onend();
            }, e.prototype.handleTrailingData = function () {
              var e = this.buffer.length + this.offset;
              this.state === i.InCommentLike ? this.currentSequence === c.CdataEnd ? this.cbs.oncdata(this.sectionStart, e, 0) : this.cbs.oncomment(this.sectionStart, e, 0) : this.state === i.InNumericEntity && this.allowLegacyEntity() || this.state === i.InHexEntity && this.allowLegacyEntity() ? this.emitNumericEntity(!1) : this.state === i.InTagName || this.state === i.BeforeAttributeName || this.state === i.BeforeAttributeValue || this.state === i.AfterAttributeName || this.state === i.InAttributeName || this.state === i.InAttributeValueSq || this.state === i.InAttributeValueDq || this.state === i.InAttributeValueNq || this.state === i.InClosingTagName || this.cbs.ontext(this.sectionStart, e);
            }, e.prototype.emitPartial = function (e, t) {
              this.baseState !== i.Text && this.baseState !== i.InSpecialTag ? this.cbs.onattribdata(e, t) : this.cbs.ontext(e, t);
            }, e.prototype.emitCodePoint = function (e) {
              this.baseState !== i.Text && this.baseState !== i.InSpecialTag ? this.cbs.onattribentity(e) : this.cbs.ontextentity(e);
            }, e;
          }();
        t.default = d;
      },
      8659: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          n = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && s(t, e, r);
            return i(t, e), t;
          },
          o = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DomUtils = t.parseFeed = t.getFeed = t.ElementType = t.Tokenizer = t.createDomStream = t.parseDOM = t.parseDocument = t.DefaultHandler = t.DomHandler = t.Parser = void 0;
        var a = r(1724),
          u = r(1724);
        Object.defineProperty(t, "Parser", {
          enumerable: !0,
          get: function () {
            return u.Parser;
          }
        });
        var l = r(1141),
          c = r(1141);
        function d(e, t) {
          var r = new l.DomHandler(void 0, t);
          return new a.Parser(r, t).end(e), r.root;
        }
        function v(e, t) {
          return d(e, t).children;
        }
        Object.defineProperty(t, "DomHandler", {
          enumerable: !0,
          get: function () {
            return c.DomHandler;
          }
        }), Object.defineProperty(t, "DefaultHandler", {
          enumerable: !0,
          get: function () {
            return c.DomHandler;
          }
        }), t.parseDocument = d, t.parseDOM = v, t.createDomStream = function (e, t, r) {
          var s = new l.DomHandler(e, t, r);
          return new a.Parser(s, t);
        };
        var p = r(7918);
        Object.defineProperty(t, "Tokenizer", {
          enumerable: !0,
          get: function () {
            return o(p).default;
          }
        }), t.ElementType = n(r(5413));
        var _ = r(8888),
          f = r(8888);
        Object.defineProperty(t, "getFeed", {
          enumerable: !0,
          get: function () {
            return f.getFeed;
          }
        });
        var h = {
          xmlMode: !0
        };
        t.parseFeed = function (e, t) {
          return void 0 === t && (t = h), (0, _.getFeed)(v(e, t));
        }, t.DomUtils = n(r(8888));
      },
      8682: (e, t) => {
        "use strict";

        function r(e) {
          return "[object Object]" === Object.prototype.toString.call(e);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isPlainObject = function (e) {
          var t, s;
          return !1 !== r(e) && (void 0 === (t = e.constructor) || !1 !== r(s = t.prototype) && !1 !== s.hasOwnProperty("isPrototypeOf"));
        };
      },
      2733: function (e) {
        e.exports = function () {
          "use strict";

          function e(e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var s in r) e[s] = r[s];
            }
            return e;
          }
          function t(r, s) {
            function i(t, i, n) {
              if ("undefined" != typeof document) {
                "number" == typeof (n = e({}, s, n)).expires && (n.expires = new Date(Date.now() + 864e5 * n.expires)), n.expires && (n.expires = n.expires.toUTCString()), t = encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                var o = "";
                for (var a in n) n[a] && (o += "; " + a, !0 !== n[a] && (o += "=" + n[a].split(";")[0]));
                return document.cookie = t + "=" + r.write(i, t) + o;
              }
            }
            function n(e) {
              if ("undefined" != typeof document && (!arguments.length || e)) {
                for (var t = document.cookie ? document.cookie.split("; ") : [], s = {}, i = 0; i < t.length; i++) {
                  var n = t[i].split("="),
                    o = n.slice(1).join("=");
                  try {
                    var a = decodeURIComponent(n[0]);
                    if (s[a] = r.read(o, a), e === a) break;
                  } catch (e) {}
                }
                return e ? s[e] : s;
              }
            }
            return Object.create({
              set: i,
              get: n,
              remove: function (t, r) {
                i(t, "", e({}, r, {
                  expires: -1
                }));
              },
              withAttributes: function (r) {
                return t(this.converter, e({}, this.attributes, r));
              },
              withConverter: function (r) {
                return t(e({}, this.converter, r), this.attributes);
              }
            }, {
              attributes: {
                value: Object.freeze(s)
              },
              converter: {
                value: Object.freeze(r)
              }
            });
          }
          return t({
            read: function (e) {
              return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
            },
            write: function (e) {
              return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
            }
          }, {
            path: "/"
          });
        }();
      },
      9466: function (e, t) {
        var r, s, i;
        s = [], void 0 === (i = "function" == typeof (r = function () {
          return function (e) {
            function t(e) {
              return " " === e || "\t" === e || "\n" === e || "\f" === e || "\r" === e;
            }
            function r(t) {
              var r,
                s = t.exec(e.substring(f));
              if (s) return r = s[0], f += r.length, r;
            }
            for (var s, i, n, o, a, u = e.length, l = /^[ \t\n\r\u000c]+/, c = /^[, \t\n\r\u000c]+/, d = /^[^ \t\n\r\u000c]+/, v = /[,]+$/, p = /^\d+$/, _ = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, f = 0, h = [];;) {
              if (r(c), f >= u) return h;
              s = r(d), i = [], "," === s.slice(-1) ? (s = s.replace(v, ""), g()) : m();
            }
            function m() {
              for (r(l), n = "", o = "in descriptor";;) {
                if (a = e.charAt(f), "in descriptor" === o) {
                  if (t(a)) n && (i.push(n), n = "", o = "after descriptor");else {
                    if ("," === a) return f += 1, n && i.push(n), void g();
                    if ("(" === a) n += a, o = "in parens";else {
                      if ("" === a) return n && i.push(n), void g();
                      n += a;
                    }
                  }
                } else if ("in parens" === o) {
                  if (")" === a) n += a, o = "in descriptor";else {
                    if ("" === a) return i.push(n), void g();
                    n += a;
                  }
                } else if ("after descriptor" === o) if (t(a)) ;else {
                  if ("" === a) return void g();
                  o = "in descriptor", f -= 1;
                }
                f += 1;
              }
            }
            function g() {
              var t,
                r,
                n,
                o,
                a,
                u,
                l,
                c,
                d,
                v = !1,
                f = {};
              for (o = 0; o < i.length; o++) u = (a = i[o])[a.length - 1], l = a.substring(0, a.length - 1), c = parseInt(l, 10), d = parseFloat(l), p.test(l) && "w" === u ? ((t || r) && (v = !0), 0 === c ? v = !0 : t = c) : _.test(l) && "x" === u ? ((t || r || n) && (v = !0), d < 0 ? v = !0 : r = d) : p.test(l) && "h" === u ? ((n || r) && (v = !0), 0 === c ? v = !0 : n = c) : v = !0;
              v ? console && console.log && console.log("Invalid srcset descriptor found in '" + e + "' at '" + a + "'.") : (f.url = s, t && (f.w = t), r && (f.d = r), n && (f.h = n), h.push(f));
            }
          };
        }) ? r.apply(t, s) : r) || (e.exports = i);
      },
      8633: e => {
        var t = String,
          r = function () {
            return {
              isColorSupported: !1,
              reset: t,
              bold: t,
              dim: t,
              italic: t,
              underline: t,
              inverse: t,
              hidden: t,
              strikethrough: t,
              black: t,
              red: t,
              green: t,
              yellow: t,
              blue: t,
              magenta: t,
              cyan: t,
              white: t,
              gray: t,
              bgBlack: t,
              bgRed: t,
              bgGreen: t,
              bgYellow: t,
              bgBlue: t,
              bgMagenta: t,
              bgCyan: t,
              bgWhite: t
            };
          };
        e.exports = r(), e.exports.createColors = r;
      },
      396: (e, t, r) => {
        "use strict";

        let s = r(7793);
        class i extends s {
          constructor(e) {
            super(e), this.type = "atrule";
          }
          append(...e) {
            return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
          }
          prepend(...e) {
            return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
          }
        }
        e.exports = i, i.default = i, s.registerAtRule(i);
      },
      9371: (e, t, r) => {
        "use strict";

        let s = r(3152);
        class i extends s {
          constructor(e) {
            super(e), this.type = "comment";
          }
        }
        e.exports = i, i.default = i;
      },
      7793: (e, t, r) => {
        "use strict";

        let s,
          i,
          n,
          o,
          {
            isClean: a,
            my: u
          } = r(4151),
          l = r(5238),
          c = r(9371),
          d = r(3152);
        function v(e) {
          return e.map(e => (e.nodes && (e.nodes = v(e.nodes)), delete e.source, e));
        }
        function p(e) {
          if (e[a] = !1, e.proxyOf.nodes) for (let t of e.proxyOf.nodes) p(t);
        }
        class _ extends d {
          append(...e) {
            for (let t of e) {
              let e = this.normalize(t, this.last);
              for (let t of e) this.proxyOf.nodes.push(t);
            }
            return this.markDirty(), this;
          }
          cleanRaws(e) {
            if (super.cleanRaws(e), this.nodes) for (let t of this.nodes) t.cleanRaws(e);
          }
          each(e) {
            if (!this.proxyOf.nodes) return;
            let t,
              r,
              s = this.getIterator();
            for (; this.indexes[s] < this.proxyOf.nodes.length && (t = this.indexes[s], r = e(this.proxyOf.nodes[t], t), !1 !== r);) this.indexes[s] += 1;
            return delete this.indexes[s], r;
          }
          every(e) {
            return this.nodes.every(e);
          }
          getIterator() {
            this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
            let e = this.lastEach;
            return this.indexes[e] = 0, e;
          }
          getProxyProcessor() {
            return {
              get: (e, t) => "proxyOf" === t ? e : e[t] ? "each" === t || "string" == typeof t && t.startsWith("walk") ? (...r) => e[t](...r.map(e => "function" == typeof e ? (t, r) => e(t.toProxy(), r) : e)) : "every" === t || "some" === t ? r => e[t]((e, ...t) => r(e.toProxy(), ...t)) : "root" === t ? () => e.root().toProxy() : "nodes" === t ? e.nodes.map(e => e.toProxy()) : "first" === t || "last" === t ? e[t].toProxy() : e[t] : e[t],
              set: (e, t, r) => (e[t] === r || (e[t] = r, "name" !== t && "params" !== t && "selector" !== t || e.markDirty()), !0)
            };
          }
          index(e) {
            return "number" == typeof e ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
          }
          insertAfter(e, t) {
            let r,
              s = this.index(e),
              i = this.normalize(t, this.proxyOf.nodes[s]).reverse();
            s = this.index(e);
            for (let e of i) this.proxyOf.nodes.splice(s + 1, 0, e);
            for (let e in this.indexes) r = this.indexes[e], s < r && (this.indexes[e] = r + i.length);
            return this.markDirty(), this;
          }
          insertBefore(e, t) {
            let r,
              s = this.index(e),
              i = 0 === s && "prepend",
              n = this.normalize(t, this.proxyOf.nodes[s], i).reverse();
            s = this.index(e);
            for (let e of n) this.proxyOf.nodes.splice(s, 0, e);
            for (let e in this.indexes) r = this.indexes[e], s <= r && (this.indexes[e] = r + n.length);
            return this.markDirty(), this;
          }
          normalize(e, t) {
            if ("string" == typeof e) e = v(s(e).nodes);else if (void 0 === e) e = [];else if (Array.isArray(e)) {
              e = e.slice(0);
              for (let t of e) t.parent && t.parent.removeChild(t, "ignore");
            } else if ("root" === e.type && "document" !== this.type) {
              e = e.nodes.slice(0);
              for (let t of e) t.parent && t.parent.removeChild(t, "ignore");
            } else if (e.type) e = [e];else if (e.prop) {
              if (void 0 === e.value) throw new Error("Value field is missed in node creation");
              "string" != typeof e.value && (e.value = String(e.value)), e = [new l(e)];
            } else if (e.selector) e = [new i(e)];else if (e.name) e = [new n(e)];else {
              if (!e.text) throw new Error("Unknown node type in node creation");
              e = [new c(e)];
            }
            return e.map(e => (e[u] || _.rebuild(e), (e = e.proxyOf).parent && e.parent.removeChild(e), e[a] && p(e), void 0 === e.raws.before && t && void 0 !== t.raws.before && (e.raws.before = t.raws.before.replace(/\S/g, "")), e.parent = this.proxyOf, e));
          }
          prepend(...e) {
            e = e.reverse();
            for (let t of e) {
              let e = this.normalize(t, this.first, "prepend").reverse();
              for (let t of e) this.proxyOf.nodes.unshift(t);
              for (let t in this.indexes) this.indexes[t] = this.indexes[t] + e.length;
            }
            return this.markDirty(), this;
          }
          push(e) {
            return e.parent = this, this.proxyOf.nodes.push(e), this;
          }
          removeAll() {
            for (let e of this.proxyOf.nodes) e.parent = void 0;
            return this.proxyOf.nodes = [], this.markDirty(), this;
          }
          removeChild(e) {
            let t;
            e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
            for (let r in this.indexes) t = this.indexes[r], t >= e && (this.indexes[r] = t - 1);
            return this.markDirty(), this;
          }
          replaceValues(e, t, r) {
            return r || (r = t, t = {}), this.walkDecls(s => {
              t.props && !t.props.includes(s.prop) || t.fast && !s.value.includes(t.fast) || (s.value = s.value.replace(e, r));
            }), this.markDirty(), this;
          }
          some(e) {
            return this.nodes.some(e);
          }
          walk(e) {
            return this.each((t, r) => {
              let s;
              try {
                s = e(t, r);
              } catch (e) {
                throw t.addToError(e);
              }
              return !1 !== s && t.walk && (s = t.walk(e)), s;
            });
          }
          walkAtRules(e, t) {
            return t ? e instanceof RegExp ? this.walk((r, s) => {
              if ("atrule" === r.type && e.test(r.name)) return t(r, s);
            }) : this.walk((r, s) => {
              if ("atrule" === r.type && r.name === e) return t(r, s);
            }) : (t = e, this.walk((e, r) => {
              if ("atrule" === e.type) return t(e, r);
            }));
          }
          walkComments(e) {
            return this.walk((t, r) => {
              if ("comment" === t.type) return e(t, r);
            });
          }
          walkDecls(e, t) {
            return t ? e instanceof RegExp ? this.walk((r, s) => {
              if ("decl" === r.type && e.test(r.prop)) return t(r, s);
            }) : this.walk((r, s) => {
              if ("decl" === r.type && r.prop === e) return t(r, s);
            }) : (t = e, this.walk((e, r) => {
              if ("decl" === e.type) return t(e, r);
            }));
          }
          walkRules(e, t) {
            return t ? e instanceof RegExp ? this.walk((r, s) => {
              if ("rule" === r.type && e.test(r.selector)) return t(r, s);
            }) : this.walk((r, s) => {
              if ("rule" === r.type && r.selector === e) return t(r, s);
            }) : (t = e, this.walk((e, r) => {
              if ("rule" === e.type) return t(e, r);
            }));
          }
          get first() {
            if (this.proxyOf.nodes) return this.proxyOf.nodes[0];
          }
          get last() {
            if (this.proxyOf.nodes) return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
          }
        }
        _.registerParse = e => {
          s = e;
        }, _.registerRule = e => {
          i = e;
        }, _.registerAtRule = e => {
          n = e;
        }, _.registerRoot = e => {
          o = e;
        }, e.exports = _, _.default = _, _.rebuild = e => {
          "atrule" === e.type ? Object.setPrototypeOf(e, n.prototype) : "rule" === e.type ? Object.setPrototypeOf(e, i.prototype) : "decl" === e.type ? Object.setPrototypeOf(e, l.prototype) : "comment" === e.type ? Object.setPrototypeOf(e, c.prototype) : "root" === e.type && Object.setPrototypeOf(e, o.prototype), e[u] = !0, e.nodes && e.nodes.forEach(e => {
            _.rebuild(e);
          });
        };
      },
      1233: (e, t, r) => {
        "use strict";

        let s = r(8633),
          i = r(9746);
        class n extends Error {
          constructor(e, t, r, s, i, o) {
            super(e), this.name = "CssSyntaxError", this.reason = e, i && (this.file = i), s && (this.source = s), o && (this.plugin = o), void 0 !== t && void 0 !== r && ("number" == typeof t ? (this.line = t, this.column = r) : (this.line = t.line, this.column = t.column, this.endLine = r.line, this.endColumn = r.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, n);
          }
          setMessage() {
            this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", void 0 !== this.line && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
          }
          showSourceCode(e) {
            if (!this.source) return "";
            let t = this.source;
            null == e && (e = s.isColorSupported), i && e && (t = i(t));
            let r,
              n,
              o = t.split(/\r?\n/),
              a = Math.max(this.line - 3, 0),
              u = Math.min(this.line + 2, o.length),
              l = String(u).length;
            if (e) {
              let {
                bold: e,
                gray: t,
                red: i
              } = s.createColors(!0);
              r = t => e(i(t)), n = e => t(e);
            } else r = n = e => e;
            return o.slice(a, u).map((e, t) => {
              let s = a + 1 + t,
                i = " " + (" " + s).slice(-l) + " | ";
              if (s === this.line) {
                let t = n(i.replace(/\d/g, " ")) + e.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return r(">") + n(i) + e + "\n " + t + r("^");
              }
              return " " + n(i) + e;
            }).join("\n");
          }
          toString() {
            let e = this.showSourceCode();
            return e && (e = "\n\n" + e + "\n"), this.name + ": " + this.message + e;
          }
        }
        e.exports = n, n.default = n;
      },
      5238: (e, t, r) => {
        "use strict";

        let s = r(3152);
        class i extends s {
          constructor(e) {
            e && void 0 !== e.value && "string" != typeof e.value && (e = {
              ...e,
              value: String(e.value)
            }), super(e), this.type = "decl";
          }
          get variable() {
            return this.prop.startsWith("--") || "$" === this.prop[0];
          }
        }
        e.exports = i, i.default = i;
      },
      145: (e, t, r) => {
        "use strict";

        let s,
          i,
          n = r(7793);
        class o extends n {
          constructor(e) {
            super({
              type: "document",
              ...e
            }), this.nodes || (this.nodes = []);
          }
          toResult(e = {}) {
            return new s(new i(), this, e).stringify();
          }
        }
        o.registerLazyResult = e => {
          s = e;
        }, o.registerProcessor = e => {
          i = e;
        }, e.exports = o, o.default = o;
      },
      3438: (e, t, r) => {
        "use strict";

        let s = r(5238),
          i = r(3878),
          n = r(9371),
          o = r(396),
          a = r(1106),
          u = r(5644),
          l = r(1534);
        function c(e, t) {
          if (Array.isArray(e)) return e.map(e => c(e));
          let {
            inputs: r,
            ...d
          } = e;
          if (r) {
            t = [];
            for (let e of r) {
              let r = {
                ...e,
                __proto__: a.prototype
              };
              r.map && (r.map = {
                ...r.map,
                __proto__: i.prototype
              }), t.push(r);
            }
          }
          if (d.nodes && (d.nodes = e.nodes.map(e => c(e, t))), d.source) {
            let {
              inputId: e,
              ...r
            } = d.source;
            d.source = r, null != e && (d.source.input = t[e]);
          }
          if ("root" === d.type) return new u(d);
          if ("decl" === d.type) return new s(d);
          if ("rule" === d.type) return new l(d);
          if ("comment" === d.type) return new n(d);
          if ("atrule" === d.type) return new o(d);
          throw new Error("Unknown node type: " + e.type);
        }
        e.exports = c, c.default = c;
      },
      1106: (e, t, r) => {
        "use strict";

        let {
            SourceMapConsumer: s,
            SourceMapGenerator: i
          } = r(1866),
          {
            fileURLToPath: n,
            pathToFileURL: o
          } = r(2739),
          {
            isAbsolute: a,
            resolve: u
          } = r(197),
          {
            nanoid: l
          } = r(5042),
          c = r(9746),
          d = r(1233),
          v = r(3878),
          p = Symbol("fromOffsetCache"),
          _ = Boolean(s && i),
          f = Boolean(u && a);
        class h {
          constructor(e, t = {}) {
            if (null == e || "object" == typeof e && !e.toString) throw new Error(`PostCSS received ${e} instead of CSS string`);
            if (this.css = e.toString(), "\ufeff" === this.css[0] || "￾" === this.css[0] ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, t.from && (!f || /^\w+:\/\//.test(t.from) || a(t.from) ? this.file = t.from : this.file = u(t.from)), f && _) {
              let e = new v(this.css, t);
              if (e.text) {
                this.map = e;
                let t = e.consumer().file;
                !this.file && t && (this.file = this.mapResolve(t));
              }
            }
            this.file || (this.id = "<input css " + l(6) + ">"), this.map && (this.map.file = this.from);
          }
          error(e, t, r, s = {}) {
            let i, n, a;
            if (t && "object" == typeof t) {
              let e = t,
                s = r;
              if ("number" == typeof e.offset) {
                let s = this.fromOffset(e.offset);
                t = s.line, r = s.col;
              } else t = e.line, r = e.column;
              if ("number" == typeof s.offset) {
                let e = this.fromOffset(s.offset);
                n = e.line, a = e.col;
              } else n = s.line, a = s.column;
            } else if (!r) {
              let e = this.fromOffset(t);
              t = e.line, r = e.col;
            }
            let u = this.origin(t, r, n, a);
            return i = u ? new d(e, void 0 === u.endLine ? u.line : {
              column: u.column,
              line: u.line
            }, void 0 === u.endLine ? u.column : {
              column: u.endColumn,
              line: u.endLine
            }, u.source, u.file, s.plugin) : new d(e, void 0 === n ? t : {
              column: r,
              line: t
            }, void 0 === n ? r : {
              column: a,
              line: n
            }, this.css, this.file, s.plugin), i.input = {
              column: r,
              endColumn: a,
              endLine: n,
              line: t,
              source: this.css
            }, this.file && (o && (i.input.url = o(this.file).toString()), i.input.file = this.file), i;
          }
          fromOffset(e) {
            let t, r;
            if (this[p]) r = this[p];else {
              let e = this.css.split("\n");
              r = new Array(e.length);
              let t = 0;
              for (let s = 0, i = e.length; s < i; s++) r[s] = t, t += e[s].length + 1;
              this[p] = r;
            }
            t = r[r.length - 1];
            let s = 0;
            if (e >= t) s = r.length - 1;else {
              let t,
                i = r.length - 2;
              for (; s < i;) if (t = s + (i - s >> 1), e < r[t]) i = t - 1;else {
                if (!(e >= r[t + 1])) {
                  s = t;
                  break;
                }
                s = t + 1;
              }
            }
            return {
              col: e - r[s] + 1,
              line: s + 1
            };
          }
          mapResolve(e) {
            return /^\w+:\/\//.test(e) ? e : u(this.map.consumer().sourceRoot || this.map.root || ".", e);
          }
          origin(e, t, r, s) {
            if (!this.map) return !1;
            let i,
              u,
              l = this.map.consumer(),
              c = l.originalPositionFor({
                column: t,
                line: e
              });
            if (!c.source) return !1;
            "number" == typeof r && (i = l.originalPositionFor({
              column: s,
              line: r
            })), u = a(c.source) ? o(c.source) : new URL(c.source, this.map.consumer().sourceRoot || o(this.map.mapFile));
            let d = {
              column: c.column,
              endColumn: i && i.column,
              endLine: i && i.line,
              line: c.line,
              url: u.toString()
            };
            if ("file:" === u.protocol) {
              if (!n) throw new Error("file: protocol is not available in this PostCSS build");
              d.file = n(u);
            }
            let v = l.sourceContentFor(c.source);
            return v && (d.source = v), d;
          }
          toJSON() {
            let e = {};
            for (let t of ["hasBOM", "css", "file", "id"]) null != this[t] && (e[t] = this[t]);
            return this.map && (e.map = {
              ...this.map
            }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
          }
          get from() {
            return this.file || this.id;
          }
        }
        e.exports = h, h.default = h, c && c.registerInput && c.registerInput(h);
      },
      6966: (e, t, r) => {
        "use strict";

        let {
            isClean: s,
            my: i
          } = r(4151),
          n = r(3604),
          o = r(3303),
          a = r(7793),
          u = r(145),
          l = (r(6156), r(3717)),
          c = r(1958),
          d = r(5644);
        const v = {
            atrule: "AtRule",
            comment: "Comment",
            decl: "Declaration",
            document: "Document",
            root: "Root",
            rule: "Rule"
          },
          p = {
            AtRule: !0,
            AtRuleExit: !0,
            Comment: !0,
            CommentExit: !0,
            Declaration: !0,
            DeclarationExit: !0,
            Document: !0,
            DocumentExit: !0,
            Once: !0,
            OnceExit: !0,
            postcssPlugin: !0,
            prepare: !0,
            Root: !0,
            RootExit: !0,
            Rule: !0,
            RuleExit: !0
          },
          _ = {
            Once: !0,
            postcssPlugin: !0,
            prepare: !0
          },
          f = 0;
        function h(e) {
          return "object" == typeof e && "function" == typeof e.then;
        }
        function m(e) {
          let t = !1,
            r = v[e.type];
          return "decl" === e.type ? t = e.prop.toLowerCase() : "atrule" === e.type && (t = e.name.toLowerCase()), t && e.append ? [r, r + "-" + t, f, r + "Exit", r + "Exit-" + t] : t ? [r, r + "-" + t, r + "Exit", r + "Exit-" + t] : e.append ? [r, f, r + "Exit"] : [r, r + "Exit"];
        }
        function g(e) {
          let t;
          return t = "document" === e.type ? ["Document", f, "DocumentExit"] : "root" === e.type ? ["Root", f, "RootExit"] : m(e), {
            eventIndex: 0,
            events: t,
            iterator: 0,
            node: e,
            visitorIndex: 0,
            visitors: []
          };
        }
        function b(e) {
          return e[s] = !1, e.nodes && e.nodes.forEach(e => b(e)), e;
        }
        let y = {};
        class w {
          constructor(e, t, r) {
            let s;
            if (this.stringified = !1, this.processed = !1, "object" != typeof t || null === t || "root" !== t.type && "document" !== t.type) {
              if (t instanceof w || t instanceof l) s = b(t.root), t.map && (void 0 === r.map && (r.map = {}), r.map.inline || (r.map.inline = !1), r.map.prev = t.map);else {
                let e = c;
                r.syntax && (e = r.syntax.parse), r.parser && (e = r.parser), e.parse && (e = e.parse);
                try {
                  s = e(t, r);
                } catch (e) {
                  this.processed = !0, this.error = e;
                }
                s && !s[i] && a.rebuild(s);
              }
            } else s = b(t);
            this.result = new l(e, s, r), this.helpers = {
              ...y,
              postcss: y,
              result: this.result
            }, this.plugins = this.processor.plugins.map(e => "object" == typeof e && e.prepare ? {
              ...e,
              ...e.prepare(this.result)
            } : e);
          }
          async() {
            return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
          }
          catch(e) {
            return this.async().catch(e);
          }
          finally(e) {
            return this.async().then(e, e);
          }
          getAsyncError() {
            throw new Error("Use process(css).then(cb) to work with async plugins");
          }
          handleError(e, t) {
            let r = this.result.lastPlugin;
            try {
              t && t.addToError(e), this.error = e, "CssSyntaxError" !== e.name || e.plugin ? r.postcssVersion : (e.plugin = r.postcssPlugin, e.setMessage());
            } catch (e) {
              console && console.error && console.error(e);
            }
            return e;
          }
          prepareVisitors() {
            this.listeners = {};
            let e = (e, t, r) => {
              this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push([e, r]);
            };
            for (let t of this.plugins) if ("object" == typeof t) for (let r in t) {
              if (!p[r] && /^[A-Z]/.test(r)) throw new Error(`Unknown event ${r} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
              if (!_[r]) if ("object" == typeof t[r]) for (let s in t[r]) e(t, "*" === s ? r : r + "-" + s.toLowerCase(), t[r][s]);else "function" == typeof t[r] && e(t, r, t[r]);
            }
            this.hasListener = Object.keys(this.listeners).length > 0;
          }
          async runAsync() {
            this.plugin = 0;
            for (let e = 0; e < this.plugins.length; e++) {
              let t = this.plugins[e],
                r = this.runOnRoot(t);
              if (h(r)) try {
                await r;
              } catch (e) {
                throw this.handleError(e);
              }
            }
            if (this.prepareVisitors(), this.hasListener) {
              let e = this.result.root;
              for (; !e[s];) {
                e[s] = !0;
                let t = [g(e)];
                for (; t.length > 0;) {
                  let e = this.visitTick(t);
                  if (h(e)) try {
                    await e;
                  } catch (e) {
                    let r = t[t.length - 1].node;
                    throw this.handleError(e, r);
                  }
                }
              }
              if (this.listeners.OnceExit) for (let [t, r] of this.listeners.OnceExit) {
                this.result.lastPlugin = t;
                try {
                  if ("document" === e.type) {
                    let t = e.nodes.map(e => r(e, this.helpers));
                    await Promise.all(t);
                  } else await r(e, this.helpers);
                } catch (e) {
                  throw this.handleError(e);
                }
              }
            }
            return this.processed = !0, this.stringify();
          }
          runOnRoot(e) {
            this.result.lastPlugin = e;
            try {
              if ("object" == typeof e && e.Once) {
                if ("document" === this.result.root.type) {
                  let t = this.result.root.nodes.map(t => e.Once(t, this.helpers));
                  return h(t[0]) ? Promise.all(t) : t;
                }
                return e.Once(this.result.root, this.helpers);
              }
              if ("function" == typeof e) return e(this.result.root, this.result);
            } catch (e) {
              throw this.handleError(e);
            }
          }
          stringify() {
            if (this.error) throw this.error;
            if (this.stringified) return this.result;
            this.stringified = !0, this.sync();
            let e = this.result.opts,
              t = o;
            e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
            let r = new n(t, this.result.root, this.result.opts).generate();
            return this.result.css = r[0], this.result.map = r[1], this.result;
          }
          sync() {
            if (this.error) throw this.error;
            if (this.processed) return this.result;
            if (this.processed = !0, this.processing) throw this.getAsyncError();
            for (let e of this.plugins) {
              if (h(this.runOnRoot(e))) throw this.getAsyncError();
            }
            if (this.prepareVisitors(), this.hasListener) {
              let e = this.result.root;
              for (; !e[s];) e[s] = !0, this.walkSync(e);
              if (this.listeners.OnceExit) if ("document" === e.type) for (let t of e.nodes) this.visitSync(this.listeners.OnceExit, t);else this.visitSync(this.listeners.OnceExit, e);
            }
            return this.result;
          }
          then(e, t) {
            return this.async().then(e, t);
          }
          toString() {
            return this.css;
          }
          visitSync(e, t) {
            for (let [r, s] of e) {
              let e;
              this.result.lastPlugin = r;
              try {
                e = s(t, this.helpers);
              } catch (e) {
                throw this.handleError(e, t.proxyOf);
              }
              if ("root" !== t.type && "document" !== t.type && !t.parent) return !0;
              if (h(e)) throw this.getAsyncError();
            }
          }
          visitTick(e) {
            let t = e[e.length - 1],
              {
                node: r,
                visitors: i
              } = t;
            if ("root" !== r.type && "document" !== r.type && !r.parent) return void e.pop();
            if (i.length > 0 && t.visitorIndex < i.length) {
              let [e, s] = i[t.visitorIndex];
              t.visitorIndex += 1, t.visitorIndex === i.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = e;
              try {
                return s(r.toProxy(), this.helpers);
              } catch (e) {
                throw this.handleError(e, r);
              }
            }
            if (0 !== t.iterator) {
              let i,
                n = t.iterator;
              for (; i = r.nodes[r.indexes[n]];) if (r.indexes[n] += 1, !i[s]) return i[s] = !0, void e.push(g(i));
              t.iterator = 0, delete r.indexes[n];
            }
            let n = t.events;
            for (; t.eventIndex < n.length;) {
              let e = n[t.eventIndex];
              if (t.eventIndex += 1, e === f) return void (r.nodes && r.nodes.length && (r[s] = !0, t.iterator = r.getIterator()));
              if (this.listeners[e]) return void (t.visitors = this.listeners[e]);
            }
            e.pop();
          }
          walkSync(e) {
            e[s] = !0;
            let t = m(e);
            for (let r of t) if (r === f) e.nodes && e.each(e => {
              e[s] || this.walkSync(e);
            });else {
              let t = this.listeners[r];
              if (t && this.visitSync(t, e.toProxy())) return;
            }
          }
          warnings() {
            return this.sync().warnings();
          }
          get content() {
            return this.stringify().content;
          }
          get css() {
            return this.stringify().css;
          }
          get map() {
            return this.stringify().map;
          }
          get messages() {
            return this.sync().messages;
          }
          get opts() {
            return this.result.opts;
          }
          get processor() {
            return this.result.processor;
          }
          get root() {
            return this.sync().root;
          }
          get [Symbol.toStringTag]() {
            return "LazyResult";
          }
        }
        w.registerPostcss = e => {
          y = e;
        }, e.exports = w, w.default = w, d.registerLazyResult(w), u.registerLazyResult(w);
      },
      1752: e => {
        "use strict";

        let t = {
          comma: e => t.split(e, [","], !0),
          space: e => t.split(e, [" ", "\n", "\t"]),
          split(e, t, r) {
            let s = [],
              i = "",
              n = !1,
              o = 0,
              a = !1,
              u = "",
              l = !1;
            for (let r of e) l ? l = !1 : "\\" === r ? l = !0 : a ? r === u && (a = !1) : '"' === r || "'" === r ? (a = !0, u = r) : "(" === r ? o += 1 : ")" === r ? o > 0 && (o -= 1) : 0 === o && t.includes(r) && (n = !0), n ? ("" !== i && s.push(i.trim()), i = "", n = !1) : i += r;
            return (r || "" !== i) && s.push(i.trim()), s;
          }
        };
        e.exports = t, t.default = t;
      },
      3604: (e, t, r) => {
        "use strict";

        let {
            SourceMapConsumer: s,
            SourceMapGenerator: i
          } = r(1866),
          {
            dirname: n,
            relative: o,
            resolve: a,
            sep: u
          } = r(197),
          {
            pathToFileURL: l
          } = r(2739),
          c = r(1106),
          d = Boolean(s && i),
          v = Boolean(n && a && o && u);
        e.exports = class {
          constructor(e, t, r, s) {
            this.stringify = e, this.mapOpts = r.map || {}, this.root = t, this.opts = r, this.css = s, this.originalCSS = s, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = new Map(), this.memoizedPaths = new Map(), this.memoizedURLs = new Map();
          }
          addAnnotation() {
            let e;
            e = this.isInline() ? "data:application/json;base64," + this.toBase64(this.map.toString()) : "string" == typeof this.mapOpts.annotation ? this.mapOpts.annotation : "function" == typeof this.mapOpts.annotation ? this.mapOpts.annotation(this.opts.to, this.root) : this.outputFile() + ".map";
            let t = "\n";
            this.css.includes("\r\n") && (t = "\r\n"), this.css += t + "/*# sourceMappingURL=" + e + " */";
          }
          applyPrevMaps() {
            for (let e of this.previous()) {
              let t,
                r = this.toUrl(this.path(e.file)),
                i = e.root || n(e.file);
              !1 === this.mapOpts.sourcesContent ? (t = new s(e.text), t.sourcesContent && (t.sourcesContent = null)) : t = e.consumer(), this.map.applySourceMap(t, r, this.toUrl(this.path(i)));
            }
          }
          clearAnnotation() {
            if (!1 !== this.mapOpts.annotation) if (this.root) {
              let e;
              for (let t = this.root.nodes.length - 1; t >= 0; t--) e = this.root.nodes[t], "comment" === e.type && 0 === e.text.indexOf("# sourceMappingURL=") && this.root.removeChild(t);
            } else this.css && (this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, ""));
          }
          generate() {
            if (this.clearAnnotation(), v && d && this.isMap()) return this.generateMap();
            {
              let e = "";
              return this.stringify(this.root, t => {
                e += t;
              }), [e];
            }
          }
          generateMap() {
            if (this.root) this.generateString();else if (1 === this.previous().length) {
              let e = this.previous()[0].consumer();
              e.file = this.outputFile(), this.map = i.fromSourceMap(e, {
                ignoreInvalidMapping: !0
              });
            } else this.map = new i({
              file: this.outputFile(),
              ignoreInvalidMapping: !0
            }), this.map.addMapping({
              generated: {
                column: 0,
                line: 1
              },
              original: {
                column: 0,
                line: 1
              },
              source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
            return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
          }
          generateString() {
            this.css = "", this.map = new i({
              file: this.outputFile(),
              ignoreInvalidMapping: !0
            });
            let e,
              t,
              r = 1,
              s = 1,
              n = "<no source>",
              o = {
                generated: {
                  column: 0,
                  line: 0
                },
                original: {
                  column: 0,
                  line: 0
                },
                source: ""
              };
            this.stringify(this.root, (i, a, u) => {
              if (this.css += i, a && "end" !== u && (o.generated.line = r, o.generated.column = s - 1, a.source && a.source.start ? (o.source = this.sourcePath(a), o.original.line = a.source.start.line, o.original.column = a.source.start.column - 1, this.map.addMapping(o)) : (o.source = n, o.original.line = 1, o.original.column = 0, this.map.addMapping(o))), e = i.match(/\n/g), e ? (r += e.length, t = i.lastIndexOf("\n"), s = i.length - t) : s += i.length, a && "start" !== u) {
                let e = a.parent || {
                  raws: {}
                };
                ("decl" === a.type || "atrule" === a.type && !a.nodes) && a === e.last && !e.raws.semicolon || (a.source && a.source.end ? (o.source = this.sourcePath(a), o.original.line = a.source.end.line, o.original.column = a.source.end.column - 1, o.generated.line = r, o.generated.column = s - 2, this.map.addMapping(o)) : (o.source = n, o.original.line = 1, o.original.column = 0, o.generated.line = r, o.generated.column = s - 1, this.map.addMapping(o)));
              }
            });
          }
          isAnnotation() {
            return !!this.isInline() || (void 0 !== this.mapOpts.annotation ? this.mapOpts.annotation : !this.previous().length || this.previous().some(e => e.annotation));
          }
          isInline() {
            if (void 0 !== this.mapOpts.inline) return this.mapOpts.inline;
            let e = this.mapOpts.annotation;
            return (void 0 === e || !0 === e) && (!this.previous().length || this.previous().some(e => e.inline));
          }
          isMap() {
            return void 0 !== this.opts.map ? !!this.opts.map : this.previous().length > 0;
          }
          isSourcesContent() {
            return void 0 !== this.mapOpts.sourcesContent ? this.mapOpts.sourcesContent : !this.previous().length || this.previous().some(e => e.withContent());
          }
          outputFile() {
            return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
          }
          path(e) {
            if (this.mapOpts.absolute) return e;
            if (60 === e.charCodeAt(0)) return e;
            if (/^\w+:\/\//.test(e)) return e;
            let t = this.memoizedPaths.get(e);
            if (t) return t;
            let r = this.opts.to ? n(this.opts.to) : ".";
            "string" == typeof this.mapOpts.annotation && (r = n(a(r, this.mapOpts.annotation)));
            let s = o(r, e);
            return this.memoizedPaths.set(e, s), s;
          }
          previous() {
            if (!this.previousMaps) if (this.previousMaps = [], this.root) this.root.walk(e => {
              if (e.source && e.source.input.map) {
                let t = e.source.input.map;
                this.previousMaps.includes(t) || this.previousMaps.push(t);
              }
            });else {
              let e = new c(this.originalCSS, this.opts);
              e.map && this.previousMaps.push(e.map);
            }
            return this.previousMaps;
          }
          setSourcesContent() {
            let e = {};
            if (this.root) this.root.walk(t => {
              if (t.source) {
                let r = t.source.input.from;
                if (r && !e[r]) {
                  e[r] = !0;
                  let s = this.usesFileUrls ? this.toFileUrl(r) : this.toUrl(this.path(r));
                  this.map.setSourceContent(s, t.source.input.css);
                }
              }
            });else if (this.css) {
              let e = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
              this.map.setSourceContent(e, this.css);
            }
          }
          sourcePath(e) {
            return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
          }
          toBase64(e) {
            return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
          }
          toFileUrl(e) {
            let t = this.memoizedFileURLs.get(e);
            if (t) return t;
            if (l) {
              let t = l(e).toString();
              return this.memoizedFileURLs.set(e, t), t;
            }
            throw new Error("`map.absolute` option is not available in this PostCSS build");
          }
          toUrl(e) {
            let t = this.memoizedURLs.get(e);
            if (t) return t;
            "\\" === u && (e = e.replace(/\\/g, "/"));
            let r = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
            return this.memoizedURLs.set(e, r), r;
          }
        };
      },
      4211: (e, t, r) => {
        "use strict";

        let s = r(3604),
          i = r(3303),
          n = (r(6156), r(1958));
        const o = r(3717);
        class a {
          constructor(e, t, r) {
            let n;
            t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = r, this._map = void 0;
            let a = i;
            this.result = new o(this._processor, n, this._opts), this.result.css = t;
            let u = this;
            Object.defineProperty(this.result, "root", {
              get: () => u.root
            });
            let l = new s(a, n, this._opts, t);
            if (l.isMap()) {
              let [e, t] = l.generate();
              e && (this.result.css = e), t && (this.result.map = t);
            } else l.clearAnnotation(), this.result.css = l.css;
          }
          async() {
            return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
          }
          catch(e) {
            return this.async().catch(e);
          }
          finally(e) {
            return this.async().then(e, e);
          }
          sync() {
            if (this.error) throw this.error;
            return this.result;
          }
          then(e, t) {
            return this.async().then(e, t);
          }
          toString() {
            return this._css;
          }
          warnings() {
            return [];
          }
          get content() {
            return this.result.css;
          }
          get css() {
            return this.result.css;
          }
          get map() {
            return this.result.map;
          }
          get messages() {
            return [];
          }
          get opts() {
            return this.result.opts;
          }
          get processor() {
            return this.result.processor;
          }
          get root() {
            if (this._root) return this._root;
            let e,
              t = n;
            try {
              e = t(this._css, this._opts);
            } catch (e) {
              this.error = e;
            }
            if (this.error) throw this.error;
            return this._root = e, e;
          }
          get [Symbol.toStringTag]() {
            return "NoWorkResult";
          }
        }
        e.exports = a, a.default = a;
      },
      3152: (e, t, r) => {
        "use strict";

        let {
            isClean: s,
            my: i
          } = r(4151),
          n = r(1233),
          o = r(7668),
          a = r(3303);
        function u(e, t) {
          let r = new e.constructor();
          for (let s in e) {
            if (!Object.prototype.hasOwnProperty.call(e, s)) continue;
            if ("proxyCache" === s) continue;
            let i = e[s],
              n = typeof i;
            "parent" === s && "object" === n ? t && (r[s] = t) : "source" === s ? r[s] = i : Array.isArray(i) ? r[s] = i.map(e => u(e, r)) : ("object" === n && null !== i && (i = u(i)), r[s] = i);
          }
          return r;
        }
        class l {
          constructor(e = {}) {
            this.raws = {}, this[s] = !1, this[i] = !0;
            for (let t in e) if ("nodes" === t) {
              this.nodes = [];
              for (let r of e[t]) "function" == typeof r.clone ? this.append(r.clone()) : this.append(r);
            } else this[t] = e[t];
          }
          addToError(e) {
            if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
              let t = this.source;
              e.stack = e.stack.replace(/\n\s{4}at /, `$&${t.input.from}:${t.start.line}:${t.start.column}$&`);
            }
            return e;
          }
          after(e) {
            return this.parent.insertAfter(this, e), this;
          }
          assign(e = {}) {
            for (let t in e) this[t] = e[t];
            return this;
          }
          before(e) {
            return this.parent.insertBefore(this, e), this;
          }
          cleanRaws(e) {
            delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
          }
          clone(e = {}) {
            let t = u(this);
            for (let r in e) t[r] = e[r];
            return t;
          }
          cloneAfter(e = {}) {
            let t = this.clone(e);
            return this.parent.insertAfter(this, t), t;
          }
          cloneBefore(e = {}) {
            let t = this.clone(e);
            return this.parent.insertBefore(this, t), t;
          }
          error(e, t = {}) {
            if (this.source) {
              let {
                end: r,
                start: s
              } = this.rangeBy(t);
              return this.source.input.error(e, {
                column: s.column,
                line: s.line
              }, {
                column: r.column,
                line: r.line
              }, t);
            }
            return new n(e);
          }
          getProxyProcessor() {
            return {
              get: (e, t) => "proxyOf" === t ? e : "root" === t ? () => e.root().toProxy() : e[t],
              set: (e, t, r) => (e[t] === r || (e[t] = r, "prop" !== t && "value" !== t && "name" !== t && "params" !== t && "important" !== t && "text" !== t || e.markDirty()), !0)
            };
          }
          markDirty() {
            if (this[s]) {
              this[s] = !1;
              let e = this;
              for (; e = e.parent;) e[s] = !1;
            }
          }
          next() {
            if (!this.parent) return;
            let e = this.parent.index(this);
            return this.parent.nodes[e + 1];
          }
          positionBy(e, t) {
            let r = this.source.start;
            if (e.index) r = this.positionInside(e.index, t);else if (e.word) {
              let s = (t = this.toString()).indexOf(e.word);
              -1 !== s && (r = this.positionInside(s, t));
            }
            return r;
          }
          positionInside(e, t) {
            let r = t || this.toString(),
              s = this.source.start.column,
              i = this.source.start.line;
            for (let t = 0; t < e; t++) "\n" === r[t] ? (s = 1, i += 1) : s += 1;
            return {
              column: s,
              line: i
            };
          }
          prev() {
            if (!this.parent) return;
            let e = this.parent.index(this);
            return this.parent.nodes[e - 1];
          }
          rangeBy(e) {
            let t = {
                column: this.source.start.column,
                line: this.source.start.line
              },
              r = this.source.end ? {
                column: this.source.end.column + 1,
                line: this.source.end.line
              } : {
                column: t.column + 1,
                line: t.line
              };
            if (e.word) {
              let s = this.toString(),
                i = s.indexOf(e.word);
              -1 !== i && (t = this.positionInside(i, s), r = this.positionInside(i + e.word.length, s));
            } else e.start ? t = {
              column: e.start.column,
              line: e.start.line
            } : e.index && (t = this.positionInside(e.index)), e.end ? r = {
              column: e.end.column,
              line: e.end.line
            } : "number" == typeof e.endIndex ? r = this.positionInside(e.endIndex) : e.index && (r = this.positionInside(e.index + 1));
            return (r.line < t.line || r.line === t.line && r.column <= t.column) && (r = {
              column: t.column + 1,
              line: t.line
            }), {
              end: r,
              start: t
            };
          }
          raw(e, t) {
            return new o().raw(this, e, t);
          }
          remove() {
            return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
          }
          replaceWith(...e) {
            if (this.parent) {
              let t = this,
                r = !1;
              for (let s of e) s === this ? r = !0 : r ? (this.parent.insertAfter(t, s), t = s) : this.parent.insertBefore(t, s);
              r || this.remove();
            }
            return this;
          }
          root() {
            let e = this;
            for (; e.parent && "document" !== e.parent.type;) e = e.parent;
            return e;
          }
          toJSON(e, t) {
            let r = {},
              s = null == t;
            t = t || new Map();
            let i = 0;
            for (let e in this) {
              if (!Object.prototype.hasOwnProperty.call(this, e)) continue;
              if ("parent" === e || "proxyCache" === e) continue;
              let s = this[e];
              if (Array.isArray(s)) r[e] = s.map(e => "object" == typeof e && e.toJSON ? e.toJSON(null, t) : e);else if ("object" == typeof s && s.toJSON) r[e] = s.toJSON(null, t);else if ("source" === e) {
                let n = t.get(s.input);
                null == n && (n = i, t.set(s.input, i), i++), r[e] = {
                  end: s.end,
                  inputId: n,
                  start: s.start
                };
              } else r[e] = s;
            }
            return s && (r.inputs = [...t.keys()].map(e => e.toJSON())), r;
          }
          toProxy() {
            return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
          }
          toString(e = a) {
            e.stringify && (e = e.stringify);
            let t = "";
            return e(this, e => {
              t += e;
            }), t;
          }
          warn(e, t, r) {
            let s = {
              node: this
            };
            for (let e in r) s[e] = r[e];
            return e.warn(t, s);
          }
          get proxyOf() {
            return this;
          }
        }
        e.exports = l, l.default = l;
      },
      1958: (e, t, r) => {
        "use strict";

        let s = r(7793),
          i = r(8339),
          n = r(1106);
        function o(e, t) {
          let r = new n(e, t),
            s = new i(r);
          try {
            s.parse();
          } catch (e) {
            throw e;
          }
          return s.root;
        }
        e.exports = o, o.default = o, s.registerParse(o);
      },
      8339: (e, t, r) => {
        "use strict";

        let s = r(5238),
          i = r(5781),
          n = r(9371),
          o = r(396),
          a = r(5644),
          u = r(1534);
        const l = {
          empty: !0,
          space: !0
        };
        e.exports = class {
          constructor(e) {
            this.input = e, this.root = new a(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = {
              input: e,
              start: {
                column: 1,
                line: 1,
                offset: 0
              }
            };
          }
          atrule(e) {
            let t,
              r,
              s,
              i = new o();
            i.name = e[1].slice(1), "" === i.name && this.unnamedAtrule(i, e), this.init(i, e[2]);
            let n = !1,
              a = !1,
              u = [],
              l = [];
            for (; !this.tokenizer.endOfFile();) {
              if (t = (e = this.tokenizer.nextToken())[0], "(" === t || "[" === t ? l.push("(" === t ? ")" : "]") : "{" === t && l.length > 0 ? l.push("}") : t === l[l.length - 1] && l.pop(), 0 === l.length) {
                if (";" === t) {
                  i.source.end = this.getPosition(e[2]), i.source.end.offset++, this.semicolon = !0;
                  break;
                }
                if ("{" === t) {
                  a = !0;
                  break;
                }
                if ("}" === t) {
                  if (u.length > 0) {
                    for (s = u.length - 1, r = u[s]; r && "space" === r[0];) r = u[--s];
                    r && (i.source.end = this.getPosition(r[3] || r[2]), i.source.end.offset++);
                  }
                  this.end(e);
                  break;
                }
                u.push(e);
              } else u.push(e);
              if (this.tokenizer.endOfFile()) {
                n = !0;
                break;
              }
            }
            i.raws.between = this.spacesAndCommentsFromEnd(u), u.length ? (i.raws.afterName = this.spacesAndCommentsFromStart(u), this.raw(i, "params", u), n && (e = u[u.length - 1], i.source.end = this.getPosition(e[3] || e[2]), i.source.end.offset++, this.spaces = i.raws.between, i.raws.between = "")) : (i.raws.afterName = "", i.params = ""), a && (i.nodes = [], this.current = i);
          }
          checkMissedSemicolon(e) {
            let t = this.colon(e);
            if (!1 === t) return;
            let r,
              s = 0;
            for (let i = t - 1; i >= 0 && (r = e[i], "space" === r[0] || (s += 1, 2 !== s)); i--);
            throw this.input.error("Missed semicolon", "word" === r[0] ? r[3] + 1 : r[2]);
          }
          colon(e) {
            let t,
              r,
              s,
              i = 0;
            for (let [n, o] of e.entries()) {
              if (t = o, r = t[0], "(" === r && (i += 1), ")" === r && (i -= 1), 0 === i && ":" === r) {
                if (s) {
                  if ("word" === s[0] && "progid" === s[1]) continue;
                  return n;
                }
                this.doubleColon(t);
              }
              s = t;
            }
            return !1;
          }
          comment(e) {
            let t = new n();
            this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
            let r = e[1].slice(2, -2);
            if (/^\s*$/.test(r)) t.text = "", t.raws.left = r, t.raws.right = "";else {
              let e = r.match(/^(\s*)([^]*\S)(\s*)$/);
              t.text = e[2], t.raws.left = e[1], t.raws.right = e[3];
            }
          }
          createTokenizer() {
            this.tokenizer = i(this.input);
          }
          decl(e, t) {
            let r = new s();
            this.init(r, e[0][2]);
            let i,
              n = e[e.length - 1];
            for (";" === n[0] && (this.semicolon = !0, e.pop()), r.source.end = this.getPosition(n[3] || n[2] || function (e) {
              for (let t = e.length - 1; t >= 0; t--) {
                let r = e[t],
                  s = r[3] || r[2];
                if (s) return s;
              }
            }(e)), r.source.end.offset++; "word" !== e[0][0];) 1 === e.length && this.unknownWord(e), r.raws.before += e.shift()[1];
            for (r.source.start = this.getPosition(e[0][2]), r.prop = ""; e.length;) {
              let t = e[0][0];
              if (":" === t || "space" === t || "comment" === t) break;
              r.prop += e.shift()[1];
            }
            for (r.raws.between = ""; e.length;) {
              if (i = e.shift(), ":" === i[0]) {
                r.raws.between += i[1];
                break;
              }
              "word" === i[0] && /\w/.test(i[1]) && this.unknownWord([i]), r.raws.between += i[1];
            }
            "_" !== r.prop[0] && "*" !== r.prop[0] || (r.raws.before += r.prop[0], r.prop = r.prop.slice(1));
            let o,
              a = [];
            for (; e.length && (o = e[0][0], "space" === o || "comment" === o);) a.push(e.shift());
            this.precheckMissedSemicolon(e);
            for (let t = e.length - 1; t >= 0; t--) {
              if (i = e[t], "!important" === i[1].toLowerCase()) {
                r.important = !0;
                let s = this.stringFrom(e, t);
                s = this.spacesFromEnd(e) + s, " !important" !== s && (r.raws.important = s);
                break;
              }
              if ("important" === i[1].toLowerCase()) {
                let s = e.slice(0),
                  i = "";
                for (let e = t; e > 0; e--) {
                  let t = s[e][0];
                  if (0 === i.trim().indexOf("!") && "space" !== t) break;
                  i = s.pop()[1] + i;
                }
                0 === i.trim().indexOf("!") && (r.important = !0, r.raws.important = i, e = s);
              }
              if ("space" !== i[0] && "comment" !== i[0]) break;
            }
            e.some(e => "space" !== e[0] && "comment" !== e[0]) && (r.raws.between += a.map(e => e[1]).join(""), a = []), this.raw(r, "value", a.concat(e), t), r.value.includes(":") && !t && this.checkMissedSemicolon(e);
          }
          doubleColon(e) {
            throw this.input.error("Double colon", {
              offset: e[2]
            }, {
              offset: e[2] + e[1].length
            });
          }
          emptyRule(e) {
            let t = new u();
            this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
          }
          end(e) {
            this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
          }
          endFile() {
            this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
          }
          freeSemicolon(e) {
            if (this.spaces += e[1], this.current.nodes) {
              let e = this.current.nodes[this.current.nodes.length - 1];
              e && "rule" === e.type && !e.raws.ownSemicolon && (e.raws.ownSemicolon = this.spaces, this.spaces = "");
            }
          }
          getPosition(e) {
            let t = this.input.fromOffset(e);
            return {
              column: t.col,
              line: t.line,
              offset: e
            };
          }
          init(e, t) {
            this.current.push(e), e.source = {
              input: this.input,
              start: this.getPosition(t)
            }, e.raws.before = this.spaces, this.spaces = "", "comment" !== e.type && (this.semicolon = !1);
          }
          other(e) {
            let t = !1,
              r = null,
              s = !1,
              i = null,
              n = [],
              o = e[1].startsWith("--"),
              a = [],
              u = e;
            for (; u;) {
              if (r = u[0], a.push(u), "(" === r || "[" === r) i || (i = u), n.push("(" === r ? ")" : "]");else if (o && s && "{" === r) i || (i = u), n.push("}");else if (0 === n.length) {
                if (";" === r) {
                  if (s) return void this.decl(a, o);
                  break;
                }
                if ("{" === r) return void this.rule(a);
                if ("}" === r) {
                  this.tokenizer.back(a.pop()), t = !0;
                  break;
                }
                ":" === r && (s = !0);
              } else r === n[n.length - 1] && (n.pop(), 0 === n.length && (i = null));
              u = this.tokenizer.nextToken();
            }
            if (this.tokenizer.endOfFile() && (t = !0), n.length > 0 && this.unclosedBracket(i), t && s) {
              if (!o) for (; a.length && (u = a[a.length - 1][0], "space" === u || "comment" === u);) this.tokenizer.back(a.pop());
              this.decl(a, o);
            } else this.unknownWord(a);
          }
          parse() {
            let e;
            for (; !this.tokenizer.endOfFile();) switch (e = this.tokenizer.nextToken(), e[0]) {
              case "space":
                this.spaces += e[1];
                break;
              case ";":
                this.freeSemicolon(e);
                break;
              case "}":
                this.end(e);
                break;
              case "comment":
                this.comment(e);
                break;
              case "at-word":
                this.atrule(e);
                break;
              case "{":
                this.emptyRule(e);
                break;
              default:
                this.other(e);
            }
            this.endFile();
          }
          precheckMissedSemicolon() {}
          raw(e, t, r, s) {
            let i,
              n,
              o,
              a,
              u = r.length,
              c = "",
              d = !0;
            for (let e = 0; e < u; e += 1) i = r[e], n = i[0], "space" !== n || e !== u - 1 || s ? "comment" === n ? (a = r[e - 1] ? r[e - 1][0] : "empty", o = r[e + 1] ? r[e + 1][0] : "empty", l[a] || l[o] || "," === c.slice(-1) ? d = !1 : c += i[1]) : c += i[1] : d = !1;
            if (!d) {
              let s = r.reduce((e, t) => e + t[1], "");
              e.raws[t] = {
                raw: s,
                value: c
              };
            }
            e[t] = c;
          }
          rule(e) {
            e.pop();
            let t = new u();
            this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
          }
          spacesAndCommentsFromEnd(e) {
            let t,
              r = "";
            for (; e.length && (t = e[e.length - 1][0], "space" === t || "comment" === t);) r = e.pop()[1] + r;
            return r;
          }
          spacesAndCommentsFromStart(e) {
            let t,
              r = "";
            for (; e.length && (t = e[0][0], "space" === t || "comment" === t);) r += e.shift()[1];
            return r;
          }
          spacesFromEnd(e) {
            let t,
              r = "";
            for (; e.length && (t = e[e.length - 1][0], "space" === t);) r = e.pop()[1] + r;
            return r;
          }
          stringFrom(e, t) {
            let r = "";
            for (let s = t; s < e.length; s++) r += e[s][1];
            return e.splice(t, e.length - t), r;
          }
          unclosedBlock() {
            let e = this.current.source.start;
            throw this.input.error("Unclosed block", e.line, e.column);
          }
          unclosedBracket(e) {
            throw this.input.error("Unclosed bracket", {
              offset: e[2]
            }, {
              offset: e[2] + 1
            });
          }
          unexpectedClose(e) {
            throw this.input.error("Unexpected }", {
              offset: e[2]
            }, {
              offset: e[2] + 1
            });
          }
          unknownWord(e) {
            throw this.input.error("Unknown word", {
              offset: e[0][2]
            }, {
              offset: e[0][2] + e[0][1].length
            });
          }
          unnamedAtrule(e, t) {
            throw this.input.error("At-rule without name", {
              offset: t[2]
            }, {
              offset: t[2] + t[1].length
            });
          }
        };
      },
      2895: (e, t, r) => {
        "use strict";

        let s = r(1233),
          i = r(5238),
          n = r(6966),
          o = r(7793),
          a = r(6846),
          u = r(3303),
          l = r(3438),
          c = r(145),
          d = r(38),
          v = r(9371),
          p = r(396),
          _ = r(3717),
          f = r(1106),
          h = r(1958),
          m = r(1752),
          g = r(1534),
          b = r(5644),
          y = r(3152);
        function w(...e) {
          return 1 === e.length && Array.isArray(e[0]) && (e = e[0]), new a(e);
        }
        w.plugin = function (e, t) {
          let r,
            s = !1;
          function i(...r) {
            console && console.warn && !s && (s = !0, console.warn(e + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration"), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(e + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226"));
            let i = t(...r);
            return i.postcssPlugin = e, i.postcssVersion = new a().version, i;
          }
          return Object.defineProperty(i, "postcss", {
            get: () => (r || (r = i()), r)
          }), i.process = function (e, t, r) {
            return w([i(r)]).process(e, t);
          }, i;
        }, w.stringify = u, w.parse = h, w.fromJSON = l, w.list = m, w.comment = e => new v(e), w.atRule = e => new p(e), w.decl = e => new i(e), w.rule = e => new g(e), w.root = e => new b(e), w.document = e => new c(e), w.CssSyntaxError = s, w.Declaration = i, w.Container = o, w.Processor = a, w.Document = c, w.Comment = v, w.Warning = d, w.AtRule = p, w.Result = _, w.Input = f, w.Rule = g, w.Root = b, w.Node = y, n.registerPostcss(w), e.exports = w, w.default = w;
      },
      3878: (e, t, r) => {
        "use strict";

        let {
            SourceMapConsumer: s,
            SourceMapGenerator: i
          } = r(1866),
          {
            existsSync: n,
            readFileSync: o
          } = r(9977),
          {
            dirname: a,
            join: u
          } = r(197);
        class l {
          constructor(e, t) {
            if (!1 === t.map) return;
            this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
            let r = t.map ? t.map.prev : void 0,
              s = this.loadMap(t.from, r);
            !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = a(this.mapFile)), s && (this.text = s);
          }
          consumer() {
            return this.consumerCache || (this.consumerCache = new s(this.text)), this.consumerCache;
          }
          decodeInline(e) {
            if (/^data:application\/json;charset=utf-?8,/.test(e) || /^data:application\/json,/.test(e)) return decodeURIComponent(e.substr(RegExp.lastMatch.length));
            if (/^data:application\/json;charset=utf-?8;base64,/.test(e) || /^data:application\/json;base64,/.test(e)) return t = e.substr(RegExp.lastMatch.length), Buffer ? Buffer.from(t, "base64").toString() : window.atob(t);
            var t;
            let r = e.match(/data:application\/json;([^,]+),/)[1];
            throw new Error("Unsupported source map encoding " + r);
          }
          getAnnotationURL(e) {
            return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
          }
          isMap(e) {
            return "object" == typeof e && ("string" == typeof e.mappings || "string" == typeof e._mappings || Array.isArray(e.sections));
          }
          loadAnnotation(e) {
            let t = e.match(/\/\*\s*# sourceMappingURL=/gm);
            if (!t) return;
            let r = e.lastIndexOf(t.pop()),
              s = e.indexOf("*/", r);
            r > -1 && s > -1 && (this.annotation = this.getAnnotationURL(e.substring(r, s)));
          }
          loadFile(e) {
            if (this.root = a(e), n(e)) return this.mapFile = e, o(e, "utf-8").toString().trim();
          }
          loadMap(e, t) {
            if (!1 === t) return !1;
            if (t) {
              if ("string" == typeof t) return t;
              if ("function" != typeof t) {
                if (t instanceof s) return i.fromSourceMap(t).toString();
                if (t instanceof i) return t.toString();
                if (this.isMap(t)) return JSON.stringify(t);
                throw new Error("Unsupported previous source map format: " + t.toString());
              }
              {
                let r = t(e);
                if (r) {
                  let e = this.loadFile(r);
                  if (!e) throw new Error("Unable to load previous source map: " + r.toString());
                  return e;
                }
              }
            } else {
              if (this.inline) return this.decodeInline(this.annotation);
              if (this.annotation) {
                let t = this.annotation;
                return e && (t = u(a(e), t)), this.loadFile(t);
              }
            }
          }
          startWith(e, t) {
            return !!e && e.substr(0, t.length) === t;
          }
          withContent() {
            return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
          }
        }
        e.exports = l, l.default = l;
      },
      6846: (e, t, r) => {
        "use strict";

        let s = r(4211),
          i = r(6966),
          n = r(145),
          o = r(5644);
        class a {
          constructor(e = []) {
            this.version = "8.4.38", this.plugins = this.normalize(e);
          }
          normalize(e) {
            let t = [];
            for (let r of e) if (!0 === r.postcss ? r = r() : r.postcss && (r = r.postcss), "object" == typeof r && Array.isArray(r.plugins)) t = t.concat(r.plugins);else if ("object" == typeof r && r.postcssPlugin) t.push(r);else if ("function" == typeof r) t.push(r);else {
              if ("object" != typeof r || !r.parse && !r.stringify) throw new Error(r + " is not a PostCSS plugin");
            }
            return t;
          }
          process(e, t = {}) {
            return this.plugins.length || t.parser || t.stringifier || t.syntax ? new i(this, e, t) : new s(this, e, t);
          }
          use(e) {
            return this.plugins = this.plugins.concat(this.normalize([e])), this;
          }
        }
        e.exports = a, a.default = a, o.registerProcessor(a), n.registerProcessor(a);
      },
      3717: (e, t, r) => {
        "use strict";

        let s = r(38);
        class i {
          constructor(e, t, r) {
            this.processor = e, this.messages = [], this.root = t, this.opts = r, this.css = void 0, this.map = void 0;
          }
          toString() {
            return this.css;
          }
          warn(e, t = {}) {
            t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
            let r = new s(e, t);
            return this.messages.push(r), r;
          }
          warnings() {
            return this.messages.filter(e => "warning" === e.type);
          }
          get content() {
            return this.css;
          }
        }
        e.exports = i, i.default = i;
      },
      5644: (e, t, r) => {
        "use strict";

        let s,
          i,
          n = r(7793);
        class o extends n {
          constructor(e) {
            super(e), this.type = "root", this.nodes || (this.nodes = []);
          }
          normalize(e, t, r) {
            let s = super.normalize(e);
            if (t) if ("prepend" === r) this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;else if (this.first !== t) for (let e of s) e.raws.before = t.raws.before;
            return s;
          }
          removeChild(e, t) {
            let r = this.index(e);
            return !t && 0 === r && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[r].raws.before), super.removeChild(e);
          }
          toResult(e = {}) {
            return new s(new i(), this, e).stringify();
          }
        }
        o.registerLazyResult = e => {
          s = e;
        }, o.registerProcessor = e => {
          i = e;
        }, e.exports = o, o.default = o, n.registerRoot(o);
      },
      1534: (e, t, r) => {
        "use strict";

        let s = r(7793),
          i = r(1752);
        class n extends s {
          constructor(e) {
            super(e), this.type = "rule", this.nodes || (this.nodes = []);
          }
          get selectors() {
            return i.comma(this.selector);
          }
          set selectors(e) {
            let t = this.selector ? this.selector.match(/,\s*/) : null,
              r = t ? t[0] : "," + this.raw("between", "beforeOpen");
            this.selector = e.join(r);
          }
        }
        e.exports = n, n.default = n, s.registerRule(n);
      },
      7668: e => {
        "use strict";

        const t = {
          after: "\n",
          beforeClose: "\n",
          beforeComment: "\n",
          beforeDecl: "\n",
          beforeOpen: " ",
          beforeRule: "\n",
          colon: ": ",
          commentLeft: " ",
          commentRight: " ",
          emptyBody: "",
          indent: "    ",
          semicolon: !1
        };
        class r {
          constructor(e) {
            this.builder = e;
          }
          atrule(e, t) {
            let r = "@" + e.name,
              s = e.params ? this.rawValue(e, "params") : "";
            if (void 0 !== e.raws.afterName ? r += e.raws.afterName : s && (r += " "), e.nodes) this.block(e, r + s);else {
              let i = (e.raws.between || "") + (t ? ";" : "");
              this.builder(r + s + i, e);
            }
          }
          beforeAfter(e, t) {
            let r;
            r = "decl" === e.type ? this.raw(e, null, "beforeDecl") : "comment" === e.type ? this.raw(e, null, "beforeComment") : "before" === t ? this.raw(e, null, "beforeRule") : this.raw(e, null, "beforeClose");
            let s = e.parent,
              i = 0;
            for (; s && "root" !== s.type;) i += 1, s = s.parent;
            if (r.includes("\n")) {
              let t = this.raw(e, null, "indent");
              if (t.length) for (let e = 0; e < i; e++) r += t;
            }
            return r;
          }
          block(e, t) {
            let r,
              s = this.raw(e, "between", "beforeOpen");
            this.builder(t + s + "{", e, "start"), e.nodes && e.nodes.length ? (this.body(e), r = this.raw(e, "after")) : r = this.raw(e, "after", "emptyBody"), r && this.builder(r), this.builder("}", e, "end");
          }
          body(e) {
            let t = e.nodes.length - 1;
            for (; t > 0 && "comment" === e.nodes[t].type;) t -= 1;
            let r = this.raw(e, "semicolon");
            for (let s = 0; s < e.nodes.length; s++) {
              let i = e.nodes[s],
                n = this.raw(i, "before");
              n && this.builder(n), this.stringify(i, t !== s || r);
            }
          }
          comment(e) {
            let t = this.raw(e, "left", "commentLeft"),
              r = this.raw(e, "right", "commentRight");
            this.builder("/*" + t + e.text + r + "*/", e);
          }
          decl(e, t) {
            let r = this.raw(e, "between", "colon"),
              s = e.prop + r + this.rawValue(e, "value");
            e.important && (s += e.raws.important || " !important"), t && (s += ";"), this.builder(s, e);
          }
          document(e) {
            this.body(e);
          }
          raw(e, r, s) {
            let i;
            if (s || (s = r), r && (i = e.raws[r], void 0 !== i)) return i;
            let n = e.parent;
            if ("before" === s) {
              if (!n || "root" === n.type && n.first === e) return "";
              if (n && "document" === n.type) return "";
            }
            if (!n) return t[s];
            let o = e.root();
            if (o.rawCache || (o.rawCache = {}), void 0 !== o.rawCache[s]) return o.rawCache[s];
            if ("before" === s || "after" === s) return this.beforeAfter(e, s);
            {
              let t = "raw" + ((a = s)[0].toUpperCase() + a.slice(1));
              this[t] ? i = this[t](o, e) : o.walk(e => {
                if (i = e.raws[r], void 0 !== i) return !1;
              });
            }
            var a;
            return void 0 === i && (i = t[s]), o.rawCache[s] = i, i;
          }
          rawBeforeClose(e) {
            let t;
            return e.walk(e => {
              if (e.nodes && e.nodes.length > 0 && void 0 !== e.raws.after) return t = e.raws.after, t.includes("\n") && (t = t.replace(/[^\n]+$/, "")), !1;
            }), t && (t = t.replace(/\S/g, "")), t;
          }
          rawBeforeComment(e, t) {
            let r;
            return e.walkComments(e => {
              if (void 0 !== e.raws.before) return r = e.raws.before, r.includes("\n") && (r = r.replace(/[^\n]+$/, "")), !1;
            }), void 0 === r ? r = this.raw(t, null, "beforeDecl") : r && (r = r.replace(/\S/g, "")), r;
          }
          rawBeforeDecl(e, t) {
            let r;
            return e.walkDecls(e => {
              if (void 0 !== e.raws.before) return r = e.raws.before, r.includes("\n") && (r = r.replace(/[^\n]+$/, "")), !1;
            }), void 0 === r ? r = this.raw(t, null, "beforeRule") : r && (r = r.replace(/\S/g, "")), r;
          }
          rawBeforeOpen(e) {
            let t;
            return e.walk(e => {
              if ("decl" !== e.type && (t = e.raws.between, void 0 !== t)) return !1;
            }), t;
          }
          rawBeforeRule(e) {
            let t;
            return e.walk(r => {
              if (r.nodes && (r.parent !== e || e.first !== r) && void 0 !== r.raws.before) return t = r.raws.before, t.includes("\n") && (t = t.replace(/[^\n]+$/, "")), !1;
            }), t && (t = t.replace(/\S/g, "")), t;
          }
          rawColon(e) {
            let t;
            return e.walkDecls(e => {
              if (void 0 !== e.raws.between) return t = e.raws.between.replace(/[^\s:]/g, ""), !1;
            }), t;
          }
          rawEmptyBody(e) {
            let t;
            return e.walk(e => {
              if (e.nodes && 0 === e.nodes.length && (t = e.raws.after, void 0 !== t)) return !1;
            }), t;
          }
          rawIndent(e) {
            if (e.raws.indent) return e.raws.indent;
            let t;
            return e.walk(r => {
              let s = r.parent;
              if (s && s !== e && s.parent && s.parent === e && void 0 !== r.raws.before) {
                let e = r.raws.before.split("\n");
                return t = e[e.length - 1], t = t.replace(/\S/g, ""), !1;
              }
            }), t;
          }
          rawSemicolon(e) {
            let t;
            return e.walk(e => {
              if (e.nodes && e.nodes.length && "decl" === e.last.type && (t = e.raws.semicolon, void 0 !== t)) return !1;
            }), t;
          }
          rawValue(e, t) {
            let r = e[t],
              s = e.raws[t];
            return s && s.value === r ? s.raw : r;
          }
          root(e) {
            this.body(e), e.raws.after && this.builder(e.raws.after);
          }
          rule(e) {
            this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
          }
          stringify(e, t) {
            if (!this[e.type]) throw new Error("Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier.");
            this[e.type](e, t);
          }
        }
        e.exports = r, r.default = r;
      },
      3303: (e, t, r) => {
        "use strict";

        let s = r(7668);
        function i(e, t) {
          new s(t).stringify(e);
        }
        e.exports = i, i.default = i;
      },
      4151: e => {
        "use strict";

        e.exports.isClean = Symbol("isClean"), e.exports.my = Symbol("my");
      },
      5781: e => {
        "use strict";

        const t = "'".charCodeAt(0),
          r = '"'.charCodeAt(0),
          s = "\\".charCodeAt(0),
          i = "/".charCodeAt(0),
          n = "\n".charCodeAt(0),
          o = " ".charCodeAt(0),
          a = "\f".charCodeAt(0),
          u = "\t".charCodeAt(0),
          l = "\r".charCodeAt(0),
          c = "[".charCodeAt(0),
          d = "]".charCodeAt(0),
          v = "(".charCodeAt(0),
          p = ")".charCodeAt(0),
          _ = "{".charCodeAt(0),
          f = "}".charCodeAt(0),
          h = ";".charCodeAt(0),
          m = "*".charCodeAt(0),
          g = ":".charCodeAt(0),
          b = "@".charCodeAt(0),
          y = /[\t\n\f\r "#'()/;[\\\]{}]/g,
          w = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g,
          x = /.[\r\n"'(/\\]/,
          S = /[\da-f]/i;
        e.exports = function (e, k = {}) {
          let T,
            M,
            O,
            A,
            P,
            C,
            E,
            I,
            j,
            N,
            D = e.css.valueOf(),
            L = k.ignoreErrors,
            R = D.length,
            B = 0,
            q = [],
            F = [];
          function V(t) {
            throw e.error("Unclosed " + t, B);
          }
          return {
            back: function (e) {
              F.push(e);
            },
            endOfFile: function () {
              return 0 === F.length && B >= R;
            },
            nextToken: function (e) {
              if (F.length) return F.pop();
              if (B >= R) return;
              let k = !!e && e.ignoreUnclosed;
              switch (T = D.charCodeAt(B), T) {
                case n:
                case o:
                case u:
                case l:
                case a:
                  M = B;
                  do {
                    M += 1, T = D.charCodeAt(M);
                  } while (T === o || T === n || T === u || T === l || T === a);
                  N = ["space", D.slice(B, M)], B = M - 1;
                  break;
                case c:
                case d:
                case _:
                case f:
                case g:
                case h:
                case p:
                  {
                    let e = String.fromCharCode(T);
                    N = [e, e, B];
                    break;
                  }
                case v:
                  if (I = q.length ? q.pop()[1] : "", j = D.charCodeAt(B + 1), "url" === I && j !== t && j !== r && j !== o && j !== n && j !== u && j !== a && j !== l) {
                    M = B;
                    do {
                      if (C = !1, M = D.indexOf(")", M + 1), -1 === M) {
                        if (L || k) {
                          M = B;
                          break;
                        }
                        V("bracket");
                      }
                      for (E = M; D.charCodeAt(E - 1) === s;) E -= 1, C = !C;
                    } while (C);
                    N = ["brackets", D.slice(B, M + 1), B, M], B = M;
                  } else M = D.indexOf(")", B + 1), A = D.slice(B, M + 1), -1 === M || x.test(A) ? N = ["(", "(", B] : (N = ["brackets", A, B, M], B = M);
                  break;
                case t:
                case r:
                  O = T === t ? "'" : '"', M = B;
                  do {
                    if (C = !1, M = D.indexOf(O, M + 1), -1 === M) {
                      if (L || k) {
                        M = B + 1;
                        break;
                      }
                      V("string");
                    }
                    for (E = M; D.charCodeAt(E - 1) === s;) E -= 1, C = !C;
                  } while (C);
                  N = ["string", D.slice(B, M + 1), B, M], B = M;
                  break;
                case b:
                  y.lastIndex = B + 1, y.test(D), M = 0 === y.lastIndex ? D.length - 1 : y.lastIndex - 2, N = ["at-word", D.slice(B, M + 1), B, M], B = M;
                  break;
                case s:
                  for (M = B, P = !0; D.charCodeAt(M + 1) === s;) M += 1, P = !P;
                  if (T = D.charCodeAt(M + 1), P && T !== i && T !== o && T !== n && T !== u && T !== l && T !== a && (M += 1, S.test(D.charAt(M)))) {
                    for (; S.test(D.charAt(M + 1));) M += 1;
                    D.charCodeAt(M + 1) === o && (M += 1);
                  }
                  N = ["word", D.slice(B, M + 1), B, M], B = M;
                  break;
                default:
                  T === i && D.charCodeAt(B + 1) === m ? (M = D.indexOf("*/", B + 2) + 1, 0 === M && (L || k ? M = D.length : V("comment")), N = ["comment", D.slice(B, M + 1), B, M], B = M) : (w.lastIndex = B + 1, w.test(D), M = 0 === w.lastIndex ? D.length - 1 : w.lastIndex - 2, N = ["word", D.slice(B, M + 1), B, M], q.push(N), B = M);
              }
              return B++, N;
            },
            position: function () {
              return B;
            }
          };
        };
      },
      6156: e => {
        "use strict";

        let t = {};
        e.exports = function (e) {
          t[e] || (t[e] = !0, "undefined" != typeof console && console.warn && console.warn(e));
        };
      },
      38: e => {
        "use strict";

        class t {
          constructor(e, t = {}) {
            if (this.type = "warning", this.text = e, t.node && t.node.source) {
              let e = t.node.rangeBy(t);
              this.line = e.start.line, this.column = e.start.column, this.endLine = e.end.line, this.endColumn = e.end.column;
            }
            for (let e in t) this[e] = t[e];
          }
          toString() {
            return this.node ? this.node.error(this.text, {
              index: this.index,
              plugin: this.plugin,
              word: this.word
            }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
          }
        }
        e.exports = t, t.default = t;
      },
      3e3: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "18px",
            height: "18px",
            viewBox: "0 0 18 18",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }, t), ["\n    ", (0, s.h)("title", {}, ["Shape"]), "\n    ", (0, s.h)("g", {
            id: "svg-checkbox-WVa6d7V",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }, ["\n        ", (0, s.h)("g", {
            id: "svg-checkbox-21K9kaa",
            fill: "#161616",
            "fill-rule": "nonzero"
          }, ["\n            ", (0, s.h)("path", {
            fill: "currentColor",
            d: "M16,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,16 C0,17.1045695 0.8954305,18 2,18 L16,18 C17.1045695,18 18,17.1045695 18,16 L18,2 C18,0.8954305 17.1045695,0 16,0 Z M7,14 L2,9 L3.41,7.59 L7,11.17 L14.59,3.58 L16,5 L7,14 Z",
            id: "svg-checkbox-YnjGPzk"
          }, []), "\n        "]), "\n    "]), "\n"]);
        }
      },
      3193: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }, t), ["\n    ", (0, s.h)("defs", {}, ["\n        ", (0, s.h)("path", {
            id: "svg-arrow-forward-1HGzT8b",
            d: "M10 0 8.238 1.762l6.975 6.988H0v2.5h15.213l-6.975 6.988L10 20l10-10z"
          }, []), "\n    "]), "\n    ", (0, s.h)("g", {
            fill: "none",
            "fill-rule": "evenodd"
          }, ["\n        ", (0, s.h)("path", {
            d: "M0 0h24v24H0z"
          }, []), "\n        ", (0, s.h)("g", {
            transform: "translate(2 2)"
          }, ["\n            ", (0, s.h)("mask", {
            id: "svg-arrow-forward-2GksUkA",
            fill: "#fff"
          }, ["\n                ", (0, s.h)("use", {
            "xlink:href": "#svg-arrow-forward-1HGzT8b"
          }, []), "\n            "]), "\n            ", (0, s.h)("use", {
            fill: "#29292A",
            "xlink:href": "#svg-arrow-forward-1HGzT8b"
          }, []), "\n            ", (0, s.h)("path", {
            fill: "#29292A",
            mask: "url(#svg-arrow-forward-2GksUkA)",
            d: "M-2-2h24v24H-2z"
          }, []), "\n        "]), "\n    "]), "\n"]);
        }
      },
      67: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            xmlns: "http://www.w3.org/2000/svg"
          }, t), ["\n  ", (0, s.h)("rect", {
            fill: "#29292A",
            opacity: "0.1",
            x: "0",
            y: "0",
            width: "40",
            height: "40",
            rx: "3"
          }, []), "\n  ", (0, s.h)("g", {
            fill: "#29292A",
            opacity: "0.5"
          }, ["\n    ", (0, s.h)("rect", {
            x: "11",
            y: "27",
            width: "18",
            height: "2"
          }, []), "\n  "]), "\n"]);
        }
      },
      9773: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "24px",
            height: "24px",
            viewBox: "0 0 24 24",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }, t), ["\n    ", (0, s.h)("title", {}, ["icon / basic / arrow forward"]), "\n    ", (0, s.h)("defs", {}, ["\n        ", (0, s.h)("polygon", {
            id: "svg-ArrowForward-1-iWS0H",
            points: "12 2 10.2375 3.7625 17.2125 10.75 2 10.75 2 13.25 17.2125 13.25 10.2375 20.2375 12 22 22 12"
          }, []), "\n    "]), "\n    ", (0, s.h)("g", {
            id: "svg-ArrowForward-2QtnVG5",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }, ["\n        ", (0, s.h)("polygon", {
            id: "svg-ArrowForward-3jY1JFX",
            points: "0 0 24 0 24 24 0 24"
          }, []), "\n        ", (0, s.h)("mask", {
            id: "svg-ArrowForward-1zPcJy0",
            fill: "white"
          }, ["\n            ", (0, s.h)("use", {
            "xlink:href": "#svg-ArrowForward-1-iWS0H"
          }, []), "\n        "]), "\n        ", (0, s.h)("use", {
            id: "svg-ArrowForward-3esRkKp",
            fill: "#747776",
            "xlink:href": "#svg-ArrowForward-1-iWS0H"
          }, []), "\n    "]), "\n"]);
        }
      },
      6539: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "10px",
            height: "7px",
            viewBox: "0 0 10 7",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }, t), ["\n    ", (0, s.h)("title", {}, ["Path"]), "\n    ", (0, s.h)("g", {
            id: "svg-CaretDownIcon-OdlnnTv",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }, ["\n        ", (0, s.h)("g", {
            id: "svg-CaretDownIcon-1PxQxlW",
            transform: "translate(-5.000000, -7.000000)",
            fill: "#161616"
          }, ["\n            ", (0, s.h)("polygon", {
            id: "svg-CaretDownIcon-3jY1JFX",
            points: "13.825 7.15833333 10 10.975 6.175 7.15833333 5 8.33333333 10 13.3333333 15 8.33333333"
          }, []), "\n        "]), "\n    "]), "\n"]);
        }
      },
      2994: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "40px",
            height: "40px",
            viewBox: "3.968 3.968 40.065 40.064",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg"
          }, t), ["\n  ", (0, s.h)("g", {
            id: "svg-CloseIcon-OdlnnTv",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
            transform: "matrix(0, 0.813242, -0.813242, 0, 31.264067, 18.278988)",
            style: ""
          }, ["\n    ", (0, s.h)("g", {
            id: "svg-CloseIcon-1-RfPIO",
            transform: "translate(-3.000000, -3.000000)",
            fill: "#29292A"
          }, ["\n      ", (0, s.h)("polygon", {
            id: "svg-CloseIcon-YnjGPzk",
            points: "21 4.81285714 19.1871429 3 12 10.1871429 4.81285714 3 3 4.81285714 10.1871429 12 3 19.1871429 4.81285714 21 12 13.8128571 19.1871429 21 21 19.1871429 13.8128571 12"
          }, []), "\n    "]), "\n  "]), "\n"]);
        }
      },
      6930: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "90",
            height: "17",
            viewBox: "0 0 497 83",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, t), ["\n", (0, s.h)("path", {
            d: "M19.7577 61.9935C19.7577 64.798 23.3382 66.4781 28.6099 66.4781C30.7371 66.4781 34.3176 66.1474 34.3176 64.1234C34.3176 62.0993 31.4109 61.6628 20.4315 58.8318C9.22756 55.9214 2.39682 50.5372 2.39682 40.9991C2.39682 29.9 13.4819 23.1797 25.69 23.1797C41.9279 23.1797 51.1104 32.1489 51.1104 42.3485H32.0715C32.0715 39.4381 28.1078 38.8692 26.3638 38.8692C24.131 38.8692 21.4357 39.4381 21.4357 40.9991C21.4357 42.5601 23.4571 42.6924 36.1145 46.6082C51.1104 51.2119 53.2904 58.8318 53.2904 64.5467C53.2904 76.3205 41.3994 82.1544 28.0946 82.1544C12.0285 82.1809 0.666016 75.8971 0.666016 61.9935H19.7577Z",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M119.195 24.3311V81.0569H101.279L100.156 74.244C94.5675 78.9535 87.9614 82.1813 80.5625 82.1813C66.2272 82.1813 60.0703 73.1063 60.0703 58.184V24.3311H79.1091V48.9899C79.1091 60.9885 82.2404 64.2429 88.3577 64.2429C93.7351 64.2429 100.117 61.4383 100.117 50.1143V24.3311H119.195Z",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M166.002 25.559L163.531 42.2672C161.868 41.5225 160.067 41.1392 158.246 41.1427C152.538 41.1427 148.284 45.8522 148.284 59.7559V81.0545H129.271V24.3287H147.187L147.967 29.3689C151.442 25.559 155.366 23.2042 159.501 23.2042C161.89 23.1183 164.22 23.9623 166.002 25.559",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M239.12 24.3311L215.272 81.0569H193.208L169.359 24.3311H190.644L204.306 60.6578L217.848 24.3311H239.12Z",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M263.762 81.0562H244.723V24.3304H263.762V81.0562ZM245.264 9.30226C245.264 7.52831 245.79 5.7942 246.774 4.31921C247.758 2.84423 249.157 1.69461 250.794 1.01575C252.431 0.336892 254.232 0.159274 255.97 0.505354C257.708 0.851434 259.304 1.70567 260.556 2.96004C261.809 4.21441 262.662 5.81258 263.008 7.55244C263.354 9.2923 263.176 11.0957 262.498 12.7346C261.82 14.3735 260.672 15.7744 259.199 16.7599C257.726 17.7455 255.994 18.2715 254.222 18.2715C251.877 18.2998 249.616 17.3947 247.936 15.7552C246.257 14.1156 245.296 11.8756 245.264 9.52715V9.30226Z",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M303.728 41.1715C298.245 41.1715 291.744 45.2063 291.744 52.7204C291.744 60.2344 298.245 64.2693 303.728 64.2693C305.974 64.3436 308.212 63.965 310.31 63.156C312.407 62.3469 314.32 61.1239 315.936 59.5597V77.4982C311.407 80.7368 305.934 82.3834 300.372 82.1813C283.46 82.1813 271.596 68.6216 271.596 52.6939C271.596 37.0044 283.487 23.2065 300.372 23.2065C305.94 23.0198 311.413 24.6852 315.936 27.9425V45.6561C314.296 44.1414 312.373 42.9656 310.278 42.1961C308.183 41.4265 305.957 41.0784 303.728 41.1715",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M350.091 23.2061C358.719 23.2061 364.876 27.1747 367.267 31.8446L368.39 24.3305H386.306V81.0563H368.337L367.228 73.5423C364.876 78.146 358.719 82.1808 350.052 82.1808C333.814 82.1808 322.623 68.9518 322.623 52.6934C322.623 36.435 333.814 23.2061 350.052 23.2061H350.091ZM353.408 64.2159C354.984 64.3247 356.566 64.108 358.056 63.5791C359.546 63.0502 360.911 62.2205 362.067 61.1413C363.223 60.0622 364.145 58.7568 364.776 57.306C365.407 55.8552 365.733 54.29 365.735 52.7076C365.737 51.1252 365.414 49.5592 364.786 48.107C364.159 46.6548 363.239 45.3472 362.086 44.2654C360.932 43.1837 359.569 42.3508 358.081 41.8185C356.593 41.2862 355.011 41.0658 353.434 41.171C350.375 41.171 347.441 42.3878 345.278 44.5536C343.115 46.7194 341.9 49.6569 341.9 52.7199C341.9 55.7828 343.115 58.7204 345.278 60.8862C347.441 63.052 350.375 64.2688 353.434 64.2688",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M436.671 42.2696H422.878V81.057H403.839V42.2696H394.102V24.3312H403.839V7.50391H422.878V24.3312H436.671V42.2696Z",
            fill: "#171D1A"
          }, []), "\n", (0, s.h)("path", {
            d: "M496.664 58.5268H459.049C459.273 61.1726 461.625 65.3529 469.46 65.3529C471.345 65.399 473.215 65.0088 474.925 64.2126C476.634 63.4163 478.137 62.2356 479.316 60.7625L495.884 62.4426C494.801 70.0625 485.922 82.1802 469.341 82.1802C451.319 82.1802 440.01 68.2765 440.01 52.3489C440.01 36.6593 450.87 23.2451 468.337 23.2451C485.803 23.2451 496.664 37.0297 496.664 53.6718V58.5268ZM477.625 45.6285C477.4 42.7182 473.926 40.0195 468.376 40.0195C462.827 40.0195 459.313 42.6652 459.128 45.6285H477.625Z",
            fill: "#171D1A"
          }, []), "\n"]);
        }
      },
      757: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            width: "16px",
            height: "21px",
            viewBox: "0 0 16 21",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }, t), ["\n    ", (0, s.h)("title", {}, ["Shape"]), "\n    ", (0, s.h)("g", {
            id: "svg-LockIconPageSurvey-OdlnnTv",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }, ["\n        ", (0, s.h)("g", {
            id: "svg-LockIconPageSurvey-2sOzLBS",
            transform: "translate(-4.000000, -1.000000)",
            fill: "#000000",
            "fill-rule": "nonzero"
          }, ["\n            ", (0, s.h)("g", {
            id: "svg-LockIconPageSurvey-2PLrhI7"
          }, ["\n                ", (0, s.h)("path", {
            d: "M18,8 L17,8 L17,6 C17,3.24 14.76,1 12,1 C9.24,1 7,3.24 7,6 L7,8 L6,8 C4.9,8 4,8.9 4,10 L4,20 C4,21.1 4.9,22 6,22 L18,22 C19.1,22 20,21.1 20,20 L20,10 C20,8.9 19.1,8 18,8 Z M12,17 C10.9,17 10,16.1 10,15 C10,13.9 10.9,13 12,13 C13.1,13 14,13.9 14,15 C14,16.1 13.1,17 12,17 Z M15.1,8 L8.9,8 L8.9,6 C8.9,4.29 10.29,2.9 12,2.9 C13.71,2.9 15.1,4.29 15.1,6 L15.1,8 Z",
            id: "svg-LockIconPageSurvey-YnjGPzk"
          }, []), "\n            "]), "\n        "]), "\n    "]), "\n"]);
        }
      },
      6560: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => i
        });
        var s = r(172);
        function i(e) {
          e.styles;
          var t = Object.assign({}, e);
          return delete t.styles, (0, s.h)("svg", Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            height: "14px",
            viewBox: "0 0 24 24",
            width: "14px",
            fill: "#ffffff"
          }, t), [(0, s.h)("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
          }, []), (0, s.h)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
          }, [])]);
        }
      },
      172: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          Component: () => x,
          Fragment: () => w,
          cloneElement: () => H,
          createContext: () => $,
          createElement: () => g,
          createRef: () => y,
          h: () => g,
          hydrate: () => U,
          isValidElement: () => o,
          options: () => i,
          render: () => z,
          toChildArray: () => C
        });
        var s,
          i,
          n,
          o,
          a,
          u,
          l,
          c,
          d,
          v = {},
          p = [],
          _ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
          f = Array.isArray;
        function h(e, t) {
          for (var r in t) e[r] = t[r];
          return e;
        }
        function m(e) {
          var t = e.parentNode;
          t && t.removeChild(e);
        }
        function g(e, t, r) {
          var i,
            n,
            o,
            a = {};
          for (o in t) "key" == o ? i = t[o] : "ref" == o ? n = t[o] : a[o] = t[o];
          if (arguments.length > 2 && (a.children = arguments.length > 3 ? s.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps) for (o in e.defaultProps) void 0 === a[o] && (a[o] = e.defaultProps[o]);
          return b(e, a, i, n, null);
        }
        function b(e, t, r, s, o) {
          var a = {
            type: e,
            props: t,
            key: r,
            ref: s,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __d: void 0,
            __c: null,
            constructor: void 0,
            __v: null == o ? ++n : o,
            __i: -1,
            __u: 0
          };
          return null == o && null != i.vnode && i.vnode(a), a;
        }
        function y() {
          return {
            current: null
          };
        }
        function w(e) {
          return e.children;
        }
        function x(e, t) {
          this.props = e, this.context = t;
        }
        function S(e, t) {
          if (null == t) return e.__ ? S(e.__, e.__i + 1) : null;
          for (var r; t < e.__k.length; t++) if (null != (r = e.__k[t]) && null != r.__e) return r.__e;
          return "function" == typeof e.type ? S(e) : null;
        }
        function k(e) {
          var t, r;
          if (null != (e = e.__) && null != e.__c) {
            for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if (null != (r = e.__k[t]) && null != r.__e) {
              e.__e = e.__c.base = r.__e;
              break;
            }
            return k(e);
          }
        }
        function T(e) {
          (!e.__d && (e.__d = !0) && a.push(e) && !M.__r++ || u !== i.debounceRendering) && ((u = i.debounceRendering) || l)(M);
        }
        function M() {
          var e, t, r, s, n, o, u, l, d;
          for (a.sort(c); e = a.shift();) e.__d && (t = a.length, s = void 0, o = (n = (r = e).__v).__e, l = [], d = [], (u = r.__P) && ((s = h({}, n)).__v = n.__v + 1, i.vnode && i.vnode(s), L(u, s, n, r.__n, void 0 !== u.ownerSVGElement, 32 & n.__u ? [o] : null, l, null == o ? S(n) : o, !!(32 & n.__u), d), s.__v = n.__v, s.__.__k[s.__i] = s, R(l, s, d), s.__e != o && k(s)), a.length > t && a.sort(c));
          M.__r = 0;
        }
        function O(e, t, r, s, i, n, o, a, u, l, c) {
          var d,
            _,
            f,
            h,
            m,
            g = s && s.__k || p,
            b = t.length;
          for (r.__d = u, A(r, t, g), u = r.__d, d = 0; d < b; d++) null != (f = r.__k[d]) && "boolean" != typeof f && "function" != typeof f && (_ = -1 === f.__i ? v : g[f.__i] || v, f.__i = d, L(e, f, _, i, n, o, a, u, l, c), h = f.__e, f.ref && _.ref != f.ref && (_.ref && q(_.ref, null, f), c.push(f.ref, f.__c || h, f)), null == m && null != h && (m = h), 65536 & f.__u || _.__k === f.__k ? (h || _.__e != u || (u = S(_)), u = P(f, u, e)) : "function" == typeof f.type && void 0 !== f.__d ? u = f.__d : h && (u = h.nextSibling), f.__d = void 0, f.__u &= -196609);
          r.__d = u, r.__e = m;
        }
        function A(e, t, r) {
          var s,
            i,
            n,
            o,
            a,
            u = t.length,
            l = r.length,
            c = l,
            d = 0;
          for (e.__k = [], s = 0; s < u; s++) o = s + d, null != (i = e.__k[s] = null == (i = t[s]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? b(null, i, null, null, null) : f(i) ? b(w, {
            children: i
          }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? b(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = e, i.__b = e.__b + 1, a = E(i, r, o, c), i.__i = a, n = null, -1 !== a && (c--, (n = r[a]) && (n.__u |= 131072)), null == n || null === n.__v ? (-1 == a && d--, "function" != typeof i.type && (i.__u |= 65536)) : a !== o && (a === o + 1 ? d++ : a > o ? c > u - o ? d += a - o : d-- : a < o ? a == o - 1 && (d = a - o) : d = 0, a !== s + d && (i.__u |= 65536))) : (n = r[o]) && null == n.key && n.__e && 0 == (131072 & n.__u) && (n.__e == e.__d && (e.__d = S(n)), F(n, n, !1), r[o] = null, c--);
          if (c) for (s = 0; s < l; s++) null != (n = r[s]) && 0 == (131072 & n.__u) && (n.__e == e.__d && (e.__d = S(n)), F(n, n));
        }
        function P(e, t, r) {
          var s, i;
          if ("function" == typeof e.type) {
            for (s = e.__k, i = 0; s && i < s.length; i++) s[i] && (s[i].__ = e, t = P(s[i], t, r));
            return t;
          }
          e.__e != t && (r.insertBefore(e.__e, t || null), t = e.__e);
          do {
            t = t && t.nextSibling;
          } while (null != t && 8 === t.nodeType);
          return t;
        }
        function C(e, t) {
          return t = t || [], null == e || "boolean" == typeof e || (f(e) ? e.some(function (e) {
            C(e, t);
          }) : t.push(e)), t;
        }
        function E(e, t, r, s) {
          var i = e.key,
            n = e.type,
            o = r - 1,
            a = r + 1,
            u = t[r];
          if (null === u || u && i == u.key && n === u.type && 0 == (131072 & u.__u)) return r;
          if (s > (null != u && 0 == (131072 & u.__u) ? 1 : 0)) for (; o >= 0 || a < t.length;) {
            if (o >= 0) {
              if ((u = t[o]) && 0 == (131072 & u.__u) && i == u.key && n === u.type) return o;
              o--;
            }
            if (a < t.length) {
              if ((u = t[a]) && 0 == (131072 & u.__u) && i == u.key && n === u.type) return a;
              a++;
            }
          }
          return -1;
        }
        function I(e, t, r) {
          "-" === t[0] ? e.setProperty(t, null == r ? "" : r) : e[t] = null == r ? "" : "number" != typeof r || _.test(t) ? r : r + "px";
        }
        function j(e, t, r, s, i) {
          var n;
          e: if ("style" === t) {
            if ("string" == typeof r) e.style.cssText = r;else {
              if ("string" == typeof s && (e.style.cssText = s = ""), s) for (t in s) r && t in r || I(e.style, t, "");
              if (r) for (t in r) s && r[t] === s[t] || I(e.style, t, r[t]);
            }
          } else if ("o" === t[0] && "n" === t[1]) n = t !== (t = t.replace(/(PointerCapture)$|Capture$/i, "$1")), t = t.toLowerCase() in e || "onFocusOut" === t || "onFocusIn" === t ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + n] = r, r ? s ? r.u = s.u : (r.u = Date.now(), e.addEventListener(t, n ? D : N, n)) : e.removeEventListener(t, n ? D : N, n);else {
            if (i) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && "role" !== t && t in e) try {
              e[t] = null == r ? "" : r;
              break e;
            } catch (e) {}
            "function" == typeof r || (null == r || !1 === r && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, r));
          }
        }
        function N(e) {
          if (this.l) {
            var t = this.l[e.type + !1];
            if (e.t) {
              if (e.t <= t.u) return;
            } else e.t = Date.now();
            return t(i.event ? i.event(e) : e);
          }
        }
        function D(e) {
          if (this.l) return this.l[e.type + !0](i.event ? i.event(e) : e);
        }
        function L(e, t, r, s, n, o, a, u, l, c) {
          var d,
            v,
            p,
            _,
            m,
            g,
            b,
            y,
            S,
            k,
            T,
            M,
            A,
            P,
            C,
            E = t.type;
          if (void 0 !== t.constructor) return null;
          128 & r.__u && (l = !!(32 & r.__u), o = [u = t.__e = r.__e]), (d = i.__b) && d(t);
          e: if ("function" == typeof E) try {
            if (y = t.props, S = (d = E.contextType) && s[d.__c], k = d ? S ? S.props.value : d.__ : s, r.__c ? b = (v = t.__c = r.__c).__ = v.__E : ("prototype" in E && E.prototype.render ? t.__c = v = new E(y, k) : (t.__c = v = new x(y, k), v.constructor = E, v.render = V), S && S.sub(v), v.props = y, v.state || (v.state = {}), v.context = k, v.__n = s, p = v.__d = !0, v.__h = [], v._sb = []), null == v.__s && (v.__s = v.state), null != E.getDerivedStateFromProps && (v.__s == v.state && (v.__s = h({}, v.__s)), h(v.__s, E.getDerivedStateFromProps(y, v.__s))), _ = v.props, m = v.state, v.__v = t, p) null == E.getDerivedStateFromProps && null != v.componentWillMount && v.componentWillMount(), null != v.componentDidMount && v.__h.push(v.componentDidMount);else {
              if (null == E.getDerivedStateFromProps && y !== _ && null != v.componentWillReceiveProps && v.componentWillReceiveProps(y, k), !v.__e && (null != v.shouldComponentUpdate && !1 === v.shouldComponentUpdate(y, v.__s, k) || t.__v === r.__v)) {
                for (t.__v !== r.__v && (v.props = y, v.state = v.__s, v.__d = !1), t.__e = r.__e, t.__k = r.__k, t.__k.forEach(function (e) {
                  e && (e.__ = t);
                }), T = 0; T < v._sb.length; T++) v.__h.push(v._sb[T]);
                v._sb = [], v.__h.length && a.push(v);
                break e;
              }
              null != v.componentWillUpdate && v.componentWillUpdate(y, v.__s, k), null != v.componentDidUpdate && v.__h.push(function () {
                v.componentDidUpdate(_, m, g);
              });
            }
            if (v.context = k, v.props = y, v.__P = e, v.__e = !1, M = i.__r, A = 0, "prototype" in E && E.prototype.render) {
              for (v.state = v.__s, v.__d = !1, M && M(t), d = v.render(v.props, v.state, v.context), P = 0; P < v._sb.length; P++) v.__h.push(v._sb[P]);
              v._sb = [];
            } else do {
              v.__d = !1, M && M(t), d = v.render(v.props, v.state, v.context), v.state = v.__s;
            } while (v.__d && ++A < 25);
            v.state = v.__s, null != v.getChildContext && (s = h(h({}, s), v.getChildContext())), p || null == v.getSnapshotBeforeUpdate || (g = v.getSnapshotBeforeUpdate(_, m)), O(e, f(C = null != d && d.type === w && null == d.key ? d.props.children : d) ? C : [C], t, r, s, n, o, a, u, l, c), v.base = t.__e, t.__u &= -161, v.__h.length && a.push(v), b && (v.__E = v.__ = null);
          } catch (e) {
            t.__v = null, l || null != o ? (t.__e = u, t.__u |= l ? 160 : 32, o[o.indexOf(u)] = null) : (t.__e = r.__e, t.__k = r.__k), i.__e(e, t, r);
          } else null == o && t.__v === r.__v ? (t.__k = r.__k, t.__e = r.__e) : t.__e = B(r.__e, t, r, s, n, o, a, l, c);
          (d = i.diffed) && d(t);
        }
        function R(e, t, r) {
          t.__d = void 0;
          for (var s = 0; s < r.length; s++) q(r[s], r[++s], r[++s]);
          i.__c && i.__c(t, e), e.some(function (t) {
            try {
              e = t.__h, t.__h = [], e.some(function (e) {
                e.call(t);
              });
            } catch (e) {
              i.__e(e, t.__v);
            }
          });
        }
        function B(e, t, r, i, n, o, a, u, l) {
          var c,
            d,
            p,
            _,
            h,
            g,
            b,
            y = r.props,
            w = t.props,
            x = t.type;
          if ("svg" === x && (n = !0), null != o) for (c = 0; c < o.length; c++) if ((h = o[c]) && "setAttribute" in h == !!x && (x ? h.localName === x : 3 === h.nodeType)) {
            e = h, o[c] = null;
            break;
          }
          if (null == e) {
            if (null === x) return document.createTextNode(w);
            e = n ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, w.is && w), o = null, u = !1;
          }
          if (null === x) y === w || u && e.data === w || (e.data = w);else {
            if (o = o && s.call(e.childNodes), y = r.props || v, !u && null != o) for (y = {}, c = 0; c < e.attributes.length; c++) y[(h = e.attributes[c]).name] = h.value;
            for (c in y) h = y[c], "children" == c || ("dangerouslySetInnerHTML" == c ? p = h : "key" === c || c in w || j(e, c, null, h, n));
            for (c in w) h = w[c], "children" == c ? _ = h : "dangerouslySetInnerHTML" == c ? d = h : "value" == c ? g = h : "checked" == c ? b = h : "key" === c || u && "function" != typeof h || y[c] === h || j(e, c, h, y[c], n);
            if (d) u || p && (d.__html === p.__html || d.__html === e.innerHTML) || (e.innerHTML = d.__html), t.__k = [];else if (p && (e.innerHTML = ""), O(e, f(_) ? _ : [_], t, r, i, n && "foreignObject" !== x, o, a, o ? o[0] : r.__k && S(r, 0), u, l), null != o) for (c = o.length; c--;) null != o[c] && m(o[c]);
            u || (c = "value", void 0 !== g && (g !== e[c] || "progress" === x && !g || "option" === x && g !== y[c]) && j(e, c, g, y[c], !1), c = "checked", void 0 !== b && b !== e[c] && j(e, c, b, y[c], !1));
          }
          return e;
        }
        function q(e, t, r) {
          try {
            "function" == typeof e ? e(t) : e.current = t;
          } catch (e) {
            i.__e(e, r);
          }
        }
        function F(e, t, r) {
          var s, n;
          if (i.unmount && i.unmount(e), (s = e.ref) && (s.current && s.current !== e.__e || q(s, null, t)), null != (s = e.__c)) {
            if (s.componentWillUnmount) try {
              s.componentWillUnmount();
            } catch (e) {
              i.__e(e, t);
            }
            s.base = s.__P = null, e.__c = void 0;
          }
          if (s = e.__k) for (n = 0; n < s.length; n++) s[n] && F(s[n], t, r || "function" != typeof e.type);
          r || null == e.__e || m(e.__e), e.__ = e.__e = e.__d = void 0;
        }
        function V(e, t, r) {
          return this.constructor(e, r);
        }
        function z(e, t, r) {
          var n, o, a, u;
          i.__ && i.__(e, t), o = (n = "function" == typeof r) ? null : r && r.__k || t.__k, a = [], u = [], L(t, e = (!n && r || t).__k = g(w, null, [e]), o || v, v, void 0 !== t.ownerSVGElement, !n && r ? [r] : o ? null : t.firstChild ? s.call(t.childNodes) : null, a, !n && r ? r : o ? o.__e : t.firstChild, n, u), R(a, e, u);
        }
        function U(e, t) {
          z(e, t, U);
        }
        function H(e, t, r) {
          var i,
            n,
            o,
            a,
            u = h({}, e.props);
          for (o in e.type && e.type.defaultProps && (a = e.type.defaultProps), t) "key" == o ? i = t[o] : "ref" == o ? n = t[o] : u[o] = void 0 === t[o] && void 0 !== a ? a[o] : t[o];
          return arguments.length > 2 && (u.children = arguments.length > 3 ? s.call(arguments, 2) : r), b(e.type, u, i || e.key, n || e.ref, null);
        }
        function $(e, t) {
          var r = {
            __c: t = "__cC" + d++,
            __: e,
            Consumer: function (e, t) {
              return e.children(t);
            },
            Provider: function (e) {
              var r, s;
              return this.getChildContext || (r = [], (s = {})[t] = this, this.getChildContext = function () {
                return s;
              }, this.shouldComponentUpdate = function (e) {
                this.props.value !== e.value && r.some(function (e) {
                  e.__e = !0, T(e);
                });
              }, this.sub = function (e) {
                r.push(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function () {
                  r.splice(r.indexOf(e), 1), t && t.call(e);
                };
              }), e.children;
            }
          };
          return r.Provider.__ = r.Consumer.contextType = r;
        }
        s = p.slice, i = {
          __e: function (e, t, r, s) {
            for (var i, n, o; t = t.__;) if ((i = t.__c) && !i.__) try {
              if ((n = i.constructor) && null != n.getDerivedStateFromError && (i.setState(n.getDerivedStateFromError(e)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(e, s || {}), o = i.__d), o) return i.__E = i;
            } catch (t) {
              e = t;
            }
            throw e;
          }
        }, n = 0, o = function (e) {
          return null != e && null == e.constructor;
        }, x.prototype.setState = function (e, t) {
          var r;
          r = null != this.__s && this.__s !== this.state ? this.__s : this.__s = h({}, this.state), "function" == typeof e && (e = e(h({}, r), this.props)), e && h(r, e), null != e && this.__v && (t && this._sb.push(t), T(this));
        }, x.prototype.forceUpdate = function (e) {
          this.__v && (this.__e = !0, e && this.__h.push(e), T(this));
        }, x.prototype.render = w, a = [], l = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, c = function (e, t) {
          return e.__v.__b - t.__v.__b;
        }, M.__r = 0, d = 0;
      },
      5994: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          useCallback: () => M,
          useContext: () => O,
          useDebugValue: () => A,
          useEffect: () => w,
          useErrorBoundary: () => P,
          useId: () => C,
          useImperativeHandle: () => k,
          useLayoutEffect: () => x,
          useMemo: () => T,
          useReducer: () => y,
          useRef: () => S,
          useState: () => b
        });
        var s,
          i,
          n,
          o,
          a = r(172),
          u = 0,
          l = [],
          c = [],
          d = a.options,
          v = d.__b,
          p = d.__r,
          _ = d.diffed,
          f = d.__c,
          h = d.unmount,
          m = d.__;
        function g(e, t) {
          d.__h && d.__h(i, e, u || t), u = 0;
          var r = i.__H || (i.__H = {
            __: [],
            __h: []
          });
          return e >= r.__.length && r.__.push({
            __V: c
          }), r.__[e];
        }
        function b(e) {
          return u = 1, y(R, e);
        }
        function y(e, t, r) {
          var n = g(s++, 2);
          if (n.t = e, !n.__c && (n.__ = [r ? r(t) : R(void 0, t), function (e) {
            var t = n.__N ? n.__N[0] : n.__[0],
              r = n.t(t, e);
            t !== r && (n.__N = [r, n.__[1]], n.__c.setState({}));
          }], n.__c = i, !i.u)) {
            var o = function (e, t, r) {
              if (!n.__c.__H) return !0;
              var s = n.__c.__H.__.filter(function (e) {
                return !!e.__c;
              });
              if (s.every(function (e) {
                return !e.__N;
              })) return !a || a.call(this, e, t, r);
              var i = !1;
              return s.forEach(function (e) {
                if (e.__N) {
                  var t = e.__[0];
                  e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (i = !0);
                }
              }), !(!i && n.__c.props === e) && (!a || a.call(this, e, t, r));
            };
            i.u = !0;
            var a = i.shouldComponentUpdate,
              u = i.componentWillUpdate;
            i.componentWillUpdate = function (e, t, r) {
              if (this.__e) {
                var s = a;
                a = void 0, o(e, t, r), a = s;
              }
              u && u.call(this, e, t, r);
            }, i.shouldComponentUpdate = o;
          }
          return n.__N || n.__;
        }
        function w(e, t) {
          var r = g(s++, 3);
          !d.__s && L(r.__H, t) && (r.__ = e, r.i = t, i.__H.__h.push(r));
        }
        function x(e, t) {
          var r = g(s++, 4);
          !d.__s && L(r.__H, t) && (r.__ = e, r.i = t, i.__h.push(r));
        }
        function S(e) {
          return u = 5, T(function () {
            return {
              current: e
            };
          }, []);
        }
        function k(e, t, r) {
          u = 6, x(function () {
            return "function" == typeof e ? (e(t()), function () {
              return e(null);
            }) : e ? (e.current = t(), function () {
              return e.current = null;
            }) : void 0;
          }, null == r ? r : r.concat(e));
        }
        function T(e, t) {
          var r = g(s++, 7);
          return L(r.__H, t) ? (r.__V = e(), r.i = t, r.__h = e, r.__V) : r.__;
        }
        function M(e, t) {
          return u = 8, T(function () {
            return e;
          }, t);
        }
        function O(e) {
          var t = i.context[e.__c],
            r = g(s++, 9);
          return r.c = e, t ? (null == r.__ && (r.__ = !0, t.sub(i)), t.props.value) : e.__;
        }
        function A(e, t) {
          d.useDebugValue && d.useDebugValue(t ? t(e) : e);
        }
        function P(e) {
          var t = g(s++, 10),
            r = b();
          return t.__ = e, i.componentDidCatch || (i.componentDidCatch = function (e, s) {
            t.__ && t.__(e, s), r[1](e);
          }), [r[0], function () {
            r[1](void 0);
          }];
        }
        function C() {
          var e = g(s++, 11);
          if (!e.__) {
            for (var t = i.__v; null !== t && !t.__m && null !== t.__;) t = t.__;
            var r = t.__m || (t.__m = [0, 0]);
            e.__ = "P" + r[0] + "-" + r[1]++;
          }
          return e.__;
        }
        function E() {
          for (var e; e = l.shift();) if (e.__P && e.__H) try {
            e.__H.__h.forEach(N), e.__H.__h.forEach(D), e.__H.__h = [];
          } catch (t) {
            e.__H.__h = [], d.__e(t, e.__v);
          }
        }
        d.__b = function (e) {
          i = null, v && v(e);
        }, d.__ = function (e, t) {
          e && t.__k && t.__k.__m && (e.__m = t.__k.__m), m && m(e, t);
        }, d.__r = function (e) {
          p && p(e), s = 0;
          var t = (i = e.__c).__H;
          t && (n === i ? (t.__h = [], i.__h = [], t.__.forEach(function (e) {
            e.__N && (e.__ = e.__N), e.__V = c, e.__N = e.i = void 0;
          })) : (t.__h.forEach(N), t.__h.forEach(D), t.__h = [], s = 0)), n = i;
        }, d.diffed = function (e) {
          _ && _(e);
          var t = e.__c;
          t && t.__H && (t.__H.__h.length && (1 !== l.push(t) && o === d.requestAnimationFrame || ((o = d.requestAnimationFrame) || j)(E)), t.__H.__.forEach(function (e) {
            e.i && (e.__H = e.i), e.__V !== c && (e.__ = e.__V), e.i = void 0, e.__V = c;
          })), n = i = null;
        }, d.__c = function (e, t) {
          t.some(function (e) {
            try {
              e.__h.forEach(N), e.__h = e.__h.filter(function (e) {
                return !e.__ || D(e);
              });
            } catch (r) {
              t.some(function (e) {
                e.__h && (e.__h = []);
              }), t = [], d.__e(r, e.__v);
            }
          }), f && f(e, t);
        }, d.unmount = function (e) {
          h && h(e);
          var t,
            r = e.__c;
          r && r.__H && (r.__H.__.forEach(function (e) {
            try {
              N(e);
            } catch (e) {
              t = e;
            }
          }), r.__H = void 0, t && d.__e(t, r.__v));
        };
        var I = "function" == typeof requestAnimationFrame;
        function j(e) {
          var t,
            r = function () {
              clearTimeout(s), I && cancelAnimationFrame(t), setTimeout(e);
            },
            s = setTimeout(r, 100);
          I && (t = requestAnimationFrame(r));
        }
        function N(e) {
          var t = i,
            r = e.__c;
          "function" == typeof r && (e.__c = void 0, r()), i = t;
        }
        function D(e) {
          var t = i;
          e.__c = e.__(), i = t;
        }
        function L(e, t) {
          return !e || e.length !== t.length || t.some(function (t, r) {
            return t !== e[r];
          });
        }
        function R(e, t) {
          return "function" == typeof t ? t(e) : t;
        }
      },
      4728: (e, t, r) => {
        const s = r(8659),
          i = r(2834),
          {
            isPlainObject: n
          } = r(8682),
          o = r(4744),
          a = r(9466),
          {
            parse: u
          } = r(2895),
          l = ["img", "audio", "video", "picture", "svg", "object", "map", "iframe", "embed"],
          c = ["script", "style"];
        function d(e, t) {
          e && Object.keys(e).forEach(function (r) {
            t(e[r], r);
          });
        }
        function v(e, t) {
          return {}.hasOwnProperty.call(e, t);
        }
        function p(e, t) {
          const r = [];
          return d(e, function (e) {
            t(e) && r.push(e);
          }), r;
        }
        e.exports = f;
        const _ = /^[^\0\t\n\f\r /<=>]+$/;
        function f(e, t, r) {
          if (null == e) return "";
          "number" == typeof e && (e = e.toString());
          let m = "",
            g = "";
          function b(e, t) {
            const r = this;
            this.tag = e, this.attribs = t || {}, this.tagPosition = m.length, this.text = "", this.mediaChildren = [], this.updateParentNodeText = function () {
              if (C.length) {
                C[C.length - 1].text += r.text;
              }
            }, this.updateParentNodeMediaChildren = function () {
              if (C.length && l.includes(this.tag)) {
                C[C.length - 1].mediaChildren.push(this.tag);
              }
            };
          }
          (t = Object.assign({}, f.defaults, t)).parser = Object.assign({}, h, t.parser);
          const y = function (e) {
            return !1 === t.allowedTags || (t.allowedTags || []).indexOf(e) > -1;
          };
          c.forEach(function (e) {
            y(e) && !t.allowVulnerableTags && console.warn(`\n\n⚠️ Your \`allowedTags\` option includes, \`${e}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
          });
          const w = t.nonTextTags || ["script", "style", "textarea", "option"];
          let x, S;
          t.allowedAttributes && (x = {}, S = {}, d(t.allowedAttributes, function (e, t) {
            x[t] = [];
            const r = [];
            e.forEach(function (e) {
              "string" == typeof e && e.indexOf("*") >= 0 ? r.push(i(e).replace(/\\\*/g, ".*")) : x[t].push(e);
            }), r.length && (S[t] = new RegExp("^(" + r.join("|") + ")$"));
          }));
          const k = {},
            T = {},
            M = {};
          d(t.allowedClasses, function (e, t) {
            if (x && (v(x, t) || (x[t] = []), x[t].push("class")), k[t] = e, Array.isArray(e)) {
              const r = [];
              k[t] = [], M[t] = [], e.forEach(function (e) {
                "string" == typeof e && e.indexOf("*") >= 0 ? r.push(i(e).replace(/\\\*/g, ".*")) : e instanceof RegExp ? M[t].push(e) : k[t].push(e);
              }), r.length && (T[t] = new RegExp("^(" + r.join("|") + ")$"));
            }
          });
          const O = {};
          let A, P, C, E, I, j, N;
          d(t.transformTags, function (e, t) {
            let r;
            "function" == typeof e ? r = e : "string" == typeof e && (r = f.simpleTransform(e)), "*" === t ? A = r : O[t] = r;
          });
          let D = !1;
          R();
          const L = new s.Parser({
            onopentag: function (e, r) {
              if (t.enforceHtmlBoundary && "html" === e && R(), j) return void N++;
              const s = new b(e, r);
              C.push(s);
              let i = !1;
              const l = !!s.text;
              let c;
              if (v(O, e) && (c = O[e](e, r), s.attribs = r = c.attribs, void 0 !== c.text && (s.innerText = c.text), e !== c.tagName && (s.name = e = c.tagName, I[P] = c.tagName)), A && (c = A(e, r), s.attribs = r = c.attribs, e !== c.tagName && (s.name = e = c.tagName, I[P] = c.tagName)), (!y(e) || "recursiveEscape" === t.disallowedTagsMode && !function (e) {
                for (const t in e) if (v(e, t)) return !1;
                return !0;
              }(E) || null != t.nestingLimit && P >= t.nestingLimit) && (i = !0, E[P] = !0, "discard" !== t.disallowedTagsMode && "completelyDiscard" !== t.disallowedTagsMode || -1 !== w.indexOf(e) && (j = !0, N = 1), E[P] = !0), P++, i) {
                if ("discard" === t.disallowedTagsMode || "completelyDiscard" === t.disallowedTagsMode) return;
                g = m, m = "";
              }
              m += "<" + e, "script" === e && (t.allowedScriptHostnames || t.allowedScriptDomains) && (s.innerText = ""), (!x || v(x, e) || x["*"]) && d(r, function (r, i) {
                if (!_.test(i)) return void delete s.attribs[i];
                if ("" === r && !t.allowedEmptyAttributes.includes(i) && (t.nonBooleanAttributes.includes(i) || t.nonBooleanAttributes.includes("*"))) return void delete s.attribs[i];
                let l = !1;
                if (!x || v(x, e) && -1 !== x[e].indexOf(i) || x["*"] && -1 !== x["*"].indexOf(i) || v(S, e) && S[e].test(i) || S["*"] && S["*"].test(i)) l = !0;else if (x && x[e]) for (const t of x[e]) if (n(t) && t.name && t.name === i) {
                  l = !0;
                  let e = "";
                  if (!0 === t.multiple) {
                    const s = r.split(" ");
                    for (const r of s) -1 !== t.values.indexOf(r) && ("" === e ? e = r : e += " " + r);
                  } else t.values.indexOf(r) >= 0 && (e = r);
                  r = e;
                }
                if (l) {
                  if (-1 !== t.allowedSchemesAppliedToAttributes.indexOf(i) && q(e, r)) return void delete s.attribs[i];
                  if ("script" === e && "src" === i) {
                    let e = !0;
                    try {
                      const s = F(r);
                      if (t.allowedScriptHostnames || t.allowedScriptDomains) {
                        const r = (t.allowedScriptHostnames || []).find(function (e) {
                            return e === s.url.hostname;
                          }),
                          i = (t.allowedScriptDomains || []).find(function (e) {
                            return s.url.hostname === e || s.url.hostname.endsWith(`.${e}`);
                          });
                        e = r || i;
                      }
                    } catch (t) {
                      e = !1;
                    }
                    if (!e) return void delete s.attribs[i];
                  }
                  if ("iframe" === e && "src" === i) {
                    let e = !0;
                    try {
                      const s = F(r);
                      if (s.isRelativeUrl) e = v(t, "allowIframeRelativeUrls") ? t.allowIframeRelativeUrls : !t.allowedIframeHostnames && !t.allowedIframeDomains;else if (t.allowedIframeHostnames || t.allowedIframeDomains) {
                        const r = (t.allowedIframeHostnames || []).find(function (e) {
                            return e === s.url.hostname;
                          }),
                          i = (t.allowedIframeDomains || []).find(function (e) {
                            return s.url.hostname === e || s.url.hostname.endsWith(`.${e}`);
                          });
                        e = r || i;
                      }
                    } catch (t) {
                      e = !1;
                    }
                    if (!e) return void delete s.attribs[i];
                  }
                  if ("srcset" === i) try {
                    let e = a(r);
                    if (e.forEach(function (e) {
                      q("srcset", e.url) && (e.evil = !0);
                    }), e = p(e, function (e) {
                      return !e.evil;
                    }), !e.length) return void delete s.attribs[i];
                    r = p(e, function (e) {
                      return !e.evil;
                    }).map(function (e) {
                      if (!e.url) throw new Error("URL missing");
                      return e.url + (e.w ? ` ${e.w}w` : "") + (e.h ? ` ${e.h}h` : "") + (e.d ? ` ${e.d}x` : "");
                    }).join(", "), s.attribs[i] = r;
                  } catch (e) {
                    return void delete s.attribs[i];
                  }
                  if ("class" === i) {
                    const t = k[e],
                      n = k["*"],
                      a = T[e],
                      u = M[e],
                      l = [a, T["*"]].concat(u).filter(function (e) {
                        return e;
                      });
                    if (!(r = V(r, t && n ? o(t, n) : t || n, l)).length) return void delete s.attribs[i];
                  }
                  if ("style" === i) if (t.parseStyleAttributes) try {
                    const n = function (e, t) {
                      if (!t) return e;
                      const r = e.nodes[0];
                      let s;
                      s = t[r.selector] && t["*"] ? o(t[r.selector], t["*"]) : t[r.selector] || t["*"];
                      s && (e.nodes[0].nodes = r.nodes.reduce(function (e) {
                        return function (t, r) {
                          if (v(e, r.prop)) {
                            e[r.prop].some(function (e) {
                              return e.test(r.value);
                            }) && t.push(r);
                          }
                          return t;
                        };
                      }(s), []));
                      return e;
                    }(u(e + " {" + r + "}", {
                      map: !1
                    }), t.allowedStyles);
                    if (r = function (e) {
                      return e.nodes[0].nodes.reduce(function (e, t) {
                        return e.push(`${t.prop}:${t.value}${t.important ? " !important" : ""}`), e;
                      }, []).join(";");
                    }(n), 0 === r.length) return void delete s.attribs[i];
                  } catch (t) {
                    return "undefined" != typeof window && console.warn('Failed to parse "' + e + " {" + r + "}\", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547"), void delete s.attribs[i];
                  } else if (t.allowedStyles) throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
                  m += " " + i, r && r.length ? m += '="' + B(r, !0) + '"' : t.allowedEmptyAttributes.includes(i) && (m += '=""');
                } else delete s.attribs[i];
              }), -1 !== t.selfClosing.indexOf(e) ? m += " />" : (m += ">", !s.innerText || l || t.textFilter || (m += B(s.innerText), D = !0)), i && (m = g + B(m), g = "");
            },
            ontext: function (e) {
              if (j) return;
              const r = C[C.length - 1];
              let s;
              if (r && (s = r.tag, e = void 0 !== r.innerText ? r.innerText : e), "completelyDiscard" !== t.disallowedTagsMode || y(s)) {
                if ("discard" !== t.disallowedTagsMode && "completelyDiscard" !== t.disallowedTagsMode || "script" !== s && "style" !== s) {
                  const r = B(e, !1);
                  t.textFilter && !D ? m += t.textFilter(r, s) : D || (m += r);
                } else m += e;
              } else e = "";
              if (C.length) {
                C[C.length - 1].text += e;
              }
            },
            onclosetag: function (e, r) {
              if (j) {
                if (N--, N) return;
                j = !1;
              }
              const s = C.pop();
              if (!s) return;
              if (s.tag !== e) return void C.push(s);
              j = !!t.enforceHtmlBoundary && "html" === e, P--;
              const i = E[P];
              if (i) {
                if (delete E[P], "discard" === t.disallowedTagsMode || "completelyDiscard" === t.disallowedTagsMode) return void s.updateParentNodeText();
                g = m, m = "";
              }
              I[P] && (e = I[P], delete I[P]), t.exclusiveFilter && t.exclusiveFilter(s) ? m = m.substr(0, s.tagPosition) : (s.updateParentNodeMediaChildren(), s.updateParentNodeText(), -1 !== t.selfClosing.indexOf(e) || r && !y(e) && ["escape", "recursiveEscape"].indexOf(t.disallowedTagsMode) >= 0 ? i && (m = g, g = "") : (m += "</" + e + ">", i && (m = g + B(m), g = ""), D = !1));
            }
          }, t.parser);
          return L.write(e), L.end(), m;
          function R() {
            m = "", P = 0, C = [], E = {}, I = {}, j = !1, N = 0;
          }
          function B(e, r) {
            return "string" != typeof e && (e += ""), t.parser.decodeEntities && (e = e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), r && (e = e.replace(/"/g, "&quot;"))), e = e.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), r && (e = e.replace(/"/g, "&quot;")), e;
          }
          function q(e, r) {
            for (r = r.replace(/[\x00-\x20]+/g, "");;) {
              const e = r.indexOf("\x3c!--");
              if (-1 === e) break;
              const t = r.indexOf("--\x3e", e + 4);
              if (-1 === t) break;
              r = r.substring(0, e) + r.substring(t + 3);
            }
            const s = r.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
            if (!s) return !!r.match(/^[/\\]{2}/) && !t.allowProtocolRelative;
            const i = s[1].toLowerCase();
            return v(t.allowedSchemesByTag, e) ? -1 === t.allowedSchemesByTag[e].indexOf(i) : !t.allowedSchemes || -1 === t.allowedSchemes.indexOf(i);
          }
          function F(e) {
            if ((e = e.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//")).startsWith("relative:")) throw new Error("relative: exploit attempt");
            let t = "relative://relative-site";
            for (let e = 0; e < 100; e++) t += `/${e}`;
            const r = new URL(e, t);
            return {
              isRelativeUrl: r && "relative-site" === r.hostname && "relative:" === r.protocol,
              url: r
            };
          }
          function V(e, t, r) {
            return t ? (e = e.split(/\s+/)).filter(function (e) {
              return -1 !== t.indexOf(e) || r.some(function (t) {
                return t.test(e);
              });
            }).join(" ") : e;
          }
        }
        const h = {
          decodeEntities: !0
        };
        f.defaults = {
          allowedTags: ["address", "article", "aside", "footer", "header", "h1", "h2", "h3", "h4", "h5", "h6", "hgroup", "main", "nav", "section", "blockquote", "dd", "div", "dl", "dt", "figcaption", "figure", "hr", "li", "main", "ol", "p", "pre", "ul", "a", "abbr", "b", "bdi", "bdo", "br", "cite", "code", "data", "dfn", "em", "i", "kbd", "mark", "q", "rb", "rp", "rt", "rtc", "ruby", "s", "samp", "small", "span", "strong", "sub", "sup", "time", "u", "var", "wbr", "caption", "col", "colgroup", "table", "tbody", "td", "tfoot", "th", "thead", "tr"],
          nonBooleanAttributes: ["abbr", "accept", "accept-charset", "accesskey", "action", "allow", "alt", "as", "autocapitalize", "autocomplete", "blocking", "charset", "cite", "class", "color", "cols", "colspan", "content", "contenteditable", "coords", "crossorigin", "data", "datetime", "decoding", "dir", "dirname", "download", "draggable", "enctype", "enterkeyhint", "fetchpriority", "for", "form", "formaction", "formenctype", "formmethod", "formtarget", "headers", "height", "hidden", "high", "href", "hreflang", "http-equiv", "id", "imagesizes", "imagesrcset", "inputmode", "integrity", "is", "itemid", "itemprop", "itemref", "itemtype", "kind", "label", "lang", "list", "loading", "low", "max", "maxlength", "media", "method", "min", "minlength", "name", "nonce", "optimum", "pattern", "ping", "placeholder", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "referrerpolicy", "rel", "rows", "rowspan", "sandbox", "scope", "shape", "size", "sizes", "slot", "span", "spellcheck", "src", "srcdoc", "srclang", "srcset", "start", "step", "style", "tabindex", "target", "title", "translate", "type", "usemap", "value", "width", "wrap", "onauxclick", "onafterprint", "onbeforematch", "onbeforeprint", "onbeforeunload", "onbeforetoggle", "onblur", "oncancel", "oncanplay", "oncanplaythrough", "onchange", "onclick", "onclose", "oncontextlost", "oncontextmenu", "oncontextrestored", "oncopy", "oncuechange", "oncut", "ondblclick", "ondrag", "ondragend", "ondragenter", "ondragleave", "ondragover", "ondragstart", "ondrop", "ondurationchange", "onemptied", "onended", "onerror", "onfocus", "onformdata", "onhashchange", "oninput", "oninvalid", "onkeydown", "onkeypress", "onkeyup", "onlanguagechange", "onload", "onloadeddata", "onloadedmetadata", "onloadstart", "onmessage", "onmessageerror", "onmousedown", "onmouseenter", "onmouseleave", "onmousemove", "onmouseout", "onmouseover", "onmouseup", "onoffline", "ononline", "onpagehide", "onpageshow", "onpaste", "onpause", "onplay", "onplaying", "onpopstate", "onprogress", "onratechange", "onreset", "onresize", "onrejectionhandled", "onscroll", "onscrollend", "onsecuritypolicyviolation", "onseeked", "onseeking", "onselect", "onslotchange", "onstalled", "onstorage", "onsubmit", "onsuspend", "ontimeupdate", "ontoggle", "onunhandledrejection", "onunload", "onvolumechange", "onwaiting", "onwheel"],
          disallowedTagsMode: "discard",
          allowedAttributes: {
            a: ["href", "name", "target"],
            img: ["src", "srcset", "alt", "title", "width", "height", "loading"]
          },
          allowedEmptyAttributes: ["alt"],
          selfClosing: ["img", "br", "hr", "area", "base", "basefont", "input", "link", "meta"],
          allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
          allowedSchemesByTag: {},
          allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
          allowProtocolRelative: !0,
          enforceHtmlBoundary: !1,
          parseStyleAttributes: !0
        }, f.simpleTransform = function (e, t, r) {
          return r = void 0 === r || r, t = t || {}, function (s, i) {
            let n;
            if (r) for (n in t) i[n] = t[n];else i = t;
            return {
              tagName: e,
              attribs: i
            };
          };
        };
      },
      6996: (e, t, r) => {
        "use strict";

        r.r(t), r.d(t, {
          default: () => m
        });
        var s = r(5072),
          i = r.n(s),
          n = r(7825),
          o = r.n(n),
          a = r(7659),
          u = r.n(a),
          l = r(5056),
          c = r.n(l),
          d = r(540),
          v = r.n(d),
          p = r(1113),
          _ = r.n(p),
          f = r(3469),
          h = {};
        h.styleTagTransform = _(), h.setAttributes = c(), h.insert = u().bind(null, "head"), h.domAPI = o(), h.insertStyleElement = v();
        i()(f.A, h);
        const m = f.A && f.A.locals ? f.A.locals : void 0;
      },
      5072: e => {
        "use strict";

        var t = [];
        function r(e) {
          for (var r = -1, s = 0; s < t.length; s++) if (t[s].identifier === e) {
            r = s;
            break;
          }
          return r;
        }
        function s(e, s) {
          for (var n = {}, o = [], a = 0; a < e.length; a++) {
            var u = e[a],
              l = s.base ? u[0] + s.base : u[0],
              c = n[l] || 0,
              d = "".concat(l, " ").concat(c);
            n[l] = c + 1;
            var v = r(d),
              p = {
                css: u[1],
                media: u[2],
                sourceMap: u[3],
                supports: u[4],
                layer: u[5]
              };
            if (-1 !== v) t[v].references++, t[v].updater(p);else {
              var _ = i(p, s);
              s.byIndex = a, t.splice(a, 0, {
                identifier: d,
                updater: _,
                references: 1
              });
            }
            o.push(d);
          }
          return o;
        }
        function i(e, t) {
          var r = t.domAPI(t);
          r.update(e);
          return function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
              r.update(e = t);
            } else r.remove();
          };
        }
        e.exports = function (e, i) {
          var n = s(e = e || [], i = i || {});
          return function (e) {
            e = e || [];
            for (var o = 0; o < n.length; o++) {
              var a = r(n[o]);
              t[a].references--;
            }
            for (var u = s(e, i), l = 0; l < n.length; l++) {
              var c = r(n[l]);
              0 === t[c].references && (t[c].updater(), t.splice(c, 1));
            }
            n = u;
          };
        };
      },
      7659: e => {
        "use strict";

        var t = {};
        e.exports = function (e, r) {
          var s = function (e) {
            if (void 0 === t[e]) {
              var r = document.querySelector(e);
              if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                r = r.contentDocument.head;
              } catch (e) {
                r = null;
              }
              t[e] = r;
            }
            return t[e];
          }(e);
          if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          s.appendChild(r);
        };
      },
      540: e => {
        "use strict";

        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      5056: (e, t, r) => {
        "use strict";

        e.exports = function (e) {
          var t = r.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      7825: e => {
        "use strict";

        e.exports = function (e) {
          if ("undefined" == typeof document) return {
            update: function () {},
            remove: function () {}
          };
          var t = e.insertStyleElement(e);
          return {
            update: function (r) {
              !function (e, t, r) {
                var s = "";
                r.supports && (s += "@supports (".concat(r.supports, ") {")), r.media && (s += "@media ".concat(r.media, " {"));
                var i = void 0 !== r.layer;
                i && (s += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), s += r.css, i && (s += "}"), r.media && (s += "}"), r.supports && (s += "}");
                var n = r.sourceMap;
                n && "undefined" != typeof btoa && (s += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), " */")), t.styleTagTransform(s, e, t.options);
              }(t, e, r);
            },
            remove: function () {
              !function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              }(t);
            }
          };
        };
      },
      1113: e => {
        "use strict";

        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;else {
            for (; t.firstChild;) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(e));
          }
        };
      },
      4338: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(1831)),
          o = s(r(3053)),
          a = r(7057),
          u = s(r(579)),
          l = r(9027);
        class c extends i.Component {
          constructor(e) {
            var t;
            super(e), this.scrollableAreaHeight = 0, this.isPreview = (null === (t = window._svc) || void 0 === t ? void 0 : t.isPreview) || l.storeManager.getStore(a.SurveyType.PageSurvey).getState().rootElement, this.getScrollableAreaHeight = () => {
              var e, t;
              return u.default.isWidthMobile() ? (null === (e = document.querySelector('[data-id="scrollable-area"]')) || void 0 === e ? void 0 : e.clientHeight) || 0 : this.props.shouldUseAlternateSelectors ? (null === (t = document.querySelector('[data-id="branded-point-scrollable-area"]')) || void 0 === t ? void 0 : t.clientHeight) || 0 : Math.max(document.body.scrollHeight || 0, document.documentElement.scrollHeight || 0, document.body.offsetHeight || 0, document.documentElement.offsetHeight || 0, document.body.clientHeight || 0, document.documentElement.clientHeight || 0);
            }, this.getScrollPercent = () => {
              const e = document.querySelector(this.getScrollContainerSelector());
              return ((() => u.default.isWidthMobile() || this.props.shouldUseAlternateSelectors ? (null == e ? void 0 : e.scrollTop) || 0 : window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop || 0)() + (() => u.default.isWidthMobile() || this.props.shouldUseAlternateSelectors ? (null == e ? void 0 : e.clientHeight) || 0 : window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0)()) / this.getScrollableAreaHeight() * 100;
            }, this.checkIfActive = (0, n.default)(() => {
              const e = this.getScrollPercent();
              e > 95 && this.state.isActive && this.setState({
                isActive: !1
              }), e < 95 && !this.state.isActive && this.setState({
                isActive: !0
              });
            }, 50), this.detectScrollableAreaHeightChange = () => {
              const e = this.getScrollableAreaHeight();
              (this.scrollableAreaHeight !== e || this.isPreview) && (this.scrollableAreaHeight = e, this.checkIfActive());
            }, this.getScrollContainerSelector = () => this.props.shouldUseAlternateSelectors ? '[data-testid="finish-screen"]' : '[data-id="scroll-container"]', this.state = {
              isActive: !1
            };
          }
          componentDidMount() {
            var e;
            this.checkIfActive(), window.addEventListener("scroll", this.checkIfActive), null === (e = document.querySelector(this.getScrollContainerSelector())) || void 0 === e || e.addEventListener("scroll", this.checkIfActive);
            const t = this.isPreview ? 100 : 1e3;
            this.scrollableAreaHeightListener = window.setInterval(this.detectScrollableAreaHeightChange, t);
          }
          componentWillUnmount() {
            var e;
            window.removeEventListener("scroll", this.checkIfActive), null === (e = document.querySelector(this.getScrollContainerSelector())) || void 0 === e || e.removeEventListener("scroll", this.checkIfActive), window.clearInterval(this.scrollableAreaHeightListener);
          }
          render() {
            var e;
            const t = {
              "sv__scroll-indicator": !0,
              "sv__scroll-indicator-inactive": !(null === (e = this.state) || void 0 === e ? void 0 : e.isActive)
            };
            return (0, i.h)("div", {
              className: (0, o.default)(t)
            }, (0, i.h)("span", {
              "data-testid": "scroll-indicator"
            }, "Scroll down"));
          }
        }
        t.default = c;
      },
      9304: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.BrandedView = void 0;
        const i = r(172),
          n = r(5220),
          o = r(7289),
          a = s(r(3053)),
          u = r(7057),
          l = r(9027),
          c = s(r(4338)),
          d = r(9924),
          v = r(3644),
          p = r(4014),
          _ = s(r(5578));
        t.BrandedView = ({
          backgroundImage: e,
          screenType: t,
          point: r,
          isMobile: s,
          themeSettings: f
        }) => {
          const h = t === p.ScreenType.Unavailable,
            m = t === p.ScreenType.ThankYou,
            {
              backendData: {
                workspaceKey: g
              },
              surveyState: {
                survey: b,
                theme: y
              }
            } = l.storeManager.getStore(u.SurveyType.PageSurvey).getState(),
            w = `https://survicate.com/create-your-link-survey/?utm_source=${m || t === p.ScreenType.Finish ? "Survey+branding+thank+you+page" : "Survey_unavailable"}&utm_medium=PageSurvey&utm_content=${g}&utm_term=${null == b ? void 0 : b.id}`,
            {
              paragraphs: x,
              list: S,
              button: k,
              titles: T
            } = _.default,
            M = t === p.ScreenType.Finish,
            O = f || (null == y ? void 0 : y.settings),
            A = {
              "sv__survey-status-view--with-branding": !0,
              "sv__thank-you": m
            },
            P = {
              surveyAvailable: {
                emoji: "🎉",
                subtitle: T.desktop[0],
                title: T.desktop[1]
              },
              surveyUnavailable: {
                emoji: "😔",
                subtitle: null,
                title: T.unavailable
              }
            },
            C = h ? P.surveyUnavailable : P.surveyAvailable;
          if (s) return (0, i.h)(v.MobileBrandedView, {
            buttonLink: w,
            screenType: t,
            texts: _.default,
            point: r
          });
          const E = (0, i.h)("div", {
              className: "sv__content"
            }, (0, i.h)("img", {
              className: "sv__content__logo",
              src: "https://surveys-static.survicate.com/images/surviLogoDark.svg",
              alt: "Survicate Logo"
            }), (0, i.h)("div", {
              className: "sv__title__wrapper"
            }, C.subtitle && (0, i.h)("h4", {
              className: "sv__subtitle"
            }, " ", C.subtitle, " "), (0, i.h)("div", {
              className: "sv__title-emoji__wrapper"
            }, (0, i.h)("h1", {
              className: "sv__title"
            }, " ", C.title, " "), (0, i.h)("p", {
              className: "sv__emoji"
            }, C.emoji, " "))), h && (0, i.h)(i.Fragment, null, (0, i.h)("p", {
              className: "sv__content__paragraph"
            }, x.desktop.map(e => (0, i.h)("div", {
              key: e.substring(0, 5)
            }, " ", e, " "))), (0, i.h)("ul", {
              className: "sv__content__list"
            }, S.map(e => (0, i.h)("li", {
              className: "sv__content__list--element",
              key: e.substring(0, 5)
            }, (0, i.h)("img", {
              src: "https://surveys-static.survicate.com/images/iconTick.svg",
              alt: "Tick icon"
            }), (0, i.h)("div", null, " ", e, " ")))), (0, i.h)(n.SimpleLinkButton, {
              buttonLink: w,
              buttonText: k
            }))),
            I = (0, i.h)("div", {
              className: `sv__branded-point-wrapper sv__branded-${null == r ? void 0 : r.props.point.answer_type}-point-wrapper`
            }, r, (0, i.h)(c.default, {
              shouldUseAlternateSelectors: !0
            }));
          return (0, i.h)("div", {
            className: (0, a.default)(A),
            style: m ? `${(0, o.getBackgroundStyles)(O)}\n        background-color: ${(null == y ? void 0 : y.color_scheme).background};` : "",
            "data-testid": "finish-screen"
          }, r ? I : E, (0, i.h)(d.SurveyStatusBrandingImage, {
            isClickable: M,
            buttonLink: w,
            imageURL: e
          }));
        };
      },
      3644: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.MobileBrandedView = void 0;
        const s = r(172),
          i = r(250),
          n = r(5220),
          o = r(4014);
        t.MobileBrandedView = ({
          texts: {
            button: e,
            paragraphs: {
              mobile: t
            },
            titles: r
          },
          buttonLink: a = "",
          screenType: u,
          point: l
        }) => {
          const c = u === o.ScreenType.Finish,
            d = {
              alt: c ? "Completed icon" : "Survey unavailable icon",
              url: "https://surveys-static.survicate.com/images/" + (c ? "surveyCompletedIcon.svg" : "surveyUnavailableIcon.svg")
            },
            v = {
              alt: c ? "Completed icon" : "Thank you icon",
              url: "https://surveys-static.survicate.com/images/" + (c ? "mobileCompleted.svg" : "mobileThankYou.svg")
            };
          return (0, s.h)("div", {
            className: "sv__survey-status-view--with-branding"
          }, l ? (0, s.h)(s.Fragment, null, l, (0, s.h)(i.BrandedFooter, {
            buttonLink: a
          })) : (0, s.h)(s.Fragment, null, (0, s.h)("img", {
            className: "sv__survi-logo",
            src: "https://surveys-static.survicate.com/images/surviLogoDark.svg",
            alt: "Survicate Logo"
          }), (0, s.h)("div", {
            className: "Mask"
          }), (0, s.h)("img", {
            className: "sv__status-emoji",
            src: d.url,
            alt: d.alt
          }), (0, s.h)("div", {
            className: "sv__content"
          }, (0, s.h)("div", {
            className: "sv__title-wrapper"
          }, (0, s.h)("p", {
            className: "sv__title"
          }, " ", c ? r.mobile : r.unavailable, " "), (0, s.h)("p", {
            className: "sv__emoji"
          }, c ? "🙌" : "😔", " ")), (0, s.h)("p", {
            className: "sv__paragraph"
          }, (c ? t.finish : t.unavailable).map(e => (0, s.h)("div", {
            key: e.substring(0, 5)
          }, " ", e, " ")))), (0, s.h)("img", {
            className: "sv__status-logo",
            src: v.url,
            alt: v.alt
          }), (0, s.h)(n.SimpleLinkButton, {
            buttonLink: a,
            buttonText: e
          })));
        };
      },
      5122: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.NonBrandedView = void 0;
        const s = r(172);
        t.NonBrandedView = ({
          text: e,
          theme: t
        }) => {
          var r;
          let i = "#29292a",
            n = "";
          return (null == t ? void 0 : t.color_scheme) && (i = t.color_scheme.answer, (null === (r = t.settings) || void 0 === r ? void 0 : r.background_url) || (n = t.color_scheme.background)), (0, s.h)("div", {
            className: "sv__survey-status-view--non-branded",
            style: {
              backgroundColor: n
            }
          }, (0, s.h)("div", {
            className: "sv__intro-text",
            style: {
              color: i
            }
          }), (0, s.h)("div", {
            className: "sv__main-text__wrapper"
          }, (0, s.h)("span", {
            className: "sv__main-text",
            "data-testid": "survey-status-main-text",
            style: {
              color: i
            }
          }, e)));
        };
      },
      4390: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyStatusView = void 0;
        const i = r(172),
          n = r(5994),
          o = r(1617),
          a = r(7289),
          u = s(r(3053)),
          l = s(r(1835)),
          c = r(7057),
          d = r(5346),
          v = r(9027),
          p = r(9304),
          _ = r(2441),
          f = r(4014),
          h = r(5122),
          m = s(r(5578));
        t.SurveyStatusView = ({
          text: e,
          screenType: t
        }) => {
          document.body.style.margin = "0";
          const {
              themes: r
            } = (0, n.useContext)(d.SurveyConfigContext),
            s = (0, n.useContext)(o.SubmitButtonContext),
            g = t === f.ScreenType.Finish,
            b = t === f.ScreenType.Security,
            y = (0, _.checkIfBrandingIsHidden)(c.SurveyType.PageSurvey, t),
            w = (0, l.default)(v.storeManager.getStore(c.SurveyType.PageSurvey).getState().previewDevice),
            x = null == r ? void 0 : r[0],
            {
              security: S
            } = m.default,
            k = {
              finishURL: "https://surveys-static.survicate.com/images/backgroundFinish.svg",
              surveyUnavailableURL: "https://surveys-static.survicate.com/images/surveyUnavailable.svg"
            },
            T = {
              survicate_unavailable_GfpPU: !g,
              sv__finish: g,
              "sv__is-mobile": w,
              "sv__survey-status-view": !0,
              sv__unavailable: !g
            };
          return (0, n.useEffect)(() => {
            s.render(!1);
          }, []), (0, i.h)("div", {
            className: (0, u.default)(T),
            "data-testid": "survey-status-gate",
            style: b || !y ? "" : (0, a.getBackgroundStyles)(null == x ? void 0 : x.settings)
          }, b || y ? (0, i.h)(h.NonBrandedView, {
            text: b ? S : e,
            theme: x
          }) : (0, i.h)(p.BrandedView, {
            screenType: t,
            backgroundImage: g ? k.finishURL : k.surveyUnavailableURL,
            isMobile: w
          }));
        };
      },
      9924: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyStatusBrandingImage = void 0;
        const i = r(172),
          n = s(r(3053));
        t.SurveyStatusBrandingImage = ({
          isClickable: e,
          imageURL: t,
          buttonLink: r
        }) => {
          const s = {
            sv__background__wrapper: !0,
            "sv__background__wrapper--unclickable": !e
          };
          return (0, i.h)("a", {
            className: (0, n.default)(s),
            href: r,
            target: "_blank",
            rel: "noreferrer",
            title: "Click to go to the Survicate homepage"
          }, (0, i.h)("img", {
            className: "sv__background",
            "data-testid": "survey-status-background",
            src: t,
            alt: "Background"
          }));
        };
      },
      2441: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.checkIfBrandingIsHidden = void 0;
        const s = r(9027),
          i = r(4014);
        t.checkIfBrandingIsHidden = (e, t) => {
          var r, n, o, a, u;
          return t === i.ScreenType.Unavailable ? null === (o = null === (n = null === (r = window._svd) || void 0 === r ? void 0 : r.survey) || void 0 === n ? void 0 : n.settings) || void 0 === o ? void 0 : o.hide_footer : null === (u = null === (a = s.storeManager.getStore(e).getState().surveyState.survey) || void 0 === a ? void 0 : a.settings) || void 0 === u ? void 0 : u.hide_footer;
        };
      },
      4014: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ScreenType = void 0, function (e) {
          e.Finish = "finish", e.Security = "security", e.Unavailable = "unavailable", e.ThankYou = "thankYou";
        }(r || (t.ScreenType = r = {}));
      },
      9990: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(8200);
        t.default = e => {
          if (!e || !e.length) return !1;
          const t = e[e.length - 1].point.answer_type;
          return -1 !== Object.values(s.SurveyCtaAnswerType).filter(e => e !== s.SurveyCtaAnswerType.button).indexOf(t);
        };
      },
      1392: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ApiEvent = t.AppearMethod = void 0, function (e) {
          e.immediately = "immediately", e.delayed = "delayed", e.exitIntent = "exitIntent", e.scroll = "onScroll";
        }(r || (t.AppearMethod = r = {})), function (e) {
          e.questionAnswered = "question_answered", e.surveyDisplayed = "survey_displayed", e.surveyCompleted = "survey_completed", e.surveyClosed = "survey_closed";
        }(s || (t.ApiEvent = s = {}));
      },
      2067: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.init = void 0;
        const n = r(172),
          o = i(r(9160)),
          a = i(r(3450)),
          u = r(7057),
          l = i(r(719));
        r(6996);
        t.init = e => s(void 0, void 0, void 0, function* () {
          var t, r, s;
          const i = yield (0, o.default)("https://survey.survicate.com").get(`/workspaces/${e.workspaceKey}/web_surveys.json`).catch(e => (console.error("Error fetching survey data:", e), null));
          if (!i) return null;
          if (window._sva = window._sva || {}, e.traits && (window._sva.traits = e.traits), e.disableTargeting && (window._sva.disableTargeting = !0), window._svc = {
            initialized: !1,
            isPreview: !1,
            workspaceKey: e.workspaceKey
          }, window._svd = yield i.data, !(null === (t = window._svd.permissions) || void 0 === t ? void 0 : t.web_surveys_npm_package)) return void console.warn("Failed to init Survicate. \n Upgrade your account to get access to npm package feature");
          (null === (s = null === (r = window._svd) || void 0 === r ? void 0 : r.surveys) || void 0 === s ? void 0 : s.some(e => "feedback" === e.settings.format)) && (0, a.default)(u.SurveyType.FeedbackButton, (0, n.createElement)(l.default, {})), (0, a.default)(u.SurveyType.WidgetSurvey, (0, n.createElement)(l.default, {}));
        });
      },
      1150: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
          return new (r || (r = Promise))(function (i, n) {
            function o(e) {
              try {
                u(s.next(e));
              } catch (e) {
                n(e);
              }
            }
            function a(e) {
              try {
                u(s.throw(e));
              } catch (e) {
                n(e);
              }
            }
            function u(e) {
              var t;
              e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                e(t);
              })).then(o, a);
            }
            u((s = s.apply(e, t || [])).next());
          });
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(1392),
          n = {
            ApiEvent: i.ApiEvent,
            AppearMethod: i.AppearMethod,
            init: e => s(void 0, void 0, void 0, function* () {
              return "undefined" != typeof window ? Promise.resolve().then(r.t.bind(r, 2067, 23)).then(({
                init: t
              }) => t(e)) : (console.error("Survicate can only be initialized in a browser environment."), Promise.resolve(null));
            })
          };
        s(void 0, void 0, void 0, function* () {
          return "undefined" != typeof window ? Promise.resolve().then(r.t.bind(r, 4590, 23)).then(({
            surveyApi: e
          }) => e) : Promise.resolve({});
        }).then(e => {
          Object.assign(n, e);
        }), t.default = n;
      },
      1367: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(2994)),
          o = s(r(3053)),
          a = s(r(67)),
          u = s(r(4776)),
          l = s(r(6626));
        t.default = e => {
          const {
            close: t,
            showCloseBtn: r,
            showMinimizeBtn: s,
            toggleMinimize: c
          } = e;
          if (!r && !s) return null;
          return (0, i.h)("div", {
            className: (0, o.default)({
              "survicate_survey-buttons_3ws-x": !0,
              "sv__bar-buttons": !0
            })
          }, s && (0, i.h)(l.default, {
            toggleMinimize: c,
            showBackground: !r
          }, (0, i.h)(a.default, null)), r && (0, i.h)(u.default, {
            close: t
          }, (0, i.h)(n.default, null)));
        };
      },
      4776: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172),
          i = r(1406);
        t.default = ({
          close: e,
          children: t
        }) => (0, s.h)("button", {
          type: "button",
          title: "Close survey",
          "aria-label": "Close survey",
          onClick: e,
          onKeyDown: t => (0, i.keyboardClick)(t, e, {
            preventDefault: !0
          }),
          className: "sv-col-small-button-bw sv__btn-close"
        }, t);
      },
      6626: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(3053)),
          o = r(1406);
        t.default = ({
          toggleMinimize: e,
          showBackground: t,
          children: r
        }) => {
          const s = {
            "sv-col-small-button-bw": !0,
            "sv__btn-minimize": !0,
            "sv__btn-minimize--padded": t
          };
          return (0, i.h)("button", {
            type: "button",
            title: "Minimize survey",
            "aria-label": "Minimize survey",
            onClick: t => {
              t.preventDefault(), t.stopPropagation(), e();
            },
            onKeyDown: t => (0, o.keyboardClick)(t, e, {
              preventDefault: !0
            }),
            className: (0, n.default)(s)
          }, r);
        };
      },
      9017: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.FeedbackMinimized = void 0;
        const i = r(172),
          n = s(r(3053)),
          o = r(1406),
          a = r(7057),
          u = r(9071);
        t.FeedbackMinimized = ({
          toggleMinimize: e,
          tooltipText: t
        }) => {
          const r = {
            [u.WidgetSurveyStyles.printSurveyClasses(a.SurveyType.FeedbackButton)]: !0,
            "sv__feedback-survey--minimized": !0
          };
          return (0, i.h)("button", {
            "aria-label": "Open feedback survey",
            type: "button",
            className: (0, n.default)(r),
            onClick: () => e(!1),
            onKeyDown: t => (0, o.keyboardClick)(t, () => e(!1))
          }, (0, i.h)("div", {
            className: "sv__feedback-survey__text"
          }, t));
        };
      },
      8579: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.FinishView = void 0;
        const i = r(172),
          n = r(5994),
          o = r(1617),
          a = r(5220),
          u = r(7057),
          l = r(5346),
          c = r(9027),
          d = s(r(2174));
        t.FinishView = ({
          message: e,
          hideBranding: t
        }) => {
          var r;
          const s = (0, n.useContext)(o.SubmitButtonContext),
            {
              surveyType: v
            } = (0, n.useContext)(l.SurveyConfigContext),
            p = null === (r = c.storeManager.getStore(v).getState().surveyState.survey) || void 0 === r ? void 0 : r.id,
            _ = `https://survicate.com/create-your-website-survey/?utm_source=Survey+branding+thank+you+screen&utm_medium=${u.SurveyType.WidgetSurvey}&utm_content=${window.location.hostname}&utm_term=${p}`;
          return (0, n.useEffect)(() => {
            s.render(!1);
          }, []), (0, i.h)("div", {
            className: "sv__finish-view"
          }, t ? (0, i.h)("p", {
            className: "sv__thank-you-message sv--color-question",
            "data-testid": "non-branded-finish-screen-message"
          }, null != e ? e : d.default.defaultThankYouMessage) : (0, i.h)("div", {
            className: "sv__branded-finish-view--content"
          }, (0, i.h)("p", {
            className: "sv__introduction",
            "data-testid": "branded-finish-screen-message"
          }, d.default.introduction), (0, i.h)("div", {
            className: "sv__paragraph__container"
          }, d.default.paragraph.map(e => (0, i.h)("p", {
            key: e.substring(0, 3),
            className: "sv__paragraph__item"
          }, e))), (0, i.h)("img", {
            className: "sv__finish-logo",
            src: "https://surveys-static.survicate.com/images/mobileCompleted.svg",
            alt: "Survey completed logo"
          })), !t && (0, i.h)("div", {
            className: "sv__simple-link-button__wrapper"
          }, (0, i.h)(a.SimpleLinkButton, {
            buttonLink: _,
            buttonText: d.default.button
          })));
        };
      },
      7809: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(250),
          a = s(r(3053)),
          u = r(7057),
          l = r(8200),
          c = r(5346),
          d = r(9027),
          v = s(r(5653));
        t.default = e => {
          var t;
          const {
              hide: r,
              pointAnswerType: s
            } = e,
            {
              surveyType: p
            } = (0, n.useContext)(c.SurveyConfigContext),
            _ = null === (t = d.storeManager.getStore(p).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            f = [l.SurveyCtaAnswerType.buttonLink, l.SurveyCtaAnswerType.redirect, l.SurveyCtaAnswerType.social, l.SurveyCtaAnswerType.thankYouMessage, l.SurveyCtaAnswerType.buttonClose].includes(s) && p === u.SurveyType.WidgetSurvey,
            h = `https://survicate.com/create-your-website-survey/?utm_source=${"Survey+branding" + (f ? "+thank+you+screen" : "")}&utm_medium=${p}&utm_content=${window.location.hostname}&utm_term=${_}`,
            m = {
              "sv__branded-footer--with-border": f && !r,
              sv__footer__wrapper: !0
            };
          return (0, i.h)("div", {
            className: (0, a.default)(m)
          }, !r && (f ? (0, i.h)(o.BrandedFooter, {
            buttonLink: h
          }) : (0, i.h)(v.default, {
            "data-testid": "footer",
            buttonLink: h
          })));
        };
      },
      5733: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(8534)),
          o = s(r(3053));
        t.default = e => {
          const {
              avatar_image: t,
              children: r,
              company_logo: s,
              completionRate: a,
              personalization: u,
              className: l,
              short_text_message: c,
              showProgressBar: d,
              isFinished: v,
              hideBranding: p
            } = e,
            _ = {
              "sv--color-question": !0,
              "sv__micro-top-bar": !0,
              "sv__micro-top-bar--branded": !p,
              "sv__micro-top-bar--flat": ![s, t, c].some(e => !!e),
              "sv__micro-top-bar--with-logo": !!s,
              [e.className]: !!l,
              "sv__micro-top-bar--with-personalization": !!s || !!c
            };
          return (0, i.h)("div", {
            className: (0, o.default)(_)
          }, (0, i.h)("div", {
            className: "sv__micro-top-bar__row"
          }, v && !p && (0, i.h)("img", {
            className: "sv__survicate__logo",
            src: "https://surveys-static.survicate.com/images/surviLogoDark.svg",
            alt: "Survicate logo"
          }), s && (0, i.h)("img", {
            className: "sv__micro-top-bar__logo",
            src: s,
            alt: "Company logo"
          }), u && (0, i.h)("div", {
            className: "sv__micro-top-bar__personalization"
          }, t && (0, i.h)("img", {
            className: "sv__micro-top-bar__logo sv__micro-top-bar__avatar",
            src: t,
            alt: "Survey top bar avatar"
          }), c && (0, i.h)("div", {
            className: "sv__micro-top-bar__short-text"
          }, c)), r), !v && d && (0, i.h)(n.default, {
            "data-testid": "progress-bar",
            progress: a
          }));
        };
      },
      6813: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(9635),
          o = s(r(3053)),
          a = r(5409),
          u = r(5595),
          l = (0, n.connect)(({
            surveyState: e
          }) => ({
            overlay: e.survey && e.isOverlayActive ? e.survey.settings.overlay : null
          }), a.actions)(({
            overlay: e,
            hideOverlay: t
          }) => {
            if (!e) return null;
            const r = {
              survicate_dark_Wdv2U: e === u.OverlayType.dark,
              survicate_light_JL8G_: e === u.OverlayType.light,
              survicate_overlay_stIWL: !0,
              sv__overlay: !0,
              "sv__overlay--dark": e === u.OverlayType.dark,
              "sv__overlay--light": e === u.OverlayType.light
            };
            return (0, i.h)("div", {
              role: "button",
              tabIndex: 0,
              className: (0, o.default)(r),
              onClick: t,
              onKeyDown: t,
              label: "hide-overlay"
            });
          });
        t.default = l;
      },
      7599: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          n = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && s(t, e, r);
            return i(t, e), t;
          },
          o = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const a = r(172),
          u = r(5994),
          l = o(r(3871)),
          c = o(r(2202)),
          d = o(r(1088)),
          v = o(r(1104)),
          p = o(r(347)),
          _ = o(r(5528)),
          f = o(r(3108)),
          h = o(r(8123)),
          m = o(r(7651)),
          g = o(r(1561)),
          b = o(r(9713)),
          y = o(r(4039)),
          w = o(r(9633)),
          x = o(r(9649)),
          S = o(r(9133)),
          k = n(r(2887)),
          T = o(r(3053)),
          M = o(r(2156)),
          O = o(r(5890)),
          A = r(4539),
          P = r(8200),
          C = r(4585),
          E = r(4073),
          I = r(3501),
          j = r(5346);
        t.default = e => {
          const {
              surveyType: t
            } = (0, u.useContext)(j.SurveyConfigContext),
            r = (0, u.useMemo)(() => (0, A.translatePoint)(t, e.point), [e.point]),
            {
              answer: s,
              close: i,
              previewDevice: n,
              value: o,
              answerRequiredText: N,
              dropdownPlaceholder: D
            } = e,
            L = {
              "sv__point-texts": !0,
              "sv__point-texts--empty": !r.description && !r.content
            },
            R = (0, a.h)("div", {
              className: (0, T.default)(L),
              "data-testid": "point-texts"
            }, r.description && (0, a.h)(k.default, {
              text: r.description,
              type: k.PointTextType.description
            }), r.content && (0, a.h)(k.default, {
              text: r.content,
              type: k.PointTextType.question
            })),
            B = `sv__point sv__${r.answer_type}-survey-point`;
          return (0, u.useEffect)(() => {
            const e = (0, M.default)(".sv__point", t);
            e && (0, O.default)(e);
          }, [r]), (0, a.h)("div", {
            className: B,
            tabIndex: -1
          }, (0, a.h)("div", {
            className: "sv__point-wrapper"
          }, (() => {
            const e = {
              [I.SurveyQuestionAnswerType.single]: f.default,
              [I.SurveyQuestionAnswerType.multiple]: _.default,
              [I.SurveyQuestionAnswerType.text]: S.default,
              [I.SurveyQuestionAnswerType.smileyScale]: x.default,
              [I.SurveyQuestionAnswerType.date]: m.default,
              [I.SurveyQuestionAnswerType.dropdown]: g.default,
              [I.SurveyQuestionAnswerType.rating]: w.default,
              [I.SurveyQuestionAnswerType.numericalScale]: y.default,
              [I.SurveyQuestionAnswerType.customerSatisfaction]: h.default,
              [E.SurveyNpsAnswerType.nps]: p.default,
              [P.SurveyCtaAnswerType.button]: c.default,
              [P.SurveyCtaAnswerType.buttonLink]: c.default,
              [P.SurveyCtaAnswerType.redirect]: v.default,
              [P.SurveyCtaAnswerType.social]: d.default,
              [P.SurveyCtaAnswerType.thankYouMessage]: v.default,
              [P.SurveyCtaAnswerType.buttonClose]: c.default,
              [C.SurveyFormAnswerType.form]: l.default,
              [I.SurveyQuestionAnswerType.matrix]: b.default
            }[r.answer_type || r.type];
            if (!e) return setTimeout(() => s({
              anonymizedTextResponse: "",
              answers: [],
              textResponse: ""
            })), null;
            const {
                answer_type: t
              } = r,
              u = [I.SurveyQuestionAnswerType.date, I.SurveyQuestionAnswerType.text, I.SurveyQuestionAnswerType.dropdown, I.SurveyQuestionAnswerType.single, I.SurveyQuestionAnswerType.multiple].includes(t),
              k = [E.SurveyNpsAnswerType.nps, I.SurveyQuestionAnswerType.date, I.SurveyQuestionAnswerType.numericalScale, I.SurveyQuestionAnswerType.rating, I.SurveyQuestionAnswerType.matrix].includes(t);
            return (0, a.createElement)(e, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
              answer: s
            }, r.answer_type === P.SurveyCtaAnswerType.buttonClose && {
              close: i
            }), u && {
              answerRequiredText: N
            }), r.answer_type === I.SurveyQuestionAnswerType.dropdown && {
              dropdownPlaceholder: D
            }), {
              key: r.id,
              point: r
            }), k && {
              previewDevice: n
            }), {
              value: o
            }), [R]);
          })()));
        };
      },
      719: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.WidgetSurveyComponent = void 0;
        const i = r(172),
          n = r(5994),
          o = r(9635),
          a = s(r(3053)),
          u = r(4409),
          l = r(7057),
          c = r(5346),
          d = s(r(1982)),
          v = r(5409),
          p = s(r(6813)),
          _ = s(r(3283)),
          f = s(r(3081)),
          h = s(r(2091)),
          m = r(9017);
        t.WidgetSurveyComponent = e => {
          const {
              isPreview: t,
              surveyType: r
            } = (0, n.useContext)(c.SurveyConfigContext),
            {
              survey: s,
              isMinimized: o,
              close: v,
              retarget: g,
              toggleMinimize: b,
              tooltipText: y
            } = e,
            w = () => {
              (null == s ? void 0 : s.settings.close_on_urlchange) && v(), d.default.getVisit(r).setCurrentView(), g();
            };
          (0, n.useEffect)(() => {
            h.default.startInterval(w, r);
          }, [s]);
          const x = {
              "sv-box-child": !0,
              [`sv-${e.previewDevice}`]: t && !!e.previewDevice
            },
            S = s ? (0, u.translateMessages)(r, s).tooltip : y,
            k = r === l.SurveyType.WidgetSurvey ? (0, i.h)(f.default, {
              tooltipText: S
            }) : (0, i.h)(m.FeedbackMinimized, {
              toggleMinimize: b,
              tooltipText: S
            });
          return (0, i.h)("div", {
            className: (0, a.default)(x),
            role: "dialog",
            "aria-label": "Survey"
          }, (0, i.h)(p.default, null), !!s && (o ? k : (0, i.h)(_.default, null)));
        };
        const g = (0, o.connect)(({
          previewDevice: e,
          surveyState: {
            isMinimized: t,
            survey: r,
            theme: s
          }
        }) => {
          var i, n;
          return {
            isMinimized: t,
            previewDevice: e,
            survey: r,
            themeType: null == s ? void 0 : s.type,
            tooltipText: null === (n = null === (i = null == r ? void 0 : r.settings) || void 0 === i ? void 0 : i.messages) || void 0 === n ? void 0 : n.tooltip
          };
        }, v.actions)(t.WidgetSurveyComponent);
        t.default = g;
      },
      3283: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.WidgetSurveyBodyComponent = void 0;
        const i = r(172),
          n = r(5994),
          o = r(9635),
          a = s(r(9990)),
          u = s(r(9438)),
          l = r(1617),
          c = s(r(1831)),
          d = r(6029),
          v = r(4409),
          p = r(7057),
          _ = r(3501),
          f = r(5346),
          h = s(r(8946)),
          m = r(5409),
          g = r(830),
          b = r(9027),
          y = r(9849),
          w = s(r(1367)),
          x = s(r(7599)),
          S = s(r(4647)),
          k = r(8579),
          T = s(r(7809)),
          M = s(r(5733)),
          O = r(9071),
          A = e => {
            var r;
            const s = (0, n.useRef)(!0),
              o = (0, n.useMemo)(() => ({
                current: "",
                next: ""
              }), []),
              [a, u] = (0, n.useState)(e.surveyPoint),
              [l, c] = (0, n.useState)(null),
              [d, v] = (0, n.useState)(o),
              {
                isPreview: p,
                surveyType: _
              } = (0, n.useContext)(f.SurveyConfigContext);
            (0, n.useEffect)(() => {
              s.current || u(e.surveyPoint);
            }, [e.surveyPoint]);
            (0, n.useEffect)(() => {
              var t, r;
              s.current ? s.current = !1 : e.surveyPoint && e.previousPoint && (t = e.previousPoint, r = e.surveyPoint, u(t), c(r), v({
                current: "sv__survey--slide-out",
                next: "sv__survey--slide-in"
              }), setTimeout(() => {
                u(r), c(null), v(o);
              }, 300));
            }, [null === (r = e.surveyPoint) || void 0 === r ? void 0 : r.point.id]);
            const h = Object.assign(Object.assign({}, e), {
                className: d.current,
                close: () => {
                  v({
                    current: "sv__survey--slide-down",
                    next: o.next
                  });
                  const {
                    surveyState: t
                  } = b.storeManager.getStore(_).getState();
                  setTimeout(() => {
                    p ? ((0, y.closeSurvey)(t, _), (0, y.reopenSurvey)(t, _)) : e.close(), v(o);
                  }, 300);
                },
                surveyPoint: a
              }),
              m = Object.assign(Object.assign({}, e), {
                className: d.next,
                surveyPoint: l
              });
            return (0, i.h)(i.Fragment, null, a && (0, i.h)(t.WidgetSurveyBodyComponent, Object.assign({}, h)), l && (0, i.h)(t.WidgetSurveyBodyComponent, Object.assign({}, m)));
          };
        t.WidgetSurveyBodyComponent = ({
          className: e,
          close: t,
          completionRate: r,
          isFinished: s,
          microThemeSettings: o,
          pointAnswer: d,
          pointsDisplayed: p,
          previewDevice: m,
          survey: y,
          surveyPoint: A,
          toggleMinimize: P
        }) => {
          const {
              isPreview: C,
              surveyType: E
            } = (0, n.useContext)(f.SurveyConfigContext),
            I = (0, n.useCallback)((0, c.default)(() => {
              S.default.setSurveyHeight(m, C, E);
            }, 100), [m, C]);
          if (!y) return null;
          const j = (0, n.useContext)(l.SubmitButtonContext),
            {
              show_progress_bar: N,
              show_close: D,
              show_minimize: L,
              hide_footer: R
            } = y.settings,
            B = s && !(0, a.default)(p),
            q = (0, v.translateMessages)(E, y),
            {
              answer_required_text: F,
              dropdown_placeholder: V,
              thankyou_text: z
            } = q,
            U = e ? ` ${e}` : "",
            H = () => {
              const e = document.querySelector(".sv__survey");
              e && e.classList.add("sv__outline");
            };
          return (0, n.useEffect)(() => {
            !C && y && y.activated && y.points.length && b.storeManager.getStore(E).action(g.seen)({
              surveyId: y.id,
              surveyName: y.name
            });
          }, []), (0, n.useEffect)(() => (window.addEventListener("resize", I), I(), () => {
            window.removeEventListener("resize", I);
          }), [I]), (0, n.useEffect)(() => {
            I(), S.default.removeBodyScrollListeners(), (null == A ? void 0 : A.point.answer_type) === _.SurveyQuestionAnswerType.date && S.default.lockBodyScroll();
          }, [I, A]), (0, n.useEffect)(() => {
            h.default.watchTabs(H);
          }, [A]), A ? (0, i.h)("div", {
            className: `${O.WidgetSurveyStyles.printSurveyClasses(E)}${U}`,
            "data-testid": "survey"
          }, (0, i.h)(M.default, Object.assign({}, o, {
            completionRate: r,
            className: `sv__${A.point.answer_type}__micro-top-bar`,
            showProgressBar: !s && N,
            isFinished: s,
            hideBranding: R
          }), (0, i.h)(w.default, {
            showCloseBtn: s || !!D,
            showMinimizeBtn: !s && !!L,
            toggleMinimize: () => P(!0),
            close: t
          })), B ? (0, i.h)(k.FinishView, {
            message: z,
            hideBranding: R
          }) : (0, i.h)(x.default, {
            answerRequiredText: F,
            dropdownPlaceholder: V,
            point: A.point,
            value: A.value,
            close: t,
            answer: d,
            previewDevice: m
          }), j.isVisible && (0, i.h)(u.default, null), (0, i.h)(T.default, {
            hide: s || R,
            pointAnswerType: A.point.answer_type
          })) : null;
        };
        const P = (0, o.connect)(({
          previewDevice: e,
          storeType: t,
          surveyState: {
            pointsDisplayed: r,
            isFinished: s,
            survey: i
          }
        }) => ({
          completionRate: (0, d.getProgressRate)(r),
          isFinished: s,
          microThemeSettings: O.WidgetSurveyStyles.MicroThemeSettings(t),
          pointsDisplayed: r,
          previewDevice: e,
          previousPoint: r[r.length - 2],
          storeType: t,
          survey: i,
          surveyPoint: r[r.length - 1]
        }), m.actions)(e => e.storeType === p.SurveyType.MobileSurvey ? (0, i.h)(A, Object.assign({}, e)) : (0, i.h)(t.WidgetSurveyBodyComponent, Object.assign({}, e)));
        t.default = P;
      },
      9071: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.WidgetSurveyStyles = void 0;
        const i = s(r(3053)),
          n = s(r(1835)),
          o = r(7057),
          a = r(9027),
          u = r(5595);
        t.WidgetSurveyStyles = class {
          static MicroThemeSettings(e) {
            const {
              theme: t
            } = a.storeManager.getStore(e).getState().surveyState;
            return (null == t ? void 0 : t.settings) || null;
          }
          static getWidgetSurveyClasses(e) {
            return {
              "sv__position-center": e === u.WidgetPosition.center,
              "sv__position-left": e === u.WidgetPosition.left,
              "sv__position-right": e === u.WidgetPosition.right,
              "sv__position-top-left": e === u.WidgetPosition.topLeft,
              "sv__position-top-right": e === u.WidgetPosition.topRight
            };
          }
          static getMobileSurveyClasses(e, t) {
            return {
              "sv__mobile-survey": !0,
              "sv__position-fullscreen": t === u.WidgetPosition.fullscreen,
              "sv__survey--with-footer": e
            };
          }
          static getFeedbackSurveyClasses(e, t) {
            return {
              "sv__feedback-survey": !0,
              "sv__feedback-survey--mobile": e,
              "sv__position-center-left": t === u.WidgetPosition.left,
              "sv__position-center-right": t === u.WidgetPosition.right
            };
          }
          static printSurveyClasses(e) {
            var t;
            if (!e) return "";
            const {
              surveyState: {
                survey: r,
                pointsDisplayed: s,
                isFinished: u,
                isRTLLanguage: l
              },
              previewDevice: c
            } = a.storeManager.getStore(e).getState();
            if (!(null == r ? void 0 : r.settings)) return "";
            const {
                settings: d
              } = r,
              v = d,
              p = v.place_to_show,
              _ = !v.hide_footer,
              f = null === (t = s[s.length - 1]) || void 0 === t ? void 0 : t.point.answer_type,
              h = e === o.SurveyType.MobileSurvey,
              m = (0, n.default)(c),
              g = {
                "sv--background-main": !0,
                "sv-bg-bw": !0,
                "sv__micro-theme": !0,
                "sv__position-mobile": h || m,
                "sv__rtl-lang": l,
                sv__survey: !0,
                "sv__survey--branded": _,
                "sv__survey--finished": !h && u,
                [`sv__survey--${f}`]: !!f
              },
              b = {
                [o.SurveyType.WidgetSurvey]: this.getWidgetSurveyClasses(p),
                [o.SurveyType.MobileSurvey]: this.getMobileSurveyClasses(_, p),
                [o.SurveyType.FeedbackButton]: this.getFeedbackSurveyClasses(m, p)
              },
              y = Object.assign(Object.assign({}, g), b[e] || {});
            return (0, i.default)(y);
          }
        };
      },
      3081: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(9635),
          o = s(r(3053)),
          a = r(1406),
          u = r(1461),
          l = r(7057),
          c = r(5409),
          d = s(r(3193)),
          v = r(9071),
          p = (0, n.connect)(e => ({
            storeType: e.storeType
          }), c.actions)(({
            tooltipText: e,
            toggleMinimize: t
          }) => {
            const r = {
              [v.WidgetSurveyStyles.printSurveyClasses(l.SurveyType.WidgetSurvey)]: !0,
              "sv--color-question": !0,
              "sv-col-question": !0,
              sv__minimized: !0
            };
            return (0, i.h)("div", {
              role: "button",
              tabIndex: 0,
              className: (0, o.default)(r),
              onClick: () => t(!1),
              onKeyDown: e => (0, a.keyboardClick)(e, () => t(!1)),
              onFocus: e => (0, u.skipFocus)(e, "sv__minimized-symbol")
            }, (0, i.h)("div", {
              className: "sv__minimized__text sv--color-answer"
            }, e), (0, i.h)("button", {
              tabIndex: 0,
              "aria-label": "Start survey",
              type: "button",
              className: (0, o.default)({
                "sv--background-button": !0,
                "sv__btn-maximize-plus": !0,
                "sv__minimized-symbol": !0
              })
            }, (0, i.h)(d.default, {
              className: "sv__forward-arrow"
            })));
          });
        t.default = p;
      },
      5653: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(6930)),
          o = s(r(3053));
        t.default = ({
          buttonLink: e
        }) => (0, i.h)("div", {
          className: "sv__footer"
        }, (0, i.h)("a", {
          href: e,
          rel: "noopener noreferrer",
          target: "_blank",
          title: "Click to go to the Survicate homepage",
          className: (0, o.default)({
            sv__footer__button: !0
          })
        }, (0, i.h)("small", {
          className: "sv__footer__small-text"
        }, "Powered by"), (0, i.h)(n.default, null)));
      },
      1248: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(9160));
        t.default = (e, t) => {
          (null == e ? void 0 : e.installing) && t.workspaceKey && (0, i.default)("https://respondent.survicate.com").post(`/workspaces/${t.workspaceKey}/installed.json`, {
            platform: "web"
          });
        };
      },
      7028: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurvicateEvent = t.SurveyTargetingEventType = void 0, function (e) {
          e.Segment = "segment", e.JSApi = "js_api";
        }(r || (t.SurveyTargetingEventType = r = {})), function (e) {
          e.SurveySeen = "survicate_survey_shown", e.SurveyPointAnswered = "survicate_survey_answered";
        }(s || (t.SurvicateEvent = s = {}));
      },
      5595: (e, t) => {
        "use strict";

        var r, s, i, n, o, a;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyFormat = t.DisplayPer = t.WidgetPosition = t.AppearMethodApi = t.AppearMethod = t.OverlayType = void 0, function (e) {
          e.light = "light", e.dark = "dark";
        }(r || (t.OverlayType = r = {})), function (e) {
          e.immediately = "immediately", e.delayed = "delayed", e.exitIntent = "leaveintent", e.scroll = "scroll", e.event = "event";
        }(s || (t.AppearMethod = s = {})), function (e) {
          e.immediately = "immediately", e.delayed = "delayed", e.exitIntent = "exitIntent", e.scroll = "onScroll";
        }(i || (t.AppearMethodApi = i = {})), function (e) {
          e.center = "center", e.dialog = "dialog", e.fullscreen = "fullscreen", e.left = "left", e.right = "right", e.topLeft = "topleft", e.topRight = "topright";
        }(n || (t.WidgetPosition = n = {})), function (e) {
          e.visit = "visit", e.visitor = "visitor";
        }(o || (t.DisplayPer = o = {})), function (e) {
          e.Widget = "widget", e.Feedback = "feedback";
        }(a || (t.SurveyFormat = a = {}));
      },
      2091: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(7057),
          n = s(r(5575));
        t.default = new class {
          constructor() {
            this.urls = {
              [i.SurveyType.FeedbackButton]: n.default.getUrl(),
              [i.SurveyType.WidgetSurvey]: n.default.getUrl()
            }, this.intervals = {
              [i.SurveyType.FeedbackButton]: null,
              [i.SurveyType.WidgetSurvey]: null
            };
          }
          clearInterval(e) {
            const t = this.intervals[e];
            t && (clearInterval(t), this.intervals[e] = null);
          }
          startInterval(e, t) {
            this.clearInterval(t), this.intervals[t] = window.setInterval(() => {
              this.hasUrlChanged(t) && (this.urls[t] = n.default.getUrl(), e());
            }, 1e3);
          }
          hasUrlChanged(e) {
            return n.default.getUrl() !== this.urls[e];
          }
        }();
      },
      4647: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(1835)),
          n = s(r(2156)),
          o = r(7057),
          a = r(9027),
          u = r(5595);
        t.default = new class {
          constructor() {
            this.MAX_DESKTOP_SURVEY_HEIGHT = 664, this.WINDOW_HEIGHT_PERCENTAGE = .9, this.PREVIEW_WINDOW_HEIGHT_PERCENTAGE = .65, this.PREVIEW_IFRAME_OFFSET = 100, this.handleTouchMove = e => {
              e.preventDefault();
            };
          }
          getSurvey() {
            return (0, n.default)('[data-testid="survey"]', o.SurveyType.WidgetSurvey);
          }
          lockBodyScroll() {
            const e = this.getSurvey();
            e && e.addEventListener("touchmove", this.handleTouchMove);
          }
          removeBodyScrollListeners() {
            const e = this.getSurvey();
            e && e.removeEventListener("touchmove", this.handleTouchMove);
          }
          getSurveyMaxHeight(e, t, r) {
            var s, n, o;
            const l = (0, i.default)(e),
              c = window.innerHeight,
              d = t ? "preview" : "live",
              v = (null === (o = null === (n = null === (s = a.storeManager.getStore(r).getState().surveyState) || void 0 === s ? void 0 : s.survey) || void 0 === n ? void 0 : n.settings) || void 0 === o ? void 0 : o.place_to_show) === u.WidgetPosition.fullscreen,
              p = {
                live: c > this.MAX_DESKTOP_SURVEY_HEIGHT,
                preview: c - this.PREVIEW_IFRAME_OFFSET > this.MAX_DESKTOP_SURVEY_HEIGHT
              },
              _ = {
                default: this.MAX_DESKTOP_SURVEY_HEIGHT,
                live: c * this.WINDOW_HEIGHT_PERCENTAGE,
                preview: c * this.PREVIEW_WINDOW_HEIGHT_PERCENTAGE
              };
            let f = _.default;
            return l || p[d] || (f = _[d]), l && (f = _.live), v && (f = c), f;
          }
          setSurveyHeight(e, t, r) {
            const s = this.getSurvey();
            if (!s) return;
            const i = this.getSurveyMaxHeight(e, t, r);
            s.style.maxHeight = `${i}px`;
          }
        }();
      },
      250: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.BrandedFooter = void 0;
        const i = r(172),
          n = s(r(9773)),
          o = s(r(6930));
        t.BrandedFooter = ({
          buttonLink: e
        }) => (0, i.h)("a", {
          className: "sv__branded-footer",
          type: "button",
          href: e,
          target: "_blank",
          title: "Click to go to the Survicate homepage",
          rel: "noreferrer"
        }, (0, i.h)("div", {
          className: "sv__branded-footer__content"
        }, (0, i.h)("p", {
          className: "sv__branded-footer__text"
        }, " Your turn to use "), (0, i.h)(o.default, {
          className: "sv__survicate-wordmark"
        }), (0, i.h)(n.default, {
          className: "sv__arrow-forward"
        })));
      },
      9812: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(1580)),
          a = r(3711),
          u = s(r(3053)),
          l = r(5346),
          c = r(9027);
        t.default = ({
          setValue: e,
          optionHeight: t,
          optionCount: r
        }) => {
          const {
              surveyType: s
            } = (0, n.useContext)(l.SurveyConfigContext),
            d = new Date(),
            [v, p] = (0, n.useState)(d.getDate()),
            [_, f] = (0, n.useState)(d.getMonth() + 1),
            [h, m] = (0, n.useState)(d.getFullYear()),
            g = () => new Date(h, _, 0).getDate(),
            b = (0, n.useMemo)(() => g(), [_]),
            y = (0, n.useMemo)(() => (0, a.getArrayWithNumbers)(1, b).map(e => `${e}`), [b]),
            w = (0, n.useMemo)(() => (0, a.getArrayWithNumbers)(1920, h + 1).map(e => `${e}`), []),
            x = () => {
              const e = new Date(),
                {
                  isPreview: t,
                  surveyState: {
                    translationLanguage: r
                  }
                } = c.storeManager.getStore(s).getState(),
                i = t && r ? r : window.navigator.language.substring(0, 2);
              return Array.from(Array(12).keys()).map(t => (e.setDate(1), e.setMonth(t), e.toLocaleDateString(i, {
                month: "long"
              })));
            };
          (0, n.useEffect)(() => {
            e({
              day: v,
              month: _,
              year: h
            });
          }, [v, _, h]), (0, n.useEffect)(() => {
            p(Math.min(v, g()));
          }, [_]);
          return (0, i.h)("div", {
            className: (0, u.default)({
              "sv--background-main": !0,
              "sv--color-answer": !0,
              sv__datepicker: !0,
              "sv__mobile-datepicker": !0
            }),
            style: {
              height: t * r
            }
          }, (0, i.h)("div", {
            className: (0, u.default)({
              "sv--background-answer-opacity-10": !0,
              "sv__datepicker--selected": !0,
              "sv__mobile-datepicker--selected": !0
            }),
            style: {
              height: t
            }
          }), (0, i.h)(o.default, {
            optionHeight: t,
            testId: "day",
            value: v.toString(),
            options: y,
            setValue: e => p(e + 1)
          }), (0, i.h)(o.default, {
            optionHeight: t,
            testId: "month",
            value: x()[_ - 1],
            options: x(),
            setValue: e => f(e + 1)
          }), (0, i.h)(o.default, {
            optionHeight: t,
            testId: "year",
            value: h.toString(),
            options: w,
            setValue: e => m(e + 1920)
          }));
        };
      },
      1580: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(1831)),
          o = s(r(3053));
        class a extends i.Component {
          constructor(e) {
            super(), this.timeUnit = 20, this.ref = null, this.updateTranslate = e => {
              const {
                optionHeight: t,
                options: r
              } = this.props;
              this.setState({
                translate: 2 * t - r.indexOf(e) * this.props.optionHeight
              });
            }, this.touchStart = e => {
              this.setState({
                touchStart: e.clientY || e.touches[0].clientY,
                transitionTime: 0
              });
            }, this.touchMove = (0, n.default)(e => {
              if (!this.state.touchStart) return;
              const t = e.clientY || e.touches[0].clientY;
              this.setState(e => {
                if (!e.touchStart) return {};
                const r = t - e.touchStart;
                let s = e.translate + r;
                return s = Math.max(e.translateMin - 2 * this.props.optionHeight, Math.min(s, e.translateMax + 2 * this.props.optionHeight)), {
                  speed: r,
                  touchStart: t,
                  translate: s
                };
              });
            }, this.timeUnit), this.getTransitionTime = e => Math.max(e * this.timeUnit * 3, 600), this.touchEnd = () => {
              this.state.touchStart && this.setState(e => {
                const t = e.speed,
                  r = Math.abs(t / -5);
                let s = Math.abs(-5) * r * (r / 2);
                t < 0 && (s *= -1);
                let i = Math.round((e.translate + s) / this.props.optionHeight) * this.props.optionHeight;
                i = Math.max(e.translateMin, Math.min(i, e.translateMax));
                const n = e.translate - i,
                  o = Math.abs(n) / t,
                  a = (i - e.translateMax) / this.props.optionHeight;
                return this.props.setValue(Math.abs(a)), {
                  speed: null,
                  touchStart: null,
                  transitionTime: this.getTransitionTime(o),
                  translate: i
                };
              });
            }, this.tryTouchStart = e => {
              let t,
                r = 0,
                s = 0;
              if (e.clientX ? (t = e, r = t.clientX, s = t.clientY) : e.touches && (t = e, r = t.touches[0].clientX, s = t.touches[0].clientY), !this.ref) return;
              const i = this.ref.getBoundingClientRect();
              this.isPointInRect(r, s, i) && this.touchStart(t);
            };
            const t = e.options.indexOf(e.value);
            this.state = {
              speed: null,
              touchStart: null,
              transitionTime: 0,
              translate: 2 * e.optionHeight - t * e.optionHeight,
              translateMax: 2 * e.optionHeight,
              translateMin: 2 * e.optionHeight - e.optionHeight * (e.options.length - 1)
            };
          }
          componentDidUpdate(e) {
            e.value !== this.props.value && this.updateTranslate(this.props.value);
          }
          isPointInRect(e, t, r) {
            return r.left <= e && e <= r.right && r.top <= t && t <= r.bottom;
          }
          componentWillMount() {
            document.addEventListener("mousemove", this.touchMove), document.addEventListener("mousedown", this.tryTouchStart), document.addEventListener("mouseup", this.touchEnd), document.addEventListener("touchstart", this.tryTouchStart), document.addEventListener("touchmove", this.touchMove), document.addEventListener("touchend", this.touchEnd);
          }
          componentWillUnmount() {
            document.removeEventListener("mousedown", this.tryTouchStart), document.removeEventListener("mousemove", this.touchMove), document.removeEventListener("mouseup", this.touchEnd);
          }
          render() {
            const {
                translate: e,
                transitionTime: t
              } = this.state,
              {
                options: r,
                optionHeight: s
              } = this.props;
            return (0, i.h)("div", {
              "data-testid": this.props.testId,
              className: (0, o.default)({
                "sv__datepicker--roller--wrapper": !0,
                sv__roller__wrapper: !0
              }),
              ref: e => {
                this.ref = e;
              }
            }, (0, i.h)("div", {
              className: (0, o.default)({
                "sv__datepicker--roller": !0,
                sv__roller: !0
              }),
              style: `\n            -webkit-transition: transform ${t}ms cubic-bezier(.62,1.51,.57,.95);\n            -webkit-transform: translate3d(0,${e}px,0);`
            }, r.map(e => (0, i.h)("div", {
              key: e,
              className: "sv__roller__option",
              style: {
                height: s
              }
            }, e))));
          }
        }
        t.default = a;
      },
      2887: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.PointTextType = void 0;
        const i = r(172),
          n = r(5994),
          o = s(r(3945)),
          a = s(r(3053)),
          u = r(5346),
          l = s(r(9510));
        var c;
        !function (e) {
          e[e.question = 0] = "question", e[e.description = 1] = "description";
        }(c || (t.PointTextType = c = {}));
        t.default = ({
          text: e,
          type: t,
          allowHTML: r = !0
        }) => {
          const {
              surveyType: s
            } = (0, n.useContext)(u.SurveyConfigContext),
            d = t === c.question,
            v = t === c.description,
            p = {
              "sv--color-question": d || v,
              "sv__point-description sv-col-description": v,
              "sv__point-question sv-col-question": d,
              "sv__point-text": !0
            };
          if (!r) {
            const t = /&/g,
              r = "&",
              n = e.replace(t, r);
            return (0, i.h)("div", {
              className: (0, a.default)(p)
            }, l.default.replaceTags(s, n));
          }
          return (0, i.h)(o.default, {
            className: (0, a.default)(p),
            content: l.default.replaceTags(s, e)
          });
        };
      },
      2202: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172),
          i = r(5994),
          n = r(5448),
          o = r(4539),
          a = r(8200),
          u = r(5346),
          l = r(2214),
          c = r(9027),
          d = r(3614),
          v = r(1617);
        t.default = ({
          point: e,
          answer: t,
          close: r,
          children: p
        }) => {
          var _;
          const f = (0, i.useContext)(v.SubmitButtonContext),
            {
              isPreview: h,
              surveyType: m
            } = (0, i.useContext)(u.SurveyConfigContext),
            g = (0, o.translatePoint)(m, e).settings;
          return f.useEvent({
            surveyId: null === (_ = c.storeManager.getStore(m).getState().surveyState.survey) || void 0 === _ ? void 0 : _.id,
            surveyType: m
          }, () => {
            if (e.answer_type === a.SurveyCtaAnswerType.buttonClose && "function" == typeof r) return void r();
            t((0, d.getButtonNextAnswerEvent)({
              point: e
            }));
            const s = g,
              {
                link: i,
                open_new_card: o
              } = s;
            if (i && (h && o || !h)) {
              const e = (0, l.sanitizeString)(i);
              window.open((0, n.decodeHTMLEntities)(e), o ? "_blank" : "_self");
            }
          }), (0, s.h)("div", {
            className: "sv__cta",
            "data-testid": "button-next"
          }, p && (0, s.h)("div", {
            className: "sv__scroll-container"
          }, [...p]));
        };
      },
      1088: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(3053)),
          o = r(1406);
        t.default = ({
          point: e,
          answer: t,
          children: r
        }) => {
          const {
              user_tag: s,
              facebook_link: a,
              twitter_link: u,
              linkedin_link: l
            } = e.settings,
            c = {
              anonymizedTextResponse: "",
              answers: [{
                nextSurveyPointId: -1,
                user_tag: s
              }],
              textResponse: ""
            },
            d = {
              "sv__social-button": !0
            };
          return (0, i.h)("div", {
            className: "sv__social"
          }, r && (0, i.h)("div", {
            className: "sv__scroll-container"
          }, [...r]), a && (0, i.h)("a", {
            className: `${(0, n.default)(d)} sv__fb`,
            href: a,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: () => t(c),
            onKeyDown: e => (0, o.keyboardClick)(e, () => t(c), {
              preventDefault: !0
            }),
            title: "Click to go to Facebook",
            "data-testid": "social-fb"
          }, (0, i.h)("svg", {
            width: "20",
            height: "20",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, i.h)("path", {
            d: "m6.490006,20l0,-9.12l2.95,0l0.44,-3.56l-3.39,0l0,-2.27a1.45,1.45 0 0 1 1.7,-1.73l1.81,0l0,-3.18a23.39,23.39 0 0 0 -2.64,-0.14c-2.61,0 -4.4,1.66 -4.4,4.7l0,2.62l-3,0l0,3.56l3,0l0,9.12l3.54,0l-0.01,0z"
          })), "Like"), u && (0, i.h)("a", {
            className: `${(0, n.default)(d)} sv__twitter`,
            href: u,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: () => t(c),
            onKeyDown: e => (0, o.keyboardClick)(e, () => t(c), {
              preventDefault: !0
            }),
            title: "Click to go to Twitter",
            "data-testid": "social-twitter"
          }, (0, i.h)("svg", {
            width: "17",
            height: "15",
            xmlns: "http://www.w3.org/2000/svg"
          }, (0, i.h)("path", {
            d: "m17,1.78a6.55,6.55 0 0 1 -2,0.6a3.76,3.76 0 0 0 1.53,-2.09a6.66,6.66 0 0 1 -2.21,0.92a3.36,3.36 0 0 0 -2.55,-1.2a3.65,3.65 0 0 0 -3.49,3.79a4.1,4.1 0 0 0 0.09,0.86a9.67,9.67 0 0 1 -7.19,-4a4,4 0 0 0 -0.47,1.9a3.88,3.88 0 0 0 1.55,3.15a3.27,3.27 0 0 1 -1.58,-0.47l0,0a3.72,3.72 0 0 0 2.8,3.71a3.23,3.23 0 0 1 -1.58,0.06a3.54,3.54 0 0 0 3.26,2.63a6.66,6.66 0 0 1 -4.33,1.62a6.56,6.56 0 0 1 -0.83,-0.05a9.32,9.32 0 0 0 5.35,1.7c6.42,0 9.92,-5.77 9.92,-10.77q0,-0.25 0,-0.49a7.45,7.45 0 0 0 1.73,-1.87z"
          })), "Follow"), l && (0, i.h)("a", {
            className: `${(0, n.default)(d)} sv__linkedin`,
            href: l,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: () => t(c),
            onKeyDown: e => (0, o.keyboardClick)(e, () => t(c), {
              preventDefault: !0
            }),
            title: "Click to go to LinkedIn",
            "data-testid": "social-linkedin"
          }, (0, i.h)("svg", {
            width: "21px",
            height: "21px"
          }, (0, i.h)("path", {
            d: "M1.06284545,7.43996625 L5.21369002,7.43996625 L5.21369002,20.793119 L1.06284545,20.793119 L1.06284545,7.43996625 Z M3.13521243,0.793994886 C4.45946716,0.793994886 5.53580603,1.87221749 5.53580603,3.19878807 C5.53580603,4.52535865 4.45946716,5.60620323 3.13608537,5.60620323 C1.80988051,5.60331939 0.735360446,4.52731106 0.732,3.19878807 C0.732,2.56054285 0.985278036,1.94847675 1.43604323,1.49741533 C1.88680842,1.0463539 2.4980818,0.793300051 3.13521243,0.793994886 M7.80545816,7.43996625 L11.7790953,7.43996625 L11.7790953,9.26498457 L11.8340907,9.26498457 C12.3875366,8.2156209 13.7388526,7.10854222 15.7623348,7.10854222 C19.9576994,7.10854222 20.732,9.87448997 20.732,13.469435 L20.732,20.7939935 L16.5916307,20.7939935 L16.5916307,14.2984323 C16.5916307,12.7506209 16.5636966,10.7568299 14.438953,10.7568299 C12.2827835,10.7568299 11.9510651,12.4445565 11.9510651,14.1847513 L11.9510651,20.7904956 L7.81156877,20.7904956 L7.81156877,7.43734284 L7.80545816,7.43996625 Z"
          })), "Follow"));
        };
      },
      1104: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172),
          i = r(5994),
          n = r(9635),
          o = r(5448),
          a = r(8200),
          u = r(2214),
          l = r(5409),
          c = r(1617),
          d = (0, n.connect)(({
            isPreview: e
          }) => ({
            isPreview: e
          }), l.actions)(({
            point: e,
            answer: t,
            children: r,
            isPreview: n
          }) => {
            const l = (0, i.useContext)(c.SubmitButtonContext),
              d = e.answer_type === a.SurveyCtaAnswerType.redirect,
              {
                timeout_display_count: v,
                user_tag: p,
                link: _,
                open_new_card: f
              } = e.settings;
            return (0, i.useEffect)(() => {
              if (t({
                anonymizedTextResponse: "",
                answers: [{
                  nextSurveyPointId: -1,
                  user_tag: p
                }],
                textResponse: ""
              }), d) {
                const e = parseInt(v || "0", 10);
                setTimeout(() => {
                  if (n) return;
                  const e = (0, u.sanitizeString)(_);
                  window.open((0, o.decodeHTMLEntities)(e), f ? "_blank" : "_self");
                }, 1e3 * e);
              }
            }, [e]), (0, i.useEffect)(() => {
              l.render(!1);
            }, []), (0, s.h)("div", {
              className: "sv__cta" + (d ? "-redirect" : ""),
              "data-testid": d ? "redirect-cta" : "thank-you-cta"
            }, r && (0, s.h)("div", {
              className: "sv__scroll-container"
            }, [...r]));
          });
        t.default = d;
      },
      6878: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(3249)),
          a = r(8243),
          u = r(4753),
          l = s(r(3945)),
          c = s(r(4998)),
          d = s(r(7826)),
          v = r(5346);
        t.default = ({
          isConfirmed: e,
          isInvalid: t,
          setConfirmation: r,
          label: s
        }) => {
          const {
            surveyType: p
          } = (0, n.useContext)(v.SurveyConfigContext);
          return (0, i.h)("div", {
            role: "button",
            className: "sv__contact-form-confirmation sv__contact-form-field sv--background-answer-opacity-10",
            onClick: () => {
              c.default.isSimpleTheme(p) && r();
            }
          }, (0, i.h)(d.default, {
            invalid: t,
            type: "confirmation"
          }, (0, i.h)(o.default, {
            key: e ? "checked" : "unchecked",
            isSelected: e,
            onKeyboardClick: r,
            onClick: e => {
              e.stopPropagation(), r();
            },
            display: u.CheckboxDisplay.square,
            colors: a.CheckboxColors.nestedInBw,
            invalid: t,
            label: s,
            testId: "confirmation-checkbox"
          }), (0, i.h)("div", {
            role: "button",
            className: "sv-col-fw sv__contact-form-agreement-label sv--color-answer",
            onClick: () => {
              c.default.isSimpleTheme(p) || r();
            },
            "data-testid": "confirmation-label"
          }, (0, i.h)(l.default, {
            content: s,
            className: "sv__contact-form-confirmation__content sv--color-answer"
          }))));
        };
      },
      3871: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(6878)),
          a = s(r(4645)),
          u = r(288),
          l = r(4285),
          c = s(r(3945)),
          d = r(7311),
          v = s(r(4998)),
          p = s(r(5890)),
          _ = s(r(7539)),
          f = r(7057),
          h = r(4585),
          m = r(5346),
          g = r(2214),
          b = r(9027),
          y = r(1617),
          w = s(r(757)),
          x = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        t.default = e => {
          var t, r;
          const s = (0, n.useContext)(y.SubmitButtonContext),
            {
              surveyType: S
            } = (0, n.useContext)(m.SurveyConfigContext),
            {
              answer: k,
              children: T,
              point: M,
              value: O
            } = e,
            A = () => ({
              confirmation: !1,
              values: C.map(() => !1)
            }),
            {
              confirmation: P,
              fields: C,
              security: E
            } = (() => {
              const e = M.fields.filter(({
                field_type: e
              }) => e !== h.FormFieldTypes.confirmation && e !== h.FormFieldTypes.security_info).sort((0, _.default)("order_number").ascending);
              return {
                confirmation: M.settings.consent ? M.settings.consent_text : "",
                fields: e,
                security: M.settings.disclaimer ? M.settings.disclaimer_text : ""
              };
            })(),
            I = {
              confirmation: P,
              fields: C,
              invalid: A(),
              isConfirmed: !!O,
              pointId: M.id,
              reducedState: d.PreviewHelpers.reduceContactForm(M),
              security: E,
              values: O || C.map(() => "")
            };
          (0, n.useEffect)(() => {
            N({
              payload: A(),
              type: "setInvalid"
            });
          }, [M]);
          const [j, N] = (0, n.useReducer)(u.contactFormStateReducer, I),
            {
              values: D,
              invalid: L,
              isConfirmed: R
            } = j,
            B = (e, t) => {
              const r = [...D];
              r[t] = e, N({
                payload: r,
                type: "setValues"
              });
            },
            q = (e, t) => {
              const r = e.trim();
              B(r, t), ((e, t) => {
                const r = [...L.values];
                r[t] = !1, C[t].field_type !== h.FormFieldTypes.email && C[t].required && !e && (r[t] = !0), C[t].field_type === h.FormFieldTypes.email && e && !x.test(e) && (r[t] = !0), N({
                  payload: Object.assign(Object.assign({}, L), {
                    values: r
                  }),
                  type: "setInvalid"
                });
              })(r, t);
            },
            F = (null === (t = b.storeManager.getStore(S).getState().surveyState.survey) || void 0 === t ? void 0 : t.type) === f.SurveyType.PageSurvey,
            V = v.default.isMicroTheme(S),
            z = (0, n.useMemo)(() => C.some((e, t) => e.required && !D[t]), [D, R, L]);
          return (0, n.useEffect)(() => {
            s.disable(z);
          }, [z]), s.useEvent({
            surveyId: null === (r = b.storeManager.getStore(S).getState().surveyState.survey) || void 0 === r ? void 0 : r.id,
            surveyType: S
          }, () => {
            (() => {
              const e = A();
              let t = !0;
              return P && !R && (e.confirmation = !0, t = !1), C.forEach((r, s) => {
                const i = D[s];
                r.required && !i && (e.values[s] = !0, t = !1), r.field_type === h.FormFieldTypes.email && i && !x.test(i) && (e.values[s] = !0, t = !1);
              }), N({
                payload: e,
                type: "setInvalid"
              }), t;
            })() ? k({
              anonymizedTextResponse: "",
              answers: C.map((e, t) => ({
                answer_type: e.field_type,
                content: (0, g.sanitizeString)(D[t]),
                field_id: e.id,
                nextSurveyPointId: M.settings.next_survey_point_id,
                user_tag: M.settings.user_tag
              })),
              textResponse: "",
              value: D
            }) : setTimeout(() => {
              const e = document.querySelector(".sv__invalid input");
              e && (e.focus(), (0, p.default)());
            }, 0);
          }), (0, i.h)("div", {
            className: "sv__contact-form"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, T && [...T], C.map((e, t) => (0, i.h)(a.default, {
            key: e.id,
            label: e.label,
            required: e.required,
            value: D[t],
            invalid: L.values[t],
            type: e.field_type,
            onInput: e => B(e, t),
            onBlur: e => q(e, t)
          })), P && (0, i.h)(o.default, {
            isConfirmed: R,
            isInvalid: L.confirmation,
            setConfirmation: () => N({
              payload: !R,
              type: "setIsConfirmed"
            }),
            label: P
          }), (F || V) && E && (0, i.h)("div", {
            className: (0, l.getSecurityClasses)(S)
          }, (0, i.h)("div", {
            "aria-label": "Agree on the conditions",
            className: "sv__lock-icon"
          }, (0, i.h)(w.default, null)), (0, i.h)(c.default, {
            className: "sv__contact-form-agreement-label sv--color-answer",
            inline: !0,
            content: E
          }))));
        };
      },
      4645: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(2831),
          a = s(r(4998)),
          u = s(r(7826)),
          l = s(r(3053)),
          c = r(5346),
          d = r(9027);
        t.default = e => {
          const t = (0, n.useRef)(null),
            {
              label: r,
              required: s,
              value: v,
              invalid: p,
              type: _,
              placeholder: f
            } = e,
            {
              surveyType: h
            } = (0, n.useContext)(c.SurveyConfigContext),
            m = `${r}${s ? "*" : ""}`,
            g = d.storeManager.getStore(h).getState().surveyState.survey,
            b = g && "PageSurvey" === g.type,
            y = a.default.isMicroTheme(h),
            w = (0, o.v4)(),
            x = g && "MobileSurvey" === g.type,
            S = {
              "sv__contact-form-field": !0,
              "sv__contact-form-field-filled": !!v,
              sv__dark: !x && a.default.isBackgroundLight(h),
              sv__invalid: !!p,
              [`sv__contact-form-${e.type}`]: !0,
              sv__light: !x && !a.default.isBackgroundLight(h)
            },
            k = {
              "sv-nested-bg-bw sv-nested-bg-hover-bw sv-col-fw sv__input sv--color-answer sv--background-answer-opacity-10": !a.default.isSimpleTheme(h)
            };
          return (0, i.h)("div", {
            className: (0, l.default)(S)
          }, (b || y) && r && (0, i.h)("label", {
            className: "sv__contact-form-field-label sv--color-answer",
            htmlFor: w
          }, m), (0, i.h)(u.default, {
            invalid: p,
            type: _
          }, (0, i.h)("input", {
            "aria-labelledby": m,
            ref: t,
            id: w,
            "data-testid": r,
            className: (0, l.default)(k),
            type: "text",
            placeholder: y ? "" : f || (b ? "" : m),
            value: v,
            onInput: t => {
              t.target instanceof HTMLInputElement && e.onInput && e.onInput(t.target.value);
            },
            onBlur: t => {
              e.onBlur && t.target instanceof HTMLInputElement && e.onBlur && e.onBlur(t.target.value);
            }
          })));
        };
      },
      288: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.contactFormStateReducer = void 0;
        t.contactFormStateReducer = (e, t) => {
          switch (t.type) {
            case "setIsConfirmed":
              return Object.assign(Object.assign({}, e), {
                isConfirmed: t.payload
              });
            case "setInvalid":
              return Object.assign(Object.assign({}, e), {
                invalid: t.payload
              });
            case "setValues":
              return Object.assign(Object.assign({}, e), {
                values: t.payload
              });
          }
        };
      },
      4285: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getSecurityClasses = void 0;
        const i = s(r(4998)),
          n = s(r(3053));
        t.getSecurityClasses = e => {
          const t = {
            "sv--background-answer-opacity-10": !0,
            "sv-col-small-button-bw": !i.default.isSimpleTheme(e),
            "sv__contact-form-field": !0,
            "sv__contact-form-security": !0
          };
          return (0, n.default)(t);
        };
      },
      347: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(4998)),
          a = s(r(3053)),
          u = r(1406),
          l = r(7057),
          c = r(4073),
          d = r(5346),
          v = s(r(5575)),
          p = s(r(579)),
          _ = r(4397),
          f = r(9027),
          h = r(3614),
          m = s(r(489)),
          g = r(1617);
        t.default = e => {
          var t, r, s, b, y, w;
          const x = (0, n.useContext)(g.SubmitButtonContext),
            {
              surveyType: S
            } = (0, n.useContext)(d.SurveyConfigContext),
            k = f.storeManager.getStore(S),
            {
              previewDevice: T,
              point: M,
              children: O
            } = e,
            A = v.default.params.aid,
            P = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            C = M.id === (null === (t = k.getState().surveyState.survey) || void 0 === t ? void 0 : t.points[0].id) ? A : void 0,
            E = e.value || 0 === e.value ? String(e.value) : C,
            I = !!M.settings.mandatory_submit_button,
            j = null === (r = k.getState().surveyState) || void 0 === r ? void 0 : r.isRTLLanguage,
            N = (null === (b = null === (s = k.getState().surveyState) || void 0 === s ? void 0 : s.survey) || void 0 === b ? void 0 : b.type) === l.SurveyType.PageSurvey,
            D = o.default.isMicroTheme(S),
            [L, R] = (0, n.useState)(E),
            B = (0, n.useMemo)(() => T === _.PreviewDevice.mobile || T !== _.PreviewDevice.desktop && p.default.isWidthMobile(), [T]),
            q = null !== (y = M.settings.answers_layout) && void 0 !== y ? y : c.Orientation.default,
            F = (N || D) && B && q === c.Orientation.default,
            V = t => {
              L || I ? R(String(t)) : e.answer((0, h.getNpsAnswerEvent)({
                point: M,
                value: t
              }));
            },
            z = {
              sv__nps: !0,
              "sv__nps--horizontal": D && B && q === c.Orientation.horizontal,
              "sv__nps--vertical": F,
              "sv__nps-wrapper": !0,
              "sv__nps-wrapper--mobile": F
            },
            U = {
              sv__buttons: !0,
              "sv__buttons--vertical": F
            },
            H = e => {
              const t = e === Number(L),
                r = {
                  "sv--background-answer-opacity-10": !0,
                  "sv--color-answer": !0,
                  "sv-bg-hov-ba": !0,
                  "sv-col-fa": !0,
                  "sv-col-main": t,
                  sv__button: !0,
                  "sv__button--selected": t,
                  "sv__nps--selected": t,
                  "sv__nps-button": !0
                };
              return (0, a.default)(r);
            },
            $ = M.settings.text_on_the_left,
            G = M.settings.text_on_the_right,
            W = {
              highestValueText: G,
              lowestValueText: $
            },
            K = {
              left: `0 - ${$}`,
              right: `10 - ${G}`
            };
          return j && (K.left = `0 - ${$}`, K.right = `10 - ${G}`), (0, n.useEffect)(() => {
            x.render(!!A || !!L || I);
          }, [L, I]), (0, n.useEffect)(() => {
            x.disable(!L);
          }, [L]), x.useEvent({
            surveyId: null === (w = f.storeManager.getStore(S).getState().surveyState.survey) || void 0 === w ? void 0 : w.id,
            surveyType: S
          }, () => {
            L && e.answer((0, h.getNpsAnswerEvent)({
              point: M,
              value: Number(L)
            }));
          }), (0, i.h)("div", {
            className: (0, a.default)(z)
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, O && [...O], (0, i.h)("div", {
            className: (0, a.default)(U)
          }, P.map((e, t) => {
            const r = {
              current: t,
              last: P.length - 1
            };
            return (0, i.h)("button", {
              "aria-label": `Choose button value: ${e}`,
              key: e,
              className: H(e),
              type: "button",
              "data-value": e,
              onClick: () => V(e),
              onKeyDown: t => (0, u.keyboardClick)(t, () => V(e), {
                preventDefault: !0
              }),
              "data-testid": `button-label-${e}`
            }, (0, i.h)(m.default, Object.assign({}, F && {
              content: W
            }, {
              answer: e,
              indexes: r
            })));
          })), !F && (0, i.h)("div", {
            className: (0, a.default)({
              "sv-col-fw": !0,
              sv__labels: !0,
              "sv__nps-labels": !0
            }),
            "data-testid": "nps-labels"
          }, $ && (0, i.h)("div", {
            className: "sv__label sv__label--left sv--color-answer"
          }, K.left), G && (0, i.h)("div", {
            className: "sv__label sv__label--right sv--color-answer"
          }, K.right))));
        };
      },
      6912: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(8697)),
          a = s(r(3249)),
          u = r(8243),
          l = s(r(3945)),
          c = s(r(4998)),
          d = s(r(3053)),
          v = s(r(6733)),
          p = r(5346);
        t.default = e => {
          const {
              answer: t,
              answerRequiredText: r,
              comment: s,
              display: _,
              isSelected: f,
              mandatoryComment: h,
              select: m,
              textPlaceholder: g,
              updateComment: b,
              dataTestid: y,
              shouldSkipTab: w
            } = e,
            {
              isPage: x,
              surveyType: S
            } = (0, n.useContext)(p.SurveyConfigContext),
            k = (0, i.createRef)(),
            T = e => {
              e.currentTarget instanceof HTMLDivElement && (e.currentTarget.blur(), e.stopPropagation()), m();
            },
            M = e => {
              e.preventDefault();
              let t = "";
              if (e.target instanceof HTMLTextAreaElement) {
                const r = x || A ? 0 : 44;
                (0, v.default)(e.target, r), t = e.target.value;
              }
              b && b(t);
            };
          (0, n.useEffect)(() => {
            f && (null == k ? void 0 : k.current) && k.current.focus();
          }, [f]);
          const O = f && t.add_comment,
            A = c.default.isMicroTheme(S),
            P = {
              "sv--background-answer-opacity-10": !0,
              "sv--color-answer": !0,
              "sv-bg-ba": !0,
              "sv-bg-shaded-ba": f,
              "sv-border-color-answer": f,
              "sv-col-fa": !0,
              "sv__choice-button": !0,
              "sv__choice-button--selected": f,
              "sv__choice-button--selected--expanded": A && !!O,
              sv__selected: x && f
            },
            C = {
              "sv--color-answer": !0,
              "sv-col-fa": !0,
              "sv-col-main": x && e.isSelected,
              "sv__answer-text": A
            },
            E = {
              "sv__textarea-wrapper": !0,
              "sv__textarea-wrapper--narrower": !!h && !!O && !!r
            },
            I = x || A ? "sv__textarea sv-border-color-main sv--color-answer sv--background-answer-opacity-10" : "sv-bg-bw sv-col-fw sv-border-top-ba";
          return (0, i.h)("div", {
            className: "sv__choice-button-wrapper"
          }, (0, i.h)("div", {
            role: "button",
            className: (0, d.default)(P),
            onClick: e => T(e),
            tabIndex: -1,
            onKeyDown: () => null,
            "data-testid": null != y ? y : "choice-button"
          }, x || A ? (0, i.h)(i.Fragment, null, (0, i.h)("div", {
            className: "sv__choice-button-question"
          }, (0, i.h)(a.default, {
            colors: u.CheckboxColors.bw,
            display: _,
            isSelected: f,
            onClick: e => T(e),
            onKeyboardClick: () => m(),
            shouldSkipTab: w,
            label: t.possible_answer,
            testId: `checkbox-${t.id}`
          }), (0, i.h)(l.default, {
            className: (0, d.default)(C),
            content: t.possible_answer
          })), O && (0, i.h)("div", {
            className: (0, d.default)(E)
          }, (0, i.h)(o.default, {
            text: r || "",
            shouldShow: !!h
          }), (0, i.h)("textarea", {
            "aria-label": "Comment your answer",
            className: I,
            "data-gramm_editor": "false",
            "data-testid": `comment-field-${t.id}`,
            name: "comment",
            onClick: e => e.stopPropagation(),
            onInput: e => {
              M(e);
            },
            onKeyDown: e => e.stopPropagation(),
            placeholder: g,
            ref: k,
            title: "comment",
            value: s
          }))) : (0, i.h)(i.Fragment, null, (0, i.h)(a.default, {
            colors: u.CheckboxColors.bw,
            display: _,
            isSelected: f,
            onClick: e => T(e),
            onKeyboardClick: () => m(),
            label: t.possible_answer,
            testId: `checkbox-${t.id}`
          }), (0, i.h)("div", null, (0, i.h)(l.default, {
            className: (0, d.default)(C),
            content: t.possible_answer
          }), O && (0, i.h)(i.Fragment, null, (0, i.h)(o.default, {
            text: r || "",
            shouldShow: !!h
          }), (0, i.h)("textarea", {
            "aria-label": "Comment your answer",
            className: I,
            "data-gramm_editor": "false",
            "data-testid": `comment-field-${t.id}`,
            name: "comment",
            onClick: e => e.stopPropagation(),
            onInput: e => {
              M(e);
            },
            onKeyDown: e => e.stopPropagation(),
            placeholder: g,
            ref: k,
            title: "comment",
            value: s
          }))))));
        };
      },
      5528: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(6912)),
          a = r(4206),
          u = r(6701),
          l = s(r(8697)),
          c = r(4753),
          d = r(7311),
          v = r(1617),
          p = r(2780),
          _ = r(7057),
          f = r(5346),
          h = r(2214),
          m = r(9027);
        t.default = e => {
          var t, r, s, g, b, y, w, x;
          const {
              surveyType: S
            } = (0, n.useContext)(f.SurveyConfigContext),
            {
              point: k,
              value: T
            } = e,
            {
              mandatory_comment: M,
              next_survey_point_id: O,
              randomize_answers: A,
              randomize_except_last: P
            } = k.settings,
            C = null === (t = k.settings.mandatory) || void 0 === t || t,
            E = m.storeManager.getStore(S).getState().surveyState.survey,
            I = E && E.type === _.SurveyType.MobileSurvey,
            j = {
              answers: (0, a.randomizeAnswers)(k),
              comments: (0, p.getComments)(k, T),
              pointId: k.id,
              reducedAnswers: d.PreviewHelpers.reduceAnswers((0, a.randomizeAnswers)(k)),
              selectedAnswers: (null == T ? void 0 : T.answers) || []
            },
            [N, D] = (0, n.useReducer)(u.choiceStateReducer, j),
            L = (0, n.useContext)(v.SubmitButtonContext),
            R = N.selectedAnswers.reduce((e, t) => {
              const r = (0, h.sanitizeString)(N.comments[t.id] || "");
              return Object.assign(Object.assign({}, e), {
                [t.id]: r
              });
            }, {}),
            B = M && N.selectedAnswers.some(e => e.add_comment && !N.comments[e.id]);
          (0, n.useEffect)(() => {
            N.reducedAnswers !== d.PreviewHelpers.reduceAnswers(k.answers) && (D({
              payload: k.answers,
              type: "setAnswers"
            }), D({
              payload: d.PreviewHelpers.reduceAnswers(k.answers),
              type: "setReducedAnswers"
            }));
          }, [k.answers]), (0, n.useEffect)(() => {
            const e = N.answers.filter(e => N.selectedAnswers.find(t => e.id === t.id));
            D({
              payload: e,
              type: "setSelectedAnswers"
            });
          }, [N.answers]), (0, n.useEffect)(() => {
            D({
              payload: (0, a.randomizeAnswers)(k),
              type: "setAnswers"
            });
          }, [A, P, k.id]);
          const q = (null === (s = null === (r = e.point.settings) || void 0 === r ? void 0 : r.choice) || void 0 === s ? void 0 : s.min) || 1,
            F = (null === (b = null === (g = e.point.settings) || void 0 === g ? void 0 : g.choice) || void 0 === b ? void 0 : b.max) || 0,
            V = q <= N.selectedAnswers.length && (!F || F >= N.selectedAnswers.length);
          return L.useEvent({
            surveyId: null === (y = m.storeManager.getStore(S).getState().surveyState.survey) || void 0 === y ? void 0 : y.id,
            surveyType: S
          }, () => {
            if (!N.selectedAnswers.length) return void e.answer({
              anonymizedTextResponse: "",
              answers: [],
              textResponse: ""
            });
            const t = N.selectedAnswers.reduce((e, t) => e ? `${e}, ${t.possible_answer}` : `${t.possible_answer}`, "");
            e.answer({
              anonymizedTextResponse: t,
              answers: N.selectedAnswers.map(e => ({
                content: (0, h.sanitizeString)(N.comments[e.id]) || null,
                nextSurveyPointId: O,
                survey_question_answer_id: e.id,
                user_tag: e.user_tag
              })),
              textResponse: t,
              value: {
                answers: N.selectedAnswers,
                comments: R
              }
            });
          }), (0, n.useEffect)(() => {
            L.disable(!(I || V && !B || !C && !N.selectedAnswers.length));
          }, [I, V, B, N.selectedAnswers, C]), (0, i.h)("div", {
            className: "sv__multiple-choice"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, e.children && [...e.children], (0, i.h)(l.default, {
            shouldShow: !!(null === (w = e.point.settings.choice) || void 0 === w ? void 0 : w.text),
            text: null === (x = e.point.settings.choice) || void 0 === x ? void 0 : x.text
          }), N.answers.map(t => {
            const r = !!N.selectedAnswers.find(e => e.id === t.id);
            return (0, i.h)(o.default, {
              answerRequiredText: e.answerRequiredText,
              mandatoryComment: e.point.settings.mandatory_comment,
              textPlaceholder: e.textPlaceholder,
              key: t.id,
              answer: t,
              display: c.CheckboxDisplay.square,
              isSelected: r,
              comment: N.comments[t.id],
              updateComment: e => {
                return r = e, s = t.id, void D({
                  payload: Object.assign(Object.assign({}, N.comments), {
                    [s]: r
                  }),
                  type: "setComments"
                });
                var r, s;
              },
              select: () => (e => {
                let t = [...N.selectedAnswers];
                t.find(t => t.id === e.id) ? t = t.filter(t => t.id !== e.id) : t.push(e), D({
                  payload: t,
                  type: "setSelectedAnswers"
                });
              })(t),
              dataTestid: `choice-button-${t.id.toString()}`
            });
          })));
        };
      },
      3108: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(6912)),
          a = r(4206),
          u = r(6701),
          l = r(4753),
          c = r(7311),
          d = r(1617),
          v = r(2780),
          p = r(5346),
          _ = r(2214),
          f = s(r(5575)),
          h = r(9027),
          m = r(3614);
        t.default = e => {
          var t, r;
          const s = (0, n.useContext)(d.SubmitButtonContext),
            {
              isWidget: g,
              surveyType: b
            } = (0, n.useContext)(p.SurveyConfigContext),
            {
              answer: y,
              answerRequiredText: w,
              point: x,
              textPlaceholder: S,
              value: k,
              children: T
            } = e,
            {
              mandatory_submit_button: M,
              mandatory_comment: O,
              randomize_answers: A,
              randomize_except_last: P
            } = x.settings,
            C = null === (t = x.settings.mandatory) || void 0 === t || t,
            E = f.default.params.aid,
            I = x.answers.find(({
              id: e
            }) => e === Number(E)),
            j = {
              answers: (0, a.randomizeAnswers)(x),
              comments: (0, v.getComments)(x, k),
              pointId: x.id,
              reducedAnswers: c.PreviewHelpers.reduceAnswers(x.answers),
              selectedAnswer: I
            },
            [N, D] = (0, n.useReducer)(u.choiceStateReducer, j),
            {
              answers: L,
              selectedAnswer: R,
              comments: B
            } = N,
            q = C && !R;
          return (0, n.useEffect)(() => {
            I || D({
              payload: null == k ? void 0 : k.answer,
              type: "setSelectedAnswer"
            });
          }, [k]), (0, n.useEffect)(() => {
            D({
              payload: (0, a.randomizeAnswers)(x),
              type: "setAnswers"
            });
          }, [A, P]), (0, n.useEffect)(() => {
            const e = c.PreviewHelpers.reduceAnswers(x.answers);
            N.reducedAnswers !== e && (D({
              payload: x.answers,
              type: "setAnswers"
            }), D({
              payload: e,
              type: "setReducedAnswers"
            }));
          }, [x.answers]), (0, n.useEffect)(() => {
            s.render(!!R || !!M || !C && g);
          }, [R, C, M]), (0, n.useEffect)(() => {
            s.disable(q || !(!O || !(null == R ? void 0 : R.add_comment) || B[R.id]));
          }, [R, C, O, B]), s.useEvent({
            surveyId: null === (r = h.storeManager.getStore(b).getState().surveyState.survey) || void 0 === r ? void 0 : r.id,
            surveyType: b
          }, () => {
            if (!R) return void y({
              anonymizedTextResponse: "",
              answers: [],
              textResponse: ""
            });
            const e = (0, _.sanitizeString)(N.comments[R.id]);
            O && !e && R.add_comment || y((0, m.getSingleChoiceAnswerEvent)({
              answer: R,
              comment: e,
              point: x
            }));
          }), (0, i.h)("div", {
            className: "sv__single-choice"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, T && [...T], L.map(e => (0, i.h)(o.default, {
            answerRequiredText: w,
            mandatoryComment: O,
            textPlaceholder: S,
            key: e.id,
            answer: e,
            display: l.CheckboxDisplay.circle,
            isSelected: (null == R ? void 0 : R.id) === e.id,
            comment: B[e.id],
            updateComment: t => {
              return r = t, s = e.id, void D({
                payload: Object.assign(Object.assign({}, N.comments), {
                  [s]: r
                }),
                type: "setComments"
              });
              var r, s;
            },
            select: () => (e => {
              if (e.add_comment || M) D({
                payload: e,
                type: "setSelectedAnswer"
              });else if (N.selectedAnswer) D({
                payload: e,
                type: "setSelectedAnswer"
              });else {
                const t = N.comments[e.id] || "";
                y((0, m.getSingleChoiceAnswerEvent)({
                  answer: e,
                  comment: t,
                  point: x
                }));
              }
            })(e),
            dataTestid: `choice-button-${e.id}`
          }))));
        };
      },
      6701: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.choiceStateReducer = void 0;
        t.choiceStateReducer = (e, t) => {
          switch (t.type) {
            case "setAnswers":
              return Object.assign(Object.assign({}, e), {
                answers: t.payload
              });
            case "setComments":
              return Object.assign(Object.assign({}, e), {
                comments: t.payload
              });
            case "setPointId":
              return Object.assign(Object.assign({}, e), {
                pointId: t.payload
              });
            case "setReducedAnswers":
              return Object.assign(Object.assign({}, e), {
                reducedAnswers: t.payload
              });
            case "setSelectedAnswer":
              return Object.assign(Object.assign({}, e), {
                selectedAnswer: t.payload
              });
            case "setSelectedAnswers":
              return Object.assign(Object.assign({}, e), {
                selectedAnswers: t.payload
              });
          }
        };
      },
      4206: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.randomizeAnswers = void 0;
        const s = r(338);
        t.randomizeAnswers = e => {
          const t = e.answers,
            {
              randomize_answers: r,
              randomize_except_last: s
            } = e.settings;
          return i(t, r, s);
        };
        const i = (e, t, r) => t ? r ? [...(0, s.shuffleArray)(e.slice(0, -1)), e[e.length - 1]] : (0, s.shuffleArray)(e) : e;
      },
      8123: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(6066)),
          a = s(r(6543)),
          u = s(r(4998)),
          l = r(5346),
          c = s(r(5575)),
          d = r(9027),
          v = r(3614),
          p = r(1617);
        t.default = e => {
          var t;
          const r = (0, n.useContext)(p.SubmitButtonContext),
            {
              surveyType: s
            } = (0, n.useContext)(l.SurveyConfigContext),
            {
              point: _,
              value: f
            } = e,
            {
              mandatory_submit_button: h
            } = _.settings,
            m = c.default.params.aid,
            g = _.answers.find(({
              id: e
            }) => e === Number(m)),
            [b, y] = (0, n.useState)(f || g),
            w = u.default.isMicroTheme(s),
            x = t => {
              b || h ? y(t) : e.answer((0, v.getScaleAnswerEvent)({
                answer: t,
                point: _
              }));
            };
          return (0, n.useEffect)(() => {
            r.render(!!b || !!m || !!h);
          }, [b, h]), (0, n.useEffect)(() => {
            r.disable(!b);
          }, [b]), r.useEvent({
            surveyId: null === (t = d.storeManager.getStore(s).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: s
          }, () => {
            b && e.answer((0, v.getScaleAnswerEvent)({
              answer: b,
              point: _
            }));
          }), (0, i.h)("div", {
            className: "sv__customer-satisfaction"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, e.children && [...e.children], w ? (0, i.h)(a.default, {
            answers: _.answers,
            handleAnswer: x
          }) : (0, i.h)(o.default, {
            answers: _.answers,
            selectedAnswer: b,
            handleAnswer: x
          })));
        };
      },
      6066: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(6912)),
          o = r(4753);
        t.default = ({
          answers: e,
          selectedAnswer: t,
          handleAnswer: r
        }) => (0, i.h)(i.Fragment, null, e.map(e => (0, i.h)(n.default, {
          key: e.id,
          answer: e,
          display: o.CheckboxDisplay.circle,
          isSelected: (null == t ? void 0 : t.id) === e.id,
          select: () => r(e),
          dataTestid: `choice-button-${e.id.toString()}`
        })));
      },
      6543: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172);
        t.default = ({
          answers: e,
          handleAnswer: t
        }) => (0, s.h)("div", {
          className: "sv__buttons sv__buttons--vertical"
        }, e.map(e => (0, s.h)("button", {
          "aria-label": `Choose answer: ${e.possible_answer}`,
          "data-testid": `choice-button-${e.id}`,
          key: e.id,
          type: "button",
          className: "sv__button sv--color-answer sv--background-answer-opacity-10",
          onClick: () => t(e)
        }, (0, s.h)("span", {
          className: "sv__buttons__answer"
        }, e.possible_answer))));
      },
      7651: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(9812)),
          a = s(r(7826)),
          u = s(r(3053)),
          l = s(r(1835)),
          c = r(3501),
          d = r(5346),
          v = s(r(579)),
          p = r(4397),
          _ = r(9027),
          f = s(r(8697)),
          h = r(1617),
          m = s(r(4998)),
          g = r(1e3),
          b = r(2279),
          y = r(529),
          w = r(7),
          x = r(4489),
          S = r(1424);
        t.default = e => {
          var t, r, s, k;
          const T = (0, n.useContext)(h.SubmitButtonContext),
            {
              surveyType: M
            } = (0, n.useContext)(d.SurveyConfigContext),
            O = [(0, n.useRef)(null), (0, n.useRef)(null), (0, n.useRef)(null)],
            {
              point: A,
              value: P
            } = e,
            C = {
              [c.TimeUnit.day]: null !== (t = null == P ? void 0 : P[c.TimeUnit.day]) && void 0 !== t ? t : "",
              [c.TimeUnit.month]: null !== (r = null == P ? void 0 : P[c.TimeUnit.month]) && void 0 !== r ? r : "",
              [c.TimeUnit.year]: null !== (s = null == P ? void 0 : P[c.TimeUnit.year]) && void 0 !== s ? s : "",
              containerClass: "",
              error: !1,
              pointId: A.id
            },
            [E, I] = (0, n.useReducer)(g.dateStateReducer, C),
            j = e => {
              I({
                payload: e,
                type: "setContainerClass"
              });
            },
            {
              point: {
                settings: {
                  mandatory: N,
                  date_separator: D,
                  date_order: L
                }
              },
              answerRequiredText: R,
              previewDevice: B
            } = e,
            q = (0, w.getTimeUnitsOrder)(L),
            F = !E[c.TimeUnit.year] || !E[c.TimeUnit.month] || !E[c.TimeUnit.day],
            V = N && F,
            z = m.default.isMicroTheme(M),
            U = (0, l.default)(B) && z || B !== p.PreviewDevice.desktop && v.default.isWidthMobile() && z,
            H = {
              "sv--background-answer-opacity-10": !0,
              sv__date: !0,
              sv__invalid: E.error,
              [E.containerClass]: !!E.containerClass
            },
            $ = {
              "sv--color-answer": !0,
              "sv-col-fw": !0,
              sv__date__input: !0
            };
          return (0, n.useEffect)(() => {
            T.disable(V);
          }, [N, E[c.TimeUnit.day], E[c.TimeUnit.month], E[c.TimeUnit.year]]), T.useEvent({
            surveyId: null === (k = _.storeManager.getStore(M).getState().surveyState.survey) || void 0 === k ? void 0 : k.id,
            surveyType: M
          }, () => {
            const {
                mandatory: t,
                next_survey_point_id: r,
                user_tag: s
              } = e.point.settings,
              i = (0, x.isInputValid)(c.TimeUnit.year, E) && (0, x.isInputValid)(c.TimeUnit.month, E) && (0, x.isInputValid)(c.TimeUnit.day, E),
              n = !E[c.TimeUnit.year] && !E[c.TimeUnit.month] && !E[c.TimeUnit.day];
            if (!i) return !t && n ? e.answer({
              anonymizedTextResponse: "",
              answers: [{
                content: "",
                user_tag: s
              }],
              textResponse: ""
            }) : I({
              payload: !0,
              type: "setError"
            }), void (0, y.focusOnFirstEmptyInput)();
            const o = (0, b.ensureLength)(E[c.TimeUnit.day], 2),
              a = (0, b.ensureLength)(E[c.TimeUnit.month], 2),
              u = E[c.TimeUnit.year];
            e.answer({
              anonymizedTextResponse: `${u}-${a}-${o}`,
              answers: [{
                content: `${u}-${a}-${o}`,
                nextSurveyPointId: r,
                user_tag: s
              }],
              textResponse: `${u}-${a}-${o}`,
              value: {
                [c.TimeUnit.day]: o,
                [c.TimeUnit.month]: a,
                [c.TimeUnit.year]: u
              }
            });
          }), (0, i.h)("div", {
            className: (0, u.default)({
              "sv__date-wrapper": !0,
              sv__date__wrapper: !0
            })
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, e.children && [...e.children], U ? (0, i.h)(o.default, {
            setValue: e => (({
              day: e,
              month: t,
              year: r
            }) => {
              const s = [c.TimeUnit.day, c.TimeUnit.month, c.TimeUnit.year],
                i = [e, t, r];
              s.forEach((e, t) => {
                I({
                  payload: `${i[t]}`,
                  type: e
                });
              });
            })(e),
            optionHeight: 56,
            optionCount: 5
          }) : (0, i.h)(i.Fragment, null, (0, i.h)(f.default, {
            shouldShow: N,
            text: R
          }), (0, i.h)("div", {
            className: (0, u.default)(H),
            role: "button",
            tabIndex: 0
          }, q.map((e, t) => [(0, i.h)(a.default, {
            "data-testid": `${e}-input-validation`,
            invalid: E.error,
            key: e,
            type: "date"
          }, (0, i.h)("input", {
            "aria-label": `Choose time unit: ${e}`,
            className: (0, u.default)($),
            "data-testid": e,
            maxLength: e.length,
            onBlur: () => j(""),
            onFocus: () => j("focused"),
            onInput: r => ((e, t, r) => {
              let s = "";
              e.target instanceof HTMLInputElement && (s = e.target.value), s = s.replace(/\D/g, ""), I({
                payload: s,
                type: t
              });
              const i = O[r + 1];
              (0, S.isLengthMaxed)(t, s) && r < 2 && i && i.current && i.current.focus();
            })(r, e, t),
            placeholder: e,
            ref: O[t],
            type: "text",
            value: E[e]
          })), 2 !== t ? (0, i.h)("div", {
            className: "sv__date__separator sv--color-answer"
          }, D) : null])))));
        };
      },
      1e3: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.dateStateReducer = void 0;
        const s = r(3501);
        t.dateStateReducer = (e, t) => {
          switch (t.type) {
            case "setError":
              return Object.assign(Object.assign({}, e), {
                error: t.payload
              });
            case s.TimeUnit.day:
              return Object.assign(Object.assign({}, e), {
                [s.TimeUnit.day]: t.payload
              });
            case s.TimeUnit.month:
              return Object.assign(Object.assign({}, e), {
                [s.TimeUnit.month]: t.payload
              });
            case s.TimeUnit.year:
              return Object.assign(Object.assign({}, e), {
                [s.TimeUnit.year]: t.payload
              });
            case "setContainerClass":
              return Object.assign(Object.assign({}, e), {
                containerClass: t.payload
              });
            case "setPointId":
              return Object.assign(Object.assign({}, e), {
                pointId: t.payload
              });
            default:
              return e;
          }
        };
      },
      2279: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ensureLength = void 0;
        t.ensureLength = (e, t) => e.padStart(t, "0");
      },
      529: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.focusOnFirstEmptyInput = void 0;
        t.focusOnFirstEmptyInput = () => {
          const e = Array.from(document.querySelectorAll(".sv__survey input"));
          if (e.length) {
            const t = e.find(e => !e.value);
            t && t.focus();
          }
        };
      },
      7: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getTimeUnitsOrder = void 0;
        const s = r(3501),
          i = r(2920);
        t.getTimeUnitsOrder = e => {
          switch (e) {
            case i.DateOrder.DMY:
              return [s.TimeUnit.day, s.TimeUnit.month, s.TimeUnit.year];
            case i.DateOrder.MDY:
              return [s.TimeUnit.month, s.TimeUnit.day, s.TimeUnit.year];
            case i.DateOrder.YMD:
            default:
              return [s.TimeUnit.year, s.TimeUnit.month, s.TimeUnit.day];
          }
        };
      },
      4489: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isInputValid = void 0;
        const s = r(3501);
        t.isInputValid = (e, t) => {
          const r = parseInt(t[e], 10);
          if (Number.isNaN(r)) return !1;
          const i = {
            [s.TimeUnit.day]: {
              max: 31,
              min: 1
            },
            [s.TimeUnit.month]: {
              max: 12,
              min: 1
            },
            [s.TimeUnit.year]: {
              max: 5e3,
              min: 1e3
            }
          }[e];
          if (!i) throw new Error("TimeUnit is incorrect.");
          return r >= i.min && r <= i.max;
        };
      },
      1424: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isLengthMaxed = void 0;
        const s = r(3501);
        t.isLengthMaxed = (e, t) => e === s.TimeUnit.year ? 4 === t.length : e === s.TimeUnit.month ? 2 === t.length || parseInt(t, 10) > 1 : 2 === t.length || parseInt(t, 10) > 3;
      },
      1561: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(4206),
          a = r(1254),
          u = s(r(8697)),
          l = s(r(7755)),
          c = s(r(3053)),
          d = r(5346),
          v = r(9027),
          p = r(1617);
        t.default = e => {
          var t;
          const r = (0, n.useContext)(p.SubmitButtonContext),
            {
              surveyType: s
            } = (0, n.useContext)(d.SurveyConfigContext),
            {
              answerRequiredText: _,
              dropdownPlaceholder: f,
              point: {
                answers: h,
                id: m,
                settings: {
                  mandatory: g
                }
              },
              value: b
            } = e,
            y = h.reduce((e, t) => `${e}${t.possible_answer}`, ""),
            w = {
              answers: (0, o.randomizeAnswers)(e.point),
              error: !1,
              pointId: m,
              reducedAnswers: y,
              value: b || null
            },
            [x, S] = (0, n.useReducer)(a.dropdownStateReducer, w),
            k = document.querySelector('[data-testid="select-input"]'),
            T = () => null == x ? void 0 : x.answers.map(e => ({
              label: e.possible_answer.replace("&amp;", "&"),
              value: e.id
            }));
          (0, n.useEffect)(() => {
            var t;
            (null === (t = window._svc) || void 0 === t ? void 0 : t.isPreview) && S({
              payload: (0, o.randomizeAnswers)(e.point),
              type: "setAnswers"
            }), T();
          }, [h]);
          return (0, n.useEffect)(() => {
            const e = !x.value && (g || !!(null == k ? void 0 : k.value));
            r.disable(e);
          }, [x.value, null == k ? void 0 : k.value, g]), r.useEvent({
            surveyId: null === (t = v.storeManager.getStore(s).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: s
          }, () => {
            const t = x.value;
            if (!t) return g ? void S({
              payload: !0,
              type: "setError"
            }) : void e.answer({
              anonymizedTextResponse: "",
              answers: [],
              textResponse: ""
            });
            e.answer({
              anonymizedTextResponse: t.possible_answer,
              answers: [{
                nextSurveyPointId: t.next_survey_point_id,
                survey_question_answer_id: t.id,
                user_tag: t.user_tag
              }],
              textResponse: t.possible_answer,
              value: t
            });
          }), (0, i.h)("div", {
            className: (0, c.default)({
              "sv__dropdown-wrapper": !0,
              sv__dropdown__wrapper: !0
            })
          }, e.children && (0, i.h)("div", {
            className: "sv__scroll-container"
          }, [...e.children]), (0, i.h)(u.default, {
            shouldShow: g,
            text: _
          }), (0, i.h)(l.default, {
            dropdownPlaceholder: f || "Please select an answer",
            options: T(),
            onSelect: e => {
              S({
                payload: h.find(t => t.id === e) || null,
                type: "setValue"
              });
            },
            inputValue: x.value ? x.value.id : null,
            allowSearch: !0,
            isError: x.error,
            pointId: x.pointId,
            showClearButton: !0,
            shouldHideSubmitButton: !0
          }));
        };
      },
      1254: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.dropdownStateReducer = void 0;
        t.dropdownStateReducer = (e, t) => {
          switch (t.type) {
            case "setAnswers":
              return Object.assign(Object.assign({}, e), {
                answers: t.payload
              });
            case "setError":
              return Object.assign(Object.assign({}, e), {
                error: t.payload
              });
            case "setPointId":
              return Object.assign(Object.assign({}, e), {
                pointId: t.payload
              });
            case "setReducedAnswers":
              return Object.assign(Object.assign({}, e), {
                reducedAnswers: t.payload
              });
            case "setValue":
              return Object.assign(Object.assign({}, e), {
                value: t.payload
              });
          }
        };
      },
      9713: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(4206),
          a = s(r(2939)),
          u = r(5742),
          l = r(2851),
          c = r(2774),
          d = r(7311),
          v = s(r(1835)),
          p = r(5346),
          _ = s(r(8331));
        t.default = e => {
          var t, r, s;
          const {
              isPage: f,
              isWidget: h,
              isFeedback: m
            } = (0, n.useContext)(p.SurveyConfigContext),
            {
              point: g,
              answer: b,
              value: y,
              children: w,
              previewDevice: x
            } = e,
            S = (0, n.useMemo)(() => (0, o.randomizeAnswers)(g), [g]),
            k = {
              mobileQuestionNr: 0,
              pointAnswers: S,
              pointId: g.id,
              reducedAnswers: d.PreviewHelpers.reduceAnswers(S),
              selectedAnswers: y || new Array(g.answers.length).fill(0)
            },
            [T, M] = (0, n.useReducer)(c.matrixStateReducer, k),
            O = !!y,
            A = (e, t) => {
              M({
                payload: (0, l.getNewAnswers)(T, t)(e),
                type: "setAnswers"
              });
            },
            P = () => {
              b((0, u.getAnswerEventPayload)(T, e));
            },
            C = (0, v.default)(x);
          (0, n.useEffect)(() => {
            if (T.reducedAnswers !== d.PreviewHelpers.reduceAnswers(g.answers) && (M({
              payload: g.answers,
              type: "setPointAnswers"
            }), M({
              payload: d.PreviewHelpers.reduceAnswers(g.answers),
              type: "setReducedAnswers"
            })), g.answers.length !== T.selectedAnswers.length) {
              const e = Array.from({
                length: g.answers.length
              }, (e, t) => void 0 !== T.selectedAnswers[t] ? T.selectedAnswers[t] : 0);
              M({
                payload: e,
                type: "setAnswers"
              });
            }
          }, [g.answers]), (0, n.useEffect)(() => {
            M({
              payload: (0, o.randomizeAnswers)(g),
              type: "setPointAnswers"
            });
          }, [g.settings.randomize_answers, g.settings.randomize_except_last]);
          const E = (h || m) && (null === (t = T.pointAnswers) || void 0 === t ? void 0 : t.length) < 6 && (null === (s = null === (r = g.settings) || void 0 === r ? void 0 : r.scale) || void 0 === s ? void 0 : s.length) < 6;
          return C || !f && !E ? (0, i.h)(_.default, {
            point: g,
            pointAnswers: T.pointAnswers,
            selectedAnswers: T.selectedAnswers,
            selectAnswer: A,
            submit: P,
            hasNavigatedBackToQuestion: O
          }, w && [...w]) : (0, i.h)(a.default, {
            point: g,
            pointAnswers: T.pointAnswers,
            selectedAnswers: T.selectedAnswers,
            selectAnswer: A,
            submit: P
          }, w && [...w]);
        };
      },
      5992: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(6539)),
          o = s(r(3945)),
          a = s(r(3053));
        t.default = ({
          isOpen: e,
          setIsOpen: t,
          answer: r,
          selectedScaleText: s
        }) => {
          const u = {
            "sv--background-answer-opacity-10": !0,
            "sv__choice-button": !0,
            "sv__matrix-dropdown": !0,
            "sv__matrix-dropdown--closed": !e
          };
          return (0, i.h)("button", {
            "aria-label": `Choose answer: ${r.possible_answer}`,
            className: (0, a.default)(u),
            onClick: () => t(),
            onKeyDown: () => null,
            tabIndex: 0,
            type: "button"
          }, (0, i.h)("div", {
            className: "sv__matrix-answer"
          }, (0, i.h)(o.default, {
            className: "sv__answer-text sv-col-fa sv--color-answer",
            content: r.possible_answer
          }), (0, i.h)("div", {
            className: "sv__matrix-answer--selected"
          }, s)), (0, i.h)("div", {
            className: "sv__caret"
          }, (0, i.h)(n.default, null)));
        };
      },
      2939: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(717)),
          a = s(r(9547)),
          u = r(1617),
          l = r(5346),
          c = r(9027);
        t.default = e => {
          var t;
          const r = (0, n.useContext)(u.SubmitButtonContext),
            {
              surveyType: s
            } = (0, n.useContext)(l.SurveyConfigContext),
            {
              point: d,
              pointAnswers: v,
              selectedAnswers: p,
              selectAnswer: _,
              submit: f,
              children: h
            } = e,
            m = p.every(e => !!e);
          return (0, n.useEffect)(() => {
            r.disable(!m);
          }, [m]), (0, n.useEffect)(() => {
            r.render(!0);
          }, [v]), r.useEvent({
            surveyId: null === (t = c.storeManager.getStore(s).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: s
          }, f), (0, i.h)("div", {
            className: "sv__matrix-wrapper"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, h && [...h], (0, i.h)(o.default, {
            point: d
          }), v.map((e, t) => (0, i.h)(a.default, {
            isSelected: !!p[t],
            subQuestion: e.possible_answer,
            answersNumber: d.settings.scale.length,
            selectedAnswer: p[t],
            rowIndex: t,
            scale: d.settings.scale,
            selectAnswer: _,
            key: e.id
          }))));
        };
      },
      717: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(3053)),
          a = r(5346);
        t.default = ({
          point: e
        }) => {
          const {
              isWidget: t,
              isFeedback: r
            } = (0, n.useContext)(a.SurveyConfigContext),
            s = {
              "sv--color-answer": t || r,
              "sv__matrix-cell": !0
            };
          return (0, i.h)("div", {
            className: "sv__matrix-row"
          }, ["", ...e.settings.scale.map(e => e.name)].map(e => (0, i.h)("div", {
            key: e,
            className: (0, o.default)(s)
          }, e)));
        };
      },
      9296: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172),
          i = r(5994);
        t.default = ({
          isOpen: e,
          children: t,
          hasNavigatedBackToQuestion: r
        }) => {
          const [n, o] = (0, i.useState)(r || !e ? 0 : void 0),
            [a, u] = (0, i.useState)(!0),
            l = (0, i.useRef)(null);
          (0, i.useEffect)(() => {
            u(!1);
          }, []), (0, i.useEffect)(() => {
            let t = null;
            if (!a) return l.current && (o(l.current.scrollHeight), t = e ? window.setTimeout(() => o(void 0), 500) : window.setTimeout(() => o(0), 100)), () => {
              t && clearTimeout(t);
            };
          }, [e]);
          const c = {
            height: void 0 !== n ? `${n}px` : "auto",
            overflow: "hidden",
            transition: "height 500ms ease"
          };
          return (0, s.h)("div", {
            className: "sv__matrix-animation-wrapper",
            ref: l,
            style: c
          }, t);
        };
      },
      3344: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(4753),
          a = s(r(6912)),
          u = s(r(1492)),
          l = s(r(5992)),
          c = s(r(9296));
        t.default = ({
          answer: e,
          scale: t,
          selectAnswer: r,
          selectedAnswers: s,
          answerIndex: d,
          hasNavigatedBackToQuestion: v,
          toggleDropdown: p,
          isOpen: _
        }) => {
          var f, h;
          const m = (0, n.useRef)(null),
            g = s[d],
            b = null !== (h = null === (f = t.find(e => e.id === g)) || void 0 === f ? void 0 : f.name) && void 0 !== h ? h : "",
            [y, w] = (0, n.useState)(!0),
            x = s.every(e => !e);
          return (0, n.useEffect)(() => {
            w(!1);
          }, []), (0, n.useEffect)(() => {
            if (y) return;
            let e = null;
            return m.current && _ && !x && (e = window.setTimeout(() => {
              var e;
              null === (e = m.current) || void 0 === e || e.scrollIntoView({
                behavior: "smooth"
              });
            }, 600)), () => {
              e && clearTimeout(e);
            };
          }, [_]), (0, i.h)("div", {
            className: "sv__matrix-dropdown__wrapper",
            ref: m
          }, (0, i.h)(l.default, {
            isOpen: _,
            setIsOpen: () => {
              p(d, !1);
            },
            answer: e,
            selectedScaleText: b
          }), (0, i.h)(c.default, {
            isOpen: _,
            hasNavigatedBackToQuestion: v
          }, t.map(e => (0, i.h)(a.default, {
            dataTestid: `choice-button-${d}-${e.name}`,
            answer: (0, u.default)(e),
            display: o.CheckboxDisplay.circle,
            isSelected: g === e.id,
            key: e.name,
            select: () => {
              r(d, e.id), p(d);
            },
            shouldSkipTab: !_
          }))));
        };
      },
      9547: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(3249)),
          a = r(8243),
          u = r(4753),
          l = s(r(3945)),
          c = s(r(3053)),
          d = r(1461),
          v = r(5346);
        t.default = e => {
          const {
              isWidget: t,
              isFeedback: r
            } = (0, n.useContext)(v.SurveyConfigContext),
            {
              subQuestion: s,
              answersNumber: p,
              selectedAnswer: _,
              rowIndex: f,
              isSelected: h,
              scale: m,
              selectAnswer: g
            } = e,
            b = t || r,
            y = {
              "sv--background-answer-opacity-10": b,
              "sv__matrix-row": !0,
              sv__selected: h
            },
            w = {
              "sv--color-answer": b,
              "sv__matrix-cell": !0
            };
          return (0, i.h)("div", {
            className: (0, c.default)(y),
            "data-testid": `row-index=${f}`
          }, (0, i.h)("div", {
            className: (0, c.default)(w)
          }, (0, i.h)(l.default, {
            content: s
          })), Array.from({
            length: p
          }).map((e, t) => {
            const r = m[t].id;
            return (0, i.h)("div", Object.assign({
              className: (0, c.default)(w),
              key: r,
              onClick: () => g(f, r),
              onKeyUp: () => null,
              onFocus: e => (0, d.skipFocus)(e, "sv__input-checkbox"),
              role: "button",
              tabIndex: 0,
              "data-testid": r
            }, _ === r ? {
              "data-answerid": r
            } : {}), (0, i.h)(o.default, {
              testId: `checkbox-${f}-${r}`,
              display: u.CheckboxDisplay.circle,
              colors: a.CheckboxColors.bw,
              isSelected: _ === r,
              onKeyboardClick: () => g(f, r),
              onClick: () => g(f, r),
              label: `Choose answer: ${m[t].name} for ${s}`
            }));
          }));
        };
      },
      8331: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(1617),
          a = r(5346),
          u = s(r(579)),
          l = r(9027),
          c = s(r(3344));
        t.default = e => {
          var t;
          const r = (0, n.useContext)(o.SubmitButtonContext),
            {
              surveyType: s
            } = (0, n.useContext)(a.SurveyConfigContext),
            {
              children: d,
              selectedAnswers: v,
              submit: p,
              point: _,
              selectAnswer: f,
              pointAnswers: h,
              hasNavigatedBackToQuestion: m
            } = e,
            g = (0, n.useMemo)(() => v.every(e => !!e), [v]);
          (0, n.useEffect)(() => {
            r.render(g), r.disable(!1);
          }, [g]), r.useEvent({
            surveyId: null === (t = l.storeManager.getStore(s).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: s
          }, p);
          const [b, y] = (0, n.useState)([!m, ...new Array(h.length - 1).fill(!1)]);
          return (0, n.useEffect)(() => {
            const e = document.querySelector(".sv__survey-wrapper"),
              t = document.querySelector(".sv__survey"),
              r = "mobile" === l.storeManager.getStore(s).getState().previewDevice;
            return (u.default.isDeviceMobileOrTablet() || r) && e && t && (e.style.height = "100%", t.style.height = "80%"), () => {
              e && t && (e.style.height = "", t.style.height = "");
            };
          }, []), (0, n.useEffect)(() => {
            r.render(!1);
          }, []), (0, i.h)("div", {
            className: "sv__matrix-widget",
            tabIndex: -1
          }, d, h.map((e, t) => (0, i.h)(c.default, {
            answer: e,
            answerIndex: t,
            key: e.id,
            scale: _.settings.scale,
            selectedAnswers: v,
            hasNavigatedBackToQuestion: m,
            selectAnswer: f,
            toggleDropdown: (e, t) => ((e, t = !0) => {
              y(r => {
                const s = [...r];
                if (s[e] = !s[e], t) {
                  const t = v.findIndex((t, r) => 0 === t && r > e);
                  -1 !== t && (s[t] = !0);
                }
                return s;
              });
            })(e, t),
            isOpen: b[t]
          })));
        };
      },
      1492: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => ({
          id: e.id,
          next_survey_point_id: null,
          possible_answer: e.name,
          user_tag: null
        });
      },
      5742: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getAnswerEventPayload = void 0;
        t.getAnswerEventPayload = (e, t) => {
          const r = e.pointAnswers.reduce((r, s, i) => {
            const n = t.point.settings.scale[e.selectedAnswers[i]];
            return `${r}, ${s.possible_answer}: ${n}`;
          }, "");
          return {
            anonymizedTextResponse: r,
            answers: e.selectedAnswers.map((r, s) => ({
              content: `${r}`,
              nextSurveyPointId: t.point.settings.next_survey_point_id,
              survey_question_answer_id: e.pointAnswers[s].id,
              user_tag: e.pointAnswers[s].user_tag
            })),
            textResponse: r,
            value: e.selectedAnswers
          };
        };
      },
      2851: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getNewAnswers = void 0;
        t.getNewAnswers = (e, t) => r => {
          const s = e.selectedAnswers.slice();
          return s[r] = t, s;
        };
      },
      2774: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.matrixStateReducer = void 0;
        t.matrixStateReducer = (e, t) => {
          switch (t.type) {
            case "setPointId":
              return Object.assign(Object.assign({}, e), {
                pointId: t.payload
              });
            case "setAnswers":
              return Object.assign(Object.assign({}, e), {
                selectedAnswers: t.payload
              });
            case "setMobileQuestionNr":
              return Object.assign(Object.assign({}, e), {
                mobileQuestionNr: t.payload
              });
            case "setPointAnswers":
              return Object.assign(Object.assign({}, e), {
                pointAnswers: t.payload
              });
            case "setReducedAnswers":
              return Object.assign(Object.assign({}, e), {
                reducedAnswers: t.payload
              });
          }
        };
      },
      4039: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(4998)),
          a = s(r(3053)),
          u = r(5346),
          l = s(r(5575)),
          c = s(r(579)),
          d = r(4397),
          v = r(9027),
          p = r(3614),
          _ = r(1617);
        t.default = e => {
          var t;
          const r = (0, n.useContext)(_.SubmitButtonContext),
            {
              isPage: s,
              surveyType: f
            } = (0, n.useContext)(u.SurveyConfigContext),
            {
              value: h,
              point: m,
              children: g,
              previewDevice: b
            } = e,
            {
              answers: y,
              settings: w
            } = m,
            {
              text_on_the_left: x,
              text_on_the_right: S,
              mandatory_submit_button: k
            } = w,
            T = l.default.params.aid,
            M = y.find(({
              id: e
            }) => e === Number(T)),
            [O, A] = (0, n.useState)(null != h ? h : M),
            P = o.default.isMicroTheme(f),
            C = b === d.PreviewDevice.mobile || b !== d.PreviewDevice.desktop && c.default.isWidthMobile(),
            E = C && s || C && P && e.point.answers.length >= 6,
            I = t => {
              O || k ? A(t) : e.answer((0, p.getScaleAnswerEvent)({
                answer: t,
                point: e.point
              }));
            },
            j = {
              "sv__numerical-scale": !0,
              "sv__numerical-scale--mobile": E,
              "sv__numerical-scale--vertical": E
            },
            N = {
              sv__buttons: !0,
              "sv__buttons--vertical": E,
              "sv__numerical-scale__buttons": !0
            },
            D = e => {
              const t = {
                "sv--background-answer-opacity-10": !0,
                "sv--color-answer": !0,
                sv__button: !0,
                sv__selected: e.id === (null == O ? void 0 : O.id)
              };
              return (0, a.default)(t);
            };
          return (0, n.useEffect)(() => {
            r.render(!!O || !!T || !!k);
          }, [O, k]), (0, n.useEffect)(() => {
            r.disable(!O);
          }, [O]), r.useEvent({
            surveyId: null === (t = v.storeManager.getStore(f).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: f
          }, () => {
            O && e.answer((0, p.getScaleAnswerEvent)({
              answer: O,
              point: e.point
            }));
          }), (0, i.h)("div", {
            className: (0, a.default)(j)
          }, (0, i.h)("div", {
            className: "sv__numerical-scale__wrapper"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, g && [...g], (0, i.h)("div", {
            className: (0, a.default)(N)
          }, y.map((e, t) => (0, i.h)("div", {
            className: D(e),
            key: e.id,
            onClick: () => I(e),
            onKeyDown: () => I(e),
            onKeyUp: () => null,
            role: "button",
            tabIndex: 0,
            "data-testid": e.id
          }, ((e, t) => E ? 0 === t && x ? `${e} - ${x}` : t === y.length - 1 && S ? `${e} - ${S}` : e : e)(e.possible_answer, t)))), !E && (0, i.h)("div", {
            className: "sv__labels"
          }, x && (0, i.h)("div", {
            className: "sv__label sv__label--left sv--color-answer"
          }, x), S && (0, i.h)("div", {
            className: "sv__label sv__label--right sv--color-answer"
          }, S)))));
        };
      },
      9633: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(2633)),
          a = s(r(4998)),
          u = s(r(3053)),
          l = r(1406),
          c = r(5346),
          d = s(r(5575)),
          v = s(r(579)),
          p = r(4397),
          _ = r(9027),
          f = r(3614),
          h = s(r(489)),
          m = r(1617);
        t.default = e => {
          var t;
          const r = (0, n.useContext)(m.SubmitButtonContext),
            {
              surveyType: s
            } = (0, n.useContext)(c.SurveyConfigContext),
            {
              point: {
                answers: g,
                settings: b
              },
              value: y,
              children: w,
              previewDevice: x
            } = e,
            {
              shape: S,
              text_on_the_left: k,
              text_on_the_right: T,
              mandatory_submit_button: M
            } = b,
            O = d.default.params.aid,
            A = g.find(({
              id: e
            }) => e === Number(O)),
            [P, C] = (0, n.useState)(y || A),
            [E, I] = (0, n.useState)(void 0),
            j = a.default.isMicroTheme(s),
            N = x === p.PreviewDevice.mobile || x !== p.PreviewDevice.desktop && v.default.isWidthMobile(),
            D = N && j && e.point.answers.length >= 6,
            L = t => {
              P || M ? C(t) : e.answer((0, f.getScaleAnswerEvent)({
                answer: t,
                point: e.point
              }));
            },
            R = e => {
              I(e);
            },
            B = {
              sv__rating: !0,
              "sv__rating--short": e.point.answers.length <= 7,
              "sv__rating--vertical": D,
              "sv__short-rating": e.point.answers.length <= 7
            },
            q = {
              sv__buttons: !0,
              "sv__buttons--vertical": D,
              sv__rating__buttons: !0
            },
            F = e => {
              const t = e <= g.findIndex(({
                  id: e
                }) => e === (null == P ? void 0 : P.id)),
                r = void 0 !== E && e <= E,
                s = {
                  "sv--background-answer-opacity-10": D,
                  "sv-rating": !0,
                  "sv-rating-selected": t || r,
                  sv__button: !0,
                  "sv__button--selected": t || r && !N
                };
              return (0, u.default)(s);
            },
            V = {
              highestValueText: T,
              lowestValueText: k
            };
          return (0, n.useEffect)(() => {
            r.render(!!P || !!O || !!M);
          }, [P, M]), (0, n.useEffect)(() => {
            r.disable(!P);
          }, [P]), r.useEvent({
            surveyId: null === (t = _.storeManager.getStore(s).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: s
          }, () => {
            P && e.answer((0, f.getScaleAnswerEvent)({
              answer: P,
              point: e.point
            }));
          }), (0, i.h)("div", {
            className: (0, u.default)(B)
          }, (0, i.h)("div", {
            className: "sv__rating__wrapper"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, w && [...w], (0, i.h)("div", {
            className: (0, u.default)(q)
          }, [...g].map((e, t) => {
            const r = {
              current: t,
              last: g.length - 1
            };
            return (0, i.h)("button", {
              "aria-label": `Choose rating answer: ${e.possible_answer}`,
              key: e.id,
              type: "button",
              "data-value": e.possible_answer,
              className: F(t),
              onClick: () => L(e),
              onKeyDown: t => (0, l.keyboardClick)(t, () => L(e), {
                preventDefault: !0
              }),
              onMouseOver: () => R(t),
              onMouseOut: () => R(void 0),
              onFocus: () => R(t),
              onBlur: () => R(void 0),
              "data-testid": e.id
            }, (0, i.h)(o.default, {
              shape: S
            }), (0, i.h)("div", {
              className: "sv__rating__number sv-col-fa sv--color-answer"
            }, (0, i.h)(h.default, Object.assign({}, D && {
              content: V
            }, {
              answer: e.possible_answer,
              indexes: r
            }))));
          })), !D && (0, i.h)("div", {
            className: "sv__labels sv-col-fw sv--color-answer"
          }, k && (0, i.h)("div", {
            className: "sv__label sv__label--left sv--color-answer"
          }, k), T && (0, i.h)("div", {
            className: "sv__label sv__label--right sv--color-answer"
          }, T)))));
        };
      },
      2633: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172),
          i = r(3501);
        t.default = ({
          shape: e
        }) => {
          switch (e.toLowerCase()) {
            case i.RatingShape.thumbs:
              return (0, s.h)("svg", {
                viewBox: "3.90125 3.62625 55.96725 52.51425",
                xmlns: "http://www.w3.org/2000/svg"
              }, (0, s.h)("path", {
                d: "M45.958 55H19.703V21.919L37.622 4l3.085 3.02c.284.327.52.738.705 1.23.186.492.28.957.28 1.395v.853l-2.823 11.42h14.965c1.29 0 2.434.499 3.43 1.494.995.996 1.493 2.139 1.493 3.43v5.12c0 .306-.028.628-.082.968-.055.339-.137.65-.246.935l-7.746 18.05c-.372.875-1.012 1.608-1.92 2.199-.907.59-1.843.886-2.805.886zM14.78 21.919V55H5V21.919h9.78z",
                fill: "#D1D2D1",
                "fill-rule": "nonzero"
              }));
            case i.RatingShape.stars:
              return (0, s.h)("svg", {
                viewBox: "4.33125 4.05625 54.3375 50.8875",
                xmlns: "http://www.w3.org/2000/svg"
              }, (0, s.h)("path", {
                d: "m15.255 55 4.394-18.874L5 23.453l19.317-1.67L31.846 4l7.529 17.784 19.316 1.669-14.649 12.673L48.437 55 31.846 44.984z",
                fill: "#D1D2D1",
                "fill-rule": "nonzero"
              }));
            default:
              return (0, s.h)("svg", {
                viewBox: "2.78125 2.50625 57.154375 53.431875",
                xmlns: "http://www.w3.org/2000/svg"
              }, (0, s.h)("path", {
                d: "m31.818 55-3.852-3.46c-4.72-4.259-8.622-7.933-11.707-11.022-3.085-3.09-5.537-5.856-7.358-8.3-1.82-2.445-3.092-4.691-3.816-6.74A18.742 18.742 0 0 1 4 19.193c0-4.328 1.45-7.942 4.35-10.842C11.252 5.45 14.866 4 19.194 4c2.439 0 4.76.523 6.965 1.57 2.204 1.045 4.091 2.543 5.66 4.493 1.64-1.95 3.543-3.448 5.706-4.494A15.69 15.69 0 0 1 44.444 4c4.327 0 7.941 1.45 10.842 4.35 2.9 2.901 4.35 6.515 4.35 10.843 0 2.142-.361 4.237-1.085 6.285-.723 2.049-1.996 4.295-3.816 6.74-1.82 2.444-4.273 5.21-7.358 8.3-3.084 3.089-6.987 6.763-11.707 11.023L31.818 55z",
                fill: "#D1D2D1",
                "fill-rule": "nonzero"
              }));
          }
        };
      },
      3219: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172);
        t.default = ({
          smileyIcon: e
        }) => {
          if (!e) throw new Error("Invalid Smiley Type");
          return (0, s.h)("div", {
            role: "img",
            "aria-label": e.ariaLabel,
            className: `sv__smiley-scale__icon-container ${e.className}`,
            "data-testid": e.ariaLabel
          });
        };
      },
      9145: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.smileyIcons = void 0;
        const s = r(3501);
        t.smileyIcons = {
          [s.SmileyScalePossibleAnswers.verySad]: {
            ariaLabel: "very sad",
            className: "sv__very-sad"
          },
          [s.SmileyScalePossibleAnswers.sad]: {
            ariaLabel: "sad",
            className: "sv__sad"
          },
          [s.SmileyScalePossibleAnswers.neutral]: {
            ariaLabel: "neutral",
            className: "sv__neutral"
          },
          [s.SmileyScalePossibleAnswers.happy]: {
            ariaLabel: "happy",
            className: "sv__happy"
          },
          [s.SmileyScalePossibleAnswers.veryHappy]: {
            ariaLabel: "very happy",
            className: "sv__very-happy"
          }
        };
      },
      9649: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(3219)),
          a = r(9145),
          u = s(r(3053)),
          l = r(1406),
          c = r(5346),
          d = s(r(5575)),
          v = r(9027),
          p = r(3614),
          _ = r(1617);
        t.default = e => {
          var t;
          const r = (0, n.useContext)(_.SubmitButtonContext),
            {
              surveyType: s
            } = (0, n.useContext)(c.SurveyConfigContext),
            {
              point: {
                answers: f,
                settings: h
              },
              value: m,
              children: g
            } = e,
            {
              text_on_the_left: b,
              text_on_the_right: y,
              mandatory_submit_button: w
            } = h,
            x = d.default.params.aid,
            S = f.find(({
              id: e
            }) => e === Number(x)),
            [k, T] = (0, n.useState)(m || S),
            M = t => {
              k || w ? T(t) : e.answer((0, p.getScaleAnswerEvent)({
                answer: t,
                point: e.point
              }));
            },
            O = {
              "sv__smiley-scale": !0,
              "sv__three-smileys": 3 === e.point.answers.length
            },
            A = e => {
              const t = {
                sv__selected: e.id === (null == k ? void 0 : k.id),
                "sv__smiley-scale__button": !0,
                [`sv__btn-${e.possible_answer.split(" ").join("_")}`]: !0
              };
              return (0, u.default)(t);
            };
          return (0, n.useEffect)(() => {
            r.render(!!k || !!x || !!w);
          }, [k, w]), (0, n.useEffect)(() => {
            r.disable(!k);
          }, [k]), r.useEvent({
            surveyId: null === (t = v.storeManager.getStore(s).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: s
          }, () => {
            k && e.answer((0, p.getScaleAnswerEvent)({
              answer: k,
              point: e.point
            }));
          }), (0, i.h)("div", {
            className: (0, u.default)(O)
          }, (0, i.h)("div", {
            className: "sv__smiley-scale__wrapper"
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, g && [...g], (0, i.h)("div", {
            className: "sv__smiley-scale__buttons"
          }, f.map(e => (0, i.h)("button", {
            "aria-label": `Choose smiley: ${e.possible_answer}`,
            key: e.id,
            className: A(e),
            type: "button",
            onClick: () => M(e),
            onKeyDown: t => (0, l.keyboardClick)(t, () => M(e), {
              preventDefault: !0
            }),
            "data-testid": e.id
          }, (0, i.h)(o.default, {
            smileyIcon: a.smileyIcons[e.possible_answer]
          })))), (0, i.h)("div", {
            className: "sv__labels sv-col-fw"
          }, b && (0, i.h)("div", {
            className: "sv__label sv__label--left sv--color-answer"
          }, b), y && (0, i.h)("div", {
            className: "sv__label sv__label--right sv--color-answer"
          }, y)))));
        };
      },
      9133: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(7826)),
          a = s(r(3053)),
          u = s(r(6733)),
          l = r(5346),
          c = r(2214),
          d = r(9027),
          v = s(r(8697)),
          p = r(1617),
          _ = s(r(4998));
        t.default = e => {
          var t;
          const r = (0, n.useContext)(p.SubmitButtonContext),
            {
              surveyType: s
            } = (0, n.useContext)(l.SurveyConfigContext),
            {
              answer: f,
              answerRequiredText: h,
              point: m,
              textPlaceholder: g,
              children: b,
              value: y
            } = e,
            [w, x] = (0, n.useState)({
              content: null != y ? y : "",
              error: !1,
              pointId: m.id
            }),
            {
              error: S,
              content: k
            } = w,
            {
              settings: {
                mandatory: T
              }
            } = m,
            M = {
              "sv--background-answer-opacity-10": !0,
              "sv--color-answer": !0,
              "sv-border-color-main": _.default.isSimpleTheme(s),
              "sv-invalid": S,
              "sv__text-question": !0,
              sv__textarea: !0
            };
          return (0, n.useEffect)(() => {
            r.disable(!k && m.settings.mandatory);
          }, [k, m.settings.mandatory]), r.useEvent({
            surveyId: null === (t = d.storeManager.getStore(s).getState().surveyState.survey) || void 0 === t ? void 0 : t.id,
            surveyType: s
          }, () => {
            const {
              next_survey_point_id: e,
              user_tag: t,
              mandatory: r
            } = m.settings;
            if (!k && r) return x(e => Object.assign(Object.assign({}, e), {
              error: !0
            })), void (() => {
              const e = document.querySelector(".sv__survey textarea");
              e && e.focus();
            })();
            const s = (0, c.sanitizeString)(k);
            f({
              anonymizedTextResponse: "",
              answers: [{
                content: s,
                nextSurveyPointId: e,
                user_tag: t
              }],
              textResponse: s,
              value: s
            });
          }), (0, i.h)("div", {
            className: (0, a.default)({
              "sv__text-question": !0,
              "sv__text-question-wrapper": !0
            })
          }, (0, i.h)("div", {
            className: "sv__scroll-container"
          }, b && [...b], (0, i.h)(o.default, {
            invalid: S,
            type: "text"
          }, (0, i.h)(v.default, {
            shouldShow: T,
            text: h
          }), (0, i.h)("textarea", {
            "aria-labelledby": h,
            className: (0, a.default)(M),
            placeholder: g,
            value: k,
            onInput: e => {
              (e => {
                e.preventDefault();
                let t = "";
                e.target instanceof HTMLTextAreaElement && ((0, u.default)(e.target), t = e.target.value), x(e => Object.assign(Object.assign({}, e), {
                  content: t,
                  error: !1
                }));
              })(e);
            },
            "data-gramm_editor": "false",
            "data-testid": "text-area"
          }))));
        };
      },
      4998: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(5285),
          i = r(1335),
          n = r(9027),
          o = r(5595);
        class a {
          static isSurveyUp(e) {
            const {
              survey: t
            } = n.storeManager.getStore(e).getState().surveyState;
            if (t) return t.presentation_style === o.WidgetPosition.topLeft || t.presentation_style === o.WidgetPosition.topRight;
            throw new Error("No survey, when looking at isSurveyUp.");
          }
          static isBackgroundLight(e) {
            const {
              theme: t
            } = n.storeManager.getStore(e).getState().surveyState;
            return !t || (0, s.getLuminosity)(t.color_scheme.bg_widget) < .6;
          }
          static isSimpleTheme(e) {
            return a.themeType(e) === i.ThemeType.simple;
          }
          static isMicroTheme(e) {
            return a.themeType(e) === i.ThemeType.micro;
          }
          static isMobileTheme(e) {
            return a.themeType(e) === i.ThemeType.mobile;
          }
          static themeType(e) {
            const {
              theme: t
            } = n.storeManager.getStore(e).getState().surveyState;
            return t ? t.type : null;
          }
        }
        t.default = a;
      },
      8697: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172);
        t.default = ({
          text: e,
          shouldShow: t
        }) => t && e ? (0, s.h)("p", {
          className: "sv__answer-hint sv--color-answer",
          "data-testid": "answer-hint"
        }, e) : null;
      },
      489: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172);
        t.default = e => {
          const {
              answer: t,
              content: r,
              indexes: {
                current: i,
                last: n
              }
            } = e,
            {
              lowestValueText: o,
              highestValueText: a
            } = r || {};
          return (0, s.h)(s.Fragment, null, `${t}${o && 0 === i ? ` - ${o}` : a && i === n ? ` - ${a}` : ""}`);
        };
      },
      3249: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(3e3)),
          a = r(8243),
          u = r(4753),
          l = s(r(3053)),
          c = r(1406),
          d = r(5346);
        t.default = e => {
          const {
              display: t,
              colors: r,
              invalid: s,
              isSelected: v,
              testId: p,
              shouldSkipTab: _,
              label: f
            } = e,
            {
              isPage: h
            } = (0, n.useContext)(d.SurveyConfigContext),
            m = t === u.CheckboxDisplay.circle,
            g = !h && m,
            [b, y] = (0, n.useState)(!1),
            w = e => {
              var t;
              (null === (t = e.currentTarget) || void 0 === t ? void 0 : t.parentElement) && y("focus" === e.type);
            },
            x = {
              "sv--background-answer": m && v,
              "sv--color-answer": m,
              "sv-bg-bw": !h && r === a.CheckboxColors.bw,
              "sv-bg-main": m && v,
              "sv-border-color-answer": !m,
              "sv-invalid": s || !1,
              "sv-nested-bg-bw": !h && r !== a.CheckboxColors.bw,
              sv__checkbox: !0,
              "sv__checkbox--focused": b,
              sv__circle: m,
              sv__selected: (h || g) && v,
              sv__square: !m
            },
            S = {
              "sv-bg-fa": h || g,
              "sv-checkbox-tick-border-color": !0,
              sv__tick: !0
            },
            k = {
              "aria-checked": v,
              "aria-label": f,
              checked: v,
              className: "sv__hide-input sv__input-checkbox",
              id: p,
              onBlur: w,
              onClick: t => e.onClick(t),
              onFocus: w,
              onKeyDown: t => (0, c.keyboardClick)(t, () => e.onKeyboardClick(t), {
                preventDefault: !0,
                stopPropagation: !0
              }),
              tabIndex: _ ? -1 : 0,
              type: m ? "radio" : "checkbox"
            };
          return (0, i.h)("div", {
            className: (0, l.default)(x),
            "data-testid": p
          }, (0, i.h)("input", Object.assign({}, k)), (0, i.h)("label", {
            htmlFor: p,
            className: "checkbox-label"
          }, v && (m ? (0, i.h)("span", {
            "data-testid": "tick",
            className: (0, l.default)(S)
          }) : (0, i.h)(o.default, null))));
        };
      },
      8243: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.CheckboxColors = void 0, function (e) {
          e[e.bw = 0] = "bw", e[e.nestedInBw = 1] = "nestedInBw";
        }(r || (t.CheckboxColors = r = {}));
      },
      4753: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.CheckboxDisplay = void 0, function (e) {
          e[e.circle = 0] = "circle", e[e.square = 1] = "square";
        }(r || (t.CheckboxDisplay = r = {}));
      },
      3945: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172);
        t.default = ({
          content: e,
          className: t = "",
          inline: r = !1
        }) => r ? (0, s.h)("span", {
          className: t,
          dangerouslySetInnerHTML: {
            __html: e
          }
        }) : (0, s.h)("div", {
          className: t,
          dangerouslySetInnerHTML: {
            __html: e
          }
        });
      },
      7311: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.PreviewHelpers = void 0;
        t.PreviewHelpers = class {
          static getChangedAnswers(e, t) {
            const r = this.filterMissingAnswers(e, t),
              s = this.addMissingAnswers(e, r);
            return this.getModifiedAnswers(e.answers, s);
          }
          static filterMissingAnswers(e, t) {
            const r = e.answers;
            return e.settings.randomize_answers ? t.filter(e => r.some(t => e.id === t.id)) : r;
          }
          static addMissingAnswers(e, t) {
            const r = t,
              s = e.answers.filter(e => !t.some(t => t.id === e.id));
            return e.settings.randomize_answers && !e.settings.randomize_except_last ? (s.forEach(e => {
              r.splice(Math.floor(Math.random() * r.length) + 1, 0, e);
            }), r) : t.concat(s);
          }
          static getModifiedAnswers(e, t) {
            return t.map(t => Object.assign(Object.assign({}, t), {
              possible_answer: e.find(e => e.id === t.id).possible_answer
            }));
          }
          static reduceAnswers(e) {
            return e.reduce((e, t) => `${e}${t.possible_answer}${t.add_comment}${t.next_survey_point_id}`, "");
          }
          static reduceContactForm(e) {
            const t = e.fields.reduce((e, t) => `${e}${t.label}${t.required}`, "");
            let r, s;
            if (e.settings) {
              const {
                consent: t,
                disclaimer: i,
                consent_text: n,
                disclaimer_text: o
              } = e.settings;
              r = t ? n : "", s = i ? o : "";
            }
            return `${t}${r}${s}`;
          }
          static reorderContactFormValues(e, t, r) {
            return t.map(t => {
              const s = r.findIndex(e => e.id === t.id);
              return -1 !== s ? e[s] : "";
            });
          }
        };
      },
      7290: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172);
        t.default = ({
          text: e,
          highlight: t
        }) => {
          const r = t ? e.toLowerCase().indexOf(t.toLowerCase()) : -1;
          return -1 === r ? (0, s.h)("span", null, e) : (0, s.h)("span", null, e.substring(0, r), (0, s.h)("strong", null, e.substring(r, r + t.length)), e.substring(r + t.length, e.length), " ");
        };
      },
      7755: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(1472),
          a = s(r(2060)),
          u = s(r(9171)),
          l = s(r(4998)),
          c = s(r(7826)),
          d = s(r(3053)),
          v = r(5346),
          p = r(1617);
        t.default = ({
          options: e,
          inputValue: t,
          onSelect: r,
          showClearButton: s,
          isFocusable: _,
          isError: f,
          allowSearch: h,
          dropdownPlaceholder: m,
          shouldHideSubmitButton: g
        }) => {
          var b, y;
          const w = (0, n.useContext)(p.SubmitButtonContext),
            {
              isWidget: x,
              surveyType: S
            } = (0, n.useContext)(v.SurveyConfigContext),
            k = (0, n.useRef)(null),
            T = (0, n.useRef)(null),
            M = e.find(e => e.value === t) || null,
            O = {
              focusPosition: -1,
              isOpen: !1,
              search: M ? M.label : "",
              selected: M
            },
            A = e => {
              (null == k ? void 0 : k.current) && (e.composedPath().includes(k.current) || (E({
                payload: -1,
                type: "setFocusPosition"
              }), E({
                payload: !1,
                type: "setIsOpen"
              })));
            },
            P = e => {
              if (!_) return;
              const t = k.current;
              t && t.classList.toggle("sv__select--border", e);
            },
            [C, E] = (0, n.useReducer)(o.selectStateReducer, O),
            I = e => {
              let t = "";
              e.target instanceof HTMLInputElement && (t = e.target.value), E({
                payload: !!D().length,
                type: "setIsOpen"
              }), E({
                payload: t,
                type: "setSearch"
              }), E({
                payload: null,
                type: "setSelected"
              }), r("");
            },
            j = e => {
              C.isOpen && e.target.blur(), E({
                payload: !C.isOpen,
                type: "setIsOpen"
              }), E({
                payload: "",
                type: "setSearch"
              });
            },
            N = e => {
              E({
                payload: 0,
                type: "setFocusPosition"
              }), E({
                payload: !1,
                type: "setIsOpen"
              }), E({
                payload: "",
                type: "setSearch"
              }), E({
                payload: e,
                type: "setSelected"
              }), r(e.value);
            },
            D = () => {
              const {
                search: t,
                selected: r
              } = C;
              return (null == r ? void 0 : r.label) ? e.filter(e => e.value !== r.value) : t ? e.filter(e => e.label.toLowerCase().includes(t.toLowerCase())) : e;
            },
            L = (e, t) => {
              const r = D()[C.focusPosition];
              switch (e.key) {
                case "Enter":
                case " ":
                  return e.preventDefault(), t && (j(e), E({
                    payload: 0,
                    type: "setFocusPosition"
                  })), void (C.isOpen && r && N(r));
                case "Escape":
                  return e.preventDefault(), void E({
                    payload: !1,
                    type: "setIsOpen"
                  });
                case "Tab":
                  return void (C.isOpen && E({
                    payload: !1,
                    type: "setIsOpen"
                  }));
                case "ArrowUp":
                  return C.isOpen || E({
                    payload: !0,
                    type: "setIsOpen"
                  }), void R(-1);
                case "ArrowDown":
                  C.isOpen || E({
                    payload: !0,
                    type: "setIsOpen"
                  }), R(1);
              }
            },
            R = e => {
              const t = D().length;
              if (!t) return;
              const r = (C.focusPosition + e + t) % t;
              E({
                payload: r,
                type: "setFocusPosition"
              });
            },
            B = !!(null === (b = null == T ? void 0 : T.current) || void 0 === b ? void 0 : b.value) && s,
            q = !D().length || !!f,
            F = {
              "sv-invalid": q,
              sv__select: !0,
              "sv__select--open": C.isOpen,
              "sv__survey-up": x && l.default.isSurveyUp(S)
            };
          return (0, n.useEffect)(() => (document.addEventListener("click", A, !1), () => {
            document.removeEventListener("click", A, !1);
          }), []), (0, n.useEffect)(() => {
            const r = e.find(e => e.value === t) || null;
            E({
              payload: r ? r.label : "",
              type: "setSearch"
            }), E({
              payload: r,
              type: "setSelected"
            });
          }, [t]), (0, n.useEffect)(() => {
            g && w.hide(C.isOpen);
          }, [C.isOpen]), (0, i.h)("div", {
            ref: k,
            "data-testid": "select",
            className: (0, d.default)(F)
          }, (0, i.h)(c.default, {
            invalid: q,
            type: "select"
          }, (0, i.h)("input", {
            "aria-label": "Select an answer from the list",
            ref: T,
            className: "sv__input sv--color-answer sv--background-answer-opacity-10",
            type: "text",
            value: C.search || (null === (y = C.selected) || void 0 === y ? void 0 : y.label),
            onInput: I,
            onKeyDown: L,
            placeholder: m,
            onClick: j,
            autoComplete: "off",
            readOnly: !h,
            "data-testid": "select-input",
            tabIndex: 0,
            onFocus: () => P(!0),
            onBlur: e => {
              var t;
              (null === (t = k.current) || void 0 === t ? void 0 : t.contains(e.relatedTarget)) || P(!1);
            }
          })), C.isOpen && !!D().length && (0, i.h)(u.default, {
            selectOption: N,
            search: C.search,
            position: C.focusPosition,
            options: D()
          }), (0, i.h)(a.default, {
            shouldShowClearButton: B,
            clearInput: () => {
              E({
                payload: "",
                type: "setSearch"
              }), E({
                payload: null,
                type: "setSelected"
              }), B && T.current && (r(""), E({
                payload: -1,
                type: "setFocusPosition"
              }), T.current.value = "");
            },
            toggleDropdown: j,
            searchHandler: I,
            keyDownHandler: L,
            isFocusable: _
          }));
        };
      },
      2060: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(6539)),
          a = s(r(2994)),
          u = s(r(4998)),
          l = s(r(3053)),
          c = r(5346);
        t.default = ({
          shouldShowClearButton: e,
          clearInput: t,
          toggleDropdown: r,
          searchHandler: s,
          keyDownHandler: d,
          isFocusable: v
        }) => {
          const {
              isPage: p,
              surveyType: _
            } = (0, n.useContext)(c.SurveyConfigContext),
            f = u.default.isMicroTheme(_);
          return (0, i.h)("div", {
            className: (0, l.default)({
              "sv__select-buttons": !0,
              sv__select__buttons: !0
            })
          }, e && (p || f) && (0, i.h)("button", {
            "aria-label": "Close the dropdown",
            title: "Close",
            type: "button",
            onClick: t,
            onKeyDown: t,
            className: (0, l.default)({
              "sv__clear-input-icon": !0,
              "sv__select-icon": !0,
              "sv__select__clear-input": !0
            }),
            "data-testid": "clear-button",
            tabIndex: 0
          }, (0, i.h)(a.default, {
            tabIndex: -1
          })), (0, i.h)("div", {
            className: "sv__caret sv__select-icon",
            onClick: r,
            onInput: s,
            onKeyDown: e => d(e, !0),
            role: "button",
            tabIndex: v ? -1 : 0
          }, (p || f) && !e && (0, i.h)(o.default, null)));
        };
      },
      9171: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(7290)),
          a = s(r(3053)),
          u = r(1406),
          l = r(5346);
        t.default = e => {
          const {
              isPage: t
            } = (0, n.useContext)(l.SurveyConfigContext),
            r = r => {
              const s = r === e.position;
              return (0, a.default)({
                "sv--background-main": !0,
                "sv--color-answer": !t,
                "sv-col-fa": !t,
                "sv-nested-bg-bw": !t,
                "sv-nested-bg-hover-bw": !t,
                "sv-nested-bg-selected-bw": !t && s,
                "sv__select-button": !0,
                "sv__select-button--focused": s
              });
            };
          return (0, i.h)("ul", {
            "data-testid": "select-list",
            className: "sv__select-list sv--background-main"
          }, e.options.map((t, s) => (0, i.h)("li", {
            "data-testid": "select-list-element",
            className: "sv__select-list__element",
            key: t.value
          }, (0, i.h)("button", {
            tabIndex: 0,
            "aria-label": `Select option: ${t.label}`,
            className: r(s),
            type: "button",
            onClick: () => e.selectOption(t),
            onKeyDown: r => (0, u.keyboardClick)(r, () => e.selectOption(t)),
            "data-testid": `select-list-button-${s}`
          }, (0, i.h)(o.default, {
            text: t.label,
            highlight: e.search
          })))));
        };
      },
      1472: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.selectStateReducer = void 0;
        t.selectStateReducer = (e, t) => {
          switch (t.type) {
            case "setFocusPosition":
              return Object.assign(Object.assign({}, e), {
                focusPosition: t.payload
              });
            case "setIsOpen":
              return Object.assign(Object.assign({}, e), {
                isOpen: t.payload
              });
            case "setSearch":
              return Object.assign(Object.assign({}, e), {
                search: t.payload
              });
            case "setSelected":
              return Object.assign(Object.assign({}, e), {
                selected: t.payload
              });
          }
        };
      },
      9438: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(5448),
          a = s(r(3053)),
          u = r(1406),
          l = r(1617);
        t.default = () => {
          const e = (0, n.useContext)(l.SubmitButtonContext),
            t = {
              "sv--background-button": !0,
              "sv-bg-bs": !0,
              "sv-col-fs": !0,
              "sv__submit-button": !0,
              "sv__submit-button--hidden": e.isHidden
            },
            r = {
              "sv__submit-button__wrapper": !0,
              "sv__submit-button__wrapper--moved-up": e.shouldMoveUp
            },
            s = (e, t) => {
              (e => {
                e.stopPropagation(), e.preventDefault();
              })(e), t();
            };
          return (0, i.h)("div", {
            className: (0, a.default)(r)
          }, (0, i.h)("button", {
            "aria-label": "Submit survey question",
            disabled: e.isDisabled,
            type: "button",
            className: (0, a.default)(t),
            onClick: t => {
              s(t, () => {
                t.target instanceof HTMLButtonElement && t.target.blur(), e.onSubmit();
              });
            },
            onKeyDown: t => {
              "Tab" !== t.key && s(t, () => {
                (0, u.keyboardClick)(t, e.onSubmit, {
                  preventDefault: !0
                });
              });
            },
            "data-testid": "submit-button",
            tabIndex: 0
          }, (0, o.decodeHTMLEntities)(e.text), (0, i.h)("span", {
            className: "sv__submit-button-next-arrow"
          })));
        };
      },
      1617: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SubmitButtonProvider = t.ConnectedSubmitButtonProvider = t.SubmitButtonContext = void 0;
        const i = r(172),
          n = r(5994),
          o = r(9635),
          a = s(r(1835)),
          u = r(4409),
          l = r(4539),
          c = r(7057),
          d = r(8200),
          v = r(4073),
          p = r(3501),
          _ = r(5346),
          f = r(9027),
          h = r(7189),
          m = r(8298),
          g = {
            disable: () => {},
            hide: () => {},
            isDisabled: !1,
            isHidden: !1,
            isVisible: !0,
            moveUp: () => {},
            onSubmit: () => {},
            render: () => {},
            setText: () => {},
            shouldMoveUp: !1,
            text: "Submit",
            useEvent: () => {}
          };
        t.SubmitButtonContext = (0, i.createContext)(g);
        t.ConnectedSubmitButtonProvider = ({
          survey: e,
          surveyPoint: r,
          children: s,
          previewDevice: o,
          translations: b,
          translationLanguage: y,
          surveyState: w
        }) => {
          var x, S, k;
          const {
              isWidget: T,
              isPage: M,
              surveyType: O
            } = (0, n.useContext)(_.SurveyConfigContext),
            A = [v.SurveyNpsAnswerType.nps, p.SurveyQuestionAnswerType.customerSatisfaction, p.SurveyQuestionAnswerType.numericalScale, p.SurveyQuestionAnswerType.rating, p.SurveyQuestionAnswerType.single, p.SurveyQuestionAnswerType.smileyScale, p.SurveyQuestionAnswerType.matrix],
            P = [d.SurveyCtaAnswerType.social, d.SurveyCtaAnswerType.thankYouMessage, d.SurveyCtaAnswerType.redirect],
            C = [d.SurveyCtaAnswerType.button, d.SurveyCtaAnswerType.buttonLink, d.SurveyCtaAnswerType.buttonClose],
            E = [...C, p.SurveyQuestionAnswerType.ranking],
            [I, j] = (0, n.useReducer)(h.submitButtonProviderReducer, g),
            {
              rootElement: N
            } = f.storeManager.getStore(O).getState(),
            D = (0, n.useMemo)(() => Object.assign(Object.assign({}, I), {
              disable: e => j({
                payload: e,
                type: "setIsDisabled"
              }),
              hide: e => j({
                payload: e,
                type: "setIsHidden"
              }),
              onSubmit: () => {
                const t = new CustomEvent(`sv__onSubmit__${null == e ? void 0 : e.id}`);
                N && N.dispatchEvent(t), document.dispatchEvent(t);
              },
              render: e => j({
                payload: e,
                type: "shouldRender"
              }),
              setText: e => j({
                payload: e,
                type: "setText"
              }),
              useEvent: m.useSubmitEvent
            }), [I, null == e ? void 0 : e.id]),
            L = (0, n.useMemo)(() => {
              switch (null == e ? void 0 : e.type) {
                case c.SurveyType.WidgetSurvey:
                  return (0, u.translateMessages)(O, e);
                case c.SurveyType.PageSurvey:
                  return (0, u.translateMessages)(c.SurveyType.PageSurvey, e);
                case c.SurveyType.MobileSurvey:
                  return (0, u.translateMessages)(c.SurveyType.MobileSurvey, e);
                default:
                  return null == e ? void 0 : e.settings.messages;
              }
            }, [e, b]),
            R = null == r ? void 0 : r.point.answer_type,
            B = null === (x = null == r ? void 0 : r.point.settings) || void 0 === x ? void 0 : x.text,
            q = () => {
              var e;
              return L ? C.includes(R) && b ? null !== (e = (0, l.translatePoint)(O, r.point).settings.text) && void 0 !== e ? e : L.submit_text : B || L.submit_text || "Submit" : "Submit";
            };
          return (0, n.useEffect)(() => {
            var t;
            const r = w.isAlreadyAnswered || w.isFinished;
            M && r || (A.includes(R) || j({
              payload: !0,
              type: "shouldRender"
            }), P.includes(R) && j({
              payload: !1,
              type: "shouldRender"
            }), E.includes(R) && j({
              payload: !1,
              type: "setIsDisabled"
            }), T && !(null === (t = null == e ? void 0 : e.settings) || void 0 === t ? void 0 : t.hide_footer) && r && j({
              payload: !1,
              type: "shouldRender"
            }));
          }, [r, w.isAlreadyAnswered, w.isFinished]), (0, n.useEffect)(() => {
            j({
              payload: q(),
              type: "setText"
            });
          }, [null == r ? void 0 : r.point.settings, null === (k = null === (S = null == e ? void 0 : e.settings) || void 0 === S ? void 0 : S.messages) || void 0 === k ? void 0 : k.submit_text, B, y, b]), (0, n.useEffect)(() => {
            const t = (null == e ? void 0 : e.type) === c.SurveyType.PageSurvey && (0, a.default)(o) && C.includes(R) && !e.settings.hide_footer && !!r.point.settings.link;
            j({
              payload: t,
              type: "shouldMoveUp"
            });
          }, [r, o]), (0, i.h)(t.SubmitButtonContext.Provider, {
            value: D
          }, s);
        }, t.SubmitButtonProvider = (0, o.connect)(({
          surveyState: e,
          previewDevice: t
        }) => ({
          previewDevice: t,
          survey: e.survey,
          surveyPoint: e.pointsDisplayed[e.pointsDisplayed.length - 1],
          surveyState: e,
          translationLanguage: e.translationLanguage,
          translations: e.translations
        }))(t.ConnectedSubmitButtonProvider);
      },
      7189: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.submitButtonProviderReducer = void 0;
        t.submitButtonProviderReducer = (e, t) => {
          switch (t.type) {
            case "setIsHidden":
              return Object.assign(Object.assign({}, e), {
                isHidden: t.payload
              });
            case "setIsDisabled":
              return Object.assign(Object.assign({}, e), {
                isDisabled: t.payload
              });
            case "shouldRender":
              return Object.assign(Object.assign({}, e), {
                isVisible: t.payload
              });
            case "setText":
              return Object.assign(Object.assign({}, e), {
                text: t.payload
              });
            case "shouldMoveUp":
              return Object.assign(Object.assign({}, e), {
                shouldMoveUp: t.payload
              });
            default:
              return e;
          }
        };
      },
      8298: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useSubmitEvent = void 0;
        const s = r(5994),
          i = r(9027);
        t.useSubmitEvent = (e, t) => {
          var r;
          const {
              surveyType: n,
              surveyId: o
            } = e,
            a = null !== (r = i.storeManager.getStore(n).getState().rootElement) && void 0 !== r ? r : document,
            u = `sv__onSubmit__${o}`;
          (0, s.useEffect)(() => (a.addEventListener(u, t), () => {
            a.removeEventListener(u, t);
          }), [t, o]);
        };
      },
      8534: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(3053)),
          o = r(7057);
        t.default = ({
          progress: e,
          surveyType: t,
          text: r
        }) => {
          const s = t === o.SurveyType.PageSurvey;
          return (0, i.h)("div", {
            className: "sv__progress-bar__wrapper"
          }, s && (0, i.h)("div", {
            "data-testid": "progress-bar-description",
            className: "sv__progress-bar-description"
          }, (0, i.h)("span", {
            className: "sv__progress-bar-number"
          }, e, "% "), r), (0, i.h)("div", {
            className: (0, n.default)({
              "survicate_progress-bar_oTwfq": !0,
              "sv-progress-bar": !0,
              "sv__progress-bar": !0
            })
          }, (0, i.h)("div", {
            className: "sv__progress-bar-fill sv-progress-bar-fill",
            style: {
              width: `${e}%`
            }
          })));
        };
      },
      5220: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SimpleLinkButton = void 0;
        const s = r(172);
        t.SimpleLinkButton = ({
          buttonLink: e,
          buttonText: t
        }) => (0, s.h)("a", {
          className: "sv__simple-link-button",
          type: "button",
          href: e,
          target: "_blank",
          title: "Click to go to the page of the survey creator",
          rel: "noreferrer"
        }, t);
      },
      9288: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(7144),
          o = s(r(6806)),
          a = r(5346),
          u = r(318),
          l = s(r(6498)),
          c = s(r(508)),
          d = r(9410),
          v = s(r(4594)),
          p = r(1617);
        t.default = ({
          surveyType: e,
          surveyComponent: t,
          initialConfig: r
        }) => (0, i.h)(a.SurveyConfigProvider, {
          surveyType: e,
          initialSVDConfig: r
        }, (0, i.h)(o.default, null, (0, i.h)(n.SurveyActivationGate, null, (0, i.h)(d.StoreProvider, null, (0, i.h)(u.SurveyEventProvider, null, (0, i.h)(v.default, null, (0, i.h)(l.default, null, (0, i.h)(c.default, null, (0, i.h)(p.SubmitButtonProvider, null, (0, i.h)(() => t, null))))))))));
      },
      7826: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = s(r(4998)),
          a = r(5346),
          u = r(9027),
          l = s(r(6560)),
          c = s(r(4827));
        t.default = ({
          children: e,
          invalid: t,
          type: r
        }) => {
          const [s, d] = (0, n.useState)(""),
            {
              surveyType: v
            } = (0, n.useContext)(a.SurveyConfigContext),
            p = u.storeManager.getStore(v).getState().surveyState.survey,
            _ = p && "PageSurvey" === p.type,
            f = o.default.isMicroTheme(v);
          return (0, n.useEffect)(() => {
            if (!t) return d("");
            const e = r in c.default ? c.default[r].message : "This field is required";
            d(e);
          }, [t]), (0, i.h)(i.Fragment, null, (_ || f) && t && s && (0, i.h)("div", {
            className: "sv__validation"
          }, (0, i.h)(l.default, null), (0, i.h)("span", {
            "aria-live": "assertive",
            className: "sv__validation__message"
          }, s)), e);
        };
      },
      508: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(9635),
          a = r(5346),
          u = s(r(4700)),
          l = r(7151);
        t.default = (0, o.connect)(e => {
          var t;
          return {
            surveyId: null === (t = e.surveyState.survey) || void 0 === t ? void 0 : t.id
          };
        })(e => {
          const {
              children: t,
              surveyId: r
            } = e,
            {
              isPage: s
            } = (0, n.useContext)(a.SurveyConfigContext),
            {
              isMultiTab: o
            } = (0, l.useMultiTab)(r);
          return o ? s ? (0, i.h)(u.default, null) : null : t;
        });
      },
      7151: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useMultiTab = void 0;
        const s = r(5994),
          i = r(2831),
          n = r(5346),
          o = r(4496),
          a = r(3358);
        t.useMultiTab = e => {
          const {
              isPreview: t,
              surveyType: r
            } = (0, s.useContext)(n.SurveyConfigContext),
            u = {
              key: `${a.StorageKeysSingleTab.tabId}:${e}`,
              value: (0, i.v4)()
            };
          let l;
          const [c, d] = (0, s.useState)(!1);
          return (0, s.useEffect)(() => {
            if (!t) return o.LocalStoreManager.getStore(r).set(u.key, u.value), l = setInterval(() => {
              (() => {
                if (t) return void d(!1);
                o.LocalStoreManager.getStore(r).get(u.key) !== u.value && d(!0);
              })();
            }, 1e3), () => {
              clearInterval(l);
            };
          }, []), {
            isMultiTab: c
          };
        };
      },
      7144: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyActivationGate = void 0;
        const i = r(172),
          n = r(5994),
          o = r(4014),
          a = r(4390),
          u = r(4409),
          l = r(5346),
          c = r(313),
          d = r(2230),
          v = r(9027),
          p = s(r(9979)),
          _ = s(r(8108));
        t.SurveyActivationGate = ({
          children: e
        }) => {
          var t, r, s;
          const {
              pageSurvey: f,
              widgetSurveys: h,
              isPreview: m,
              update: g,
              isWidget: b,
              surveyUpdated: y,
              isPage: w,
              surveyType: x
            } = (0, n.useContext)(l.SurveyConfigContext),
            {
              isCacheOutdated: S
            } = (0, c.useStorageService)(),
            k = !!g && Object.keys(g).length > 0,
            T = k ? !!g.surveys.length : !!(null == h ? void 0 : h.length),
            M = null === (t = k ? g.survey : f) || void 0 === t ? void 0 : t.activated,
            O = !(f && (m || M && (null === (r = f.points) || void 0 === r ? void 0 : r.length))),
            A = !O || T;
          let P = "";
          O && (P = f ? (0, u.translateMessages)(x, f).disabled_text : "This survey is currently unavailable.");
          if (k && y) {
            const e = null == g ? void 0 : g.survey;
            w && (null === (s = e.settings) || void 0 === s ? void 0 : s.kiosk_enabled) && S(e.id) ? v.storeManager.getStore(x).action(_.default)(e) : b && g.surveys.length > 0 && (d.TargetingTriggersInstance.startTargeting(x, g.surveys), v.storeManager.getStore(x).action(p.default)());
          }
          return A ? e : b ? null : (0, i.h)(a.SurveyStatusView, {
            text: P,
            screenType: o.ScreenType.Unavailable
          });
        };
      },
      6806: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = r(5994),
          o = r(4014),
          a = r(4390),
          u = r(5346),
          l = s(r(6908));
        t.default = ({
          children: e
        }) => {
          const {
              isSupportedBrowser: t
            } = (0, l.default)(),
            {
              isPage: r
            } = (0, n.useContext)(u.SurveyConfigContext);
          return t ? e : r ? (0, i.h)(a.SurveyStatusView, {
            screenType: o.ScreenType.Security
          }) : null;
        };
      },
      2951: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.hasBrowserAPISupport = void 0;
        t.hasBrowserAPISupport = () => {
          try {
            const e = "function" == typeof crypto.getRandomValues,
              t = !!document.createEvent("Event");
            return e && t;
          } catch (e) {
            return !1;
          }
        };
      },
      2755: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isUnsupportedBrowser = void 0;
        const i = s(r(6880)),
          n = {
            chrome: "<63",
            edge: "<80",
            firefox: "<52",
            opera: "<42",
            safari: "<9"
          };
        t.isUnsupportedBrowser = () => !!i.default.getParser(window.navigator.userAgent).satisfies(n);
      },
      6908: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(7287),
          i = r(2951),
          n = r(2755);
        t.default = () => ({
          isSupportedBrowser: (0, i.hasBrowserAPISupport)() && !(0, s.isbot)(navigator.userAgent) && !(0, n.isUnsupportedBrowser)()
        });
      },
      9160: function (e, t) {
        "use strict";

        var r = this && this.__awaiter || function (e, t, r, s) {
          return new (r || (r = Promise))(function (i, n) {
            function o(e) {
              try {
                u(s.next(e));
              } catch (e) {
                n(e);
              }
            }
            function a(e) {
              try {
                u(s.throw(e));
              } catch (e) {
                n(e);
              }
            }
            function u(e) {
              var t;
              e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                e(t);
              })).then(o, a);
            }
            u((s = s.apply(e, t || [])).next());
          });
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => ({
          get: t => r(void 0, void 0, void 0, function* () {
            const r = yield window.fetch(`${e}${t}`, {
              headers: {
                "Content-Type": "application/json"
              },
              method: "GET"
            });
            return "text/html" === r.headers.get("content-type") ? (r.clone().text().then(e => {
              /This survey is currently unavailable/.test(e) && console.warn("Please verify your workspace key");
            }), {
              data: r
            }) : {
              data: r.json()
            };
          }),
          post: (t, s) => r(void 0, void 0, void 0, function* () {
            return window.fetch(`${e}${t}`, {
              body: JSON.stringify(s),
              headers: {
                "Content-Type": "application/json"
              },
              method: "POST"
            });
          })
        });
      },
      7678: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function (e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        };
      },
      5285: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getRGBaValue = t.ARGBToRGBA = t.getLuminosity = t.getColorShade = t.separateRGB = void 0;
        const r = (e, t) => t > 0 ? Math.floor(e * ((100 - t) / 100)) : Math.floor(255 - (100 + t) / 100 * (255 - e)),
          s = e => Math.min(Math.max(e, 0), 255);
        t.separateRGB = e => {
          let t = e;
          4 === e.length && (t = `#${e[1]}${e[1]}${e[2]}${e[2]}${e[3]}${e[3]}`);
          return {
            R: parseInt(t.substring(1, 3), 16),
            G: parseInt(t.substring(3, 5), 16),
            B: parseInt(t.substring(5, 7), 16)
          };
        };
        t.getColorShade = (e, i) => {
          let {
            R: n,
            G: o,
            B: a
          } = (0, t.separateRGB)(e);
          n = s(r(n, i)), o = s(r(o, i)), a = s(r(a, i));
          return `#${1 === n.toString(16).length ? `0${n.toString(16)}` : n.toString(16)}${1 === o.toString(16).length ? `0${o.toString(16)}` : o.toString(16)}${1 === a.toString(16).length ? `0${a.toString(16)}` : a.toString(16)}`;
        };
        t.getLuminosity = e => {
          const {
            R: r,
            G: s,
            B: i
          } = (0, t.separateRGB)(e);
          return 1 - (r + s + i) / 765;
        };
        t.ARGBToRGBA = e => {
          const t = e.slice(1);
          return `#${t.slice(2)}${t.slice(0, 2)}`;
        };
        t.getRGBaValue = (e, r) => {
          const {
            R: s,
            G: i,
            B: n
          } = (0, t.separateRGB)(e);
          return `rgba(${s}, ${i}, ${n}, ${r})`;
        };
      },
      3749: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = (e, t) => e && t ? `${e};${t}` : e || t || "";
      },
      1831: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = (e, t) => {
          let r = !1;
          return (...s) => {
            const i = () => {
              e.call(null, ...s), r = !0, setTimeout(() => {
                r = !1;
              }, t);
            };
            r ? setTimeout(() => {
              r || i();
            }, t) : i();
          };
        };
      },
      5448: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeHTMLEntities = void 0;
        t.decodeHTMLEntities = e => (null == e ? void 0 : e.length) ? e.replace(/&amp;/g, "&") : "";
      },
      4031: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(5595),
          i = r(7057);
        t.default = (e, t) => null === t ? e : e.filter(e => {
          switch (t) {
            case i.SurveyType.WidgetSurvey:
              return e.settings.format === s.SurveyFormat.Widget;
            case i.SurveyType.FeedbackButton:
              return e.settings.format === s.SurveyFormat.Feedback;
            default:
              return e;
          }
        });
      },
      3711: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getArrayWithNumbers = void 0;
        t.getArrayWithNumbers = (e, t) => {
          const r = [];
          for (let s = e; s <= t; s += 1) r.push(s);
          return r;
        };
      },
      7289: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getBackgroundStyles = void 0;
        const s = r(1335);
        t.getBackgroundStyles = e => {
          if (!e) return "";
          const t = (e => (null == e ? void 0 : e.background_layout) === s.BackgroundLayout.repeat ? "repeat" : "no-repeat")(e);
          return `\n    background-image: url('${(null == e ? void 0 : e.background_url) || ""}');\n    background-repeat: ${t};\n    background-size: ${(null == e ? void 0 : e.background_layout) || ""};\n    background-position: ${(null == e ? void 0 : e.background_position) || ""};\n  `;
        };
      },
      2780: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getComments = void 0;
        t.getComments = (e, t) => {
          const r = {};
          return e.answers.forEach(e => {
            e.add_comment && ((null == t ? void 0 : t.comments) ? r[e.id] = (null == t ? void 0 : t.comments[e.id]) || "" : r[e.id] = "");
          }), (null == t ? void 0 : t.comment) && (r[null == t ? void 0 : t.answer.id] = null == t ? void 0 : t.comment), r;
        };
      },
      3137: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getCompletionRate = void 0;
        const s = r(6029);
        t.getCompletionRate = e => (0, s.getProgressRate)(e.pointsDisplayed, 0);
      },
      9889: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const r = e => "#" === e.charAt(0) ? e.substring(1, 7) : e;
        t.default = (e, t) => (299 * parseInt(r(e).substring(0, 2), 16) + 597 * (e => parseInt(r(e).substring(2, 4), 16))(e) + 114 * (e => parseInt(r(e).substring(4, 6), 16))(e)) / 1e3 > 130 ? (null == t ? void 0 : t.dark) || "#000000" : (null == t ? void 0 : t.light) || "#ffffff";
      },
      3053: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => Object.keys(e).reduce((t, r) => e[r] ? [...t, r] : t, []).join(" ");
      },
      6029: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getProgressRate = void 0;
        const s = r(8200);
        t.getProgressRate = (e, t = 1) => {
          const r = e.length;
          if (!r) return 0;
          const {
              point: i
            } = e && e[r - 1],
            n = e[e.length - 1].point.answer_type === s.SurveyCtaAnswerType.thankYouMessage,
            o = "number" == typeof i.max_path ? i.max_path : 0;
          return n ? 100 : Math.round((r - t) / (o + r) * 100);
        };
      },
      1835: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(579)),
          n = r(4397);
        t.default = e => e === n.PreviewDevice.mobile || e !== n.PreviewDevice.desktop && i.default.isWidthMobile();
      },
      8443: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => {
          try {
            return JSON.parse(e);
          } catch (t) {
            return e;
          }
        };
      },
      1406: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.keyboardClick = void 0;
        t.keyboardClick = (e, t, r = {}) => {
          "Enter" !== e.key && " " !== e.key || (r.preventDefault && e.preventDefault(), r.stopPropagation && e.stopPropagation(), t(e));
        };
      },
      3450: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(172),
          n = s(r(1248)),
          o = s(r(9288)),
          a = r(7057),
          u = s(r(3239)),
          l = (e, t, r = 0) => {
            if (u.default.initGlobalErrorsWatch(e), !document.body) return void (r < 10 ? setTimeout(() => l(e, t, r + 1), 250) : u.default.log(e, {
              message: "Failed to load survey after a maximum of 10 retries.",
              stack: "loadSurvey.tsx"
            }));
            const s = document.createElement("div");
            s.id = "survicate-box", (e === a.SurveyType.WidgetSurvey || a.SurveyType.FeedbackButton) && (s.className = `survicate-box-${e}`), document.body.appendChild(s), (0, i.render)((0, i.h)(o.default, {
              surveyType: e,
              surveyComponent: t
            }), s);
          };
        t.default = (e, t) => {
          const r = () => l(e, t);
          e !== a.SurveyType.WidgetSurvey && e !== a.SurveyType.FeedbackButton || (0, n.default)(window._svd, window._svc), "complete" !== document.readyState && "interactive" !== document.readyState ? document.addEventListener("DOMContentLoaded", () => setTimeout(r, 1)) : setTimeout(r, 1);
        };
      },
      6716: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.is_between = void 0;
        const s = r(2878),
          i = r(205);
        t.is_between = (e, t) => {
          const r = e[0],
            n = t.find(({
              condition: e,
              value: t
            }) => e === i.LogicCondition.is_between && (0, s.isBetweenValues)(t, r));
          return n ? n.go_to : null;
        };
      },
      2156: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(9027);
        t.default = (e, t) => {
          var r;
          return (null !== (r = s.storeManager.getStore(t).getState().rootElement) && void 0 !== r ? r : document).querySelector(e);
        };
      },
      5890: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = (e = window) => {
          e && "function" == typeof e.scrollTo && e.scrollTo(0, 0);
        };
      },
      5961: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const n = r(9535),
          o = i(r(9160));
        t.default = e => s(void 0, void 0, void 0, function* () {
          try {
            200 !== (yield (0, o.default)("https://respondent.survicate.com").post(`/workspaces/${window._svc.workspaceKey}/targeting_event.json`, e)).status && n.targetingEventsStore.setState({
              isEnabled: !1
            });
          } catch (e) {
            console.error("Error sending event to backend:", e), n.targetingEventsStore.setState({
              isEnabled: !1
            });
          }
        });
      },
      338: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.shuffleArray = void 0;
        t.shuffleArray = e => {
          const t = e.slice(0);
          for (let r = e.length - 1; r > 0; r -= 1) {
            const e = Math.floor(Math.random() * (r + 1));
            [t[r], t[e]] = [t[e], t[r]];
          }
          return t;
        };
      },
      1461: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.skipFocus = void 0;
        t.skipFocus = (e, t) => {
          const r = e.currentTarget.querySelector(`.${t}`);
          r && r.focus();
        };
      },
      6549: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = e => new Promise(t => {
          setTimeout(t, e);
        });
      },
      7539: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => e ? {
          ascending: (t, r) => t[e] - r[e],
          descending: (t, r) => r[e] - t[e]
        } : {
          ascending: (e, t) => e - t,
          descending: (e, t) => t - e
        };
      },
      6733: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = (e, t = 0) => {
          e.style.height = "5px", e.style.height = `${Math.max(t, e.scrollHeight)}px`;
        };
      },
      5548: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getTranslationLang = void 0;
        const s = r(7057);
        t.getTranslationLang = e => {
          if (!e || -1 === [s.SurveyType.WidgetSurvey, s.SurveyType.FeedbackButton, s.SurveyType.PageSurvey].indexOf(e.type)) return null;
          const {
              languages: t
            } = e.settings,
            r = window.navigator.language.substring(0, 2);
          return (null == t ? void 0 : t.find(e => e === r)) || null;
        };
      },
      4467: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isRTLLanguage = void 0;
        const r = ["ar", "he", "fa", "ur", "ps", "dv", "ku", "syr", "ug", "yi"];
        t.isRTLLanguage = e => !(!e || !r.includes(e));
      },
      2654: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.mergeTranslationObjects = void 0;
        t.mergeTranslationObjects = (e, r) => r ? Object.keys(e).reduce((s, i) => {
          if (!r[i]) return Object.assign(Object.assign({}, s), {
            [i]: e[i]
          });
          let n;
          if ("string" == typeof r[i] && (n = r[i]), "settings" === i) {
            const s = e[i].scale,
              o = e[i].choice;
            if (s) {
              const o = s.map(e => {
                const s = {
                  name: r[i].scale[e.id]
                };
                return (0, t.mergeTranslationObjects)(e, s);
              });
              n = Object.assign(Object.assign({}, e[i]), {
                scale: o
              });
            } else n = (0, t.mergeTranslationObjects)(e[i], r[i]);
            if (o) {
              const e = Object.assign(Object.assign({}, o), {
                text: r[i].choice.text
              });
              n = Object.assign(Object.assign({}, n), {
                choice: e
              });
            }
          }
          return "answers" !== i && "fields" !== i || (n = e[i].map(e => {
            const s = {
              ["answers" === i ? "possible_answer" : "label"]: r[i][e.id]
            };
            return (0, t.mergeTranslationObjects)(e, s);
          })), Object.assign(Object.assign({}, s), {
            [i]: n
          });
        }, Object.assign({}, e)) : e;
      },
      4409: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.translateMessages = void 0;
        const s = r(5548),
          i = r(2654),
          n = r(9027);
        t.translateMessages = (e, t) => {
          const {
              surveyState: {
                translationLanguage: r,
                translations: o
              }
            } = n.storeManager.getStore(e).getState(),
            a = r || (0, s.getTranslationLang)(t);
          return o && a ? (0, i.mergeTranslationObjects)(t.settings.messages, o[t.id][a].settings.messages) : t.settings.messages;
        };
      },
      4539: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.translatePoint = void 0;
        const s = r(2654),
          i = r(9027);
        t.translatePoint = (e, t) => {
          const {
              surveyState: r
            } = i.storeManager.getStore(e).getState(),
            {
              translations: n,
              translationLanguage: o
            } = r,
            a = r.survey;
          return n && o ? (0, s.mergeTranslationObjects)(t, n[a.id][o].points[t.id]) : t;
        };
      },
      8885: (e, t) => {
        "use strict";

        var r, s, i, n, o, a, u;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.FilterName = t.VisitSourceType = t.LoggedInStatus = t.Device = t.RelationOperator = t.OperatorType = t.DateOperator = void 0, function (e) {
          e.on = "on", e.before = "before", e.after = "after";
        }(r || (t.DateOperator = r = {})), function (e) {
          e.exact = "exact", e.any = "any", e.is_not_equal = "is_not_equal", e.is_equal = "is_equal", e.is_between = "is_between", e.is_not_between = "is_not_between", e.is_on_the_date = "is_on_the_date", e.is_earlier_than = "is_earlier_than", e.is_later_than = "is_later_than", e.is_less_than = "is_less_than", e.is_less_than_or_equal = "is_less_than_or_equal", e.is_true = "is_true", e.is_false = "is_false", e.is_greater_than = "is_greater_than", e.is_greater_than_or_equal = "is_greater_than_or_equal", e.contains = "contains", e.does_not_contain = "does_not_contain";
        }(s || (t.OperatorType = s = {})), function (e) {
          e.and = "and", e.or = "or";
        }(i || (t.RelationOperator = i = {})), function (e) {
          e.all = "All", e.mobile = "Mobile", e.desktop = "Desktop";
        }(n || (t.Device = n = {})), function (e) {
          e.identified = "identified", e.unidentified = "unidentified";
        }(o || (t.LoggedInStatus = o = {})), function (e) {
          e.search = "search", e.referral = "referral", e.direct = "direct", e.utm = "utm";
        }(a || (t.VisitSourceType = a = {})), function (e) {
          e.attributes = "attributes", e.browser = "browser", e.cookies = "cookies", e.device = "device", e.languages = "languages", e.loggedInStatus = "logged_in_status", e.operatingSystem = "operating_system", e.optimizely = "optimizely", e.tags = "tags", e.visitDepth = "visit_depth", e.visitedUrls = "visited_urls", e.visitFrequency = "visit_frequency", e.visitSource = "visit_source";
        }(u || (t.FilterName = u = {}));
      },
      9577: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyEvent = void 0, function (e) {
          e.answered = "answered", e.finished = "finished", e.opened = "opened", e.closed = "closed", e.shouldUpdate = "shouldUpdate";
        }(r || (t.SurveyEvent = r = {}));
      },
      7057: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyType = t.LinkType = void 0, function (e) {
          e.exact = "exact", e.regexp = "regexp", e.end = "end", e.simple = "simple", e.contains = "contains";
        }(r || (t.LinkType = r = {})), function (e) {
          e.WidgetSurvey = "WidgetSurvey", e.PageSurvey = "PageSurvey", e.MobileSurvey = "MobileSurvey", e.FeedbackButton = "FeedbackButton", e.IntercomSurvey = "IntercomSurvey";
        }(s || (t.SurveyType = s = {}));
      },
      8200: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyCtaAnswerType = void 0, function (e) {
          e.button = "button_next", e.thankYouMessage = "empty", e.buttonLink = "button_link", e.buttonClose = "button_close", e.redirect = "redirect_timeout", e.social = "social_cta";
        }(r || (t.SurveyCtaAnswerType = r = {}));
      },
      4585: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyFormAnswerType = t.FormFieldTypes = void 0, function (e) {
          e.firstName = "first_name", e.lastName = "last_name", e.email = "email", e.organization = "organization", e.job = "job_title", e.phone = "phone", e.website = "website", e.comment = "comment", e.addressOne = "address_one", e.addressTwo = "address_two", e.city = "city", e.state = "state", e.zip = "zip", e.fax = "fax", e.annual_revenue = "annual_revenue", e.employees = "employees", e.industry = "industry", e.confirmation = "confirmation", e.security_info = "security_info";
        }(r || (t.FormFieldTypes = r = {})), function (e) {
          e.form = "form";
        }(s || (t.SurveyFormAnswerType = s = {}));
      },
      4073: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Orientation = t.SurveyNpsAnswerType = void 0, function (e) {
          e.nps = "nps";
        }(r || (t.SurveyNpsAnswerType = r = {})), function (e) {
          e.default = "default", e.horizontal = "horizontal";
        }(s || (t.Orientation = s = {}));
      },
      87: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyPointType = void 0, function (e) {
          e.question = "SurveyQuestion", e.nps = "SurveyNps", e.form = "SurveyForm", e.cta = "SurveyCta";
        }(r || (t.SurveyPointType = r = {}));
      },
      3501: (e, t) => {
        "use strict";

        var r, s, i, n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SmileyScalePossibleAnswers = t.SurveyQuestionAnswerType = t.TimeUnit = t.RatingShape = void 0, function (e) {
          e.hearts = "hearts", e.stars = "stars", e.thumbs = "thumbs";
        }(r || (t.RatingShape = r = {})), function (e) {
          e.day = "DD", e.month = "MM", e.year = "YYYY";
        }(s || (t.TimeUnit = s = {})), function (e) {
          e.single = "single", e.multiple = "multiple", e.text = "text", e.smileyScale = "smiley_scale", e.date = "date", e.rating = "rating", e.dropdown = "dropdown_list", e.matrix = "matrix", e.ranking = "ranking", e.numericalScale = "numerical_scale", e.customerSatisfaction = "csat";
        }(i || (t.SurveyQuestionAnswerType = i = {})), function (e) {
          e.verySad = "Extremely unsatisfied", e.sad = "Unsatisfied", e.neutral = "Neutral", e.happy = "Happy", e.veryHappy = "Extremely happy";
        }(n || (t.SmileyScalePossibleAnswers = n = {}));
      },
      2920: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DateSeparator = t.DateOrder = void 0, function (e) {
          e.YMD = "YMD", e.MDY = "MDY", e.DMY = "DMY";
        }(r || (t.DateOrder = r = {})), function (e) {
          e.dash = "-", e.slash = "/", e.dot = ".";
        }(s || (t.DateSeparator = s = {}));
      },
      1335: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.microThemeDefaultColors = t.simpleThemeDefaultColors = t.BackgroundPosition = t.BackgroundLayout = t.ThemeType = void 0;
        const s = r(5285);
        var i, n, o;
        !function (e) {
          e.micro = "MicroTheme", e.simple = "SimpleTheme", e.mobile = "MobileTheme", e.intercom = "IntercomTheme", e.newMobile = "NewMobileTheme";
        }(i || (t.ThemeType = i = {})), function (e) {
          e.cover = "cover", e.repeat = "repeat", e.contain = "contain";
        }(n || (t.BackgroundLayout = n = {})), function (e) {
          e.left = "left", e.center = "center", e.right = "right", e.bottom = "bottom", e.top = "top";
        }(o || (t.BackgroundPosition = o = {})), t.simpleThemeDefaultColors = {
          answer: "#7f8c8d",
          background: "#ffffff",
          bg_answer: (0, s.getColorShade)("#7f8c8d", -90),
          bg_submit: "#70c84a",
          bg_widget: "#ffffff",
          button: "#70c84a",
          font_answer: (0, s.getColorShade)("#7f8c8d", -10),
          font_submit: "#ffffff",
          font_widget: "#29292a",
          main_color: "#70c84a",
          progress_bar: "#70c84a",
          question: "#29292a"
        }, t.microThemeDefaultColors = {
          answer: "#7f8c8d",
          background: "#ffffff",
          bg_answer: (0, s.getColorShade)("#7f8c8d", -90),
          bg_submit: "#70c84a",
          bg_widget: "#ffffff",
          button: "#70c84a",
          font_answer: (0, s.getColorShade)("#7f8c8d", -10),
          font_submit: "#ffffff",
          font_widget: "#29292a",
          main_color: "#70c84a",
          progress_bar: "#70c84a",
          question: "#29292a"
        };
      },
      9410: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.StoreProvider = void 0;
        const s = r(172),
          i = r(5994),
          n = r(9635),
          o = r(8217),
          a = r(9027),
          u = r(5346);
        t.StoreProvider = e => {
          const {
              surveyType: t,
              initialSVDConfig: r
            } = (0, i.useContext)(u.SurveyConfigContext),
            [l, c] = (0, i.useState)(0),
            d = a.storeManager.getStore(t);
          return (0, i.useLayoutEffect)(() => {
            d.setState({
              storeType: t
            }), (0, o.initStore)(t, r), c(e => e + 1);
          }, [t, r]), (0, s.h)(n.Provider, {
            store: d,
            key: l
          }, e.children);
        };
      },
      5346: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyConfigProvider = t.SurveyConfigContext = void 0;
        const n = r(172),
          o = r(5994),
          a = i(r(4031)),
          u = i(r(9160)),
          l = r(7057);
        t.SurveyConfigContext = (0, n.createContext)({});
        t.SurveyConfigProvider = ({
          children: e,
          surveyType: r,
          initialSVDConfig: i
        }) => {
          var c;
          const d = i || window._svd || {},
            v = window._svc || {},
            p = r === l.SurveyType.PageSurvey,
            _ = r === l.SurveyType.WidgetSurvey,
            f = r === l.SurveyType.FeedbackButton,
            h = !!i || !!v.isPreview,
            m = r === l.SurveyType.PageSurvey ? `surveys/${null === (c = d.survey) || void 0 === c ? void 0 : c.id}` : "web_surveys",
            g = {
              initialSVDConfig: i,
              isFeedback: f,
              isPage: p,
              isPreview: h,
              isWidget: _,
              pageSurvey: p ? d.survey : null,
              surveyType: r,
              surveyUpdated: !1,
              themes: d.themes,
              update: {},
              widgetSurveys: d.survey && (_ || f) ? [d.survey] : d.surveys
            },
            [b, y] = (0, o.useState)(g),
            w = () => s(void 0, void 0, void 0, function* () {
              var e;
              try {
                const t = yield x();
                if (!t) return;
                (null === (e = t.surveys) || void 0 === e ? void 0 : e.length) && (t.surveys = (0, a.default)(t.surveys, r)), y(e => Object.assign(Object.assign({}, e), {
                  surveyUpdated: !0,
                  update: t
                })), setTimeout(() => y(e => Object.assign(Object.assign({}, e), {
                  surveyUpdated: !1
                })), 100);
              } catch (e) {
                console.error("Error updating survey:", e);
              }
            }),
            x = () => s(void 0, void 0, void 0, function* () {
              if (navigator.onLine) return S();
              window.addEventListener("online", k);
            }),
            S = () => s(void 0, void 0, void 0, function* () {
              var e;
              try {
                const t = yield (0, u.default)("https://survey.survicate.com").get(`/workspaces/${v.workspaceKey}/${m}.json`);
                return 404 === (null === (e = null == t ? void 0 : t.data) || void 0 === e ? void 0 : e.status) ? null : null == t ? void 0 : t.data;
              } catch (e) {
                return console.error("Error retrieving survey data:", e), null;
              }
            }),
            k = () => {
              navigator.onLine && (window.removeEventListener("online", k), w());
            };
          (0, o.useEffect)(() => {
            if (h) return;
            const e = setInterval(w, 18e5);
            return () => {
              clearInterval(e), window.removeEventListener("online", k);
            };
          }, []), (0, o.useEffect)(() => {
            i && y(e => Object.assign(Object.assign({}, e), {
              initialSVDConfig: i,
              isPreview: !0,
              surveyType: r,
              widgetSurveys: [i.survey]
            }));
          }, [r]);
          const T = (0, o.useMemo)(() => Object.assign(Object.assign({}, b), {
            triggerConfigUpdate: w
          }), [b, w]);
          return (0, n.h)(t.SurveyConfigContext.Provider, {
            value: T
          }, e);
        };
      },
      318: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyEventProvider = t.SurveyEventContext = t.fireSurveyEvent = void 0;
        const s = r(172),
          i = r(5994);
        t.fireSurveyEvent = (e, t) => {
          const r = Object.assign({
              eventType: e
            }, t),
            s = new CustomEvent("onSurveyEvent", {
              detail: r
            });
          document.dispatchEvent(s);
        }, t.SurveyEventContext = (0, s.createContext)({});
        t.SurveyEventProvider = ({
          children: e
        }) => {
          const [r, n] = (0, i.useState)();
          (0, i.useEffect)(() => {
            document.addEventListener("onSurveyEvent", e => {
              const {
                detail: t
              } = e;
              n(t);
            });
          }, []);
          const o = (0, i.useMemo)(() => ({
            surveyEvent: r
          }), [r]);
          return (0, s.h)(t.SurveyEventContext.Provider, {
            value: o
          }, e);
        };
      },
      3074: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(7057),
          n = s(r(3239)),
          o = s(r(6571)),
          a = s(r(4966)),
          u = s(r(5575)),
          l = s(r(1982)),
          c = r(9027),
          d = r(8368);
        class v {
          constructor(e, t) {
            var r;
            this.requestsHandler = new a.default(t, e, (0, o.default)("https://respondent.survicate.com")), this.workspaceKey = null === (r = window._svc) || void 0 === r ? void 0 : r.workspaceKey;
          }
          static getVisit(e) {
            if (!e) return d.emptyVisit;
            const t = c.storeManager.getStore(e);
            return {
              device_type: l.default.getVisit(e).get().device_type,
              operating_system: l.default.getVisit(e).get().operating_system,
              page_url: e === i.SurveyType.PageSurvey ? u.default.url : window.location.href,
              platform: window.navigator.platform,
              referer: l.default.getVisit(e).get().referrerUrl,
              translation: t.getState().surveyState.translationLanguage,
              user_agent: window.navigator.userAgent
            };
          }
          addRequest(e, t, r, s) {
            var i;
            window.self !== window.top && (null === (i = window._svc) || void 0 === i ? void 0 : i.isPreview) || (this.requestsHandler || !s ? this.requestsHandler.addRequest({
              payload: t,
              surveyId: r,
              type: e,
              visit: v.getVisit(s),
              wId: this.workspaceKey
            }) : n.default.log(s, {
              message: "No requestsHandler when adding a request.",
              stack: "Backend.tsx"
            }));
          }
        }
        t.default = v;
      },
      3239: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(9160)),
          n = r(3358),
          o = r(151);
        class a {
          static log(e, t) {
            if (o.SessionStoreManager.getStore(e).get(n.StorageKeysError.errorSent)) return;
            o.SessionStoreManager.getStore(e).set(n.StorageKeysError.errorSent, !0);
            const r = {
                message: t.message,
                stack: t.stack
              },
              s = window._svc || {};
            (0, i.default)("https://respondent.survicate.com").post(`/workspaces/${s.workspaceKey}/logs.json`, {
              error: r,
              url: document.location.toString(),
              user_agent: window.navigator.userAgent,
              version: "24.5.1"
            });
          }
          static isSurvicateError(e = "") {
            return !e.match(/https:\/\/(?!surveys)[^]*Generator\._invoke/) && (e.includes("widget_core") || e.includes("page_core"));
          }
          static shouldLogError(e, t) {
            return !(!t || !t.stack) && a.isSurvicateError(t.stack) && !o.SessionStoreManager.getStore(e).get(n.StorageKeysError.errorSent) && ![/Network Error/, /Navigating/, /quota/, /invalid security context/].some(e => !!t.message.match(e));
          }
          static initGlobalErrorsWatch(e) {
            window.addEventListener("error", function t(r) {
              a.shouldLogError(e, r.error) && (a.log(e, r.error), window.removeEventListener("error", t));
            }), window.addEventListener("unhandledrejection", function t(r) {
              r.reason && r.reason.stack && a.shouldLogError(e, r.reason) && (a.log(e, r.reason), window.removeEventListener("unhandledrejection", t));
            });
          }
        }
        t.default = a;
      },
      5723: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.EndpointType = void 0, function (e) {
          e.seen = "seen.json", e.answered = "answered_v3.json";
        }(r || (t.EndpointType = r = {}));
      },
      907: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getSeenPayload = t.getAnsweredPayload = t.trimVisitor = void 0;
        t.trimVisitor = e => ({
          attributes: e.attributes,
          identities: e.identities,
          tags: e.tags,
          uuid: e.uuid
        });
        t.getAnsweredPayload = (e, t) => {
          const {
              visit_points: r,
              visitor: s,
              survey_point_id: i,
              overwrite: n,
              integrations: o
            } = e,
            a = {
              visit_points: (u = r, u.map(e => {
                const t = {
                  completion_rate: e.completion_rate,
                  finished: e.finished || void 0,
                  user_tag: e.user_tag || void 0
                };
                return Object.keys(e).forEach(r => {
                  e[r] && (t[r] = e[r]);
                }), t;
              })),
              survey_point_id: i,
              visit: t,
              visitor: s,
              integrations: o || void 0,
              response_uuid: e.response_uuid
            };
          var u;
          return n && (a.overwrite = !0), a;
        };
        t.getSeenPayload = e => {
          const {
            visitor: t
          } = e;
          return {
            visitor: t,
            survey_first_seen: e.survey_first_seen || void 0
          };
        };
      },
      6571: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const n = i(r(9160)),
          o = i(r(6549)),
          a = r(5723),
          u = r(907),
          l = i(r(5657)),
          c = i(r(8388));
        let d = 0;
        const v = (e, t, r) => s(void 0, void 0, void 0, function* () {
          return (0, n.default)(t).post(`/workspaces/${e.wId}/surveys/${e.surveyId}/${e.type}`, r).then(() => new c.default()).catch(e => s(void 0, void 0, void 0, function* () {
            const {
              response: t
            } = e;
            return "Network Error" === e.message || !t || t.status >= 500 ? (d += 1, yield (0, o.default)(d > 3 ? 15e3 : 5e3), Promise.resolve(new l.default())) : Promise.resolve(new c.default());
          }));
        });
        t.default = e => t => s(void 0, void 0, void 0, function* () {
          let r;
          switch (t.type) {
            case a.EndpointType.answered:
              r = (0, u.getAnsweredPayload)(t.payload, t.visit);
              break;
            case a.EndpointType.seen:
              r = (0, u.getSeenPayload)(t.payload);
              break;
            default:
              return new c.default();
          }
          return v(t, e, r);
        });
      },
      3155: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(5285),
          n = r(7057),
          o = r(1335),
          a = s(r(5493)),
          u = r(9027);
        class l {
          static getCssFromRules(e, t) {
            let r = "";
            const s = t === n.SurveyType.WidgetSurvey || t === n.SurveyType.FeedbackButton ? `.survicate-box-${t}` : "";
            return Object.keys(e).forEach(t => {
              r += `#survicate-box${s} ${t}{`, e[t].forEach(({
                propertyName: e,
                value: t
              }) => {
                r += `${e}: ${t};`;
              }), r += "}";
            }), r;
          }
          static addImportantsToCustomCss(e = "") {
            if ("string" != typeof e) return "";
            const t = e.replace(/\s+!important;/g, ";"),
              r = [];
            let s = !1,
              i = 0;
            for (let e = 0; e < t.length; e += 1) {
              const n = e => e + 6 < t.length && "b" === t[e + 1] && "base64" === t.substring(e + 1, e + 7);
              !s && (e => "@" === t[e])(e) && (s = !0), s ? ("{" === t[e] && (i += 1), "}" === t[e] && (i -= 1, 0 === i && (s = !1))) : ";" !== t[e] || n(e) || r.push(e);
            }
            let n = 0,
              o = "";
            return r.forEach(e => {
              o = `${o}${t.substring(n, e)} !important`, n = e;
            }), o = `${o}${t.substring(n)}`, o;
          }
          static getCss(e, t) {
            const r = {},
              s = (e, t, s) => {
                r[e] || (r[e] = []), r[e].push({
                  propertyName: t,
                  value: s
                });
              };
            let i = "";
            switch (e.type) {
              case o.ThemeType.simple:
                a.default.addSimpleThemeCss(s, e.color_scheme), i += a.default.customSimpleThemeCss(e.color_scheme);
                break;
              case o.ThemeType.micro:
                a.default.addMicroThemeCss(s, e.color_scheme);
            }
            const n = this.getCssFromRules(r, t) + i;
            return u.storeManager.getStore(t).getState().isPreview && !1 === e.custom_css_enabled ? n : n + this.addImportantsToCustomCss(e.custom_css);
          }
          static getSimpleThemeColors(e) {
            return {
              answer: e.answer || o.simpleThemeDefaultColors.answer,
              background: e.background || o.simpleThemeDefaultColors.background,
              bg_answer: (0, i.getColorShade)(e.answer || o.simpleThemeDefaultColors.answer, -90),
              bg_submit: e.button || e.main_color,
              bg_widget: e.background || o.simpleThemeDefaultColors.background,
              button: e.button || e.main_color,
              font_answer: (0, i.getColorShade)(e.answer || o.simpleThemeDefaultColors.answer, -10),
              font_submit: o.simpleThemeDefaultColors.font_submit,
              font_widget: e.question || o.simpleThemeDefaultColors.question,
              main_color: e.main_color || o.simpleThemeDefaultColors.button,
              progress_bar: e.progress_bar || e.main_color,
              question: e.question || o.simpleThemeDefaultColors.question
            };
          }
          static getMicroThemeColors(e) {
            return {
              answer: e.answer || o.simpleThemeDefaultColors.answer,
              background: e.background || o.simpleThemeDefaultColors.background,
              bg_answer: (0, i.getColorShade)(e.answer || o.simpleThemeDefaultColors.answer, -90),
              bg_submit: e.button || e.main_color,
              bg_widget: e.background || o.simpleThemeDefaultColors.background,
              button: e.button || e.main_color,
              font_answer: (0, i.getColorShade)(e.answer || o.simpleThemeDefaultColors.answer, -10),
              font_submit: o.simpleThemeDefaultColors.font_submit,
              font_widget: e.question || o.simpleThemeDefaultColors.question,
              main_color: e.main_color || o.simpleThemeDefaultColors.button,
              progress_bar: e.progress_bar || e.main_color,
              question: e.question || o.simpleThemeDefaultColors.question
            };
          }
          static extendTheme(e) {
            return e.type === o.ThemeType.simple ? Object.assign(Object.assign({}, e), {
              color_scheme: this.getSimpleThemeColors(e.color_scheme)
            }) : Object.assign(Object.assign({}, e), {
              color_scheme: this.getMicroThemeColors(e.color_scheme)
            });
          }
          static reloadCss(e, t) {
            var r;
            const s = null !== (r = u.storeManager.getStore(t).getState().rootElement) && void 0 !== r ? r : document.head,
              i = t === n.SurveyType.FeedbackButton ? "survicate-feedback-core-theme" : "survicate-core-theme";
            let o = s.querySelector(`#${i}`);
            o || (o = document.createElement("style"), o.id = i, s.appendChild(o)), o.textContent = l.getCss(e, t);
          }
        }
        t.default = l;
      },
      5636: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), function (e) {
          e[e.mobile = 767] = "mobile", e[e.tablet = 1080] = "tablet";
        }(r || (r = {})), t.default = r;
      },
      5493: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(5285),
          n = s(r(9889)),
          o = s(r(5636)),
          a = r(7609),
          u = s(r(579));
        t.default = class {
          static addMicroThemeCss(e, t) {
            (0, a.getMicroThemeRules)(t).forEach(({
              property: t,
              className: r,
              state: s,
              isTopLevelClass: i,
              value: n
            }) => {
              const o = i ? ".sv__micro-theme" : ".sv__micro-theme ";
              (Array.isArray(r) ? r : [r]).forEach(r => {
                e(`${o}${s ? r + s : r}`, t, `${n} !important`);
              });
            });
          }
          static addSimpleThemeCss(e, t) {
            const {
              answer: r,
              button: s,
              background: o,
              progress_bar: a,
              question: l
            } = t;
            e(".sv__body", "background-color", o), e(".sv__label", "color", l), e(".sv-bg-main", "background-color", r), e(".sv-border-color-main", "border-color", s), e(".sv-checkbox-tick-border-color", "border-color", o), e(".sv__square svg path", "color", r), e(".sv__submit-button", "background-color", s), e(".sv__submit-button", "color", (0, n.default)(s)), e(".sv-col-description", "color", r), e(".sv-col-fa", "background-color", "transparent"), e(".sv-col-fa", "color", r), e(".sv-bg-fa", "color", r), e(".sv-col-main", "color", r), e(".sv-navigation", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv-navigation::before", "border-color", r), e(".sv-navigation-mobile", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv-navigation-mobile::before", "border-color", a), e(".sv-progress-bar", "background-color", "#ebeeee"), e(".sv-progress-bar-fill", "background-color", a), e(".sv__rating .sv__button svg path", "fill", (0, i.getRGBaValue)(r, .1)), e(".sv__rating .sv__button--selected svg path", "fill", r), e(".sv__rating .sv__button .sv__rating__number", "color", r), e(".sv__ranking-option", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv-ranking-option .sv__caret", "border-bottom-color", s), e(".sv-ranking-option .sv__caret", "border-top-color", s), e(".sv-ranking-option .sv__caret svg path:nth-child(2)", "fill", r), e(".sv__ranking-option-handler svg path:nth-child(2)", "fill", r), e(".sv__ranking-option-body strong", "color", r), e(".sv__choice-button", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__choice-button.sv__selected", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__choice-button.sv__selected", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__choice-button.sv__selected", "border-color", r), e(".sv__choice-button .sv__checkbox.sv__circle", "border-color", r), e(".sv__choice-button .sv__checkbox.sv__square", "border-color", r), e(".sv__multiple-choice__message", "color", r), e(".sv__survey input", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__survey input", "color", r), e(".sv__survey input:focus", "border-color", r), e(".sv__contact-form-field-label", "color", r), e(".sv__contact-form-confirmation", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__contact-form-confirmation div", "color", r), e(".sv__contact-form-confirmation .sv-invalid", "border", `2px solid ${r} !important`), e(".sv__contact-form-security", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__contact-form-security span", "color", r), e(".sv__branding input", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__branding input:focus", "border-color", r), e(".sv__branding input", "color", r), e(".sv__date input", "color", r), e(".sv__date.focused", "border-color", r), e(".sv__date input::placeholder", "color", (0, i.getRGBaValue)(r, .5)), e(".sv__date", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__date.sv__invalid input", "color", r), e(".sv__date .sv__date__separator", "color", r), e(".sv__matrix-survey-point .sv__point-wrapper .sv__point-question", "color", r), e(".sv__matrix-row", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__matrix-row.sv__selected", "border-color", r), e(".sv__matrix-cell", "color", l), e(".sv__matrix-cell div", "color", r), e(".sv__matrix-cell .sv__checkbox.sv__circle", "border-color", r), e(".sv__matrix-answer--selected", "color", s), e(".sv__ranking-wrapper .sv__select", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__select input", "color", r), e(".sv__select input", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__select svg g", "fill", r), e(".sv__dropdown__wrapper .sv__select .sv__select-button", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__clear-input-icon svg g", "stroke", r), e(".sv__select input::placeholder", "color", (0, i.getRGBaValue)(r, .6)), e(".sv__select--open", "border-color", r), e(".sv__select--open ul", "border-color", r), e(".sv__select--open ul span", "color", r), e(".sv__ranking-wrapper .sv__select .sv__select-list .sv__select-button", "background-color", (0, n.default)(r)), e(".sv__textarea", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__textarea", "color", r), e(".sv__answer-hint", "color", r), e(".sv__textarea-wrapper .sv__textarea", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__textarea-wrapper .sv__textarea", "color", r), e(".sv__textarea-wrapper .sv__textarea:focus", "border-color", r), e(".sv__textarea-wrapper .sv__textarea::placeholder", "color", (0, i.getRGBaValue)(r, .6)), e(".sv__text-question .sv__textarea:focus", "border-color", r), e(".sv__text-question .sv__textarea::placeholder", "color", (0, i.getRGBaValue)(r, .6)), e(".sv__point-question", "color", l), e(".sv-col-description", "color", l), e(".sv__nps .sv__labels", "color", l), e(".sv__nps .sv__button", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__nps  .sv__button-selected", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__square", "border-color", r), e(".sv__lock-icon g g path", "fill", r), e(".sv__scroll-indicator .sv__scroll-indicator-arrow", "border-color", r), e(".sv__drag-n-drop--placeholder", "border-color", r), e(".sv__numerical-scale .sv__button", "color", r), e(".sv__numerical-scale .sv__button.sv__selected", "border-color", r), e(".sv__numerical-scale .sv__button", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__customer-satisfaction .sv__button", "color", r), e(".sv__customer-satisfaction .sv__button", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__customer-satisfaction .sv__button.sv__selected", "border-color", r), e(".sv__customer-satisfaction .sv__label", "color", r), u.default.hasHover() && (e(".sv__rating .sv__button:hover svg path", "fill", r), e(".sv__mobile .sv__rating .sv__button:hover svg path", "fill", (0, i.getRGBaValue)(r, .1)), e(".sv__mobile .sv__rating .sv__button--selected.sv__button:hover svg path", "fill", r), e(".sv__choice-button:hover", "background-color", (0, i.getRGBaValue)(r, .2)), e(".sv__dropdown__wrapper .sv__select .sv__select-button:hover", "background-color", (0, i.getRGBaValue)(r, .2)), e(".sv__dropdown__wrapper .sv__select .sv__select-button--focused", "background-color", (0, i.getRGBaValue)(r, .2)), e(".sv__nps .sv__button:hover", "background-color", (0, i.getRGBaValue)(r, .2)), e(".sv__nps  .sv__button:hover", "background-color", (0, i.getRGBaValue)(r, .2)), e(".sv__nps__wrapper--vertical .sv__nps .sv__button:hover", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__nps__wrapper--vertical .sv__nps .sv__button:active", "border-color", r), e(".sv__choice-button .sv__circle:hover", "box-shadow", `0 0 0 8px ${(0, i.getRGBaValue)(r, .1)}`), e(".sv__choice-button .sv__circle:focus", "box-shadow", `0 0 0 8px ${(0, i.getRGBaValue)(r, .2)}`), e(".sv__choice-button .sv__circle:active", "box-shadow", `0 0 0 8px ${(0, i.getRGBaValue)(r, .2)}`), e(".sv__matrix-cell .sv__circle:hover", "box-shadow", `0 0 0 8px ${(0, i.getRGBaValue)(r, .1)}`), e(".sv__matrix-cell .sv__circle:focus", "box-shadow", `0 0 0 8px ${(0, i.getRGBaValue)(r, .2)}`), e(".sv__matrix-cell .sv__circle:active", "box-shadow", `0 0 0 8px ${(0, i.getRGBaValue)(r, .2)}`), e(".sv__choice-button .sv__square:hover::after", "background-color", (0, i.getRGBaValue)(r, .1)), e(".sv__choice-button .sv__square:focus::after", "background-color", (0, i.getRGBaValue)(r, .2)), e(".sv__choice-button .sv__square:active::after", "background-color", (0, i.getRGBaValue)(r, .2)), e(".sv__submit-button:hover", "background-color", (0, i.getColorShade)(s, -10)), e(".sv__submit-button:focus", "box-shadow", `0 0 0 2px white, 0 0 0 4px ${s};`), e(".sv__numerical-scale .sv__button:hover", "background-color", (0, i.getRGBaValue)(r, .2)));
          }
          static customSimpleThemeCss(e) {
            return `body{margin: 0 !important;}\n    #survicate-box .sv-col-description * { color: ${e.font_widget} }\n    html{position: relative; max-width: 100vw; background-color: white;}\n    @media only screen and (max-width: ${o.default.mobile}px) {\n      html{height: 100%;}\n      body{height: 100%;}\n      #survicate-box{height: 100%;}\n      #survicate-box .sv__submit-btn-present .sv__point-wrapper {padding-bottom: 50px;}\n    }\n    @media only screen and (min-width: ${o.default.mobile + 1}px) {\n      #survicate-box .sv-bg-bs {\n        border-radius: 6px;\n      }\n    }`;
          }
        };
      },
      7609: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getMicroThemeRules = void 0;
        const i = r(5285),
          n = s(r(9889));
        t.getMicroThemeRules = e => {
          const {
              answer: t,
              button: r,
              background: s,
              progress_bar: o,
              question: a,
              bg_answer: u
            } = e,
            l = "#171D1A",
            c = "#F1F1F1",
            d = (0, i.getRGBaValue)(t, .1),
            v = (0, i.getRGBaValue)(t, .2),
            p = (0, i.getRGBaValue)(t, .5),
            _ = (0, i.getRGBaValue)(a, .5),
            f = (0, i.getRGBaValue)(r, .7),
            h = `0 0 0 8px ${d}`;
          return [{
            className: ".sv__survey",
            isTopLevelClass: !0,
            property: "background-color",
            value: s
          }, {
            className: ".sv__mobile-survey .sv__rating .sv__buttons .sv__button",
            isTopLevelClass: !0,
            property: "background-color",
            state: ":hover",
            value: "transparent"
          }, {
            className: [".sv__survey--finished.sv__survey--branded .sv__btn-close svg g g", ".sv__survey--finished.sv__survey--branded .sv__btn-close:hover svg g g", ".sv__survey--finished.sv__survey--branded .sv__btn-close:active svg g g"],
            isTopLevelClass: !0,
            property: "fill",
            value: "black"
          }, {
            className: [".sv__mobile-survey .sv__button:hover svg path", ".sv__mobile-survey .sv__button--selected svg path"],
            isTopLevelClass: !0,
            property: "fill",
            value: (0, i.getRGBaValue)(t, .3)
          }, {
            className: [".sv__mobile-survey .sv__rating--vertical .sv__buttons .sv__button", ".sv__mobile-survey .sv__button", ".sv__mobile-survey .sv__choice-button"],
            isTopLevelClass: !0,
            property: "background-color",
            state: ":hover",
            value: d
          }, {
            className: [".sv__feedback-survey--minimized.sv__feedback-survey"],
            isTopLevelClass: !0,
            property: "background-color",
            value: r
          }, {
            className: [".sv__feedback-survey--minimized.sv__feedback-survey .sv__feedback-survey__text"],
            isTopLevelClass: !0,
            property: "color",
            value: (0, n.default)(r)
          }, {
            className: ".sv--background-main",
            property: "background-color",
            value: s
          }, {
            className: ".sv--background-button",
            property: "background-color",
            value: r
          }, {
            className: ".sv--background-answer",
            property: "background-color",
            value: t
          }, {
            className: ".sv--background-answer-opacity-10",
            property: "background-color",
            value: d
          }, {
            className: ".sv__progress-bar-fill",
            property: "background-color",
            value: o
          }, {
            className: ".sv__date.focused",
            property: "border-color",
            value: t
          }, {
            className: ".sv__contact-form .sv__contact-form-field.sv__light.sv__invalid input.sv-nested-bg-bw",
            property: "background-color",
            value: u
          }, {
            className: [".sv__progress-bar", "*::-webkit-scrollbar-thumb"],
            property: "background-color",
            value: (0, i.getRGBaValue)(a, .15)
          }, {
            className: [".sv__choice-button--selected .sv__circle", ".sv__choice-button:active .sv__circle"],
            property: "background-color",
            value: t
          }, {
            className: [".sv__rating--vertical .sv__buttons .sv__button:active", ".sv__rating--vertical .sv__buttons .sv__button--selected"],
            property: "background-color",
            value: v
          }, {
            className: ".sv--color-question",
            property: "color",
            value: a
          }, {
            className: ".sv--color-answer",
            property: "color",
            value: t
          }, {
            className: ".sv__date input::placeholder",
            property: "color",
            value: p
          }, {
            className: ".sv__matrix-answer--selected",
            property: "color",
            value: r
          }, {
            className: ".sv__submit-button",
            property: "color",
            value: (0, n.default)(r)
          }, {
            className: ".sv__input::placeholder",
            property: "color",
            value: p
          }, {
            className: ".sv__footer__small-text",
            property: "color",
            value: (0, n.default)(s, {
              dark: l,
              light: c
            })
          }, {
            className: ".sv-border-color-answer",
            property: "border-color",
            value: t
          }, {
            className: ".sv__select-list",
            property: "border-color",
            value: v
          }, {
            className: ".sv__submit-button__wrapper",
            property: "border-top-color",
            value: (0, i.getRGBaValue)(a, .2)
          }, {
            className: ".sv__square",
            property: "box-shadow",
            state: ":focus::after",
            value: h
          }, {
            className: ".sv__square",
            property: "box-shadow",
            state: ":hover::after",
            value: h
          }, {
            className: ".sv__square",
            property: "box-shadow",
            state: ":active::after",
            value: h
          }, {
            className: ".sv__circle",
            property: "box-shadow",
            state: ":focus",
            value: h
          }, {
            className: ".sv__circle",
            property: "box-shadow",
            state: ":hover",
            value: h
          }, {
            className: ".sv__circle",
            property: "box-shadow",
            state: ":active",
            value: h
          }, {
            className: ".sv__btn-close svg g",
            property: "fill",
            value: _
          }, {
            className: ".sv__btn-minimize svg g rect",
            property: "fill",
            value: (0, i.getRGBaValue)(a, .85)
          }, {
            className: ".sv__button svg path",
            property: "fill",
            value: (0, i.getRGBaValue)(t, .3)
          }, {
            className: ".sv__minimized-symbol svg g g path",
            property: "fill",
            value: (0, n.default)(r, {
              dark: "#000",
              light: "#FFF"
            })
          }, {
            className: ".sv__footer__button svg path",
            property: "fill",
            value: (0, n.default)(s, {
              dark: l,
              light: c
            })
          }, {
            className: [".sv__btn-close:hover svg g g", ".sv__btn-close:active svg g g", ".sv__btn-minimize:hover svg g rect"],
            property: "fill",
            value: a
          }, {
            className: [".sv__dropdown__wrapper svg g g", ".sv__button--vertical svg path"],
            property: "fill",
            value: p
          }, {
            className: [".sv__btn-minimize--padded svg g rect", ".sv__btn-minimize--padded svg rect:first-child"],
            property: "fill",
            value: _
          }, {
            className: [".sv__btn-minimize--padded:hover svg rect", ".sv__btn-minimize--padded:active svg rect"],
            property: "fill",
            value: (0, i.getRGBaValue)(a, .9)
          }, {
            className: [".sv__lock-icon g g path", ".sv__checkbox g g path", ".sv__micro-top-bar__row svg path", ".sv__button:hover svg path", ".sv__button--selected svg path", ".sv__rating__buttons .sv__button--selected svg path", ".sv__caret svg g g"],
            property: "fill",
            value: t
          }, {
            className: ".sv__choice-button",
            property: "background-color",
            state: ":active",
            value: v
          }, {
            className: ".sv__minimized-symbol",
            property: "background-color",
            state: ":hover",
            value: f
          }, {
            className: ".sv__minimized-symbol",
            property: "background-color",
            state: ":active",
            value: f
          }, {
            className: ".sv__rating .sv__button",
            property: "background-color",
            state: ":hover",
            value: "transparent"
          }, {
            className: ".sv__choice-button",
            property: "border-color",
            state: ":active",
            value: t
          }, {
            className: ".sv-bg-bs",
            property: "border-bottom",
            value: "none"
          }, {
            className: ".sv__select-button",
            property: "background-color",
            state: ":hover",
            value: (0, i.getRGBaValue)(t, .15)
          }, {
            className: [".sv__choice-button", ".sv__button", ".sv__rating--vertical .sv__buttons .sv__button"],
            property: "background-color",
            state: ":hover",
            value: v
          }, {
            className: [".sv__textarea", ".sv__input", ".sv__date-wrapper .sv__mobile-datepicker"],
            property: "border-color",
            state: ":focus",
            value: t
          }];
        };
      },
      9510: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(1982)),
          n = r(75),
          o = r(2214),
          a = s(r(1473)),
          u = /\{\{\s?([a-z]+)(?:\.([a-zA-Z_-]+))?(?::([a-z0-9_-]+))?(?:\s?\|\s?"([^"]*)")?\s?\}\}/g;
        var l;
        !function (e) {
          e.visitor = "visitor", e.answer = "answer";
        }(l || (l = {}));
        t.default = class {
          static replaceTags(e, t) {
            return t.replace(u, (t, r, s, i, n = "") => {
              let a;
              switch (r) {
                case l.visitor:
                  a = this.getVisitorAttribute(e, s);
                  break;
                case l.answer:
                  a = this.getAnswer(e, parseInt(i, 10));
                  break;
                default:
                  a = "";
              }
              return a = "string" == typeof a ? (0, o.sanitizeString)(a) : a, a || n;
            });
          }
          static getVisitorAttribute(e, t) {
            const r = (0, n.getVisitorAttribute)(e, t);
            return (0, a.default)(r);
          }
          static getAnswer(e, t) {
            return i.default.getVisit(e).getAnswer(t);
          }
        };
      },
      8946: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static watchTabs(e) {
            const t = r => {
              "Tab" !== r.key && "Tab" !== r.code || (window.removeEventListener("keydown", t), e());
            };
            window.addEventListener("keydown", t);
          }
        };
      },
      5657: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          isSuccess() {
            return !1;
          }
        };
      },
      8388: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          isSuccess() {
            return !0;
          }
        };
      },
      4966: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const n = r(2831),
          o = i(r(6549)),
          a = i(r(3239)),
          u = i(r(4818)),
          l = r(8998),
          c = i(r(8340)),
          {
            REQUEST_HANDLER_TIMEOUT: d,
            REQUEST_HANDLER_REFRESH_INTERVAL: v,
            CONSUMPTION_INTERVAL: p,
            MUTEX_LOCK_INTERVAL: _
          } = c.default;
        t.default = class {
          constructor(e, t, r) {
            this.handlerId = (0, n.v4)(), this.isProcessing = !1, this.storage = t, this.requestsStorage = new u.default(t, e), this.consumer = r, this.consumeRequests(), this.surveyType = e;
          }
          addRequest(e) {
            const t = String(Date.now()) + (0, n.v4)();
            this.requestsStorage.add(e, t);
          }
          setThisRequestHandlerActive() {
            this.storage.put(this.surveyType, {
              key: l.StorageTableKeys.requestHandler,
              table: l.StorageTables.status
            }, {
              handlerId: this.handlerId,
              maximumTime: d + Date.now()
            });
          }
          isThisRequestHandlerActive() {
            const e = this.storage.get(this.surveyType, {
              key: l.StorageTableKeys.requestHandler,
              table: l.StorageTables.status
            });
            return !(!e || e.handlerId !== this.handlerId);
          }
          isActiveRequestHandlerInstance() {
            return s(this, void 0, void 0, function* () {
              const e = this.storage.get(this.surveyType, {
                key: l.StorageTableKeys.requestHandler,
                table: l.StorageTables.status
              });
              return e ? e && e.maximumTime < Date.now() ? (this.setThisRequestHandlerActive(), yield (0, o.default)(_), this.isThisRequestHandlerActive()) : !(!e || e.handlerId !== this.handlerId) && (!(e.maximumTime - Date.now() < v) || (this.setThisRequestHandlerActive(), yield (0, o.default)(_), this.isThisRequestHandlerActive())) : (this.setThisRequestHandlerActive(), yield (0, o.default)(_), this.isThisRequestHandlerActive());
            });
          }
          consumeRequests() {
            setInterval(() => s(this, void 0, void 0, function* () {
              if (!this.isProcessing && (yield this.isActiveRequestHandlerInstance())) {
                this.isProcessing = !0;
                try {
                  const e = this.requestsStorage.getAll();
                  if (e.length > 0) {
                    const t = e[0];
                    (yield this.consumer(t)).isSuccess() && this.requestsStorage.remove(t.key);
                  }
                } catch (e) {
                  e instanceof Error && a.default.log(this.surveyType, {
                    message: `RequestHandler: ${e.message}`,
                    stack: e.stack || ""
                  });
                }
                this.isProcessing = !1;
              }
            }), p);
          }
        };
      },
      8340: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = {
          CONSUMPTION_INTERVAL: 200,
          MUTEX_LOCK_INTERVAL: 30,
          REQUEST_HANDLER_TIMEOUT: 6e3,
          REQUEST_HANDLER_REFRESH_INTERVAL: 1e3
        };
      },
      4818: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(8998);
        t.default = class {
          constructor(e, t) {
            this.storage = e, this.storeType = t;
          }
          add(e, t) {
            const r = Object.assign(Object.assign({}, e), {
              key: t
            });
            return this.storage.put(this.storeType, {
              key: t,
              table: s.StorageTables.requests
            }, r), t;
          }
          getAll() {
            return this.storage.getAll(this.storeType, s.StorageTables.requests).sort((e, t) => e.key < t.key ? -1 : e.key > t.key ? 1 : 0);
          }
          remove(e) {
            this.storage.remove(this.storeType, {
              key: e,
              table: s.StorageTables.requests
            });
          }
        };
      },
      4201: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.sanitizeConfig = void 0, t.sanitizeConfig = {
          allowProtocolRelative: !0,
          allowedAttributes: {
            a: ["class", "href", "name", "style", {
              name: "target",
              values: ["_blank"]
            }],
            div: ["class", "title"],
            img: ["src", "alt", "title", "class", "width", "height"],
            label: ["for"],
            li: ["class"],
            p: ["class"],
            small: ["class"],
            span: ["class", "title"],
            table: ["summary"],
            td: ["abbr"],
            th: ["abbr", "class"]
          },
          allowedStyles: {
            "*": {
              "font-size": [/^\d+(?:px|em|%)$/],
              "font-weight": [/^normal|bold|bolder|lighter|([1-9]+00)$/]
            }
          },
          allowedTags: ["a", "b", "br", "div", "em", "h1", "h2", "h3", "h4", "i", "img", "li", "p", "small", "span", "strong", "table", "tbody", "th", "td", "tr", "ul"],
          transformTags: {
            span: (e, t) => t["data-suggestion"] ? {
              attribs: {},
              tagName: ""
            } : {
              attribs: t,
              tagName: e
            }
          }
        };
      },
      2214: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.sanitizeString = void 0;
        const i = s(r(4728)),
          n = r(4201);
        t.sanitizeString = e => (0, i.default)(e, n.sanitizeConfig);
      },
      1874: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.inMemoryLocalStorage = void 0, t.inMemoryLocalStorage = {
          storage: {},
          getItem(e) {
            return this.storage[e];
          },
          setItem(e, t) {
            this.storage[e] = t;
          },
          removeItem(e) {
            return delete this.storage[e];
          }
        };
      },
      9975: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.inMemorySessionStorage = void 0, t.inMemorySessionStorage = {
          storage: {},
          getItem(e) {
            return this.storage[e];
          },
          setItem(e, t) {
            this.storage[e] = t;
          },
          removeItem(e) {
            return delete this.storage[e];
          }
        };
      },
      1584: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(8443)),
          n = r(4496);
        t.default = class {
          constructor(e) {
            this.prefix = e;
          }
          getStoreKey({
            table: e,
            key: t
          }) {
            return `${this.prefix}${e}${t}`;
          }
          get(e, t) {
            return n.LocalStoreManager.getStore(e).get(this.getStoreKey(t), !0);
          }
          put(e, t, r) {
            n.LocalStoreManager.getStore(e).set(this.getStoreKey(t), r, !0);
          }
          getAll(e, t) {
            const r = [],
              s = new RegExp(`${this.prefix}${t}`);
            return n.LocalStoreManager.getStore(e).each((e, t) => {
              s.test(t) && r.push((0, i.default)(e));
            }), r;
          }
          remove(e, t) {
            n.LocalStoreManager.getStore(e).remove(this.getStoreKey(t), !0);
          }
        };
      },
      7963: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.LocalStore = void 0;
        const i = s(r(8443)),
          n = r(7057),
          o = r(9027),
          a = r(1874),
          u = r(8998);
        t.LocalStore = class {
          constructor(e) {
            var t, r;
            const s = (null === (t = o.storeManager.getStore(e).getState().backendData) || void 0 === t ? void 0 : t.workspaceKey) || (null === (r = window._svc) || void 0 === r ? void 0 : r.workspaceKey) || "",
              i = e === n.SurveyType.FeedbackButton ? `${e}::` : "";
            this.storagePrefix = `survi::${s}::${i}`, this.localStorage = this.initStorage();
          }
          initStorage() {
            try {
              const e = "__storage_test__";
              return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), window.localStorage;
            } catch (e) {
              return a.inMemoryLocalStorage;
            }
          }
          get(e, t = !1) {
            const r = t ? "" : this.storagePrefix,
              s = this.localStorage.getItem(`${r}${e}`);
            return (0, i.default)(s);
          }
          set(e, t, r = !1) {
            const s = r ? "" : this.storagePrefix;
            this.localStorage.setItem(`${s}${e}`, JSON.stringify(t));
          }
          remove(e, t = !1) {
            const r = t ? "" : this.storagePrefix;
            this.localStorage.removeItem(`${r}${e}`);
          }
          each(e) {
            Object.keys(this.localStorage).forEach(t => {
              if (t.startsWith(this.storagePrefix)) {
                const r = this.get(t, !0);
                e(r, t);
              }
            });
          }
          copyCurrentLSAndRemoveRequests(e) {
            Object.entries(e).forEach(([e, t]) => {
              e.startsWith(this.storagePrefix) && (this.localStorage.setItem(e, t), this.removeRequestsFromWindowLS(e));
            });
          }
          removeRequestsFromWindowLS(e) {
            e.includes(`${this.storagePrefix}${u.StorageTables.requests}`) && this.localStorage.removeItem(e);
          }
        };
      },
      4496: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.LocalStoreManager = void 0;
        const s = r(7963);
        t.LocalStoreManager = (() => {
          const e = {};
          return {
            getStore: t => (e[t] || (e[t] = new s.LocalStore(t)), e[t])
          };
        })();
      },
      7358: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SessionStore = void 0;
        const i = s(r(8443)),
          n = r(7057),
          o = r(9975);
        t.SessionStore = class {
          constructor(e) {
            const t = window._svc || {},
              r = e === n.SurveyType.FeedbackButton ? `${e}::` : "";
            this.storagePrefix = `survi::${t.workspaceKey}::${r}`, this.sessionStorage = this.initStorage();
          }
          initStorage() {
            try {
              const e = "__storage_test__";
              return window.sessionStorage.setItem(e, e), window.sessionStorage.removeItem(e), window.sessionStorage;
            } catch (e) {
              return o.inMemorySessionStorage;
            }
          }
          get(e) {
            const t = this.storagePrefix + e;
            return (0, i.default)(this.sessionStorage.getItem(t));
          }
          set(e, t) {
            const r = this.storagePrefix + e;
            this.sessionStorage.setItem(r, JSON.stringify(t));
          }
          remove(e) {
            const t = this.storagePrefix + e;
            this.sessionStorage.removeItem(t);
          }
        };
      },
      151: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SessionStoreManager = void 0;
        const s = r(7358);
        t.SessionStoreManager = (() => {
          const e = {};
          return {
            getStore: t => (e[t] || (e[t] = new s.SessionStore(t)), e[t])
          };
        })();
      },
      9262: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(7057),
          n = s(r(1584));
        t.default = class {
          constructor(e) {
            this.workspaceKey = e;
          }
          getStorageInstance(e) {
            const t = e === i.SurveyType.FeedbackButton ? `${e}::` : "";
            return new n.default(`survi::${this.workspaceKey}::${t}`);
          }
          get(e, t) {
            return this.getStorageInstance(e).get(e, t);
          }
          getAll(e, t) {
            return this.getStorageInstance(e).getAll(e, t);
          }
          put(e, t, r) {
            this.getStorageInstance(e).put(e, t, r);
          }
          remove(e, t) {
            this.getStorageInstance(e).remove(e, t);
          }
        };
      },
      3358: (e, t) => {
        "use strict";

        var r, s, i, n, o;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.StorageKeysError = t.StorageKeysSingleTab = t.StorageKeysQueue = t.StorageKeysVisitor = t.StorageKeysVisit = void 0, function (e) {
          e.referrerUrl = "visitReferrerUrl", e.initialUrl = "visitInitialUrl", e.displayedSurveys = "visitDisplayedSurveys", e.views = "visitViews", e.engaged = "visitEngaged", e.answers = "visitAnswers", e.sampledSurveys = "visitSampledSurveys";
        }(r || (t.StorageKeysVisit = r = {})), function (e) {
          e.uuid = "visitorUuid", e.attributes = "visitorAttributes", e.engagedSurveys = "visitorEngagedSurveys", e.displayedSurveys = "visitorDisplayedSurveys", e.identities = "visitorIdentities", e.tags = "visitorTags", e.visitsCount = "visitsCount";
        }(s || (t.StorageKeysVisitor = s = {})), function (e) {
          e.requestHandler = "requestHandler", e.savedVisitor = "visitorSaved";
        }(i || (t.StorageKeysQueue = i = {})), function (e) {
          e.state = "singleTabState", e.tabId = "singleTabId";
        }(n || (t.StorageKeysSingleTab = n = {})), function (e) {
          e.errorSent = "errorSent";
        }(o || (t.StorageKeysError = o = {}));
      },
      8998: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.StorageTableKeys = t.StorageTables = void 0, function (e) {
          e.requests = "requests", e.status = "status", e.all = "all";
        }(r || (t.StorageTables = r = {})), function (e) {
          e.visitor = "visitor", e.requestHandler = "requestHandler";
        }(s || (t.StorageTableKeys = s = {}));
      },
      6493: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ApiEvents = void 0, function (e) {
          e.questionAnswered = "question_answered", e.surveyDisplayed = "survey_displayed", e.surveyCompleted = "survey_completed", e.surveyClosed = "survey_closed";
        }(r || (t.ApiEvents = r = {}));
        t.default = new class {
          constructor() {
            this.lastEventId = 0, this.listeners = {
              [r.questionAnswered]: [],
              [r.surveyClosed]: [],
              [r.surveyCompleted]: [],
              [r.surveyDisplayed]: []
            };
          }
          add(e, t) {
            if (this.lastEventId += 1, !this.listeners[e]) throw new Error("Event Listeners: Wrong event name.");
            return this.listeners[e].push({
              callback: t,
              id: this.lastEventId
            }), this.lastEventId;
          }
          removeEventById(e) {
            const t = t => t.id !== e;
            this.listeners[r.questionAnswered] = this.listeners[r.questionAnswered].filter(t), this.listeners[r.surveyDisplayed] = this.listeners[r.surveyDisplayed].filter(t), this.listeners[r.surveyCompleted] = this.listeners[r.surveyCompleted].filter(t), this.listeners[r.surveyClosed] = this.listeners[r.surveyClosed].filter(t);
          }
          removeAllEventListenersByName(e) {
            if (!this.listeners[e]) throw new Error("Event listeners of this name cannot be removed: wrong event name.");
            this.listeners[e] = [];
          }
          remove(e) {
            "number" != typeof e ? this.removeAllEventListenersByName(e) : this.removeEventById(e);
          }
          fireEvent(e, t) {
            this.listeners[e].forEach(({
              callback: s
            }) => {
              const {
                surveyId: i,
                questionId: n,
                answer: o
              } = t;
              try {
                e === r.questionAnswered && n && o ? s(i, n, o) : s(i, o);
              } catch (t) {
                console.error(`Your callback function to Survicate '${e}' event returned an error: ${t}`);
              }
            });
          }
        }();
      },
      9049: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(4073),
          i = r(3501);
        t.default = (e, t) => {
          const {
              answer_type: r,
              surveyId: n,
              questionId: o,
              textResponse: a
            } = t,
            u = {
              answer_type: r
            };
          if (!e.length) return {
            questionId: o,
            surveyId: n
          };
          switch (r) {
            case i.SurveyQuestionAnswerType.smileyScale:
            case i.SurveyQuestionAnswerType.rating:
              u.answer_value = a;
              break;
            case i.SurveyQuestionAnswerType.single:
            case i.SurveyQuestionAnswerType.dropdown:
              u.answer_id = e[0].survey_question_answer_id;
              break;
            case i.SurveyQuestionAnswerType.multiple:
              u.answer_ids = e.map(e => e.survey_question_answer_id);
              break;
            case i.SurveyQuestionAnswerType.text:
            case i.SurveyQuestionAnswerType.date:
            case s.SurveyNpsAnswerType.nps:
              u.answer_value = e[0].content;
          }
          return {
            answer: u,
            questionId: o,
            surveyId: n
          };
        };
      },
      4590: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.initSurveyAPI = t.surveyApi = t.storeTypes = t.dispatchSurvicateReadyEvent = void 0;
        const n = i(r(5961)),
          o = r(7057),
          a = i(r(6493)),
          u = i(r(8948)),
          l = i(r(8446)),
          c = i(r(1982)),
          d = r(2230),
          v = r(3562),
          p = i(r(6374)),
          _ = r(9027),
          f = r(4144),
          h = i(r(9979)),
          m = r(9849),
          g = r(9535),
          b = r(8004),
          y = r(7028);
        var w;
        !function (e) {
          e.FeedbackSurvey = "fb", e.WidgetSurvey = "ws";
        }(w || (w = {})), t.dispatchSurvicateReadyEvent = function () {
          const e = document.createEvent("Event");
          e.initEvent("SurvicateReady", !0, !0), window._svc.initialized = !0, EventTarget.prototype.dispatchEvent.call(window, e);
        }, t.storeTypes = [o.SurveyType.WidgetSurvey, o.SurveyType.FeedbackButton], t.surveyApi = {
          addEventListener: (e, t) => a.default.add(e, t),
          destroyVisitor: e => s(void 0, void 0, void 0, function* () {
            t.storeTypes.forEach(t => {
              c.default.getVisit(t).resetVisit(), _.storeManager.getStore(t).action(m.clearSurveyState)(t), (0, p.default)(t, v.InitVisitorMode.kiosk), e && "function" == typeof e && e();
            });
          }),
          getState: e => {
            const t = e === w.FeedbackSurvey ? o.SurveyType.FeedbackButton : o.SurveyType.WidgetSurvey;
            return Object.assign(Object.assign({}, _.storeManager.getStore(t).getState()), {
              visit: c.default.getVisit(t).get()
            });
          },
          getSurvey: () => {
            const e = _.storeManager.getStore(o.SurveyType.WidgetSurvey).getState().surveyState.survey,
              t = _.storeManager.getStore(o.SurveyType.FeedbackButton).getState().surveyState.survey;
            return Object.assign(Object.assign({}, e && {
              widget: {
                id: e.id,
                name: e.name
              }
            }), t && {
              feedback: {
                id: t.id,
                name: t.name
              }
            });
          },
          getVisitorId: e => e && e === o.SurveyType.FeedbackButton ? _.storeManager.getStore(o.SurveyType.FeedbackButton).getState().visitor.uuid : _.storeManager.getStore(o.SurveyType.WidgetSurvey).getState().visitor.uuid,
          invokeEvent(e, r) {
            const s = {
              name: e,
              properties: Object.keys(r || {}),
              type: y.SurveyTargetingEventType.JSApi
            };
            if (s.name === y.SurvicateEvent.SurveySeen || s.name === y.SurvicateEvent.SurveyPointAnswered) return;
            e.startsWith("segmentEvent-") && (s.name = e.replace("segmentEvent-", ""), s.type = y.SurveyTargetingEventType.Segment);
            const {
                events: i,
                isEnabled: o
              } = g.targetingEventsStore.getState(),
              a = i.find(e => e.name === s.name),
              u = s.properties.filter(e => !(null == a ? void 0 : a.properties.includes(e)));
            if (o && (!a || a && u.length)) {
              (0, n.default)(Object.assign(Object.assign({}, s), {
                properties: u
              }));
              const e = a ? i.map(e => e.name === s.name ? Object.assign(Object.assign({}, e), {
                properties: [...e.properties, ...u]
              }) : e) : [...i, Object.assign(Object.assign({}, s), {
                properties: u
              })];
              g.targetingEventsStore.setState({
                events: e
              });
            }
            t.storeTypes.forEach(e => {
              _.storeManager.getStore(e).action(h.default)({
                eventTrigger: {
                  name: s.name,
                  properties: r
                }
              });
            });
          },
          removeEventListener: e => a.default.remove(e),
          retarget: () => {
            t.storeTypes.forEach(e => {
              const {
                surveyApiState: t,
                backendData: r
              } = _.storeManager.getStore(e).getState();
              d.TargetingTriggersInstance.startTargeting(e, [...t.surveysTriggeredByApi, ...r.surveys].filter(l.default.filterUniqueSurveys)), _.storeManager.getStore(e).action(h.default)();
            });
          },
          setVisitorTraits: e => {
            t.storeTypes.forEach(t => {
              _.storeManager.getStore(t).action(b.setVisitorAttributes)(e);
            });
          },
          showSurvey: (e, r = {}) => {
            let s = !1;
            return t.storeTypes.forEach(t => {
              const i = _.storeManager.getStore(t),
                {
                  backendData: n,
                  surveyState: o
                } = i.getState(),
                a = n.surveys.find(t => t.id === e);
              return !!a && !(!r.forceDisplay && o.survey) && (i.action(f.triggerSurveyByApi)(e, r), void (s = r.forceDisplay || u.default.ruleFulfilled(a, c.default.getVisit(t).get(), i.getState().visitor)));
            }), s;
          }
        };
        t.initSurveyAPI = e => {
          var r;
          const s = null === (r = e.permissions) || void 0 === r ? void 0 : r.targeting_javascript_api,
            i = () => {
              console.warn("The _sva object is unavailable on your current plan.\n      \n Upgrade your account to get access to JavaScript targeting feature");
            };
          window._sva = Object.assign(Object.assign({}, window._sva), Object.keys(t.surveyApi).reduce((e, r) => {
            const n = t.surveyApi[r],
              o = "setVisitorTraits" === r ? n : s ? n : i;
            return Object.assign(Object.assign({}, e), {
              [r]: o
            });
          }, {})), window._svx = {
            getEventsState: () => g.targetingEventsStore.getState(),
            showSurveyPoint: e => {
              t.storeTypes.forEach(t => {
                var r;
                const s = _.storeManager.getStore(t),
                  i = null === (r = s.getState().surveyState.survey) || void 0 === r ? void 0 : r.points.find(({
                    id: t
                  }) => t === Number(e));
                i && s.setState({
                  surveyState: Object.assign(Object.assign({}, s.getState().surveyState), {
                    pointsDisplayed: [{
                      point: i
                    }]
                  })
                });
              });
            }
          };
        };
      },
      4594: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(5994),
          i = r(9635),
          n = r(9577),
          o = r(5346),
          a = r(318),
          u = r(9027),
          l = r(313);
        t.default = (0, i.connect)(e => {
          var t;
          return {
            surveyId: null === (t = e.surveyState.survey) || void 0 === t ? void 0 : t.id
          };
        })(e => {
          const {
              surveyId: t
            } = e,
            {
              surveyEvent: r
            } = (0, s.useContext)(a.SurveyEventContext),
            {
              surveyType: i
            } = (0, s.useContext)(o.SurveyConfigContext),
            c = (0, s.useRef)(!0),
            {
              retrieveState: d,
              preserveState: v
            } = (0, l.useStorageService)(),
            [p, _] = (0, s.useState)(null);
          return (0, s.useEffect)(() => {
            var t;
            d(null === (t = u.storeManager.getStore(i).getState().surveyState.survey) || void 0 === t ? void 0 : t.id), _(e.children);
          }, [t]), (0, s.useEffect)(() => {
            c.current ? c.current = !1 : r && r.eventType !== n.SurveyEvent.closed && r.eventType !== n.SurveyEvent.finished && r.eventType !== n.SurveyEvent.shouldUpdate && v(t);
          }, [r]), p;
        });
      },
      313: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useStorageService = void 0;
        const s = r(5994),
          i = r(9577),
          n = r(5346),
          o = r(318),
          a = r(9027),
          u = r(4496),
          l = r(3358);
        t.useStorageService = () => {
          const {
              surveyEvent: e
            } = (0, s.useContext)(o.SurveyEventContext),
            {
              surveyType: t
            } = (0, s.useContext)(n.SurveyConfigContext),
            r = a.storeManager.getStore(t),
            c = u.LocalStoreManager.getStore(t),
            d = e => {
              var t;
              if (!e) return !1;
              const r = `${l.StorageKeysSingleTab.state}:${e}`,
                s = (null === (t = c.get(r)) || void 0 === t ? void 0 : t.timestamp) || 0;
              return Date.now() - s > 2592e6;
            };
          return (0, s.useEffect)(() => {
            (null == e ? void 0 : e.eventType) !== i.SurveyEvent.answered && c.remove(`${l.StorageKeysSingleTab.state}:${null == e ? void 0 : e.surveyId}`);
          }, [e]), {
            isCacheOutdated: d,
            preserveState: e => {
              if (!e) return;
              const t = `${l.StorageKeysSingleTab.state}:${e}`;
              c.set(t, {
                surveyApiState: r.getState().surveyApiState,
                surveyState: r.getState().surveyState,
                timestamp: Date.now()
              });
            },
            retrieveState: e => {
              var t, s, i, n;
              const o = r.getState();
              if (!e || o.isPreview || (null === (s = null === (t = o.surveyState.survey) || void 0 === t ? void 0 : t.settings) || void 0 === s ? void 0 : s.kiosk_enabled)) return;
              const a = `${l.StorageKeysSingleTab.state}:${e}`,
                u = null === (i = c.get(a)) || void 0 === i ? void 0 : i.surveyApiState,
                v = null === (n = c.get(a)) || void 0 === n ? void 0 : n.surveyState;
              v && u && (d(e) ? c.remove(`${l.StorageKeysSingleTab.state}:${e}`) : r.setState(Object.assign(Object.assign({}, o), {
                surveyState: Object.assign(Object.assign({}, v), u)
              })));
            }
          };
        };
      },
      6498: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(5994),
          n = r(9635),
          o = r(9577),
          a = r(5346),
          u = r(318),
          l = r(9027),
          c = s(r(9979)),
          d = s(r(3155)),
          v = r(313),
          p = s(r(579));
        t.default = (0, n.connect)(e => {
          var t;
          return {
            isPreview: e.isPreview,
            state: e,
            surveyId: null === (t = e.surveyState.survey) || void 0 === t ? void 0 : t.id
          };
        })(({
          surveyId: e,
          children: t,
          state: r
        }) => {
          const {
              update: s,
              surveyUpdated: n,
              isWidget: _,
              isFeedback: f,
              triggerConfigUpdate: h,
              isPreview: m,
              surveyType: g
            } = (0, i.useContext)(a.SurveyConfigContext),
            {
              surveyEvent: b
            } = (0, i.useContext)(u.SurveyEventContext),
            {
              isCacheOutdated: y
            } = (0, v.useStorageService)(),
            w = l.storeManager.getStore(g);
          return (0, i.useEffect)(() => {
            var t;
            if (!n || !e || !y(e)) return;
            const i = Array.isArray(s.surveys) && s.surveys.length > 0 ? s.surveys.find(t => t.id === e) : null,
              o = _ || f ? i : s.survey;
            if (!o) return w.setState(Object.assign(Object.assign({}, r), {
              surveyState: Object.assign(Object.assign({}, r.surveyState), {
                survey: null
              }),
              update: s
            })), void w.action(c.default)();
            const a = _ || f ? null == i ? void 0 : i.theme_id : null === (t = s.survey) || void 0 === t ? void 0 : t.theme_id,
              u = s.themes.find(e => e.id === a);
            let l = r.surveyState.theme;
            u && (l = d.default.extendTheme(u), d.default.reloadCss(l, g));
            const v = _ || f ? null == i ? void 0 : i.points[0] : s.survey.points[0],
              h = null == i ? void 0 : i.settings;
            let m = !1;
            (_ || f) && (m = p.default.isWidthMobile() ? !!(null == h ? void 0 : h.run_minimalized_mobile) : !!(null == h ? void 0 : h.run_minimalized)), w.setState(Object.assign(Object.assign({}, r), {
              surveyState: Object.assign(Object.assign({}, r.surveyState), {
                isAlreadyAnswered: !1,
                isFinished: !1,
                isMinimized: m,
                isOverlayActive: !(!_ && !f || !h) && !!h.overlay,
                pointsAnswered: [],
                pointsDisplayed: [{
                  point: v
                }],
                pointsForward: [],
                responseUuid: "",
                survey: o,
                theme: l
              }),
              update: s
            }));
          }, [n, s, r.surveyState]), (0, i.useEffect)(() => {
            (null == b ? void 0 : b.eventType) === o.SurveyEvent.shouldUpdate && h && !m && h();
          }, [b]), t;
        });
      },
      4642: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled(e, t, r) {
            const s = r.href.replace("://www.", "://").replace(`${r.protocol}//`, "");
            if (e) return !0;
            const i = t.filter(e => !e.visible && !!e.link && !!e.regexp_text_pattern);
            if (this.linksMatchUrl(i, r.href, s)) return !1;
            const n = t.filter(e => e.visible && !!e.link && !!e.regexp_text_pattern);
            return !n.length || this.linksMatchUrl(n, r.href, s);
          }
          static linksMatchUrl(e, t, r) {
            for (let s = 0; s < e.length; s += 1) {
              const i = new RegExp(e[s].regexp_text_pattern);
              if (i.test(t) || i.test(r)) return !0;
            }
            return !1;
          }
        };
      },
      4246: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const n = r(8885),
          o = i(r(4524)),
          a = i(r(120)),
          u = i(r(1586)),
          l = i(r(4036)),
          c = i(r(4766)),
          d = i(r(932)),
          v = i(r(9578)),
          p = i(r(4090)),
          _ = i(r(7630)),
          f = i(r(8034)),
          h = i(r(3613));
        t.default = class {
          static areFulfilled(e) {
            return s(this, arguments, void 0, function* ({
              audiences: e,
              survey: t,
              visit: r,
              visitor: i
            }) {
              const n = e.filter(e => t.audiences_ids.includes(e.id));
              return (yield Promise.all(n.map(e => s(this, void 0, void 0, function* () {
                return (yield this.isUserInAudience(e, {
                  visit: r,
                  visitor: i
                })) ? e : null;
              })))).filter(e => null !== e).length > 0;
            });
          }
          static isUserInAudience(e, t) {
            return s(this, void 0, void 0, function* () {
              const r = yield Promise.all(e.filters.map(e => this.userPassesRule(e, t)));
              return e.filters_relation === n.RelationOperator.and ? r.every(e => e) : r.some(e => e);
            });
          }
          static userPassesRule(e, t) {
            return s(this, void 0, void 0, function* () {
              const r = {
                [n.FilterName.attributes]: f.default,
                [n.FilterName.cookies]: h.default,
                [n.FilterName.device]: o.default,
                [n.FilterName.languages]: a.default,
                [n.FilterName.loggedInStatus]: u.default,
                [n.FilterName.tags]: c.default,
                [n.FilterName.visitDepth]: d.default,
                [n.FilterName.visitedUrls]: v.default,
                [n.FilterName.visitFrequency]: p.default,
                [n.FilterName.visitSource]: _.default,
                [n.FilterName.optimizely]: l.default
              }[e.name];
              if (!r) return !0;
              return (yield r.ruleFulfilled(e.parameters, t)) !== e.exclude;
            });
          }
        };
      },
      8034: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(3694),
          n = r(8885),
          o = r(7098),
          a = r(2878),
          u = r(205),
          l = s(r(6924)),
          c = s(r(2197));
        t.default = class {
          static ruleFulfilled({
            attributes: e,
            relation: t
          }, {
            visitor: r
          }) {
            var s, d;
            const v = Object.assign({}, r.attributes);
            (null === (d = null === (s = null == r ? void 0 : r.identities) || void 0 === s ? void 0 : s.api) || void 0 === d ? void 0 : d.id) && (v[i.USER_ID_TRAIT] = r.identities.api.id);
            const p = ({
              name: e,
              operator: t,
              values: r,
              attribute_type: s
            }) => {
              if (t === n.OperatorType.any) return e in v;
              if (!r || !Object.keys(v).length || !(e in v)) return !1;
              const i = (0, c.default)(v[e], s);
              if (null === i) return !1;
              const d = r.map(e => (0, c.default)(e, s)).filter(e => null !== e);
              if (!d.length) return !1;
              if ((t === n.OperatorType.is_between || t === n.OperatorType.is_not_between) && d.length < 2) return console.error("Not enough values for 'is_between' checks"), !1;
              switch (t) {
                case n.OperatorType.is_equal:
                  return l.default.isEqual(d, i);
                case n.OperatorType.is_not_equal:
                  return l.default.isNotEqual(d, i);
                case n.OperatorType.is_between:
                  return (0, a.isBetweenValues)([d[0], d[1]], i);
                case n.OperatorType.is_not_between:
                  return !(0, a.isBetweenValues)([d[0], d[1]], i);
                case n.OperatorType.is_on_the_date:
                  return l.default.compareDates(n.DateOperator.on, d[0], i);
                case n.OperatorType.is_earlier_than:
                  return l.default.compareDates(n.DateOperator.before, d[0], i);
                case n.OperatorType.is_later_than:
                  return l.default.compareDates(n.DateOperator.after, d[0], i);
                case n.OperatorType.is_less_than:
                  return "time_interval" === s ? l.default.compareDates(n.DateOperator.after, l.default.getTimeThreshold(d[0]), i) : l.default.isLessThan(d[0], i);
                case n.OperatorType.is_less_than_or_equal:
                  return l.default.isLessThanOrEqual(d[0], i);
                case n.OperatorType.is_true:
                  return !0 === i;
                case n.OperatorType.is_false:
                  return !1 === i;
                case n.OperatorType.is_greater_than:
                  return "time_interval" === s ? l.default.compareDates(n.DateOperator.before, l.default.getTimeThreshold(d[0]), i) : l.default.isGreaterThan(d[0], i);
                case n.OperatorType.is_greater_than_or_equal:
                  return l.default.isGreaterThanOrEqual(d[0], i);
                case n.OperatorType.contains:
                  return (0, o.doesContainValue)(i, {
                    condition: u.LogicCondition.answer_contains,
                    operator: u.LogicOperator.or,
                    value: d
                  });
                case n.OperatorType.does_not_contain:
                  return !(0, o.doesContainValue)(i, {
                    condition: u.LogicCondition.answer_contains,
                    operator: u.LogicOperator.and,
                    value: d
                  });
                default:
                  return console.error(`Unsupported OperatorType: ${t}`), !1;
              }
            };
            return t === n.RelationOperator.and ? e.every(p) : e.some(p);
          }
        };
      },
      6924: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(8885);
        t.default = class {
          static compareDates(e, t, r) {
            switch (e) {
              case s.DateOperator.on:
                return t === r;
              case s.DateOperator.before:
                return t > r;
              case s.DateOperator.after:
                return t < r;
            }
          }
          static isEqual(e, t) {
            return e.some(e => e === t);
          }
          static isNotEqual(e, t) {
            return e.every(e => e !== t);
          }
          static isLessThan(e, t) {
            return t < e;
          }
          static isLessThanOrEqual(e, t) {
            return t <= e;
          }
          static isGreaterThan(e, t) {
            return t > e;
          }
          static isGreaterThanOrEqual(e, t) {
            return t >= e;
          }
          static getTimeThreshold(e) {
            return new Date().getTime() - e;
          }
        };
      },
      1604: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => e instanceof Date ? e : new Date(e.toString());
      },
      2197: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(1604)),
          n = s(r(1473));
        t.default = (e, t) => {
          switch (t) {
            case "number":
              return Number(e);
            case "boolean":
              return e;
            case "datetime":
              {
                const t = (0, n.default)(e);
                return "string" == typeof t && 10 === t.length ? t : (console.error("Invalid datetime attribute. Please provide date in ISO string or Date object."), null);
              }
            case "time_interval":
              return "number" == typeof e ? e : (0, i.default)(e).getTime();
            default:
              return String(e).trim();
          }
        };
      },
      1473: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = e => "string" == typeof e && /\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d+)?(([+-]\d{2}:\d{2})|Z))?/.test(e) ? e.slice(0, 10) : "[object Date]" === Object.prototype.toString.call(e) ? e.toISOString().slice(0, 10) : e;
      },
      3613: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(2733)),
          n = r(8885);
        class o {
          static isCookieFulfilled({
            name: e,
            operator: t,
            values: r
          }) {
            const s = i.default.get(e);
            return t === n.OperatorType.is_equal && (null == r ? void 0 : r.length) ? r.some(e => `${s}` == `${e}`) : !!s;
          }
          static ruleFulfilled({
            cookies: e,
            relation: t
          }) {
            return t === n.RelationOperator.and ? e.every(e => o.isCookieFulfilled(e)) : e.some(e => o.isCookieFulfilled(e));
          }
        }
        t.default = o;
      },
      4524: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(8885),
          n = s(r(579));
        t.default = class {
          static ruleFulfilled({
            type: e
          }, {
            visit: t
          }) {
            return e === i.Device.all || (e === i.Device.mobile ? this.isMobile(t.user_agent) : !this.isMobile(t.user_agent));
          }
          static isMobile(e) {
            return n.default.isDeviceMobileOrTablet(e);
          }
        };
      },
      120: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled({
            list: e
          }, {
            visit: t
          }) {
            return e.some(e => t.language.startsWith(e));
          }
        };
      },
      1586: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(8885);
        t.default = class {
          static ruleFulfilled({
            type: e
          }, {
            visitor: t
          }) {
            const r = t.identities && t.identities.api && t.identities.api.id,
              i = t.attributes.email;
            return e === s.LoggedInStatus.identified == !(!r && !i);
          }
        };
      },
      4036: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled({
            experiment_id: e,
            variation_name: t
          }, {
            visit: r
          }) {
            return new Promise(s => {
              e && t.type || s(!0);
              let i = 0;
              const n = setInterval(() => {
                if (i += 100, i >= 8e3) return clearInterval(n), s(!1);
                const o = r.optimizelyState || window.optimizely && window.optimizely.get && window.optimizely.get("state");
                if (!o) return !1;
                if (!o.getVariationMap) return clearInterval(n), s(!1);
                const a = o.getVariationMap();
                return a[e] ? "any" === t.type ? (clearInterval(n), s(!0)) : (clearInterval(n), void s(a[e].name === t.value)) : (clearInterval(n), s(!1));
              }, 100);
            });
          }
        };
      },
      4766: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled({
            list: e
          }, {
            visitor: t
          }) {
            return e.some(e => t.tags.includes(e));
          }
        };
      },
      932: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled({
            count: e
          }, {
            visit: t
          }) {
            return e < t.views.length;
          }
        };
      },
      4090: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled({
            count: e
          }, {
            visitor: t
          }) {
            return 0 === e ? 1 === t.visitsCount : e < t.visitsCount;
          }
        };
      },
      7630: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const n = i(r(9160)),
          o = r(8885);
        t.default = class {
          static ruleFulfilled({
            type: e,
            urls: t,
            campaign: r
          }, {
            visit: s
          }) {
            switch (e) {
              case o.VisitSourceType.direct:
                return !s.referrerUrl;
              case o.VisitSourceType.referral:
                return t.some(e => new RegExp(e.regexp_text_pattern).test(s.referrerUrl.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")));
              case o.VisitSourceType.utm:
                return this.isUTMCorrect(r, s);
              case o.VisitSourceType.search:
                return this.isReferrerSearchEngine(s.referrerUrl);
            }
            return !0;
          }
          static isReferrerSearchEngine(e) {
            return s(this, void 0, void 0, function* () {
              const {
                data: t
              } = yield (0, n.default)("https://surveys-static.survicate.com").get("/data/search_engine_regexes.json");
              if (!e || !t.length) return !1;
              for (let r = 0; r < t.length; r += 1) {
                if (new RegExp(t[r]).test(e)) return !0;
              }
              return !1;
            });
          }
          static isUTMCorrect(e, t) {
            return this.isUTMParameterValid(e.medium, "utm_medium", t) && this.isUTMParameterValid(e.content, "utm_content", t) && this.isUTMParameterValid(e.name, "utm_campaign", t) && this.isUTMParameterValid(e.source, "utm_source", t) && this.isUTMParameterValid(e.term, "utm_term", t);
          }
          static isUTMParameterValid(e, t, r) {
            if (!e.length) return !0;
            const s = this.getParameterByName(t, r.initialUrl);
            return e.some(e => e === s);
          }
          static getParameterByName(e, t) {
            const r = e.replace(/[\[\]]/g, "\\$&"),
              s = new RegExp(`[?&]${r}(=([^&#]*)|&|#|$)`).exec(t);
            return s ? s[2] ? decodeURIComponent(s[2].replace(/\+/g, " ")) : "" : null;
          }
        };
      },
      9578: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled({
            urls: e
          }, {
            visit: t
          }) {
            return e.some(e => t.views.some(t => new RegExp(e.regexp_text_pattern).test(t.replace(/^(?:https?:\/\/)?(?:www\.)?/i, ""))));
          }
        };
      },
      8948: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(7057),
          i = r(5595),
          n = r(4422);
        t.default = class {
          static ruleFulfilled(e, t, r) {
            if (!e) return !0;
            if ((e.type === s.SurveyType.WidgetSurvey || e.type === s.SurveyType.FeedbackButton) && this.isSurveyInteractionActive(e, r.initialSurveysEngagement, {
              checkRecurringLifespan: !0
            })) return !1;
            if (this.isSurveyInteractionActive(e, r.engagedSurveys)) return !1;
            const i = this.findInteractionStatus(e, r.engagedSurveys) === n.InteractionStatus.none,
              o = this.isNotExpiredPerVisit(e, t) || this.isNotExpiredPerVisitor(e, r);
            return (!i || !o) && (!e.settings.display_not_engaged || !t.engaged);
          }
          static findInteractionStatus(e, t, r) {
            var s;
            if (!Array.isArray(t) || !(null == t ? void 0 : t.length) || !e) return n.InteractionStatus.none;
            const i = null == e ? void 0 : e.settings,
              o = t.find(t => (t.surveyId || t) === e.id);
            if (!o) return n.InteractionStatus.none;
            if (i.recurring && !(null == r ? void 0 : r.skipRecurringCheck)) {
              if (null == r ? void 0 : r.checkRecurringLifespan) {
                const e = 1e3 * (null !== (s = i.recurring_stop_after) && void 0 !== s ? s : 0);
                if (e > 0 && o.timestamp + e <= Date.now()) return n.InteractionStatus.recurringStopped;
              }
              const e = 1e3 * i.recurring_period;
              if (o.timestamp + e <= Date.now()) return n.InteractionStatus.expired;
            }
            return n.InteractionStatus.notExpired;
          }
          static isSurveyInteractionActive(e, t, r) {
            const s = this.findInteractionStatus(e, t, r);
            return s === n.InteractionStatus.notExpired || s === n.InteractionStatus.recurringStopped;
          }
          static isNotExpiredPerVisit(e, t) {
            return e.settings.display_per === i.DisplayPer.visit && this.findInteractionStatus(e, t.displayedSurveys, {
              skipRecurringCheck: !0
            }) === n.InteractionStatus.notExpired;
          }
          static isNotExpiredPerVisitor(e, t) {
            return e.settings.display_per === i.DisplayPer.visitor && this.findInteractionStatus(e, t.displayedSurveys, {
              skipRecurringCheck: !0
            }) === n.InteractionStatus.notExpired;
          }
        };
      },
      4422: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.InteractionStatus = void 0, function (e) {
          e[e.none = 0] = "none", e[e.expired = 1] = "expired", e[e.notExpired = 2] = "notExpired", e[e.recurringStopped = 3] = "recurringStopped";
        }(r || (t.InteractionStatus = r = {}));
      },
      9486: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.GeneralRules = void 0;
        const i = s(r(4642)),
          n = s(r(8948)),
          o = s(r(1052)),
          a = s(r(8860)),
          u = s(r(762));
        t.GeneralRules = class {
          static areFulfilled({
            survey: e,
            visit: t,
            visitor: r,
            storeType: s
          }) {
            return n.default.ruleFulfilled(e, t, r) && u.default.ruleFulfilled(e, t, r) && a.default.ruleFulfilled(e, r) && i.default.ruleFulfilled(e.settings.display_all, e.links, document.location) && o.default.ruleFulfilled(e, t, s);
          }
        };
      },
      8860: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = class {
          static ruleFulfilled(e, t) {
            var r;
            const s = null !== (r = (null == e ? void 0 : e.settings).survey_throttle) && void 0 !== r ? r : 0;
            if (s && t.displayedSurveys.length > 0) {
              const e = t.displayedSurveys[t.displayedSurveys.length - 1].timestamp;
              return Date.now() - e >= 864e5 * s;
            }
            return !0;
          }
        };
      },
      762: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(5595);
        t.default = class {
          static ruleFulfilled(e, t, r) {
            var i;
            if (!e) return !0;
            const n = null !== (i = e.settings.recurring_max_views) && void 0 !== i ? i : 0;
            return !n || (e.settings.display_per === s.DisplayPer.visit ? r.visitsCount : t.views.length) <= n;
          }
        };
      },
      1052: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(1982));
        t.default = class {
          static ruleFulfilled(e, {
            sampledSurveys: t
          }, r) {
            if (e.settings.display_percentage >= 100 || !r) return !0;
            const s = t.find(t => (t.surveyId || t) === e.id);
            if (s) return s.sampled;
            const n = 100 * Math.random() <= e.settings.display_percentage;
            return i.default.getVisit(r).addSampledSurvey(e.id, n), n;
          }
        };
      },
      2732: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(5595);
        t.default = class {
          static ruleFulfilled(e, {
            delayed: t
          }) {
            return e.settings.appear_method !== s.AppearMethod.delayed || !!t && e.settings.display_delay <= t;
          }
        };
      },
      5790: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(8885),
          i = r(5595);
        t.default = class {
          static ruleFulfilled(e, {
            eventTrigger: t
          }) {
            var r;
            const s = e.settings;
            if (s.appear_method !== i.AppearMethod.event) return !0;
            const n = null !== (r = s.events) && void 0 !== r ? r : [];
            return !(!n.length || !t) && n.some(e => t.name === e.name && this.evaluateEventPropsMatch(t.properties, e));
          }
          static evaluateEventPropsMatch(e, t) {
            return !t.properties.length || this.compareEventProps(e, t);
          }
          static compareEventProps(e, t) {
            if (!e) return !1;
            const r = Object.keys(e),
              i = t => r.includes(t.name) && e[t.name] === t.value,
              {
                relation: n,
                properties: o
              } = t;
            return n === s.RelationOperator.and ? o.every(i) : o.some(i);
          }
        };
      },
      4822: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(5595);
        t.default = class {
          static ruleFulfilled(e, {
            exitIntent: t
          }) {
            return e.settings.appear_method !== s.AppearMethod.exitIntent || !!t;
          }
        };
      },
      6016: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(5595);
        t.default = class {
          static ruleFulfilled(e, {
            scroll: t
          }) {
            return e.settings.appear_method !== s.AppearMethod.scroll || !!t && e.settings.display_scroll <= t;
          }
        };
      },
      8798: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.TriggerRules = void 0;
        const i = s(r(2732)),
          n = s(r(4822)),
          o = s(r(6016)),
          a = s(r(5790));
        t.TriggerRules = class {
          static areFulfilled(e, t) {
            return n.default.ruleFulfilled(e, t) && i.default.ruleFulfilled(e, t) && o.default.ruleFulfilled(e, t) && a.default.ruleFulfilled(e, t);
          }
        };
      },
      8446: function (e, t, r) {
        "use strict";

        var s = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const n = i(r(4246)),
          o = i(r(8948)),
          a = r(9486),
          u = r(8798),
          l = r(9027),
          c = i(r(8108)),
          d = i(r(8860)),
          v = i(r(762));
        class p {
          static filterUniqueSurveys(e, t, r = []) {
            for (let s = 0; s < r.length; s += 1) if (r[s].id === e.id && s < t) return !1;
            return !0;
          }
          static findSurveyToDisplay(e) {
            return s(this, void 0, void 0, function* () {
              const t = this.getSurveysToTarget(e),
                r = l.storeManager.getStore(e.storeType),
                i = (yield Promise.all(t.map(t => s(this, void 0, void 0, function* () {
                  return (yield p.canDisplaySurvey(Object.assign(Object.assign({}, e), {
                    survey: t
                  }))) ? t : null;
                })))).filter(e => null !== e);
              i.length > 0 && r.action(c.default)(i[0]);
            });
          }
          static canDisplaySurvey(e) {
            return s(this, void 0, void 0, function* () {
              return !!e.surveysTriggeredByApi.find(t => t.id === e.survey.id) ? this.canDisplayTriggeredSurvey(e) : p.surveyHasPoints(e.survey) && u.TriggerRules.areFulfilled(e.survey, e.triggers) && a.GeneralRules.areFulfilled(e) && n.default.areFulfilled(e);
            });
          }
          static canDisplayTriggeredSurvey(e) {
            const t = l.storeManager.getStore(e.storeType),
              r = t.getState().surveyState.forceDisplay ? p.surveyHasPoints(e.survey) : p.surveyHasPoints(e.survey) && u.TriggerRules.areFulfilled(e.survey, e.triggers) && o.default.ruleFulfilled(e.survey, e.visit, e.visitor) && v.default.ruleFulfilled(e.survey, e.visit, e.visitor) && d.default.ruleFulfilled(e.survey, e.visitor);
            return r && t.setState({
              surveyApiState: Object.assign(Object.assign({}, t.getState().surveyApiState), {
                surveysTriggeredByApi: []
              })
            }), r;
          }
          static surveyHasPoints(e) {
            return !!e.points;
          }
        }
        p.getSurveysToTarget = ({
          surveys: e,
          surveysTriggeredByApi: t
        }) => {
          var r;
          if (null === (r = window._sva) || void 0 === r ? void 0 : r.disableTargeting) return t;
          return (t ? [...t, ...e] : e).filter(p.filterUniqueSurveys);
        }, t.default = p;
      },
      5643: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Delay = void 0;
        const i = r(9027),
          n = s(r(9979)),
          o = r(5595),
          a = s(r(2091));
        t.Delay = class {
          constructor() {
            this.loadTime = Date.now(), this.intervalListeners = new Map();
          }
          fireEvent(e, t) {
            const r = i.storeManager.getStore(e);
            r.getState().surveyState.survey || r.action(n.default)({
              delayed: t
            });
          }
          startListening(e, t) {
            if (!e || !(null == t ? void 0 : t.length)) return;
            this.stopListening();
            const r = t.filter(e => e.settings.appear_method === o.AppearMethod.delayed);
            if (!r.length) return;
            const s = Math.min(...r.map(e => e.settings.display_delay)),
              i = window.setInterval(() => {
                this.loadTime = a.default.hasUrlChanged(e) ? Date.now() : this.loadTime;
                const t = (Date.now() - this.loadTime) / 1e3;
                t >= s && this.fireEvent(e, t);
              }, 1e3);
            this.intervalListeners.set(e, i);
          }
          stopListening() {
            this.intervalListeners.forEach(e => clearInterval(e)), this.intervalListeners.clear();
          }
          resetLoadTime() {
            this.loadTime = Date.now();
          }
        };
      },
      6120: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ExitIntent = void 0;
        const i = s(r(1831)),
          n = r(9027),
          o = s(r(9979)),
          a = r(5595);
        t.ExitIntent = class {
          constructor() {
            this.exitIntentListeners = new Map();
          }
          fireEvent(e) {
            n.storeManager.getStore(e).getState().surveyState.survey || n.storeManager.getStore(e).action(o.default)({
              exitIntent: !0
            });
          }
          startListening(e, t) {
            if (0 === t.filter(e => e.settings.appear_method === a.AppearMethod.exitIntent).length) return;
            const r = (0, i.default)(t => {
              t.clientY < 20 && this.fireEvent(e);
            }, 100);
            this.exitIntentListeners.set(e, r), document.addEventListener("mouseleave", r);
          }
          stopListening(e) {
            const t = this.exitIntentListeners.get(e);
            t && (document.removeEventListener("mouseleave", t), this.exitIntentListeners.delete(e));
          }
        };
      },
      1923: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Scroll = void 0;
        const i = s(r(1831)),
          n = r(9027),
          o = s(r(9979)),
          a = r(5595);
        t.Scroll = class {
          constructor() {
            this.scrollListeners = new Map();
          }
          fireEvent(e, t) {
            const r = n.storeManager.getStore(e);
            r.getState().surveyState.survey || (r.action(o.default)({
              scroll: t
            }), this.scrollListeners.get(e) || this.stopListening(e));
          }
          startListening(e, t) {
            const r = t.filter(e => e.settings.appear_method === a.AppearMethod.scroll);
            if (0 === r.length) return;
            const s = r.map(e => e.settings.display_scroll).sort((e, t) => t - e),
              n = (0, i.default)(() => {
                const t = Math.ceil(window.scrollY / (document.documentElement.scrollHeight - document.documentElement.clientHeight) * 100);
                t >= s[0] && this.fireEvent(e, t);
              }, 100);
            this.scrollListeners.set(e, n), window.addEventListener("scroll", n);
          }
          stopListening(e) {
            const t = this.scrollListeners.get(e);
            t && (window.removeEventListener("scroll", t), this.scrollListeners.delete(e));
          }
        };
      },
      8488: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.TargetingTriggerManager = void 0;
        const i = s(r(579)),
          n = r(5643),
          o = r(6120),
          a = r(1923);
        class u {
          constructor() {
            this.triggerRegistry = {};
          }
          static getInstance() {
            return u.instance || (u.instance = new u()), u.instance;
          }
          getTriggersForSurveyType(e) {
            return e ? (this.triggerRegistry[e] || (this.triggerRegistry[e] = [...(i.default.isDeviceMobileOrTablet() ? [] : [new o.ExitIntent()]), new a.Scroll(), new n.Delay()]), this.triggerRegistry[e]) : [];
          }
          startTargeting(e, t) {
            this.getTriggersForSurveyType(e).forEach(r => {
              r.stopListening(e), r.startListening(e, t);
            });
          }
          stopTargeting(e) {
            this.getTriggersForSurveyType(e).forEach(t => t.stopListening(e));
          }
          resetDelayLoadTime(e) {
            this.getTriggersForSurveyType(e).forEach(e => {
              e instanceof n.Delay && e.resetLoadTime();
            });
          }
        }
        t.TargetingTriggerManager = u;
      },
      5575: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ReservedParams = void 0;
        const s = r(7057),
          i = r(9027);
        var n;
        !function (e) {
          e.aid = "aid", e.multiple_responses = "multiple_responses", e.sid = "sid", e.uid = "uid", e.p = "p", e.autofocus = "autofocus";
        }(n || (t.ReservedParams = n = {}));
        t.default = new class {
          constructor() {
            this.params = {}, this.searchString = window.location.search.substring(1), this.url = this.getUrl(), this.params = this.searchString ? this.getParams() : {};
          }
          hasEncodedParams() {
            return !!this.parseParams(this.searchString)._svbep;
          }
          decodeSearchString() {
            return atob(this.searchString.split("_svbep=")[1]).substring(1);
          }
          getParams() {
            return this.hasEncodedParams() ? this.parseParams(this.decodeSearchString()) : this.parseParams(this.searchString);
          }
          getPointId() {
            return this.getParams().pointId || null;
          }
          getUrl() {
            const e = this.hasEncodedParams() ? this.decodeSearchString() : this.searchString;
            return `${window.location.origin}${window.location.pathname}${e ? `?${e}` : ""}${window.location.hash}`;
          }
          parseParams(e) {
            const t = {};
            return e.split("&").forEach(e => {
              const [r, s] = e.split("=");
              if (s) try {
                t[r] = decodeURIComponent(s);
              } catch (e) {
                t[r] = unescape(s);
              }
            }), t;
          }
          replaceWindowUrl() {
            if (i.storeManager.getStore(s.SurveyType.PageSurvey).getState().isPreview || this.hasEncodedParams() || !this.searchString) return;
            const e = `?${this.searchString}`,
              t = "?_svbep=",
              r = e.includes(t) ? t : `${t}${btoa(e)}`;
            window.history.replaceState({}, "", r);
          }
        }();
      },
      579: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = new class {
          constructor() {
            this.userAgent = "", this.resetUserAgent();
          }
          isAppleOS() {
            return !!this.userAgent.match(/Mac/i);
          }
          isWidthMobile() {
            return !!window.innerWidth && window.innerWidth < 768;
          }
          isBrowserIE() {
            return this.userAgent.includes("MSIE") || !!this.userAgent.match(/Trident.*rv\:11\./);
          }
          hasHover() {
            return !this.isDeviceMobileOrTablet();
          }
          isDeviceMobileOrTablet(e = "") {
            let t = !1;
            var r;
            return r = e || this.userAgent, (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(r) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(r.substr(0, 4))) && (t = !0), t;
          }
          resetUserAgent(e) {
            const t = e || window;
            this.userAgent = t.navigator.userAgent || t.navigator.vendor || t.opera;
          }
        }();
      },
      1982: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(6880)),
          n = s(r(7678)),
          o = r(3358),
          a = s(r(5575)),
          u = r(4496),
          l = r(151);
        class c {
          constructor(e) {
            this.surveyType = e, this.sessionStore = l.SessionStoreManager.getStore(this.surveyType), this.localStore = u.LocalStoreManager.getStore(this.surveyType);
            const t = this.sessionStore.get(o.StorageKeysVisit.initialUrl),
              r = this.sessionStore.get(o.StorageKeysVisit.referrerUrl);
            this.visitData = this.initializeVisitData(t, r), this.setCurrentView(), t !== this.visitData.initialUrl && this.sessionStore.set(o.StorageKeysVisit.initialUrl, this.visitData.initialUrl), r !== this.visitData.referrerUrl && this.sessionStore.set(o.StorageKeysVisit.referrerUrl, this.visitData.referrerUrl);
          }
          static getVisit(e) {
            return new c(e);
          }
          initializeVisitData(e, t) {
            return {
              answers: this.getVisitAnswers(),
              device_type: this.getDeviceType(),
              displayedSurveys: this.getDisplayedSurveys(),
              engaged: this.getEngaged(),
              initialUrl: e || a.default.getUrl().replace(`${window.location.protocol}//`, ""),
              language: window.navigator.language,
              operating_system: this.getOperatingSystem(),
              optimizelyState: window.optimizely && window.optimizely.get && window.optimizely.get("state"),
              referrerUrl: t || this.getReferrer(),
              sampledSurveys: this.getSampledSurveys(),
              user_agent: window.navigator.userAgent,
              views: this.getViews()
            };
          }
          setCurrentView() {
            const e = a.default.getUrl().replace(`${window.location.protocol}//`, "");
            this.visitData.views.includes(e) || (this.visitData.views.push(e), this.sessionStore.set(o.StorageKeysVisit.views, this.visitData.views));
          }
          get() {
            return this.visitData;
          }
          getVisitAnswers() {
            return this.localStore.get(o.StorageKeysVisit.answers) || {};
          }
          getAnswer(e) {
            return this.visitData.answers[e];
          }
          getDisplayedSurveys() {
            return this.sessionStore.get(o.StorageKeysVisit.displayedSurveys) || [];
          }
          getSampledSurveys() {
            return this.sessionStore.get(o.StorageKeysVisit.sampledSurveys) || [];
          }
          getReferrer() {
            return document.referrer;
          }
          getDeviceType() {
            let e = (0, n.default)(i.default.getParser(window.navigator.userAgent).getPlatformType());
            return ["Desktop", "Tablet", "Mobile", "Tv"].includes(e) || (e = null), e;
          }
          getOperatingSystem() {
            const e = i.default.getParser(window.navigator.userAgent).getOSName();
            return e ? ["Windows", "macOS", "iOS", "Android", "Linux", "Chrome OS"].includes(e) ? e : "Other" : null;
          }
          getViews() {
            return this.sessionStore.get(o.StorageKeysVisit.views) || [];
          }
          getEngaged() {
            return this.sessionStore.get(o.StorageKeysVisit.engaged) || !1;
          }
          addAnswer(e, t) {
            const r = Object.assign({}, this.visitData.answers);
            r[e] = t, this.visitData.answers = r, this.localStore.set(o.StorageKeysVisit.answers, r);
          }
          setEngaged() {
            this.visitData.engaged = !0, this.sessionStore.set(o.StorageKeysVisit.engaged, !0);
          }
          addDisplayedSurvey(e) {
            const t = this.getDisplayedSurveys(),
              r = {
                surveyId: e,
                timestamp: new Date().getTime()
              },
              s = t.findIndex(t => (t.surveyId || t) === e);
            -1 !== s ? t[s] = r : t.push(r), this.sessionStore.set(o.StorageKeysVisit.displayedSurveys, t), this.visitData.displayedSurveys = t;
          }
          addSampledSurvey(e, t) {
            const r = this.getSampledSurveys(),
              s = {
                sampled: t,
                surveyId: e
              },
              i = r.findIndex(t => (t.surveyId || t) === e);
            -1 !== i ? r[i] = s : r.push(s), this.sessionStore.set(o.StorageKeysVisit.sampledSurveys, r), this.visitData.sampledSurveys = r;
          }
          resetVisit() {
            this.visitData.answers = {}, this.visitData.views = [], this.visitData.displayedSurveys = [], this.visitData.sampledSurveys = [], this.visitData.engaged = !1, this.sessionStore.remove(o.StorageKeysVisit.engaged), this.localStore.remove(o.StorageKeysVisit.answers), this.sessionStore.remove(o.StorageKeysVisit.views), this.sessionStore.remove(o.StorageKeysVisit.displayedSurveys), this.sessionStore.remove(o.StorageKeysVisit.sampledSurveys), this.setCurrentView();
          }
        }
        t.default = c;
      },
      8368: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.emptyVisit = void 0, t.emptyVisit = {
          answers: {},
          device_type: "",
          displayedSurveys: [],
          engaged: !1,
          initialUrl: "",
          language: "",
          operating_system: "",
          optimizelyState: {
            getVariationMap: () => ({})
          },
          referrerUrl: "",
          sampledSurveys: [],
          user_agent: "",
          views: []
        };
      },
      5409: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.actions = t.setPreview = t.setTabId = void 0;
        const s = r(830),
          i = r(2230),
          n = r(9027),
          o = r(4144),
          a = r(9849),
          u = r(8004);
        function l(e, t) {
          n.storeManager.getStore(e.storeType).setState({
            tabId: t
          });
        }
        t.setTabId = l, t.setPreview = function (e, t) {
          n.storeManager.getStore(e.storeType).setState({
            isPreview: t
          });
        }, t.actions = function () {
          return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, o.surveyAPIActions), i.backendDataActions), a.surveyStateActions), s.apiActions), u.visitorActions), {
            setTabId: l
          });
        };
      },
      830: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          n = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && s(t, e, r);
            return i(t, e), t;
          },
          o = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.apiActions = t.surveyPointSeen = t.maximized = t.minimized = t.closed = t.seen = t.answered = void 0;
        const a = o(r(1394)),
          u = r(9902),
          l = r(87),
          c = r(5723),
          d = r(907),
          v = n(r(6493)),
          p = o(r(9049)),
          _ = o(r(1982)),
          f = r(2937),
          h = o(r(9979)),
          m = r(8004),
          g = r(4714),
          b = r(9027),
          y = e => {
            var t, r;
            return (null === (r = null === (t = e.surveyState) || void 0 === t ? void 0 : t.survey) || void 0 === r ? void 0 : r.integrations) || {};
          };
        function w(e, t) {
          var r;
          const s = b.storeManager.getStore(e.storeType);
          s.action(m.setSurveyInteraction)({
            interactionType: g.SurveyInteractionType.engaged,
            surveyId: t.survey.id
          }), e.storeType && (_.default.getVisit(e.storeType).setEngaged(), _.default.getVisit(e.storeType).addAnswer(t.surveyPointId, t.textResponse));
          const i = y(e);
          let n;
          if (t.pointType === l.SurveyPointType.form) {
            const e = {};
            t.answers.forEach(t => {
              t.answer_type && t.content && (e[t.answer_type] = t.content);
            }), s.action(m.setVisitorAttributes)(e), n = Object.assign(Object.assign({}, t), {
              contactForm: e
            });
          } else {
            const {
                surveyState: {
                  survey: r
                }
              } = e,
              s = null == r ? void 0 : r.points.map(e => e.id).indexOf(t.surveyPointId);
            n = Object.assign(Object.assign({}, t), {
              question: void 0 !== s && -1 !== s ? `${s + 1} - ${t.question}` : t.question
            });
          }
          null === (r = e.backendService) || void 0 === r || r.addRequest(c.EndpointType.answered, (0, f.getAnsweredJsonPayload)(t, e.visitor), t.survey.id, e.storeType), v.default.fireEvent(v.ApiEvents.questionAnswered, (0, p.default)(t.answers, {
            answer_type: t.answerType,
            questionId: t.surveyPointId,
            surveyId: t.survey.id,
            textResponse: t.textResponse
          })), a.default.pushEvent(u.IntegrationEventTypes.SurveyPointAnswered, n, i);
        }
        function x(e) {
          var t;
          const {
              survey: r
            } = e.surveyState,
            s = b.storeManager.getStore(e.storeType);
          if (!r) return;
          const i = {
            visitor: (0, d.trimVisitor)(e.visitor)
          };
          !s.getState().visitor.displayedSurveys.some(({
            surveyId: e
          }) => e === r.id) && (i.survey_first_seen = !0), null === (t = e.backendService) || void 0 === t || t.addRequest(c.EndpointType.seen, i, r.id, e.storeType), s.action(m.setSurveyInteraction)({
            interactionType: g.SurveyInteractionType.displayed,
            surveyId: r.id
          }), e.storeType && _.default.getVisit(e.storeType).addDisplayedSurvey(r.id), v.default.fireEvent(v.ApiEvents.surveyDisplayed, {
            surveyId: r.id
          });
          const n = y(e);
          a.default.pushEvent(u.IntegrationEventTypes.SurveySeen, {
            surveyName: r.name
          }, n);
        }
        function S(e, t) {
          const r = b.storeManager.getStore(e.storeType);
          r.action(m.setSurveyInteraction)({
            interactionType: g.SurveyInteractionType.engaged,
            surveyId: t.surveyId
          }), e.storeType && _.default.getVisit(e.storeType).setEngaged(), r.action(h.default)(), v.default.fireEvent(v.ApiEvents.surveyClosed, {
            surveyId: t.surveyId
          });
          const s = y(e);
          a.default.pushEvent(u.IntegrationEventTypes.SurveyClosed, t, s);
        }
        function k(e, t) {
          const r = y(e);
          a.default.pushEvent(u.IntegrationEventTypes.SurveyMinimized, t, r);
        }
        function T(e, t) {
          const r = y(e);
          a.default.pushEvent(u.IntegrationEventTypes.SurveyMaximized, t, r);
        }
        function M(e, t) {
          const r = y(e);
          a.default.pushEvent(u.IntegrationEventTypes.SurveyPointSeen, t, r);
        }
        t.answered = w, t.seen = x, t.closed = S, t.minimized = k, t.maximized = T, t.surveyPointSeen = M, t.apiActions = {
          answered: w,
          closed: S,
          maximized: T,
          minimized: k,
          seen: x,
          surveyPointSeen: M
        };
      },
      2937: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getAnsweredJsonPayload = void 0;
        const i = s(r(3749)),
          n = r(907),
          o = r(2230);
        t.getAnsweredJsonPayload = (e, t) => {
          return {
            integrations: o.IntegrationsServiceInstance.getAPIToAnsweredJsonIntegrations() || void 0,
            overwrite: e.overwrite || void 0,
            response_uuid: e.response_uuid,
            survey_point_id: e.surveyPointId,
            visit_points: (r = e.answers, s = e.completionRate, a = e.survey, r.map(e => {
              const {
                survey_question_answer_id: t,
                user_tag: r,
                content: n,
                answer_type: o
              } = e;
              return {
                answer_type: o || void 0,
                completion_rate: s,
                content: n || void 0,
                finished: 100 === s || void 0,
                survey_question_answer_id: t || void 0,
                user_tag: (0, i.default)(r, a.global_tags)
              };
            })),
            visitor: (0, n.trimVisitor)(t)
          };
          var r, s, a;
        };
      },
      2230: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.backendDataActions = t.setTranslations = t.setWorkspaceKey = t.setIntegrations = t.setThemes = t.setAudiences = t.setSurveys = t.IntegrationsServiceInstance = t.TargetingTriggersInstance = void 0;
        const i = s(r(7885)),
          n = s(r(4031)),
          o = r(1335),
          a = s(r(3155)),
          u = r(8488),
          l = s(r(5575)),
          c = r(9027),
          d = s(r(9979));
        function v(e, r) {
          const s = c.storeManager.getStore(e.storeType),
            i = (0, n.default)(r, e.storeType);
          s.setState({
            backendData: Object.assign(Object.assign({}, e.backendData), {
              surveys: i
            })
          }), t.TargetingTriggersInstance.startTargeting(e.storeType, i), s.action(d.default)({
            force: !0
          });
        }
        function p(e, t) {
          e.storeType && c.storeManager.getStore(e.storeType).setState({
            backendData: Object.assign(Object.assign({}, e.backendData), {
              audiences: t
            })
          });
        }
        function _(e, t = []) {
          c.storeManager.getStore(e.storeType).setState({
            backendData: Object.assign(Object.assign({}, e.backendData), {
              themes: t.map(e => e.type === o.ThemeType.mobile ? e : a.default.extendTheme(e))
            })
          });
        }
        function f(e, r) {
          c.storeManager.getStore(e.storeType).setState({
            backendData: Object.assign(Object.assign({}, e.backendData), {
              integrations: r
            })
          }), t.IntegrationsServiceInstance.init(r, l.default.params, c.storeManager.getStore(e.storeType));
        }
        function h(e, t) {
          c.storeManager.getStore(e.storeType).setState({
            backendData: Object.assign(Object.assign({}, e.backendData), {
              workspaceKey: t
            })
          });
        }
        function m(e, t) {
          c.storeManager.getStore(e.storeType).setState({
            backendData: Object.assign(Object.assign({}, e.backendData), {
              translations: t
            })
          });
        }
        t.TargetingTriggersInstance = u.TargetingTriggerManager.getInstance(), t.IntegrationsServiceInstance = new i.default(), t.setSurveys = v, t.setAudiences = p, t.setThemes = _, t.setIntegrations = f, t.setWorkspaceKey = h, t.setTranslations = m, t.backendDataActions = {
          setAudiences: p,
          setIntegrations: f,
          setSurveys: v,
          setThemes: _,
          setTranslations: m,
          setWorkspaceKey: h
        };
      },
      5487: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.emptyBackendData = void 0, t.emptyBackendData = {
          audiences: [],
          integrations: [],
          surveys: [],
          targetingEvents: [],
          themes: [],
          translations: null,
          workspaceKey: null
        };
      },
      3126: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(8885),
          n = s(r(6133));
        t.default = e => (null == e ? void 0 : e.length) ? e.map(e => {
          const t = e.filters.map(e => {
            var t, r;
            const s = null === (t = e.parameters) || void 0 === t ? void 0 : t.attributes,
              o = null === (r = e.parameters) || void 0 === r ? void 0 : r.cookies;
            let a = Object.assign({}, e.parameters);
            return (null == s ? void 0 : s.length) && (a = Object.assign(Object.assign({}, a), {
              attributes: (0, n.default)(s),
              relation: a.relation || i.RelationOperator.or
            })), (null == o ? void 0 : o.length) && (a = Object.assign(Object.assign({}, a), {
              cookies: (0, n.default)(o),
              relation: a.relation || i.RelationOperator.or
            })), Object.assign(Object.assign({}, e), {
              parameters: a
            });
          });
          return Object.assign(Object.assign({}, e), {
            filters: t,
            filters_relation: e.filters_relation || i.RelationOperator.and
          });
        }) : [];
      },
      6133: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(8885);
        t.default = e => e.map(e => "value" in e ? {
          attribute_type: "string",
          name: e.name,
          operator: e.type === s.OperatorType.any ? e.type : s.OperatorType.is_equal,
          values: e.value ? [e.value] : null
        } : e);
      },
      3562: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.InitVisitorMode = t.initServices = void 0;
        const i = s(r(9262)),
          n = s(r(3074)),
          o = r(9027);
        var a;
        t.initServices = function (e, t) {
          const r = new i.default(t),
            s = new n.default(r, e);
          o.storeManager.getStore(e).setState({
            backendService: s,
            storageService: r
          });
        }, function (e) {
          e[e.kiosk = 0] = "kiosk", e[e.normal = 1] = "normal";
        }(a || (t.InitVisitorMode = a = {}));
      },
      8217: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          n = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && s(t, e, r);
            return i(t, e), t;
          },
          o = this && this.__awaiter || function (e, t, r, s) {
            return new (r || (r = Promise))(function (i, n) {
              function o(e) {
                try {
                  u(s.next(e));
                } catch (e) {
                  n(e);
                }
              }
              function a(e) {
                try {
                  u(s.throw(e));
                } catch (e) {
                  n(e);
                }
              }
              function u(e) {
                var t;
                e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
                  e(t);
                })).then(o, a);
              }
              u((s = s.apply(e, t || [])).next());
            });
          },
          a = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.initStore = void 0;
        const u = r(2831),
          l = r(7057),
          c = r(4590),
          d = n(r(5575)),
          v = r(5409),
          p = r(2230),
          _ = r(3562),
          f = a(r(6374)),
          h = a(r(8108)),
          m = r(8004),
          g = a(r(3126)),
          b = r(9027),
          y = r(9535);
        t.initStore = (e, t) => o(void 0, void 0, void 0, function* () {
          var r, s, i;
          const n = b.storeManager.getStore(e),
            a = t || window._svd || {};
          if (0 === Object.keys(a).length) return;
          const {
              audiences: w,
              themes: x,
              translations: S
            } = a,
            k = (0, g.default)(null != w ? w : []);
          n.action(p.setAudiences)(k), n.action(p.setWorkspaceKey)(null !== (r = null == t ? void 0 : t.workspaceKey) && void 0 !== r ? r : null === (s = window._svc) || void 0 === s ? void 0 : s.workspaceKey), n.action(p.setThemes)(x), n.action(p.setTranslations)(S), n.action(v.setPreview)(!!t || (null === (i = window._svc) || void 0 === i ? void 0 : i.isPreview)), t || ((0, _.initServices)(e, window._svc.workspaceKey), (0, c.initSurveyAPI)(a));
          (e === l.SurveyType.WidgetSurvey || e === l.SurveyType.FeedbackButton) && a.surveys ? yield ((e, t) => o(void 0, void 0, void 0, function* () {
            var r;
            const s = b.storeManager.getStore(e),
              {
                surveys: i,
                integrations: n,
                targeting_events: o,
                targeting_events_enabled: a
              } = t;
            (0, f.default)(e, _.InitVisitorMode.normal), s.action(p.setIntegrations)(n), y.targetingEventsStore.setState({
              events: null != o ? o : [],
              isEnabled: null != a && a
            }), (null === (r = window._sva) || void 0 === r ? void 0 : r.traits) && s.action(m.setVisitorAttributes)(window._sva.traits), s.action(v.setTabId)((0, u.v4)()), s.action(p.setSurveys)(i);
          }))(e, a) : a.survey && (yield ((e, t) => o(void 0, void 0, void 0, function* () {
            var r, s;
            const i = b.storeManager.getStore(e),
              n = Object.assign({}, t);
            d.default.params[d.ReservedParams.multiple_responses] && (n.survey.kiosk_enabled = !0);
            const o = n.survey.settings.kiosk_enabled || (null === (r = window._svc) || void 0 === r ? void 0 : r.isPreview);
            i.setState({
              isKioskMode: o
            });
            const a = o ? _.InitVisitorMode.kiosk : _.InitVisitorMode.normal;
            (0, f.default)(e, a), i.action(p.setIntegrations)(n.integrations), i.action(m.setVisitorAttributesFromURL)(), d.default.replaceWindowUrl(), (null === (s = window._sva) || void 0 === s ? void 0 : s.traits) && i.action(m.setVisitorAttributes)(window._sva.traits), i.action(h.default)(n.survey);
          }))(e, a)), t || (0, c.dispatchSurvicateReadyEvent)();
        });
      },
      6374: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(2831),
          n = r(8998),
          o = r(3562),
          a = r(9027),
          u = r(8004),
          l = r(4714),
          c = s(r(5786));
        t.default = (e, t) => {
          const r = a.storeManager.getStore(e),
            {
              storageService: s
            } = r.getState();
          let d = Object.assign(Object.assign({}, l.emptyVisitor), {
            uuid: (0, i.v4)()
          });
          if (t === o.InitVisitorMode.normal && e) {
            const t = null == s ? void 0 : s.get(e, {
              key: n.StorageTableKeys.visitor,
              table: n.StorageTables.all
            });
            t && t.uuid && (d = t);
          }
          r.action(c.default)(d), r.action(u.addNewVisit)();
        };
      },
      4397: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.PreviewDevice = void 0, function (e) {
          e.empty = "", e.mobile = "mobile", e.tablet = "tablet", e.desktop = "desktop";
        }(r || (t.PreviewDevice = r = {}));
      },
      9027: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.storeManager = t.store = t.initialStore = void 0;
        const i = s(r(9248)),
          n = r(5487),
          o = r(4397),
          a = r(4279),
          u = r(4714);
        t.initialStore = {
          backendData: n.emptyBackendData,
          backendService: null,
          isKioskMode: !1,
          isPreview: !1,
          previewDevice: o.PreviewDevice.empty,
          rootElement: null,
          sampledSurveys: null,
          storageService: null,
          storeType: null,
          surveyApiState: {
            surveysTriggeredByApi: []
          },
          surveyState: a.emptySurveyState,
          tabId: 0,
          update: {},
          visitor: u.emptyVisitor
        }, t.store = (0, i.default)(t.initialStore);
        t.storeManager = {
          getStore: (() => {
            const e = {};
            return r => {
              if (!r) return t.store;
              const s = (e => `store_${e}`)(r);
              return e[s] || (e[s] = (0, i.default)(Object.assign({}, t.initialStore))), e[s];
            };
          })()
        };
      },
      4144: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.surveyAPIActions = t.triggerSurveyByApi = void 0;
        const i = s(r(8446)),
          n = r(2230),
          o = r(9490),
          a = s(r(9979)),
          u = r(5595),
          l = r(9027);
        function c({
          surveyApiState: e,
          surveyState: t,
          backendData: r,
          storeType: s
        }, c, d = {}) {
          const v = r.surveys.find(({
            id: e
          }) => e === c);
          if (!v) return;
          const p = Object.assign({}, v),
            {
              settings: _
            } = p,
            {
              forceDisplay: f,
              displayMethod: h,
              displayOptions: m
            } = d,
            g = l.storeManager.getStore(s);
          "forceDisplay" in d && g.setState({
            surveyState: Object.assign(Object.assign({}, t), {
              forceDisplay: f,
              survey: null
            })
          }), h ? (_.appear_method = (0, o.appearMethodParse)(h), _.appear_method === u.AppearMethod.delayed && m && m.delay && (_.display_delay = m.delay), _.appear_method === u.AppearMethod.scroll && m && m.scrolledPercentage && (_.display_scroll = m.scrolledPercentage)) : _.appear_method = u.AppearMethod.immediately;
          const b = f ? [p] : [...e.surveysTriggeredByApi, p];
          g.setState({
            surveyApiState: Object.assign(Object.assign({}, e), {
              surveysTriggeredByApi: b
            })
          }), _.appear_method === u.AppearMethod.immediately ? g.action(a.default)() : n.TargetingTriggersInstance.startTargeting(s, [...b, ...r.surveys].filter(i.default.filterUniqueSurveys));
        }
        t.triggerSurveyByApi = c, t.surveyAPIActions = {
          retarget: a.default,
          triggerSurveyByApi: c
        };
      },
      9490: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.appearMethodParse = void 0;
        const s = r(5595);
        t.appearMethodParse = e => {
          switch (e) {
            case s.AppearMethodApi.immediately:
              return s.AppearMethod.immediately;
            case s.AppearMethodApi.delayed:
              return s.AppearMethod.delayed;
            case s.AppearMethodApi.scroll:
              return s.AppearMethod.scroll;
            case s.AppearMethodApi.exitIntent:
              return s.AppearMethod.exitIntent;
          }
          return s.AppearMethod.immediately;
        };
      },
      6694: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.emptySurveysTriggeredByApi = void 0, t.emptySurveysTriggeredByApi = {
          surveysTriggeredByApi: []
        };
      },
      9979: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(8446)),
          n = s(r(1982));
        t.default = ({
          surveyApiState: e,
          backendData: t,
          surveyState: {
            survey: r
          },
          visitor: s,
          update: o,
          storeType: a
        }, u = {}) => {
          r || i.default.findSurveyToDisplay({
            audiences: t.audiences,
            integrations: t.integrations,
            storeType: a,
            surveys: Array.isArray(o.surveys) && o.surveys.length > 0 ? o.surveys : t.surveys,
            surveysTriggeredByApi: e.surveysTriggeredByApi,
            triggers: u,
            visit: n.default.getVisit(a).get(),
            visitor: s
          });
        };
      },
      9849: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.surveyStateActions = t.clearSurveyState = t.close = t.reopenSurvey = t.closeSurvey = t.toggleMinimize = t.hideOverlay = t.navigateForward = t.navigateBackward = void 0;
        const i = r(2831),
          n = r(9577),
          o = r(7057),
          a = r(318),
          u = r(907),
          l = r(8488),
          c = r(830),
          d = s(r(3507)),
          v = s(r(8623)),
          p = r(4279),
          _ = r(9777),
          f = s(r(7966)),
          h = s(r(8108)),
          m = s(r(5816)),
          g = s(r(2881)),
          b = r(8004),
          y = r(9027);
        function w({
          surveyState: e,
          storeType: t
        }) {
          const r = y.storeManager.getStore(t),
            s = e.pointsDisplayed.length;
          if (s <= 1) return;
          const i = e.pointsDisplayed.slice(0, -1);
          r.setState({
            surveyState: Object.assign(Object.assign({}, e), {
              pointsDisplayed: i,
              pointsForward: [e.pointsDisplayed[s - 1], ...e.pointsForward]
            })
          });
        }
        function x({
          surveyState: e,
          storeType: t
        }) {
          const r = y.storeManager.getStore(t);
          if (!e.pointsForward.length) return;
          const s = [...e.pointsDisplayed, e.pointsForward[0]];
          r.setState({
            surveyState: Object.assign(Object.assign({}, e), {
              pointsDisplayed: s,
              pointsForward: e.pointsForward.slice(1)
            })
          });
        }
        t.navigateBackward = w, t.navigateForward = x;
        const S = 3e3;
        function k({
          surveyState: e,
          storeType: t
        }) {
          y.storeManager.getStore(t).setState({
            surveyState: Object.assign(Object.assign({}, e), {
              isOverlayActive: !1
            })
          });
        }
        function T({
          surveyState: e,
          storeType: t
        }, r) {
          const s = y.storeManager.getStore(t);
          s.setState({
            surveyState: Object.assign(Object.assign({}, e), {
              isMinimized: r
            })
          }), e.survey && (r ? s.action(c.minimized)({
            surveyName: e.survey.name
          }) : s.action(c.maximized)({
            surveyName: e.survey.name
          }));
        }
        function M(e, t) {
          y.storeManager.getStore(t).setState({
            surveyState: Object.assign(Object.assign({}, e), {
              survey: null,
              theme: null
            })
          });
        }
        function O(e, t) {
          setTimeout(() => {
            y.storeManager.getStore(t).action(h.default)(e.survey);
          }, S);
        }
        function A(e) {
          const t = e.storeType,
            r = y.storeManager.getStore(t),
            {
              surveyState: s,
              isPreview: v,
              visitor: p
            } = e;
          if (M(s, e.storeType), !s.survey) return;
          const _ = s.survey.global_close_tags;
          _ && _.split(";").forEach(e => {
            r.action(b.setVisitorTag)(e);
          });
          const h = s.pointsDisplayed.length + s.pointsForward.length === 1,
            m = h ? (0, i.v4)() : s.responseUuid;
          h && (r.action(f.default)(m), r.action(d.default)()), r.action(c.closed)({
            response_uuid: m,
            surveyId: s.survey.id,
            surveyName: s.survey.name,
            survey_point_id: s.pointsDisplayed[0].point.id,
            user_tag: s.survey.global_close_tags,
            visitor: (0, u.trimVisitor)(p)
          }), v && O(s, t), (0, a.fireSurveyEvent)(n.SurveyEvent.closed, {
            surveyId: s.survey.id
          }), s.survey.type !== o.SurveyType.WidgetSurvey && s.survey.type !== o.SurveyType.FeedbackButton || !s.survey.settings.recurring || (0, a.fireSurveyEvent)(n.SurveyEvent.shouldUpdate, {
            surveyId: s.survey.id
          }), l.TargetingTriggerManager.getInstance().resetDelayLoadTime(e.storeType);
        }
        function P(e, t) {
          y.storeManager.getStore(t).setState({
            surveyState: Object.assign({}, p.emptySurveyState)
          });
        }
        t.hideOverlay = k, t.toggleMinimize = T, t.closeSurvey = M, t.reopenSurvey = O, t.close = A, t.clearSurveyState = P, t.surveyStateActions = {
          clearPointsAnswered: d.default,
          clearSurveyState: P,
          close: A,
          finish: v.default,
          hideOverlay: k,
          navigateBackward: w,
          navigateForward: x,
          pointAnswer: _.pointAnswer,
          setResponseUuid: f.default,
          setSurvey: h.default,
          setSurveyPoint: m.default,
          setTheme: g.default,
          toggleMinimize: T
        };
      },
      3507: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(9027);
        t.default = ({
          surveyState: e,
          storeType: t
        }) => {
          s.storeManager.getStore(t).setState({
            surveyState: Object.assign(Object.assign({}, e), {
              pointsAnswered: {}
            })
          });
        };
      },
      6810: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        s(r(5575));
        const i = r(9027);
        t.default = e => {
          i.storeManager.getStore(e.type);
        };
      },
      8623: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(9990)),
          n = r(9577),
          o = r(7057),
          a = r(8200),
          u = r(318),
          l = s(r(2424)),
          c = s(r(8108)),
          d = r(9027);
        t.default = ({
          surveyState: e,
          isPreview: t,
          storeType: r
        }) => {
          const s = d.storeManager.getStore(r);
          if (!e.survey) return;
          const v = e.pointsDisplayed[e.pointsDisplayed.length - 1].point,
            p = v.id === e.triggeredPointPreview,
            _ = v.answer_type === a.SurveyCtaAnswerType.thankYouMessage,
            f = v.answer_type === a.SurveyCtaAnswerType.redirect;
          if (p && (_ || f)) return;
          const h = e.survey.type === o.SurveyType.PageSurvey,
            m = e.survey.settings.hide_footer,
            g = e.survey.type === o.SurveyType.WidgetSurvey || e.survey.type === o.SurveyType.FeedbackButton,
            b = h || _ || m ? 3e3 : 500,
            y = g && !(0, i.default)(e.pointsDisplayed);
          if (t) {
            if ((h || y) && s.setState({
              surveyState: Object.assign(Object.assign({}, e), {
                isFinished: !0,
                survey: e.survey,
                theme: e.theme
              })
            }), !m && y) return;
            const t = s.getState().surveyState.survey;
            return void setTimeout(() => {
              s.action(c.default)(t);
            }, b);
          }
          let w = 0;
          if (g && !(0, i.default)(e.pointsDisplayed)) return s.setState({
            surveyState: Object.assign(Object.assign({}, e), {
              isFinished: !0
            })
          }), m && (w = 5e3, (0, u.fireSurveyEvent)(n.SurveyEvent.finished, {
            surveyId: e.survey.id
          }), setTimeout(() => {
            e.survey && e.survey.settings.recurring && (0, u.fireSurveyEvent)(n.SurveyEvent.shouldUpdate, {
              surveyId: e.survey.id
            }), s.setState({
              surveyState: Object.assign(Object.assign({}, e), {
                survey: null,
                theme: null
              })
            });
          }, w)), void setTimeout(() => {
            e.survey && (0, l.default)(e.survey, v, r);
          }, w);
          if (!h && (_ || f)) {
            const {
              settings: e
            } = v;
            w = 1e3 * parseInt(e.timeout_display_count, 10), Number.isNaN(w) && (w = 5e3);
          }
          setTimeout(() => {
            s.setState({
              surveyState: Object.assign(Object.assign({}, e), {
                isFinished: !0,
                survey: g ? null : e.survey,
                theme: g ? null : e.theme
              })
            }), e.survey && ((0, l.default)(e.survey, v, r), (0, u.fireSurveyEvent)(n.SurveyEvent.finished, {
              surveyId: e.survey.id
            }), e.survey.settings.recurring && (0, u.fireSurveyEvent)(n.SurveyEvent.shouldUpdate, {
              surveyId: e.survey.id
            }));
          }, w);
        };
      },
      3614: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getAnswerEvent = t.getNpsAnswerEvent = t.getButtonNextAnswerEvent = t.getMultipleChoiceAnswerEvent = t.getSingleChoiceAnswerEvent = t.getScaleAnswerEvent = void 0;
        const s = r(8200),
          i = r(4073),
          n = r(3501);
        t.getScaleAnswerEvent = ({
          answer: e
        }) => ({
          anonymizedTextResponse: e.possible_answer,
          answers: [{
            nextSurveyPointId: e.next_survey_point_id,
            survey_question_answer_id: e.id,
            user_tag: e.user_tag
          }],
          textResponse: e.possible_answer,
          value: e
        });
        const o = ({
          answer: e,
          comment: t = ""
        }) => ({
          content: t,
          nextSurveyPointId: e.next_survey_point_id,
          survey_question_answer_id: e.id,
          user_tag: e.user_tag
        });
        t.getSingleChoiceAnswerEvent = ({
          answer: e,
          point: t,
          comment: r = ""
        }) => ({
          anonymizedTextResponse: e.possible_answer,
          answers: [o({
            answer: e,
            comment: r,
            point: t
          })],
          textResponse: e.possible_answer,
          value: {
            answer: e,
            comment: r || ""
          }
        });
        t.getMultipleChoiceAnswerEvent = ({
          answers: e,
          point: t,
          comments: r = []
        }) => {
          const s = e.reduce((e, t) => `${e} ${t.possible_answer}`, "");
          return {
            anonymizedTextResponse: s,
            answers: e.map((e, s) => o({
              answer: e,
              comment: r[s],
              point: t
            })),
            textResponse: s
          };
        };
        t.getButtonNextAnswerEvent = ({
          point: e
        }) => ({
          anonymizedTextResponse: "",
          answers: [{
            nextSurveyPointId: e.settings.next_survey_point_id,
            user_tag: e.settings.user_tag
          }],
          textResponse: ""
        });
        t.getNpsAnswerEvent = ({
          value: e,
          point: t
        }) => {
          let r = null,
            s = null;
          const i = t.settings;
          return e <= 6 ? (r = i.first_range_goto_id, s = i.first_range_tag) : e <= 8 ? (r = i.second_range_goto_id, s = i.second_range_tag) : (r = i.third_range_goto_id, s = i.third_range_tag), {
            anonymizedTextResponse: `${e}`,
            answers: [{
              content: `${e}`,
              nextSurveyPointId: r,
              user_tag: s
            }],
            textResponse: `${e}`,
            value: e
          };
        };
        t.getAnswerEvent = (e, r) => {
          const o = parseInt(e, 10);
          let a;
          switch (r.answer_type) {
            case n.SurveyQuestionAnswerType.smileyScale:
              return a = r.answers.find(e => e.id === o), a ? (0, t.getScaleAnswerEvent)({
                answer: a,
                point: r
              }) : null;
            case n.SurveyQuestionAnswerType.single:
              return a = r.answers.find(e => e.id === o), a ? (0, t.getSingleChoiceAnswerEvent)({
                answer: a,
                point: r
              }) : null;
            case i.SurveyNpsAnswerType.nps:
              return 0 <= o && o <= 10 ? (0, t.getNpsAnswerEvent)({
                point: r,
                value: o
              }) : null;
            case s.SurveyCtaAnswerType.button:
              return (0, t.getButtonNextAnswerEvent)({
                point: r
              });
            case n.SurveyQuestionAnswerType.rating:
            case n.SurveyQuestionAnswerType.numericalScale:
            case n.SurveyQuestionAnswerType.customerSatisfaction:
              return a = r.answers.find(({
                id: e
              }) => e === o), a ? (0, t.getScaleAnswerEvent)({
                answer: a,
                point: r
              }) : null;
          }
          return null;
        };
      },
      7033: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(7057),
          n = s(r(5575)),
          o = r(9027),
          a = r(3614),
          u = r(9777);
        t.default = ({
          surveyState: e
        }, t) => {
          var r, s;
          const l = o.storeManager.getStore(i.SurveyType.PageSurvey);
          if (!e.survey) return;
          if (!(!!(null === (r = e.survey.points) || void 0 === r ? void 0 : r.length) && n.default.params.aid && !e.isAlreadyAnswered && !e.isAnsweredByEmail || t)) return;
          const c = t || n.default.params.aid,
            d = (0, a.getAnswerEvent)(c, e.survey.points[0]);
          if (!d) return;
          l.setState({
            surveyState: Object.assign(Object.assign({}, l.getState().surveyState), {
              isAnsweredByEmail: !0
            })
          });
          const v = d.value,
            {
              embedded_question_confirmation: p
            } = e.survey.settings;
          (null === (s = null == v ? void 0 : v.answer) || void 0 === s ? void 0 : s.add_comment) || p || l.action(u.pointAnswer)(d);
        };
      },
      2424: function (e, t, r) {
        "use strict";

        var s = this && this.__createBinding || (Object.create ? function (e, t, r, s) {
            void 0 === s && (s = r);
            var i = Object.getOwnPropertyDescriptor(t, r);
            i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
              enumerable: !0,
              get: function () {
                return t[r];
              }
            }), Object.defineProperty(e, s, i);
          } : function (e, t, r, s) {
            void 0 === s && (s = r), e[s] = t[r];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          n = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var r in e) "default" !== r && Object.prototype.hasOwnProperty.call(e, r) && s(t, e, r);
            return i(t, e), t;
          },
          o = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const a = r(9577),
          u = r(7057),
          l = r(8200),
          c = r(318),
          d = n(r(6493)),
          v = r(2230),
          p = r(3562),
          _ = o(r(6374)),
          f = o(r(9979)),
          h = o(r(3507)),
          m = r(8004),
          g = r(9027);
        t.default = (e, t, r) => {
          const s = g.storeManager.getStore(r),
            i = t && t.answer_type === l.SurveyCtaAnswerType.thankYouMessage;
          d.default.fireEvent(d.ApiEvents.surveyCompleted, Object.assign({
            surveyId: e.id
          }, i && {
            answer: {
              answer_type: l.SurveyCtaAnswerType.thankYouMessage
            }
          }));
          const {
              backendData: n
            } = s.getState(),
            o = e.settings;
          e.type !== u.SurveyType.WidgetSurvey && e.type !== u.SurveyType.FeedbackButton || (null == e ? void 0 : e.settings.recurring) || (v.TargetingTriggersInstance.startTargeting(r, n.surveys), s.action(f.default)()), o.kiosk_enabled && (setTimeout(() => {
            (0, _.default)(r, p.InitVisitorMode.kiosk);
          }, 5e3), o.kiosk_refresh_enabled && setTimeout(() => {
            s.action(h.default)(), s.action(m.setVisitorAttributesFromURL)(), (0, c.fireSurveyEvent)(a.SurveyEvent.shouldUpdate, {
              surveyId: e.id
            });
          }, 5010));
        };
      },
      4279: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.emptyState = t.emptySurveyState = void 0;
        const s = r(4397),
          i = r(5487),
          n = r(6694),
          o = r(4714);
        t.emptySurveyState = {
          forceDisplay: void 0,
          isAlreadyAnswered: !1,
          isAnsweredByEmail: !1,
          isFinished: !1,
          isRTLLanguage: !1,
          isMinimized: !1,
          isOverlayActive: !1,
          pointsAnswered: {},
          pointsDisplayed: [],
          pointsForward: [],
          responseUuid: "",
          survey: null,
          theme: null,
          translationLanguage: null,
          translations: null,
          triggeredPointPreview: null
        }, t.emptyState = {
          backendData: i.emptyBackendData,
          backendService: null,
          isKioskMode: !1,
          isPreview: !1,
          previewDevice: s.PreviewDevice.desktop,
          rootElement: null,
          sampledSurveys: null,
          storageService: null,
          storeType: null,
          surveyApiState: n.emptySurveysTriggeredByApi,
          surveyState: t.emptySurveyState,
          tabId: 0,
          update: {},
          visitor: o.emptyVisitor
        };
      },
      838: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.SurveyLogic = void 0;
        const s = r(6716),
          i = r(6954),
          n = r(8662),
          o = r(2079),
          a = r(1574),
          u = r(3474),
          l = r(9687),
          c = r(2445),
          d = r(5121),
          v = r(3082),
          p = r(5524),
          _ = r(3611),
          f = r(4242),
          h = r(8459);
        t.SurveyLogic = {
          answer_contains: i.answer_contains,
          answer_doesnt_contain: n.answer_doesnt_contain,
          doesnt_include_any_of_the_following: o.doesnt_include_any_of_the_following,
          has_any_value: a.has_any_value,
          includes_all_of_the_following: u.includes_all_of_the_following,
          includes_any_of_the_following: l.includes_any_of_the_following,
          is: c.is,
          is_between: s.is_between,
          is_exactly: d.is_exactly,
          is_filled_in: v.is_filled_in,
          is_not: p.is_not,
          is_not_filled_in: _.is_not_filled_in,
          question_is_answered: f.question_is_answered,
          question_is_not_answered: h.question_is_not_answered
        };
      },
      205: (e, t) => {
        "use strict";

        var r, s;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.LogicCondition = t.LogicOperator = void 0, function (e) {
          e.and = "and", e.or = "or";
        }(r || (t.LogicOperator = r = {})), function (e) {
          e.is = "is", e.is_not = "is_not", e.is_between = "is_between", e.is_exactly = "is_exactly", e.includes_any_of_the_following = "includes_any_of_the_following", e.includes_all_of_the_following = "includes_all_of_the_following", e.doesnt_include_any_of_the_following = "doesnt_include_any_of_the_following", e.question_is_answered = "question_is_answered", e.question_is_not_answered = "question_is_not_answered", e.answer_contains = "answer_contains", e.answer_doesnt_contain = "answer_doesnt_contain", e.has_any_value = "has_any_value", e.is_filled_in = "is_filled_in", e.is_not_filled_in = "is_not_filled_in", e.is_ranked_as = "is_ranked_as", e.is_not_ranked_as = "is_not_ranked_as", e.is_ranked_between = "is_ranked_between";
        }(s || (t.LogicCondition = s = {}));
      },
      6954: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.answer_contains = void 0;
        const s = r(7098),
          i = r(205);
        t.answer_contains = (e, t) => {
          const r = e[0],
            n = t.find(e => {
              const {
                condition: t,
                operator: n,
                value: o
              } = e;
              return e.condition === i.LogicCondition.answer_contains && (0, s.doesContainValue)(r, {
                condition: t,
                operator: n,
                value: o
              });
            });
          return n ? n.go_to : null;
        };
      },
      8662: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.answer_doesnt_contain = void 0;
        const s = r(7098),
          i = r(205);
        t.answer_doesnt_contain = (e, t) => {
          const r = e[0].toLowerCase(),
            n = t.find(e => {
              const {
                condition: t,
                operator: n,
                value: o
              } = e;
              return e.condition === i.LogicCondition.answer_doesnt_contain && !(0, s.doesContainValue)(r, {
                condition: t,
                operator: n,
                value: o
              });
            });
          return n ? n.go_to : null;
        };
      },
      2079: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.doesnt_include_any_of_the_following = void 0;
        const s = r(205);
        t.doesnt_include_any_of_the_following = (e, t) => {
          const r = t.find(({
            condition: t,
            value: r
          }) => t === s.LogicCondition.doesnt_include_any_of_the_following && r.every(t => !e.includes(t)));
          return r ? r.go_to : null;
        };
      },
      1574: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.has_any_value = void 0;
        const s = r(205);
        t.has_any_value = e => {
          const t = e.find(({
            condition: e
          }) => e === s.LogicCondition.has_any_value);
          return t ? t.go_to : null;
        };
      },
      3474: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.includes_all_of_the_following = void 0;
        const s = r(205);
        t.includes_all_of_the_following = (e, t) => {
          const r = t.find(({
            condition: t,
            value: r
          }) => t === s.LogicCondition.includes_all_of_the_following && r.every(t => e.includes(t)));
          return r ? r.go_to : null;
        };
      },
      9687: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.includes_any_of_the_following = void 0;
        const s = r(205);
        t.includes_any_of_the_following = (e, t) => {
          const r = t.find(({
            condition: t,
            value: r
          }) => t === s.LogicCondition.includes_any_of_the_following && r.some(t => e.includes(t)));
          return r ? r.go_to : null;
        };
      },
      2445: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.is = void 0;
        const s = r(205);
        t.is = (e, t) => {
          const r = e[0],
            i = t.find(({
              condition: e,
              value: t
            }) => e === s.LogicCondition.is && t.includes(r));
          return i ? i.go_to : null;
        };
      },
      5121: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.is_exactly = void 0;
        const i = s(r(7047)),
          n = r(205);
        t.is_exactly = (e, t) => {
          const r = t.find(({
            condition: t,
            value: r
          }) => t === n.LogicCondition.is_exactly && (0, i.default)(e, r));
          return r ? r.go_to : null;
        };
      },
      3082: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.is_filled_in = void 0;
        const s = r(205);
        t.is_filled_in = (e, {
          field_id: t,
          field_id_operator: r
        }) => {
          if (!(null == t ? void 0 : t.length)) return !1;
          if (-1 === t[0]) return !!e.length;
          switch (r) {
            case s.LogicOperator.and:
              return t.every(t => e.includes(t));
            case s.LogicOperator.or:
              return t.some(t => e.includes(t));
          }
        };
      },
      5524: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.is_not = void 0;
        const s = r(205);
        t.is_not = (e, t) => {
          const r = e[0],
            i = t.find(({
              condition: e,
              value: t
            }) => e === s.LogicCondition.is_not && !t.includes(r));
          return i ? i.go_to : null;
        };
      },
      3611: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.is_not_filled_in = void 0;
        const s = r(205);
        t.is_not_filled_in = (e, {
          field_id: t,
          field_id_operator: r
        }) => {
          if (!(null == t ? void 0 : t.length)) return !1;
          if (-1 === t[0]) return !!e.length;
          switch (r) {
            case s.LogicOperator.and:
              return t.every(t => !e.includes(t));
            case s.LogicOperator.or:
              return t.some(t => !e.includes(t));
          }
        };
      },
      4242: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.question_is_answered = void 0;
        const s = r(205);
        t.question_is_answered = (e, t) => {
          const r = e[0],
            i = t.find(({
              condition: e
            }) => e === s.LogicCondition.question_is_answered && r);
          return i ? i.go_to : null;
        };
      },
      8459: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.question_is_not_answered = void 0;
        const s = r(205);
        t.question_is_not_answered = (e, t) => {
          const r = e[0],
            i = t.find(({
              condition: e
            }) => e === s.LogicCondition.question_is_not_answered && !r);
          return i ? i.go_to : null;
        };
      },
      7047: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(7539));
        t.default = (e, t) => [...e].sort((0, i.default)().ascending).join("") === [...t].sort((0, i.default)().ascending).join("");
      },
      7098: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.doesContainValue = void 0;
        const s = r(205);
        t.doesContainValue = (e, {
          value: t,
          operator: r,
          condition: i
        }) => {
          const n = t.map(e => `${e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}`),
            o = e.toLowerCase(),
            a = (e => e.map(e => {
              const t = e.toLowerCase(),
                r = /^[a-z0-9]/i.test(e),
                s = /[a-z0-9]$/i.test(e),
                i = /^[a-z0-9].*[a-z0-9]$/i.test(e);
              return !r && s ? new RegExp(`\\B${t}\\b`) : r && !s ? new RegExp(`\\b${t}\\B`) : !i && t.length > 1 ? new RegExp(`\\B${t}\\B`) : new RegExp(`\\b${t}\\b`);
            }))(n),
            u = a.every(e => !!e.exec(o)),
            l = a.some(e => !!e.exec(o));
          return r === s.LogicOperator.and ? i === s.LogicCondition.answer_contains ? u : l : i === s.LogicCondition.answer_contains ? l : u;
        };
      },
      9331: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.flattenAnswers = void 0;
        t.flattenAnswers = e => e.map(e => `${e.answerId}-${e.value}`);
      },
      4152: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.flattenValues = void 0;
        t.flattenValues = (e, t) => e.map(e => t.map(t => `${e}-${t}`)).flat();
      },
      5350: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getNextSurveyPointIdForGroupLogic = void 0;
        const s = r(3214),
          i = r(205);
        t.getNextSurveyPointIdForGroupLogic = (e, t) => {
          const {
              group: r,
              go_to: n,
              group_operator: o
            } = e,
            a = r.map(e => (0, s.isValidGroupCondition)(t, e) ? n : null);
          return o === i.LogicOperator.or ? a.find(e => e) || null : o === i.LogicOperator.and && a.includes(null) ? null : a[0];
        };
      },
      2069: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getPointSpecificAnswers = void 0;
        const s = r(4585),
          i = r(4073),
          n = r(3501);
        t.getPointSpecificAnswers = (e, t) => t.map(({
          content: t,
          survey_question_answer_id: r = 0,
          field_id: o
        }) => {
          switch (e) {
            case n.SurveyQuestionAnswerType.text:
            case n.SurveyQuestionAnswerType.date:
              return t || "";
            case s.SurveyFormAnswerType.form:
              return t && o ? o : "";
            case n.SurveyQuestionAnswerType.ranking:
              return {
                answerId: r,
                value: Number(t) + 1
              };
            case n.SurveyQuestionAnswerType.matrix:
              return {
                answerId: r,
                value: Number(t)
              };
            case i.SurveyNpsAnswerType.nps:
              return Number(t);
            default:
              return r;
          }
        });
      },
      1249: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isAnswerInValues = void 0;
        const s = r(205);
        t.isAnswerInValues = (e, t, r) => {
          const i = r.includes(e);
          switch (t) {
            case s.LogicCondition.is:
            case s.LogicCondition.is_ranked_as:
              return i;
            case s.LogicCondition.is_not:
            case s.LogicCondition.is_not_ranked_as:
            default:
              return !i;
          }
        };
      },
      2878: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isBetweenValues = void 0;
        t.isBetweenValues = (e, t) => {
          const [r, s] = e;
          return t >= r && t <= s;
        };
      },
      3214: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidGroupCondition = void 0;
        const s = r(2878),
          i = r(7990),
          n = r(838),
          o = r(205);
        t.isValidGroupCondition = (e, t) => {
          let r = !1;
          switch (t.condition) {
            case o.LogicCondition.is_between:
            case o.LogicCondition.is_ranked_between:
              {
                const {
                    answer_id: i,
                    answer_id_operator: n,
                    value: a
                  } = t,
                  u = i,
                  l = e.filter(e => null == u ? void 0 : u.includes(e.answerId)),
                  c = l.map(({
                    value: e
                  }) => (0, s.isBetweenValues)(a, e));
                if (l.length) {
                  r = n === o.LogicOperator.and ? !c.includes(!1) : c.includes(!0);
                } else r = !1;
                break;
              }
            case o.LogicCondition.is:
            case o.LogicCondition.is_ranked_as:
            case o.LogicCondition.is_not:
            case o.LogicCondition.is_not_ranked_as:
              r = (0, i.isValidScaledAnswer)(t, e);
              break;
            case o.LogicCondition.is_filled_in:
              {
                const {
                  field_id: s,
                  field_id_operator: i
                } = t;
                r = n.SurveyLogic.is_filled_in(e, {
                  field_id: s,
                  field_id_operator: i
                });
                break;
              }
            case o.LogicCondition.is_not_filled_in:
              {
                const {
                  field_id: s,
                  field_id_operator: i
                } = t;
                r = n.SurveyLogic.is_not_filled_in(e, {
                  field_id: s,
                  field_id_operator: i
                });
                break;
              }
            case o.LogicCondition.has_any_value:
              r = !0;
          }
          return r;
        };
      },
      7990: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isValidScaledAnswer = void 0;
        const s = r(205),
          i = r(9331),
          n = r(4152),
          o = r(1249);
        t.isValidScaledAnswer = (e, t) => {
          const {
            answer_id: r,
            value: a,
            answer_id_operator: u,
            condition: l
          } = e;
          let c = !1;
          const d = t.filter(e => null == r ? void 0 : r.includes(e.answerId)),
            v = (0, i.flattenAnswers)(d),
            p = (0, n.flattenValues)(r, a);
          switch (u) {
            case s.LogicOperator.and:
              c = v.every(e => (0, o.isAnswerInValues)(e, l, p));
              break;
            case s.LogicOperator.or:
              c = v.some(e => (0, o.isAnswerInValues)(e, l, p));
          }
          return c;
        };
      },
      5125: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.findNextPoint = void 0;
        t.findNextPoint = (e, t) => t.reduce((r, s, i) => s.id === e.id ? t[i + 1] : r, null);
      },
      6997: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getNextPointId = void 0;
        const s = r(5350),
          i = r(838),
          n = r(205);
        t.getNextPointId = (e, t) => {
          const r = null == t ? void 0 : t.map(r => {
            var o;
            let a = null;
            const u = e,
              l = e;
            if (null === (o = r.group) || void 0 === o ? void 0 : o.length) a = (0, s.getNextSurveyPointIdForGroupLogic)(r, e);else switch (r.condition) {
              case n.LogicCondition.is:
                a = i.SurveyLogic.is(u, t);
                break;
              case n.LogicCondition.is_not:
                a = i.SurveyLogic.is_not(u, t);
                break;
              case n.LogicCondition.is_between:
                a = i.SurveyLogic.is_between(u, t);
                break;
              case n.LogicCondition.is_exactly:
                a = i.SurveyLogic.is_exactly(u, t);
                break;
              case n.LogicCondition.includes_any_of_the_following:
                a = i.SurveyLogic.includes_any_of_the_following(u, t);
                break;
              case n.LogicCondition.includes_all_of_the_following:
                a = i.SurveyLogic.includes_all_of_the_following(u, t);
                break;
              case n.LogicCondition.doesnt_include_any_of_the_following:
                a = i.SurveyLogic.doesnt_include_any_of_the_following(u, t);
                break;
              case n.LogicCondition.question_is_answered:
                a = i.SurveyLogic.question_is_answered(l, t);
                break;
              case n.LogicCondition.question_is_not_answered:
                a = i.SurveyLogic.question_is_not_answered(l, t);
                break;
              case n.LogicCondition.answer_contains:
                a = i.SurveyLogic.answer_contains(l, t);
                break;
              case n.LogicCondition.answer_doesnt_contain:
                a = i.SurveyLogic.answer_doesnt_contain(l, t);
                break;
              case n.LogicCondition.has_any_value:
                a = i.SurveyLogic.has_any_value(t);
            }
            return a;
          });
          return (null == r ? void 0 : r.filter(Number)[0]) || null;
        };
      },
      3558: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getNextSurveyPoint = void 0;
        const i = r(8200),
          n = r(3501),
          o = r(6997),
          a = r(2069),
          u = s(r(9998)),
          l = r(5125),
          c = s(r(241)),
          d = s(r(2842));
        t.getNextSurveyPoint = function ({
          points: e
        }, t, r) {
          if ([i.SurveyCtaAnswerType.social, i.SurveyCtaAnswerType.redirect, i.SurveyCtaAnswerType.buttonLink, i.SurveyCtaAnswerType.thankYouMessage].includes(t.answer_type)) return null;
          let s = t.settings.logic;
          if (null == s ? void 0 : s.length) {
            let i = (0, a.getPointSpecificAnswers)(t.answer_type, r);
            if ([n.SurveyQuestionAnswerType.smileyScale, n.SurveyQuestionAnswerType.numericalScale, n.SurveyQuestionAnswerType.rating].includes(t.answer_type)) {
              const e = t;
              i = (0, c.default)(e, r), s = (0, d.default)(e);
            }
            const v = (0, o.getNextPointId)(i, s);
            if (v === u.default) return null;
            return e.find(e => e.id === v) || (0, l.findNextPoint)(t, e);
          }
          return (0, l.findNextPoint)(t, e);
        };
      },
      6597: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(3501);
        t.default = e => {
          const {
            answers: t,
            answer_type: r
          } = e;
          return t.reduce((e, t) => {
            const {
                id: i,
                possible_answer: n
              } = t,
              o = e;
            if (r === s.SurveyQuestionAnswerType.smileyScale) {
              const e = [s.SmileyScalePossibleAnswers.verySad, s.SmileyScalePossibleAnswers.sad, s.SmileyScalePossibleAnswers.neutral, s.SmileyScalePossibleAnswers.happy, s.SmileyScalePossibleAnswers.veryHappy];
              o[i] = e.findIndex(e => e === n);
            } else o[i] = Number(n);
            return o;
          }, {});
        };
      },
      241: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(6597));
        t.default = (e, t) => {
          const r = (0, i.default)(e),
            s = t[0].survey_question_answer_id;
          return "number" == typeof s ? [r[s]] : [];
        };
      },
      2842: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(6597));
        t.default = e => {
          const t = (0, i.default)(e);
          return e.settings.logic.map(e => Object.assign(Object.assign({}, e), {
            value: e.value.map(e => t[e])
          }));
        };
      },
      9777: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.pointAnswer = void 0;
        const i = r(2831),
          n = r(3137),
          o = r(9577),
          a = r(318),
          u = r(830),
          l = r(9027),
          c = s(r(3507)),
          d = s(r(8623)),
          v = r(3558),
          p = r(4970),
          _ = s(r(7966)),
          f = s(r(5816)),
          h = s(r(4977));
        t.pointAnswer = function ({
          surveyState: e,
          visitor: t,
          storeType: r
        }, s) {
          if (!e.survey) return;
          const {
              answers: m,
              textResponse: g,
              anonymizedTextResponse: b
            } = s,
            {
              point: y
            } = e.pointsDisplayed[e.pointsDisplayed.length - 1],
            w = l.storeManager.getStore(r),
            x = e.pointsDisplayed.length + e.pointsForward.length === 1,
            S = x ? (0, i.v4)() : e.responseUuid;
          x && (w.action(_.default)(S), w.action(c.default)());
          const k = (0, v.getNextSurveyPoint)(e.survey, y, s.answers),
            T = {
              anonymizedTextResponse: b,
              answerType: y.answer_type,
              answers: m,
              completionRate: k ? (0, n.getCompletionRate)(e) : 100,
              description: y.description || void 0,
              overwrite: w.getState().surveyState.pointsAnswered[y.id] || void 0,
              pointType: y.type,
              question: y.content,
              response_uuid: S,
              survey: e.survey,
              surveyName: e.survey.name,
              surveyPointId: y.id,
              textResponse: g,
              visitor_uuid: t.uuid
            };
          w.action(u.answered)(T), (0, a.fireSurveyEvent)(o.SurveyEvent.answered, {
            pointId: y.id
          }), (0, p.setVisitorTags)(r, m, e.survey), 1 === e.pointsDisplayed.length && (0, h.default)(), k ? w.action(f.default)(k, s.value) : w.action(d.default)();
        };
      },
      4977: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(5575));
        t.default = () => {
          i.default.params.aid = "";
        };
      },
      4970: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.setVisitorTags = void 0;
        const s = r(8004),
          i = r(9027);
        t.setVisitorTags = function (e, t, r) {
          const n = r.global_tags,
            o = i.storeManager.getStore(e);
          t.forEach(e => {
            e.user_tag && e.user_tag.split(";").forEach(e => {
              o.action(s.setVisitorTag)(e);
            });
          }), n && n.split(";").forEach(e => {
            o.action(s.setVisitorTag)(e);
          });
        };
      },
      9998: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        t.default = -1;
      },
      7966: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(9027);
        t.default = ({
          surveyState: e,
          storeType: t
        }, r) => {
          s.storeManager.getStore(t).setState({
            surveyState: Object.assign(Object.assign({}, e), {
              responseUuid: r
            })
          });
        };
      },
      8108: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(5548),
          n = r(4467),
          o = r(7057),
          a = s(r(8948)),
          u = s(r(579)),
          l = s(r(1982)),
          c = s(r(6810)),
          d = s(r(7033)),
          v = r(830),
          p = r(9027),
          _ = s(r(2881));
        t.default = (e, t) => {
          var r;
          const s = Object.assign({}, t),
            f = e.storeType;
          if (!((null === (r = s.points) || void 0 === r ? void 0 : r.length) && f || (s.activated = !1, s.type !== o.SurveyType.WidgetSurvey && s.type !== o.SurveyType.FeedbackButton))) return;
          const h = p.storeManager.getStore(f),
            m = s.points && s.points.length ? [{
              point: s.points[0]
            }] : [],
            g = !(e.isPreview && window.self !== window.top) && !e.rootElement && !a.default.ruleFulfilled(s, l.default.getVisit(f).get(), e.visitor);
          h.setState({
            surveyState: Object.assign(Object.assign({}, e.surveyState), {
              isAlreadyAnswered: g,
              isFinished: !1,
              isRTLLanguage: (0, n.isRTLLanguage)((0, i.getTranslationLang)(s)),
              isMinimized: u.default.isWidthMobile() ? !!s.settings.run_minimalized_mobile : !!s.settings.run_minimalized,
              isOverlayActive: !!s.settings.overlay,
              pointsDisplayed: m,
              pointsForward: [],
              survey: s,
              translationLanguage: (0, i.getTranslationLang)(s),
              translations: e.backendData.translations
            })
          }), !e.isPreview && s && s.activated && s.points.length && s.type === o.SurveyType.PageSurvey && h.action(v.seen)({
            surveyId: s.id,
            surveyName: s.name
          }), h.action(_.default)(s), s.type === o.SurveyType.PageSurvey && (h.action(d.default)(), (0, c.default)(s));
        };
      },
      5816: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(830),
          i = r(9027);
        t.default = ({
          surveyState: e,
          storeType: t
        }, r, n) => {
          const o = i.storeManager.getStore(t),
            {
              survey: a
            } = e;
          if (!a) return;
          const u = [...e.pointsDisplayed, {
            point: r
          }];
          let l = [...e.pointsForward];
          l = l.length && l[0].point.id === r.id ? l.slice(1) : [];
          const c = u[u.length - 2],
            d = c.point;
          u[u.length - 2] = Object.assign(Object.assign({}, c), {
            value: n
          }), o.setState({
            surveyState: Object.assign(Object.assign({}, e), {
              pointsAnswered: Object.assign(Object.assign({}, e.pointsAnswered), {
                [d.id]: !0
              }),
              pointsDisplayed: u,
              pointsForward: l
            })
          }), o.action(s.surveyPointSeen)({
            question: r.content,
            surveyName: a.name
          });
        };
      },
      2881: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = s(r(3155)),
          n = r(9027);
        t.default = (e, t) => {
          const r = (Array.isArray(e.update.themes) && e.update.themes.length > 0 ? e.update.themes : e.backendData.themes).find(e => e.id === t.theme_id),
            s = e.storeType;
          if (!r || !s) return;
          const o = i.default.extendTheme(r);
          n.storeManager.getStore(s).setState({
            surveyState: Object.assign(Object.assign({}, e.surveyState), {
              theme: o
            })
          }), i.default.reloadCss(o, s);
        };
      },
      9535: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.targetingEventsStore = t.initialTargetingEventsStore = void 0;
        const i = s(r(9248));
        t.initialTargetingEventsStore = {
          events: [],
          isEnabled: !1
        }, t.targetingEventsStore = (0, i.default)(t.initialTargetingEventsStore);
      },
      8004: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.visitorActions = t.setSurveyInteraction = t.setVisitorTag = t.setVisitorAttributesFromURL = t.setVisitorAttributes = t.addNewVisit = void 0;
        const i = r(2158),
          n = r(3694),
          o = r(7057),
          a = r(2214),
          u = s(r(5575)),
          l = s(r(1982)),
          c = r(9027),
          d = r(4714),
          v = s(r(5786)),
          p = s(r(9487));
        function _(e) {
          const t = Object.assign({}, e.visitor),
            r = e.storeType;
          r && 1 === l.default.getVisit(r).get().views.length && (t.visitsCount += 1, c.storeManager.getStore(r).action(v.default)(t));
        }
        t.addNewVisit = _;
        const f = (e, t) => {
          if (t === n.USER_ID_TRAIT) return !1;
          if ("number" == typeof e || "boolean" == typeof e || e instanceof Date) return !0;
          return !/^({.*})|(\*\|.*\|\*)|(\[.*\])|(%.*%)|(~.*~)|(--.*--)|(\$.*\$)$/.test(e);
        };
        function h(e, t) {
          if (!t) return;
          const r = Object.assign({}, e.visitor);
          Object.keys(t).forEach(e => {
            let s = t[e];
            "number" == typeof s || "boolean" == typeof s || s instanceof Date || (s = `${t[e]}`.substring(0, 255)), f(s, e) && (s = "string" == typeof s ? (0, a.sanitizeString)(s) : s, r.attributes[e] = s);
          }), t[n.USER_ID_TRAIT] && (r.identities.api = r.identities.api || {}, r.identities.api = {
            id: t[n.USER_ID_TRAIT]
          }), c.storeManager.getStore(e.storeType).action(v.default)(r);
        }
        function m() {
          c.storeManager.getStore(o.SurveyType.PageSurvey).action(h)((0, i.getAttributesFromURL)(u.default.params));
        }
        function g(e, t) {
          const r = Object.assign({}, e.visitor);
          r.tags.includes(t) || (r.tags.push(t), c.storeManager.getStore(e.storeType).action(v.default)(r));
        }
        t.setVisitorAttributes = h, t.setVisitorAttributesFromURL = m, t.setVisitorTag = g;
        const b = (e, t, r) => {
          const s = {
              surveyId: t,
              timestamp: r
            },
            i = [...e],
            n = i.findIndex(e => (e.surveyId || e) === t);
          return -1 !== n ? i[n] = s : i.push(s), i;
        };
        function y(e, {
          surveyId: t,
          interactionType: r
        }) {
          const s = Object.assign({}, e.visitor),
            i = new Date().valueOf();
          if (r === d.SurveyInteractionType.engaged) {
            s.initialSurveysEngagement = s.initialSurveysEngagement || [];
            let e = s.initialSurveysEngagement.find(e => e.surveyId === t);
            e || (e = {
              surveyId: t,
              timestamp: i
            }, s.initialSurveysEngagement.push(e)), s.engagedSurveys = b([...s.engagedSurveys], t, i);
          } else r === d.SurveyInteractionType.displayed && (s.displayedSurveys = b([...s.displayedSurveys], t, i));
          c.storeManager.getStore(e.storeType).action(v.default)(s);
        }
        t.setSurveyInteraction = y, t.visitorActions = {
          addNewVisit: _,
          saveVisitor: v.default,
          setSurveyInteraction: y,
          setVisitorAttributes: h,
          setVisitorAttributesFromURL: m,
          setVisitorIdentity: p.default,
          setVisitorTag: g
        };
      },
      75: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getVisitorAttribute = void 0;
        const s = r(9027);
        t.getVisitorAttribute = (e, t) => {
          const {
            visitor: r
          } = s.storeManager.getStore(e).getState();
          return r.attributes[t];
        };
      },
      4714: (e, t) => {
        "use strict";

        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.emptyVisitor = t.SurveyInteractionType = void 0, function (e) {
          e.engaged = "engagedSurveys", e.displayed = "displayedSurveys";
        }(r || (t.SurveyInteractionType = r = {})), t.emptyVisitor = {
          attributes: {},
          displayedSurveys: [],
          engagedSurveys: [],
          identities: {},
          initialSurveysEngagement: [],
          tags: [],
          uuid: "",
          visitsCount: 0
        };
      },
      5786: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(8998),
          i = r(9027);
        t.default = ({
          storageService: e,
          isKioskMode: t,
          storeType: r
        }, n) => {
          i.storeManager.getStore(r).setState({
            visitor: n
          }), !t && r && (null == e || e.put(r, {
            key: s.StorageTableKeys.visitor,
            table: s.StorageTables.all
          }, n));
        };
      },
      9487: function (e, t, r) {
        "use strict";

        var s = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const i = r(9027),
          n = s(r(5786));
        t.default = (e, {
          identityProvider: t,
          key: r,
          value: s
        }) => {
          const o = Object.assign({}, e.visitor),
            a = Object.assign({}, o.identities);
          a[t] = Object.assign(Object.assign({}, a[t]), {
            [r]: s
          }), o.identities = a, i.storeManager.getStore(e.storeType).action(n.default)(o);
        };
      },
      4700: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const s = r(172),
          i = r(5994),
          n = r(1617),
          o = r(4409),
          a = r(7057),
          u = r(5346);
        t.default = () => {
          const e = (0, i.useContext)(n.SubmitButtonContext),
            {
              pageSurvey: t
            } = (0, i.useContext)(u.SurveyConfigContext),
            r = (0, o.translateMessages)(a.SurveyType.PageSurvey, t);
          return (0, i.useEffect)(() => {
            e.render(!1);
          }, []), (0, s.h)("div", {
            className: "sv__opened-in-new-tab"
          }, (0, s.h)("img", {
            src: "https://surveys-static.survicate.com/images/refresh.svg",
            alt: "Refresh icon"
          }), (0, s.h)("p", null, (null == r ? void 0 : r.opened_text) || "The survey was opened in a new tab. Refresh this page to continue filling out this survey."));
        };
      },
      9248: (e, t, r) => {
        "use strict";

        function s(e, t) {
          for (var r in t) e[r] = t[r];
          return e;
        }
        function i(e) {
          var t = [];
          function r(e) {
            for (var r = [], s = 0; s < t.length; s++) t[s] === e ? e = null : r.push(t[s]);
            t = r;
          }
          function i(r, i, n) {
            e = i ? r : s(s({}, e), r);
            for (var o = t, a = 0; a < o.length; a++) o[a](e, n);
          }
          return e = e || {}, {
            action: function (t) {
              function r(e) {
                i(e, !1, t);
              }
              return function () {
                for (var s = arguments, i = [e], n = 0; n < arguments.length; n++) i.push(s[n]);
                var o = t.apply(this, i);
                if (null != o) return o.then ? o.then(r) : r(o);
              };
            },
            setState: i,
            subscribe: function (e) {
              return t.push(e), function () {
                r(e);
              };
            },
            unsubscribe: r,
            getState: function () {
              return e;
            }
          };
        }
        r.r(t), r.d(t, {
          default: () => i
        });
      },
      9635: (e, t, r) => {
        var s = r(172);
        function i(e, t) {
          for (var r in t) e[r] = t[r];
          return e;
        }
        function n(e) {
          this.getChildContext = function () {
            return {
              store: e.store
            };
          };
        }
        n.prototype.render = function (e) {
          return e.children && e.children[0] || e.children;
        }, t.connect = function (e, t) {
          var r;
          return "function" != typeof e && ("string" == typeof (r = e || {}) && (r = r.split(/\s*,\s*/)), e = function (e) {
            for (var t = {}, s = 0; s < r.length; s++) t[r[s]] = e[r[s]];
            return t;
          }), function (r) {
            function n(n, o) {
              var a = this,
                u = o.store,
                l = e(u ? u.getState() : {}, n),
                c = t ? function (e, t) {
                  "function" == typeof e && (e = e(t));
                  var r = {};
                  for (var s in e) r[s] = t.action(e[s]);
                  return r;
                }(t, u) : {
                  store: u
                },
                d = function () {
                  var t = e(u ? u.getState() : {}, n);
                  for (var r in t) if (t[r] !== l[r]) return l = t, a.setState({});
                  for (var s in l) if (!(s in t)) return l = t, a.setState({});
                };
              this.componentWillReceiveProps = function (e) {
                n = e, d();
              }, this.componentDidMount = function () {
                u.subscribe(d);
              }, this.componentWillUnmount = function () {
                u.unsubscribe(d);
              }, this.render = function (e) {
                return s.h(r, i(i(i({}, c), e), l));
              };
            }
            return (n.prototype = new s.Component()).constructor = n;
          };
        }, t.Provider = n;
      },
      2831: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "NIL", {
          enumerable: !0,
          get: function () {
            return a.default;
          }
        }), Object.defineProperty(t, "parse", {
          enumerable: !0,
          get: function () {
            return d.default;
          }
        }), Object.defineProperty(t, "stringify", {
          enumerable: !0,
          get: function () {
            return c.default;
          }
        }), Object.defineProperty(t, "v1", {
          enumerable: !0,
          get: function () {
            return s.default;
          }
        }), Object.defineProperty(t, "v3", {
          enumerable: !0,
          get: function () {
            return i.default;
          }
        }), Object.defineProperty(t, "v4", {
          enumerable: !0,
          get: function () {
            return n.default;
          }
        }), Object.defineProperty(t, "v5", {
          enumerable: !0,
          get: function () {
            return o.default;
          }
        }), Object.defineProperty(t, "validate", {
          enumerable: !0,
          get: function () {
            return l.default;
          }
        }), Object.defineProperty(t, "version", {
          enumerable: !0,
          get: function () {
            return u.default;
          }
        });
        var s = v(r(3518)),
          i = v(r(4948)),
          n = v(r(5073)),
          o = v(r(7186)),
          a = v(r(4808)),
          u = v(r(7775)),
          l = v(r(7037)),
          c = v(r(9910)),
          d = v(r(6792));
        function v(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
      },
      2311: (e, t) => {
        "use strict";

        function r(e) {
          return 14 + (e + 64 >>> 9 << 4) + 1;
        }
        function s(e, t) {
          const r = (65535 & e) + (65535 & t);
          return (e >> 16) + (t >> 16) + (r >> 16) << 16 | 65535 & r;
        }
        function i(e, t, r, i, n, o) {
          return s((a = s(s(t, e), s(i, o))) << (u = n) | a >>> 32 - u, r);
          var a, u;
        }
        function n(e, t, r, s, n, o, a) {
          return i(t & r | ~t & s, e, t, n, o, a);
        }
        function o(e, t, r, s, n, o, a) {
          return i(t & s | r & ~s, e, t, n, o, a);
        }
        function a(e, t, r, s, n, o, a) {
          return i(t ^ r ^ s, e, t, n, o, a);
        }
        function u(e, t, r, s, n, o, a) {
          return i(r ^ (t | ~s), e, t, n, o, a);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var l = function (e) {
          if ("string" == typeof e) {
            const t = unescape(encodeURIComponent(e));
            e = new Uint8Array(t.length);
            for (let r = 0; r < t.length; ++r) e[r] = t.charCodeAt(r);
          }
          return function (e) {
            const t = [],
              r = 32 * e.length,
              s = "0123456789abcdef";
            for (let i = 0; i < r; i += 8) {
              const r = e[i >> 5] >>> i % 32 & 255,
                n = parseInt(s.charAt(r >>> 4 & 15) + s.charAt(15 & r), 16);
              t.push(n);
            }
            return t;
          }(function (e, t) {
            e[t >> 5] |= 128 << t % 32, e[r(t) - 1] = t;
            let i = 1732584193,
              l = -271733879,
              c = -1732584194,
              d = 271733878;
            for (let t = 0; t < e.length; t += 16) {
              const r = i,
                v = l,
                p = c,
                _ = d;
              i = n(i, l, c, d, e[t], 7, -680876936), d = n(d, i, l, c, e[t + 1], 12, -389564586), c = n(c, d, i, l, e[t + 2], 17, 606105819), l = n(l, c, d, i, e[t + 3], 22, -1044525330), i = n(i, l, c, d, e[t + 4], 7, -176418897), d = n(d, i, l, c, e[t + 5], 12, 1200080426), c = n(c, d, i, l, e[t + 6], 17, -1473231341), l = n(l, c, d, i, e[t + 7], 22, -45705983), i = n(i, l, c, d, e[t + 8], 7, 1770035416), d = n(d, i, l, c, e[t + 9], 12, -1958414417), c = n(c, d, i, l, e[t + 10], 17, -42063), l = n(l, c, d, i, e[t + 11], 22, -1990404162), i = n(i, l, c, d, e[t + 12], 7, 1804603682), d = n(d, i, l, c, e[t + 13], 12, -40341101), c = n(c, d, i, l, e[t + 14], 17, -1502002290), l = n(l, c, d, i, e[t + 15], 22, 1236535329), i = o(i, l, c, d, e[t + 1], 5, -165796510), d = o(d, i, l, c, e[t + 6], 9, -1069501632), c = o(c, d, i, l, e[t + 11], 14, 643717713), l = o(l, c, d, i, e[t], 20, -373897302), i = o(i, l, c, d, e[t + 5], 5, -701558691), d = o(d, i, l, c, e[t + 10], 9, 38016083), c = o(c, d, i, l, e[t + 15], 14, -660478335), l = o(l, c, d, i, e[t + 4], 20, -405537848), i = o(i, l, c, d, e[t + 9], 5, 568446438), d = o(d, i, l, c, e[t + 14], 9, -1019803690), c = o(c, d, i, l, e[t + 3], 14, -187363961), l = o(l, c, d, i, e[t + 8], 20, 1163531501), i = o(i, l, c, d, e[t + 13], 5, -1444681467), d = o(d, i, l, c, e[t + 2], 9, -51403784), c = o(c, d, i, l, e[t + 7], 14, 1735328473), l = o(l, c, d, i, e[t + 12], 20, -1926607734), i = a(i, l, c, d, e[t + 5], 4, -378558), d = a(d, i, l, c, e[t + 8], 11, -2022574463), c = a(c, d, i, l, e[t + 11], 16, 1839030562), l = a(l, c, d, i, e[t + 14], 23, -35309556), i = a(i, l, c, d, e[t + 1], 4, -1530992060), d = a(d, i, l, c, e[t + 4], 11, 1272893353), c = a(c, d, i, l, e[t + 7], 16, -155497632), l = a(l, c, d, i, e[t + 10], 23, -1094730640), i = a(i, l, c, d, e[t + 13], 4, 681279174), d = a(d, i, l, c, e[t], 11, -358537222), c = a(c, d, i, l, e[t + 3], 16, -722521979), l = a(l, c, d, i, e[t + 6], 23, 76029189), i = a(i, l, c, d, e[t + 9], 4, -640364487), d = a(d, i, l, c, e[t + 12], 11, -421815835), c = a(c, d, i, l, e[t + 15], 16, 530742520), l = a(l, c, d, i, e[t + 2], 23, -995338651), i = u(i, l, c, d, e[t], 6, -198630844), d = u(d, i, l, c, e[t + 7], 10, 1126891415), c = u(c, d, i, l, e[t + 14], 15, -1416354905), l = u(l, c, d, i, e[t + 5], 21, -57434055), i = u(i, l, c, d, e[t + 12], 6, 1700485571), d = u(d, i, l, c, e[t + 3], 10, -1894986606), c = u(c, d, i, l, e[t + 10], 15, -1051523), l = u(l, c, d, i, e[t + 1], 21, -2054922799), i = u(i, l, c, d, e[t + 8], 6, 1873313359), d = u(d, i, l, c, e[t + 15], 10, -30611744), c = u(c, d, i, l, e[t + 6], 15, -1560198380), l = u(l, c, d, i, e[t + 13], 21, 1309151649), i = u(i, l, c, d, e[t + 4], 6, -145523070), d = u(d, i, l, c, e[t + 11], 10, -1120210379), c = u(c, d, i, l, e[t + 2], 15, 718787259), l = u(l, c, d, i, e[t + 9], 21, -343485551), i = s(i, r), l = s(l, v), c = s(c, p), d = s(d, _);
            }
            return [i, l, c, d];
          }(function (e) {
            if (0 === e.length) return [];
            const t = 8 * e.length,
              s = new Uint32Array(r(t));
            for (let r = 0; r < t; r += 8) s[r >> 5] |= (255 & e[r / 8]) << r % 32;
            return s;
          }(e), 8 * e.length));
        };
        t.default = l;
      },
      6140: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var r = {
          randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
        };
        t.default = r;
      },
      4808: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        t.default = "00000000-0000-0000-0000-000000000000";
      },
      6792: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var s,
          i = (s = r(7037)) && s.__esModule ? s : {
            default: s
          };
        var n = function (e) {
          if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
          let t;
          const r = new Uint8Array(16);
          return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = 255 & t, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = 255 & t, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = 255 & t, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = 255 & t, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = 255 & t, r;
        };
        t.default = n;
      },
      7656: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        t.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
      },
      2858: (e, t) => {
        "use strict";

        let r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function () {
          if (!r && (r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !r)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
          return r(s);
        };
        const s = new Uint8Array(16);
      },
      9042: (e, t) => {
        "use strict";

        function r(e, t, r, s) {
          switch (e) {
            case 0:
              return t & r ^ ~t & s;
            case 1:
            case 3:
              return t ^ r ^ s;
            case 2:
              return t & r ^ t & s ^ r & s;
          }
        }
        function s(e, t) {
          return e << t | e >>> 32 - t;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var i = function (e) {
          const t = [1518500249, 1859775393, 2400959708, 3395469782],
            i = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
          if ("string" == typeof e) {
            const t = unescape(encodeURIComponent(e));
            e = [];
            for (let r = 0; r < t.length; ++r) e.push(t.charCodeAt(r));
          } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
          e.push(128);
          const n = e.length / 4 + 2,
            o = Math.ceil(n / 16),
            a = new Array(o);
          for (let t = 0; t < o; ++t) {
            const r = new Uint32Array(16);
            for (let s = 0; s < 16; ++s) r[s] = e[64 * t + 4 * s] << 24 | e[64 * t + 4 * s + 1] << 16 | e[64 * t + 4 * s + 2] << 8 | e[64 * t + 4 * s + 3];
            a[t] = r;
          }
          a[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), a[o - 1][14] = Math.floor(a[o - 1][14]), a[o - 1][15] = 8 * (e.length - 1) & 4294967295;
          for (let e = 0; e < o; ++e) {
            const n = new Uint32Array(80);
            for (let t = 0; t < 16; ++t) n[t] = a[e][t];
            for (let e = 16; e < 80; ++e) n[e] = s(n[e - 3] ^ n[e - 8] ^ n[e - 14] ^ n[e - 16], 1);
            let o = i[0],
              u = i[1],
              l = i[2],
              c = i[3],
              d = i[4];
            for (let e = 0; e < 80; ++e) {
              const i = Math.floor(e / 20),
                a = s(o, 5) + r(i, u, l, c) + d + t[i] + n[e] >>> 0;
              d = c, c = l, l = s(u, 30) >>> 0, u = o, o = a;
            }
            i[0] = i[0] + o >>> 0, i[1] = i[1] + u >>> 0, i[2] = i[2] + l >>> 0, i[3] = i[3] + c >>> 0, i[4] = i[4] + d >>> 0;
          }
          return [i[0] >> 24 & 255, i[0] >> 16 & 255, i[0] >> 8 & 255, 255 & i[0], i[1] >> 24 & 255, i[1] >> 16 & 255, i[1] >> 8 & 255, 255 & i[1], i[2] >> 24 & 255, i[2] >> 16 & 255, i[2] >> 8 & 255, 255 & i[2], i[3] >> 24 & 255, i[3] >> 16 & 255, i[3] >> 8 & 255, 255 & i[3], i[4] >> 24 & 255, i[4] >> 16 & 255, i[4] >> 8 & 255, 255 & i[4]];
        };
        t.default = i;
      },
      9910: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0, t.unsafeStringify = o;
        var s,
          i = (s = r(7037)) && s.__esModule ? s : {
            default: s
          };
        const n = [];
        for (let e = 0; e < 256; ++e) n.push((e + 256).toString(16).slice(1));
        function o(e, t = 0) {
          return n[e[t + 0]] + n[e[t + 1]] + n[e[t + 2]] + n[e[t + 3]] + "-" + n[e[t + 4]] + n[e[t + 5]] + "-" + n[e[t + 6]] + n[e[t + 7]] + "-" + n[e[t + 8]] + n[e[t + 9]] + "-" + n[e[t + 10]] + n[e[t + 11]] + n[e[t + 12]] + n[e[t + 13]] + n[e[t + 14]] + n[e[t + 15]];
        }
        var a = function (e, t = 0) {
          const r = o(e, t);
          if (!(0, i.default)(r)) throw TypeError("Stringified UUID is invalid");
          return r;
        };
        t.default = a;
      },
      3518: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var s,
          i = (s = r(2858)) && s.__esModule ? s : {
            default: s
          },
          n = r(9910);
        let o,
          a,
          u = 0,
          l = 0;
        var c = function (e, t, r) {
          let s = t && r || 0;
          const c = t || new Array(16);
          let d = (e = e || {}).node || o,
            v = void 0 !== e.clockseq ? e.clockseq : a;
          if (null == d || null == v) {
            const t = e.random || (e.rng || i.default)();
            null == d && (d = o = [1 | t[0], t[1], t[2], t[3], t[4], t[5]]), null == v && (v = a = 16383 & (t[6] << 8 | t[7]));
          }
          let p = void 0 !== e.msecs ? e.msecs : Date.now(),
            _ = void 0 !== e.nsecs ? e.nsecs : l + 1;
          const f = p - u + (_ - l) / 1e4;
          if (f < 0 && void 0 === e.clockseq && (v = v + 1 & 16383), (f < 0 || p > u) && void 0 === e.nsecs && (_ = 0), _ >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
          u = p, l = _, a = v, p += 122192928e5;
          const h = (1e4 * (268435455 & p) + _) % 4294967296;
          c[s++] = h >>> 24 & 255, c[s++] = h >>> 16 & 255, c[s++] = h >>> 8 & 255, c[s++] = 255 & h;
          const m = p / 4294967296 * 1e4 & 268435455;
          c[s++] = m >>> 8 & 255, c[s++] = 255 & m, c[s++] = m >>> 24 & 15 | 16, c[s++] = m >>> 16 & 255, c[s++] = v >>> 8 | 128, c[s++] = 255 & v;
          for (let e = 0; e < 6; ++e) c[s + e] = d[e];
          return t || (0, n.unsafeStringify)(c);
        };
        t.default = c;
      },
      4948: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var s = n(r(9025)),
          i = n(r(2311));
        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        var o = (0, s.default)("v3", 48, i.default);
        t.default = o;
      },
      9025: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.URL = t.DNS = void 0, t.default = function (e, t, r) {
          function s(e, s, o, a) {
            var u;
            if ("string" == typeof e && (e = function (e) {
              e = unescape(encodeURIComponent(e));
              const t = [];
              for (let r = 0; r < e.length; ++r) t.push(e.charCodeAt(r));
              return t;
            }(e)), "string" == typeof s && (s = (0, n.default)(s)), 16 !== (null === (u = s) || void 0 === u ? void 0 : u.length)) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
            let l = new Uint8Array(16 + e.length);
            if (l.set(s), l.set(e, s.length), l = r(l), l[6] = 15 & l[6] | t, l[8] = 63 & l[8] | 128, o) {
              a = a || 0;
              for (let e = 0; e < 16; ++e) o[a + e] = l[e];
              return o;
            }
            return (0, i.unsafeStringify)(l);
          }
          try {
            s.name = e;
          } catch (e) {}
          return s.DNS = o, s.URL = a, s;
        };
        var s,
          i = r(9910),
          n = (s = r(6792)) && s.__esModule ? s : {
            default: s
          };
        const o = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
        t.DNS = o;
        const a = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
        t.URL = a;
      },
      5073: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var s = o(r(6140)),
          i = o(r(2858)),
          n = r(9910);
        function o(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        var a = function (e, t, r) {
          if (s.default.randomUUID && !t && !e) return s.default.randomUUID();
          const o = (e = e || {}).random || (e.rng || i.default)();
          if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) {
            r = r || 0;
            for (let e = 0; e < 16; ++e) t[r + e] = o[e];
            return t;
          }
          return (0, n.unsafeStringify)(o);
        };
        t.default = a;
      },
      7186: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var s = n(r(9025)),
          i = n(r(9042));
        function n(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        var o = (0, s.default)("v5", 80, i.default);
        t.default = o;
      },
      7037: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var s,
          i = (s = r(7656)) && s.__esModule ? s : {
            default: s
          };
        var n = function (e) {
          return "string" == typeof e && i.default.test(e);
        };
        t.default = n;
      },
      7775: (e, t, r) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var s,
          i = (s = r(7037)) && s.__esModule ? s : {
            default: s
          };
        var n = function (e) {
          if (!(0, i.default)(e)) throw TypeError("Invalid UUID");
          return parseInt(e.slice(14, 15), 16);
        };
        t.default = n;
      },
      9746: () => {},
      9977: () => {},
      197: () => {},
      1866: () => {},
      2739: () => {},
      7287: e => {
        var t,
          r = Object.defineProperty,
          s = Object.getOwnPropertyDescriptor,
          i = Object.getOwnPropertyNames,
          n = Object.prototype.hasOwnProperty,
          o = {};
        ((e, t) => {
          for (var s in t) r(e, s, {
            get: t[s],
            enumerable: !0
          });
        })(o, {
          createIsbot: () => _,
          createIsbotFromList: () => f,
          getPattern: () => c,
          isbot: () => p,
          isbotMatch: () => h,
          isbotMatches: () => m,
          isbotNaive: () => v,
          isbotPattern: () => g,
          isbotPatterns: () => b,
          list: () => d
        }), e.exports = (t = o, ((e, t, o, a) => {
          if (t && "object" == typeof t || "function" == typeof t) for (let u of i(t)) n.call(e, u) || u === o || r(e, u, {
            get: () => t[u],
            enumerable: !(a = s(t, u)) || a.enumerable
          });
          return e;
        })(r({}, "__esModule", {
          value: !0
        }), t));
        var a,
          u = " daum[ /]| deusu/| yadirectfetcher|(?:^|[^g])news|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bot(?:[^\\w]|_|$)|(?<!(?: ya| yandex|^job) ?)search|(?<!(?:lib))http|(?<![hg]m)score|(?<!android|ios)@|\\(\\)|\\.com|^12345|^<|^[\\w \\.\\-\\(?:\\):]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[^ ]{50,}$|^\\w+/[\\w\\(\\)]*$|^active|^ad muncher|^amaya|^avsdevicesdk/|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^facebook|^getright/|^gozilla/|^hatena|^hobbit|^hotzonu|^hwcdn/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/\\d\\.\\d \\(compatible;?\\)$|^mozilla/\\d\\.\\d \\w*$|^navermailapp|^netsurf|^offline explorer|^postman|^python|^rank|^read|^reed|^rest|^serf|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^valid|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|^{{.*}}$|archive|ask jeeves/teoma|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check|chrome-lighthouse|chromeframe|classifier|cloud|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|evc-batch/|feed|firephp|gomezagent|headless|httrack|hubspot marketing grader|hydra|ibisbrowser|images|insight|inspect|iplabel|ips-agent|java(?!;)|library|mail\\.ru/|manager|measure|neustar wpm|node|nutch|offbyone|optimize|pageburst|parser|perl|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|reputation|resolver|retriever|rexx;|rigor|robot|rss|scan|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|trace|transcoder|url|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|zgrab",
          l = /bot|spider|crawl|http|lighthouse/i;
        function c() {
          if (a instanceof RegExp) return a;
          try {
            a = new RegExp(u, "i");
          } catch (e) {
            a = l;
          }
          return a;
        }
        var d = [" daum[ /]", " deusu/", " yadirectfetcher", "(?:^|[^g])news", "(?<! (?:channel/|google/))google(?!(app|/google| pixel))", "(?<! cu)bot(?:[^\\w]|_|$)", "(?<!(?: ya| yandex|^job) ?)search", "(?<!(?:lib))http", "(?<![hg]m)score", "(?<!android|ios)@", "\\(\\)", "\\.com", "^12345", "^<", "^[\\w \\.\\-\\(?:\\):]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)", "^[^ ]{50,}$", "^\\w+/[\\w\\(\\)]*$", "^active", "^ad muncher", "^amaya", "^avsdevicesdk/", "^biglotron", "^bot", "^bw/", "^clamav[ /]", "^client/", "^cobweb/", "^custom", "^ddg[_-]android", "^discourse", "^dispatch/\\d", "^downcast/", "^duckduckgo", "^facebook", "^getright/", "^gozilla/", "^hatena", "^hobbit", "^hotzonu", "^hwcdn/", "^jeode/", "^jetty/", "^jigsaw", "^microsoft bits", "^movabletype", "^mozilla/\\d\\.\\d \\(compatible;?\\)$", "^mozilla/\\d\\.\\d \\w*$", "^navermailapp", "^netsurf", "^offline explorer", "^postman", "^python", "^rank", "^read", "^reed", "^rest", "^serf", "^snapchat", "^space bison", "^svn", "^swcd ", "^taringa", "^thumbor/", "^track", "^valid", "^w3c", "^webbandit/", "^webcopier", "^wget", "^whatsapp", "^wordpress", "^xenu link sleuth", "^yahoo", "^yandex", "^zdm/\\d", "^zoom marketplace/", "^{{.*}}$", "archive", "ask jeeves/teoma", "bit\\.ly/", "bluecoat drtr", "browsex", "burpcollaborator", "capture", "catch", "check", "chrome-lighthouse", "chromeframe", "classifier", "cloud", "crawl", "cypress/", "dareboost", "datanyze", "dejaclick", "detect", "dmbrowser", "download", "evc-batch/", "feed", "firephp", "gomezagent", "headless", "httrack", "hubspot marketing grader", "hydra", "ibisbrowser", "images", "insight", "inspect", "iplabel", "ips-agent", "java(?!;)", "library", "mail\\.ru/", "manager", "measure", "neustar wpm", "node", "nutch", "offbyone", "optimize", "pageburst", "parser", "perl", "phantomjs", "pingdom", "powermarks", "preview", "proxy", "ptst[ /]\\d", "reputation", "resolver", "retriever", "rexx;", "rigor", "robot", "rss", "scan", "scrape", "server", "sogou", "sparkler/", "speedcurve", "spider", "splash", "statuscake", "supercleaner", "synapse", "synthetic", "tools", "torrent", "trace", "transcoder", "url", "virtuoso", "wappalyzer", "webglance", "webkit2png", "whatcms/", "zgrab"],
          v = e => Boolean(e) && l.test(e);
        function p(e) {
          return Boolean(e) && c().test(e);
        }
        var _ = e => t => Boolean(t) && e.test(t),
          f = e => {
            const t = new RegExp(e.join("|"), "i");
            return e => Boolean(e) && t.test(e);
          },
          h = e => {
            var t, r;
            return null != (r = null == (t = null == e ? void 0 : e.match(c())) ? void 0 : t[0]) ? r : null;
          },
          m = e => d.map(t => {
            var r;
            return null == (r = null == e ? void 0 : e.match(new RegExp(t, "i"))) ? void 0 : r[0];
          }).filter(Boolean),
          g = e => {
            var t;
            return e && null != (t = d.find(t => new RegExp(t, "i").test(e))) ? t : null;
          },
          b = e => e ? d.filter(t => new RegExp(t, "i").test(e)) : [];
      },
      5042: e => {
        e.exports = {
          nanoid: (e = 21) => {
            let t = "",
              r = e;
            for (; r--;) t += "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[64 * Math.random() | 0];
            return t;
          },
          customAlphabet: (e, t = 21) => (r = t) => {
            let s = "",
              i = r;
            for (; i--;) s += e[Math.random() * e.length | 0];
            return s;
          }
        };
      },
      5578: e => {
        "use strict";

        e.exports = JSON.parse('{"titles":{"desktop":["Congratulations!","You\'ve completed the survey"],"mobile":"Thank you for completing the survey! ","unavailable":"Uh-oh! This survey is currently unavailable "},"paragraphs":{"desktop":["Don\'t let that stop you! Create your own survey in just a few clicks.","With Survicate, a user journey survey software, you can get continuous user insights at all stages of the funnel:"],"mobile":{"unavailable":["Don\'t let that stop you! Create your own survey in just a few clicks.","Find out how Survicate can help you gain valuable insights."],"finish":["But hey, why stop here? You can create surveys like this one and get feedback from your own customers too.","See how to get valuable insights in no time with Survicate."]}},"list":["Better understand your audience with website surveys","Validate your product ideas with in-app feedback surveys","Identify churn reasons to improve customer experience"],"button":"LEARN MORE","security":"Your browser doesn’t meet our security standards. Please update your browser to answer this survey."}');
      },
      2174: e => {
        "use strict";

        e.exports = JSON.parse('{"button":"LEARN MORE","defaultThankYouMessage":"Thank you for taking part in our survey","introduction":"Thanks for completing the survey! 🎉","paragraph":["Want to create surveys like this and gather feedback from your customers?","Discover how Survicate can help you collect insights in minutes."]}');
      },
      4827: e => {
        "use strict";

        e.exports = JSON.parse('{"email":{"message":"Please enter a valid email address."},"phone":{"message":"Please enter a valid phone number."},"zip":{"message":"Please enter a valid ZIP code."},"date":{"message":"Please enter a valid date."},"select":{"message":"Please select an option from the list"}}');
      }
    },
    s = {};
  function i(e) {
    var t = s[e];
    if (void 0 !== t) return t.exports;
    var n = s[e] = {
      id: e,
      exports: {}
    };
    return r[e].call(n.exports, n, n.exports, i), n.exports;
  }
  i.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return i.d(t, {
      a: t
    }), t;
  }, t = Object.getPrototypeOf ? e => Object.getPrototypeOf(e) : e => e.__proto__, i.t = function (r, s) {
    if (1 & s && (r = this(r)), 8 & s) return r;
    if ("object" == typeof r && r) {
      if (4 & s && r.__esModule) return r;
      if (16 & s && "function" == typeof r.then) return r;
    }
    var n = Object.create(null);
    i.r(n);
    var o = {};
    e = e || [null, t({}), t([]), t(t)];
    for (var a = 2 & s && r; "object" == typeof a && !~e.indexOf(a); a = t(a)) Object.getOwnPropertyNames(a).forEach(e => o[e] = () => r[e]);
    return o.default = () => r, i.d(n, o), n;
  }, i.d = (e, t) => {
    for (var r in t) i.o(t, r) && !i.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), i.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, i.nc = void 0;
  var n = i(1150);
  return n = n.default;
})());